
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("25N8O", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $9979c1a16db25158$export$2e2bcd8739ae039);

var $4zyaU = parcelRequire("4zyaU");

var $b8FqF = parcelRequire("b8FqF");
var $9979c1a16db25158$export$2e2bcd8739ae039 = (0, $4zyaU.withExperienceNotifier)('request-create-form')((0, $b8FqF.default));

});
parcelRegister("b8FqF", function(module, exports) {
$parcel$export(module.exports, "default", () => $7bd48a934ff29c0f$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $9XZeF = parcelRequire("9XZeF");

var $2n2bS = parcelRequire("2n2bS");

var $luz1X = parcelRequire("luz1X");

var $io4o2 = parcelRequire("io4o2");

var $hN5YJ = parcelRequire("hN5YJ");

var $5kfOu = parcelRequire("5kfOu");

var $4h23n = parcelRequire("4h23n");

var $aUHFa = parcelRequire("aUHFa");

var $9VJCP = parcelRequire("9VJCP");

var $fOCtI = parcelRequire("fOCtI");

var $l6yt4 = parcelRequire("l6yt4");

var $aYMdQ = parcelRequire("aYMdQ");

var $fcCIH = parcelRequire("fcCIH");

var $aQ7pU = parcelRequire("aQ7pU");

var $ljSph = parcelRequire("ljSph");

var $kjNSL = parcelRequire("kjNSL");

var $68iI4 = parcelRequire("68iI4");

var $57GTn = parcelRequire("57GTn");

var $1xUIS = parcelRequire("1xUIS");

var $b46ZL = parcelRequire("b46ZL");

var $5B9nk = parcelRequire("5B9nk");
parcelRequire("lJ9q5");
var $csJp9 = parcelRequire("csJp9");
parcelRequire("9dIFA");
var $2iPie = parcelRequire("2iPie");

var $b9KEh = parcelRequire("b9KEh");

var $613oU = parcelRequire("613oU");

var $azARG = parcelRequire("azARG");

var $k2M4v = parcelRequire("k2M4v");

var $fvRm5 = parcelRequire("fvRm5");

var $9Zxa0 = parcelRequire("9Zxa0");

var $hQjsl = parcelRequire("hQjsl");

var $dRkX9 = parcelRequire("dRkX9");

var $5a4EU = parcelRequire("5a4EU");

var $1JdzP = parcelRequire("1JdzP");

var $lgMZ2 = parcelRequire("lgMZ2");

var $d7r8x = parcelRequire("d7r8x");

var $7rEw1 = parcelRequire("7rEw1");

var $cf3fd = parcelRequire("cf3fd");

var $2eOU2 = parcelRequire("2eOU2");

var $4MjGQ = parcelRequire("4MjGQ");
var $aIVqJ = parcelRequire("aIVqJ");

var $bo2GC = parcelRequire("bo2GC");

var $j6GtF = parcelRequire("j6GtF");

var $k6bCh = parcelRequire("k6bCh");

var $diqlM = parcelRequire("diqlM");

var $6rayQ = parcelRequire("6rayQ");

var $esgVk = parcelRequire("esgVk");

var $g81wt = parcelRequire("g81wt");

var $g9ziK = parcelRequire("g9ziK");

var $faYOh = parcelRequire("faYOh");

var $htET6 = parcelRequire("htET6");

var $c6H8P = parcelRequire("c6H8P");

var $26cjK = parcelRequire("26cjK");

var $4N8Pa = parcelRequire("4N8Pa");

var $1xSlZ = parcelRequire("1xSlZ");

var $67A4I = parcelRequire("67A4I");
parcelRequire("aHtaW");
var $5tElB = parcelRequire("5tElB");

var $4TGvK = parcelRequire("4TGvK");

var $4biMY = parcelRequire("4biMY");
parcelRequire("drnAg");
var $92RVp = parcelRequire("92RVp");
class $7bd48a934ff29c0f$export$23aadacdae45e79 extends $fc4bM.Component {
    static #_ = this.DIRTY_CHECK_DEBOUNCE_MS = 100;
    componentWillUnmount() {
        this.isUnmounted = true;
    }
    componentDidMount() {
        const fieldConfigErrors = this.getInvalidConfigFieldErrors();
        if (!(0, $aYMdQ.isEmpty)(fieldConfigErrors)) this.setState((previousState)=>({
                errors: {
                    ...previousState.errors,
                    fieldErrors: fieldConfigErrors
                }
            }));
    }
    renderAnonymousRedirect() {
        const { complete: complete } = this.state;
        const { portalId: portalId, requestTypeId: requestTypeId } = this.props;
        return /*#__PURE__*/ $fc4bM.createElement((0, $g9ziK.PushRedirectWithState), {
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            to: `/portal/${portalId}/create/${requestTypeId}/confirm`,
            state: {
                email: complete === null || complete === void 0 ? void 0 : complete.email,
                issueKey: complete === null || complete === void 0 ? void 0 : complete.issueKey
            }
        });
    }
    render() {
        const { formData: formData, portalId: portalId, requestTypeId: requestTypeId, userAuthenticated: userAuthenticated, canAdministerJira: canAdministerJira, isEmbeddedRoute: isEmbeddedRoute, intl: intl, error: error, isPrefillPending: isPrefillPending } = this.props;
        const referrer = $6rayQ.get((0, $26cjK.REFERRER_QUERY_PARAM));
        const shouldAddReferrer = referrer && referrer !== 'undefined';
        // TODO: Move this into <Formik /> when upgraded to formik@1.x.x
        // See: https://github.com/jaredpalmer/formik#the-gist
        const { complete: complete } = this.state;
        if (!portalId || !requestTypeId) return null;
        // Show UFOHold when formData is not loaded yet (no error)
        if (!formData && !error) return /*#__PURE__*/ $fc4bM.createElement($7bd48a934ff29c0f$var$Root, null, /*#__PURE__*/ $fc4bM.createElement((0, $d7r8x.default), {
            name: "request-create-form-loading"
        }, /*#__PURE__*/ $fc4bM.createElement((0, $aUHFa.SkeletonLoadingWrapper), {
            isLoading: true
        })));
        // When jsm_portal_rovo_integration is on and there are URL params for pre-filling,
        // we delay rendering the form until the epic has resolved all field values.
        // This prevents Formik from initialising with empty values before pre-fill data arrives.
        // We only do this when pre-fill is actually being used to avoid impacting the normal flow.
        if ((0, $dRkX9.fg)('jsm_portal_rovo_integration') && isPrefillPending) return /*#__PURE__*/ $fc4bM.createElement($7bd48a934ff29c0f$var$Root, null, /*#__PURE__*/ $fc4bM.createElement((0, $aUHFa.SkeletonLoadingWrapper), {
            isLoading: true
        }));
        // If the submission is complete we will direct the user to the next page,
        // after checking if user is authenticated and
        // portal is rendered inside an embeddable route or not
        if (complete) {
            if (userAuthenticated) return isEmbeddedRoute ? /*#__PURE__*/ $fc4bM.createElement($7bd48a934ff29c0f$var$Root, null, /*#__PURE__*/ $fc4bM.createElement((0, $5tElB.default), {
                actionHrefTarget: "_blank",
                title: intl.formatMessage((0, $4TGvK.default).thanksTitle),
                description: intl.formatMessage((0, $4TGvK.default).referenceDescription),
                callToActionHref: `/portal/${portalId}/${complete.issueKey}${shouldAddReferrer ? `?${0, $26cjK.REFERRER_QUERY_PARAM}=${referrer}` : ''}`,
                callToActionText: intl.formatMessage((0, $4TGvK.default).callToAction)
            })) : /*#__PURE__*/ $fc4bM.createElement($7bd48a934ff29c0f$var$Root, null, /*#__PURE__*/ $fc4bM.createElement((0, $g9ziK.PushRedirect), {
                to: $6rayQ.addParamsToUrl(`/portal/${portalId}/${complete.issueKey}`, {
                    created: 'true',
                    ...shouldAddReferrer && {
                        [(0, $26cjK.REFERRER_QUERY_PARAM)]: referrer
                    }
                })
            }));
            return /*#__PURE__*/ $fc4bM.createElement($7bd48a934ff29c0f$var$Root, null, this.renderAnonymousRedirect());
        }
        if (formData) {
            const { initialFieldValues: initialFieldValues, proforma: proforma } = formData;
            if (proforma && proforma.formExists && !proforma.formValid) return /*#__PURE__*/ $fc4bM.createElement((0, $92RVp.default), {
                requestTypeId: requestTypeId,
                portalId: portalId,
                admin: canAdministerJira,
                formValidationResult: proforma.formValidationResult
            });
            return /*#__PURE__*/ $fc4bM.createElement($7bd48a934ff29c0f$var$Root, null, (this.hasRequiredFields() || this.hasRequiredFieldsInProformaForm()) && /*#__PURE__*/ $fc4bM.createElement((0, $fvRm5.FormHeader), null, /*#__PURE__*/ $fc4bM.createElement((0, $1JdzP.Flex), {
                justifyContent: "space-between"
            }, /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), null, intl.formatMessage((0, $4TGvK.default).instructionForMandatoryField), /*#__PURE__*/ $fc4bM.createElement((0, $9Zxa0.RequiredAsterisk), null)))), (0, $k2M4v.default).checkGate('render_create_request_field_with_loading_cursor') ? /*#__PURE__*/ $fc4bM.createElement((0, $5B9nk.DisableViewUntilMount), {
                name: 'request-create-form'
            }, /*#__PURE__*/ $fc4bM.createElement((0, $l6yt4.Formik), {
                initialValues: initialFieldValues,
                onSubmit: this.onSubmit
            }, this.renderForm)) : /*#__PURE__*/ $fc4bM.createElement((0, $l6yt4.Formik), {
                initialValues: initialFieldValues,
                onSubmit: this.onSubmit
            }, this.renderForm));
        }
        return null;
    }
    constructor(...args){
        super(...args), this.state = {
            errors: undefined,
            submitting: false,
            submitDisabled: false,
            submissionErrorCount: 0,
            isDirty: false,
            isFormExpanded: true,
            isAttachmentUploading: false,
            resolveForgeCustomFields: ()=>Promise.resolve((0, $67A4I.FORM_SUBMISSION_PROCEED)),
            failedOrTimedOutForgeCustomFields: [],
            forgeFormData: {}
        }, this.isUnmounted = false, this.formRef = /*#__PURE__*/ $fc4bM.createRef(), /** Correlation id generated per submit attempt (set at the start of onSubmit). */ this.formSubmissionId = undefined, this.proformaSerializationTraceAttributes = {}, /** Shared trace attributes derived from props, attached to every trace event. */ this.getProformaTraceBaseAttributes = ()=>({
                context_formSubmissionId: this.formSubmissionId,
                context_hasProformaForm: this.props.hasProformaForm,
                context_portalId: this.props.portalId,
                context_requestTypeId: this.props.requestTypeId,
                context_projectId: this.props.projectId
            }), this.validateProformaFormFields = ()=>{
            let isValid = true;
            const validateFnPresent = Boolean(this.validateProformaForm);
            this.validateProformaForm && this.validateProformaForm((isFormValid)=>{
                isValid = isFormValid;
            });
            this.proformaSerializationTraceAttributes = {
                ...this.proformaSerializationTraceAttributes,
                validateForm_validateFnPresent: validateFnPresent,
                validateForm_isProformaFormValid: isValid
            };
            return isValid;
        }, this.serializeProformaFormFields = ()=>{
            let serializedAnswer = undefined;
            let serializedAnswerCount = 0;
            let visibleFieldCount;
            const serializeFnPresent = Boolean(this.serializeProformaForm);
            this.serializeProformaForm && this.serializeProformaForm((serializedData)=>{
                serializedAnswer = serializedData;
                visibleFieldCount = serializedData === null || serializedData === void 0 ? void 0 : serializedData.visibleFieldCount;
                serializedAnswerCount = serializedData !== null && serializedData !== void 0 && serializedData.answers ? Object.keys(serializedData.answers).length : 0;
            });
            this.proformaSerializationTraceAttributes = {
                ...this.proformaSerializationTraceAttributes,
                serializeForm_serializedAnswerCount: serializedAnswerCount,
                serializeForm_visibleFieldCount: visibleFieldCount,
                serializeForm_serializeFnPresent: serializeFnPresent,
                serializeForm_serializedResultPresent: Boolean(serializedAnswer)
            };
            return serializedAnswer;
        }, this.checkIfFormIsDirty = (0, $aYMdQ.debounce)((values, initialValues, fields)=>{
            const copyValues = {
                ...values
            };
            const copyIntitalValues = {
                ...initialValues
            };
            const clearValues = (fieldId)=>{
                delete copyValues[fieldId];
                delete copyIntitalValues[fieldId];
            };
            // Organisation picker and rich text area is added to the values after page load so we need
            // to remove these for a deep equality check as it doesnt appear in the initialValues
            for (const f of fields){
                if (f.type === 'organisationpicker') {
                    delete copyValues[f.id];
                    delete copyIntitalValues[f.id];
                }
                if ((0, $hN5YJ.isRichTextAreaEnabled)() && f.type === 'textarea') {
                    // Note: This will not render a dirty form warning when users replace rich text area default values with content of the same length
                    // object property order is not guaranteed to be the same in the stringified ADF values when they update so we can't do a simple equality check.
                    // this is preferred to alternatives like performing a deepEquals on the ADF structure, or normalizing the stringified ADF before comparing them
                    // because this is on a performance sensitive rendering path, and will work as expected for the vast majority of cases
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    const value = copyValues[f.id] ?? '';
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    const initial = copyIntitalValues[f.id] ?? '';
                    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                    if (initial.length === value.length) clearValues(f.id);
                }
            }
            // Remove recaptcha value when checking form is dirty - we don't want it to come up if they want
            // to leave.
            delete copyValues['g-recaptcha-response'];
            const isDirty = !(0, $aYMdQ.isEqual)(copyIntitalValues, copyValues);
            // While this isn't explicitly tested, it will result in an infinite loop without it.
            // Don't remove!
            if (this.state.isDirty !== isDirty) this.setState({
                isDirty: isDirty
            });
        }, $7bd48a934ff29c0f$export$23aadacdae45e79.DIRTY_CHECK_DEBOUNCE_MS), this.onToggleFormExpanded = ()=>{
            this.setState((prevState)=>({
                    isFormExpanded: !prevState.isFormExpanded
                }));
        }, this.getFieldErrors = (formInput)=>{
            const emptyRequiredFieldErrors = this.getEmptyRequiredFieldErrors(formInput);
            // Insight/CMDB field errors
            const cmdbOverLimitFieldErrors = this.getInsightFieldLimitErrors(formInput);
            const cmdbInvalidConfigFieldErrors = this.getInvalidConfigFieldErrors();
            // Affected Service field errors
            const affectedServiceFieldLimitErrors = this.getAffectedServicesFieldLimitErrors(formInput);
            return {
                ...emptyRequiredFieldErrors,
                ...cmdbOverLimitFieldErrors,
                ...cmdbInvalidConfigFieldErrors,
                ...affectedServiceFieldLimitErrors
            };
        }, this.ifForgeFormValid = (forgeData)=>{
            const forgeDataKeys = Object.keys(forgeData);
            return forgeDataKeys.filter((keys)=>forgeData[keys].isValid).length === forgeDataKeys.length;
        }, this.getRovoAnalyticsAttributes = (formInput, searchParams)=>{
            var _this$props$formData;
            if (!(0, $dRkX9.fg)('jsm_portal_rovo_integration')) return {};
            const prefillOverrides = ((_this$props$formData = this.props.formData) === null || _this$props$formData === void 0 ? void 0 : _this$props$formData.urlParamFieldValueOverrides) ?? {};
            const prefillFieldIds = Object.keys(prefillOverrides);
            const prefillFieldCount = prefillFieldIds.length;
            const isPrefillTriggeredByRovo = searchParams.has('rovoChatTriggeringAction');
            const prefillModifiedByUser = prefillFieldIds.some((fieldId)=>{
                // If the field was not submitted (e.g. conditionally hidden), treat it as unmodified
                if (!(fieldId in formInput)) return false;
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                const prefillValue = prefillOverrides[fieldId];
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                const submittedValue = formInput[fieldId];
                return JSON.stringify(prefillValue) !== JSON.stringify(submittedValue);
            });
            return {
                isPrefillTriggeredByRovo: isPrefillTriggeredByRovo,
                prefillFieldCount: prefillFieldCount,
                prefillFieldIds: prefillFieldIds,
                prefillModifiedByUser: prefillModifiedByUser
            };
        }, this.hasRequiredFields = ()=>{
            var _formData$fields;
            const { formData: formData } = this.props;
            return !!(formData !== null && formData !== void 0 && (_formData$fields = formData.fields) !== null && _formData$fields !== void 0 && _formData$fields.find((f)=>f.displayed && f.required));
        }, this.hasRequiredFieldsInProformaForm = ()=>{
            var _design;
            const { formData: formData } = this.props;
            const proformaForm = formData === null || formData === void 0 ? void 0 : formData.proformaTemplateForm;
            const formQuestions = proformaForm === null || proformaForm === void 0 || (_design = proformaForm.design) === null || _design === void 0 ? void 0 : _design.questions;
            let hasRequiredFields = false;
            for(const questionKey in formQuestions){
                var _formQuestions$questi;
                if ((_formQuestions$questi = formQuestions[questionKey]) !== null && _formQuestions$questi !== void 0 && (_formQuestions$questi = _formQuestions$questi.validation) !== null && _formQuestions$questi !== void 0 && _formQuestions$questi.rq) {
                    hasRequiredFields = true;
                    break;
                }
            }
            return hasRequiredFields;
        }, this.getEmptyRequiredFieldErrors = (formInput)=>{
            var _formData$fields2;
            const { formData: formData, intl: intl } = this.props;
            const requiredFields = formData === null || formData === void 0 || (_formData$fields2 = formData.fields) === null || _formData$fields2 === void 0 ? void 0 : _formData$fields2.filter((f)=>f.displayed && f.required);
            const invalidFields = Object.keys(formInput).reduce((fields, fieldId)=>{
                const invalidField = requiredFields === null || requiredFields === void 0 ? void 0 : requiredFields.find((f)=>{
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    const value = formInput[fieldId];
                    // check if value of form field is an empty array, it is an invalid value for a required field.
                    if (Array.isArray(value)) return f.id === fieldId && value.length === 0;
                    return f.id === fieldId && !Boolean(value);
                });
                return invalidField ? fields.concat(invalidField) : fields;
            }, []);
            return invalidFields.reduce((errors, field)=>{
                const invalidField = invalidFields.find((f)=>f.id === field.id);
                if (invalidField) // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                errors[invalidField.id] = intl.formatMessage((0, $4TGvK.default).fieldValidationError, {
                    fieldLabel: (field === null || field === void 0 ? void 0 : field.label) ?? ''
                });
                return errors;
            }, {});
        }, this.getAffectedServicesFieldLimitErrors = (formInput)=>{
            var _formData$fields3;
            const { formData: formData, intl: { formatMessage: formatMessage } } = this.props;
            const hasExceededLimit = (field)=>{
                var _formInput$field$id;
                return field.type === 'multiservicepicker' && Boolean(field.displayed) && // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                ((_formInput$field$id = formInput[field.id]) === null || _formInput$field$id === void 0 ? void 0 : _formInput$field$id.length) > field.limit;
            };
            const limitExceededAffectedServiceFields = (formData === null || formData === void 0 || (_formData$fields3 = formData.fields) === null || _formData$fields3 === void 0 ? void 0 : _formData$fields3.filter(hasExceededLimit)) ?? [];
            return limitExceededAffectedServiceFields.reduce((total, current)=>({
                    ...total,
                    [current.id]: formatMessage((0, $4TGvK.default).affectedServicesFieldLimitError, {
                        serviceLimit: current.limit
                    })
                }), {});
        }, this.getInsightFieldLimitErrors = (formInput)=>{
            var _formData$fields4;
            const { formData: formData, intl: intl } = this.props;
            // Filter the field type to be Cmdb Object Picker
            // and whether the cmdb object picker has exceeded its limit
            const hasExceededLimit = (field)=>{
                var _formInput$field$id2;
                return field.type === 'cmdbobjectpicker' && Boolean(field.displayed) && // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                ((_formInput$field$id2 = formInput[field.id]) === null || _formInput$field$id2 === void 0 ? void 0 : _formInput$field$id2.length) > field.limit;
            };
            const limitExceededCmdbFields = (formData === null || formData === void 0 || (_formData$fields4 = formData.fields) === null || _formData$fields4 === void 0 ? void 0 : _formData$fields4.filter(hasExceededLimit)) ?? [];
            return limitExceededCmdbFields.reduce((errors, field)=>{
                errors[field.id] = intl.formatMessage((0, $4TGvK.default).fieldLimitExceededError, {
                    objectLimit: field.limit
                });
                return errors;
            }, {});
        }, this.getInvalidConfigFieldErrors = ()=>{
            var _formData$fields5;
            const { formData: formData, intl: intl } = this.props;
            // Filter the field type to be cmdb object picker
            // and whether the REQUIRED cmdb object picker has a valid configuration
            const hasInvalidFieldConfiguration = (field)=>{
                return field.type === 'cmdbobjectpicker' && Boolean(field.required) && Boolean(field.displayed) && !field.hasValidConfig;
            };
            const invalidCmdbFields = (formData === null || formData === void 0 || (_formData$fields5 = formData.fields) === null || _formData$fields5 === void 0 ? void 0 : _formData$fields5.filter(hasInvalidFieldConfiguration)) ?? [];
            return invalidCmdbFields.reduce((errors, field)=>{
                errors[field.id] = intl.formatMessage((0, $4TGvK.default).fieldInvalidConfigError);
                return errors;
            }, {});
        }, this.shareRequestWithMentionedUsers = (completeData, users, shareRequestAction, reporterId)=>{
            // add the share event for the addParticipants
            const usersWithoutReporter = users === null || users === void 0 ? void 0 : users.filter(([userId])=>userId !== reporterId);
            const idsOnly = (usersWithoutReporter === null || usersWithoutReporter === void 0 ? void 0 : usersWithoutReporter.map(([userId])=>userId)) || [];
            const usersLength = usersWithoutReporter === null || usersWithoutReporter === void 0 ? void 0 : usersWithoutReporter.length;
            const isSingleUser = usersLength === 1;
            const firstUser = (0, $aYMdQ.first)(usersWithoutReporter);
            const firstUserName = (0, $aYMdQ.last)(firstUser);
            if (usersLength) shareRequestAction(completeData.issueKey, [], [], idsOnly, true, isSingleUser ? firstUserName : undefined, true);
        }, this.getRichTextAnalytics = (formInput)=>{
            const { formData: formData } = this.props;
            const richTextFields = formData === null || formData === void 0 ? void 0 : formData.fields.filter((field)=>field.type === 'textarea' && field.rendererType === 'atlassian-wiki-renderer');
            const formFields = Object.keys(formInput);
            const filledFields = richTextFields === null || richTextFields === void 0 ? void 0 : richTextFields.filter((field)=>formFields.includes(field.id) && !!formInput[field.id]);
            return {
                shown: (richTextFields === null || richTextFields === void 0 ? void 0 : richTextFields.length) || 0,
                filled: (filledFields === null || filledFields === void 0 ? void 0 : filledFields.length) || 0
            };
        }, this.getEntitlementPickerAnalytics = (formInput)=>{
            var _this$props$formData2;
            const entitlementField = (_this$props$formData2 = this.props.formData) === null || _this$props$formData2 === void 0 ? void 0 : _this$props$formData2.fields.find((field)=>field.type === 'entitlementpicker');
            return {
                shown: !!entitlementField,
                filled: !!entitlementField && !!formInput[entitlementField === null || entitlementField === void 0 ? void 0 : entitlementField.id]
            };
        }, this.getUserMentions = (formInput)=>{
            var _this$props$formData3;
            const adfFields = (_this$props$formData3 = this.props.formData) === null || _this$props$formData3 === void 0 ? void 0 : _this$props$formData3.fields.filter((field)=>field.type === 'textarea' && field.rendererType === 'atlassian-wiki-renderer');
            try {
                const accountIds = adfFields === null || adfFields === void 0 ? void 0 : adfFields.reduce((accIds, field)=>{
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    const content = formInput[field.id];
                    if (!content) return accIds;
                    const adfFieldContent = (0, $2eOU2.parseAdf)(content);
                    const userIds = Array.from((0, $2eOU2.getAccountIdsFromComment)(adfFieldContent));
                    return accIds.concat(userIds);
                }, []);
                return accountIds;
            } catch  {
                return [];
            }
        }, this.onSubmit = async (formInput)=>{
            const { portalId: portalId, requestTypeId: requestTypeId, xsrfToken: xsrfToken, projectId: projectId, contactLink: contactLink, userAuthenticated: userAuthenticated, analyticsPayload: analyticsPayload, isProjectAdmin: isProjectAdmin, isProjectSimplified: isProjectSimplified, projectKey: projectKey, intl: intl, shareRequestAction: shareRequestAction, createAnalyticsEvent: createAnalyticsEvent, showSuccessFlagAction: showSuccessFlagAction, showWarningFlagAction: showWarningFlagAction } = this.props;
            this.formSubmissionId = (0, $4h23n.v4)();
            this.proformaSerializationTraceAttributes = {
                registerProformaForm_invoked: this.proformaSerializationTraceAttributes.registerProformaForm_invoked,
                renderForm_completed: this.proformaSerializationTraceAttributes.renderForm_completed
            };
            (0, $j6GtF.traceProformaSerialization)((0, $j6GtF.ProformaSerializationTraceStep).PreSubmit, {
                ...this.getProformaTraceBaseAttributes(),
                ...this.proformaSerializationTraceAttributes
            });
            this.setState({
                submitting: true
            });
            const resolveStatus = await this.resolveForgeCustomFields();
            if (resolveStatus === (0, $67A4I.FORM_SUBMISSION_RE_SUBMIT_AND_PROCEED)) {
                var _this$formRef;
                // Re-submitting the form this way to have function arguments updated with the latest values.
                (_this$formRef = this.formRef) === null || _this$formRef === void 0 || (_this$formRef = _this$formRef.current) === null || _this$formRef === void 0 || _this$formRef.requestSubmit();
                return;
            }
            const fieldErrors = this.getFieldErrors(formInput);
            const isFormValid = (0, $aYMdQ.isEmpty)(fieldErrors) && this.ifForgeFormValid(this.state.forgeFormData);
            const richTextAnalyticsPayload = (0, $hN5YJ.isRichTextAreaEnabled)() ? this.getRichTextAnalytics(formInput) : undefined;
            const entitlementPickerAnalyticsPayload = this.getEntitlementPickerAnalytics(formInput);
            const searchParams = new URLSearchParams((0, $esgVk.search)());
            const isProformaFormValid = this.validateProformaFormFields();
            if (!isFormValid) {
                this.setState((previousState)=>({
                        submitting: false,
                        errors: {
                            ...previousState.errors,
                            fieldErrors: fieldErrors
                        }
                    }));
                this.focusFirstErrorField(fieldErrors);
                return;
            }
            if (!isProformaFormValid) {
                this.setState({
                    submitting: false
                });
                this.focusElement('[data-testid="proforma-form"]', {
                    useSelector: true
                });
                return;
            }
            if (portalId && requestTypeId && xsrfToken && projectId) {
                this.setState({
                    submitting: true
                });
                try {
                    const connectRequestProperties = this.props.onSubmit && await this.props.onSubmit() || [];
                    const forgeRequestProperties = (0, $aYMdQ.map)(this.state.forgeFormData, (value, key)=>({
                            [key]: value
                        }));
                    const requestProperties = [
                        ...connectRequestProperties,
                        ...forgeRequestProperties
                    ];
                    let serializedRequestProperties;
                    try {
                        serializedRequestProperties = JSON.stringify(requestProperties.reduce((acc, data)=>({
                                ...acc,
                                ...(0, $aYMdQ.mapValues)(data, JSON.stringify)
                            }), {}));
                    } catch (error) {
                        (0, $aIVqJ.trackError)('Failed to serialize request properties.', {}, error);
                    }
                    const newFormInputs = {
                        ...formInput,
                        ...requestProperties.length && {
                            requestProperties: serializedRequestProperties
                        }
                    };
                    const serializedProformaFormData = this.serializeProformaFormFields();
                    const proformaFormDataForRequest = serializedProformaFormData ? {
                        answers: serializedProformaFormData.answers,
                        templateFormId: serializedProformaFormData.templateFormId
                    } : undefined;
                    // If a Proforma form is expected but the serialized output is empty, the form data
                    // is silently omitted from the outgoing request body. Include the parent-owned
                    // diagnostics only for this unexpected failure.
                    if (this.props.hasProformaForm && !serializedProformaFormData) (0, $j6GtF.traceProformaSerialization)((0, $j6GtF.ProformaSerializationTraceStep).PostSerialization, {
                        ...this.getProformaTraceBaseAttributes(),
                        ...this.proformaSerializationTraceAttributes
                    });
                    const { issue: issue, issueType: issueType, requestDetailsBaseUrl: requestDetailsBaseUrl, key: issueKey } = await (0, $aQ7pU.createRequest)(portalId, requestTypeId, projectId, xsrfToken, newFormInputs, proformaFormDataForRequest);
                    if ((0, $dRkX9.fg)('jsm_portal_rovo_integration') && searchParams.has('rovoChatTriggeringAction')) {
                        // Notify Rovo Chat about successful request creation
                        const portalRequestURL = `${window.location.origin}${requestDetailsBaseUrl}`;
                        (0, $1xSlZ.notifyRovoRequestCreated)(portalRequestURL, searchParams.get('rovoChatTriggeringAction') || '');
                    }
                    // Suppressing existing violation. Please fix this.
                    const completeData = {
                        issueKey: issueKey,
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                        email: userAuthenticated ? undefined : formInput.email
                    };
                    let analyticsMentions;
                    // we send the participants to request details page only when the user is logged in
                    if (userAuthenticated) {
                        const usersMentionedInDescription = this.getUserMentions(formInput);
                        this.shareRequestWithMentionedUsers(completeData, usersMentionedInDescription, shareRequestAction, formInput === null || formInput === void 0 ? void 0 : formInput.reporter);
                        analyticsMentions = {
                            mentionedUsersLength: usersMentionedInDescription === null || usersMentionedInDescription === void 0 ? void 0 : usersMentionedInDescription.length
                        };
                    }
                    this.props.notifySuccess();
                    if (showSuccessFlagAction) {
                        if (this.state.failedOrTimedOutForgeCustomFields.length > 0) showWarningFlagAction((0, $4TGvK.default).requestSubmittedFcfWarningTitle, (0, $4TGvK.default).requestSubmittedFcfWarningMessageDescription, undefined, undefined, {
                            field: this.state.failedOrTimedOutForgeCustomFields.join(', ')
                        });
                        else if (projectKey && issueKey && isProjectAdmin && !isProjectSimplified) showSuccessFlagAction((0, $4TGvK.default).requestSubmittedMessage, {}, (0, $4TGvK.default).requestSubmittedDescription, [
                            {
                                contentNode: /*#__PURE__*/ $fc4bM.createElement((0, $io4o2.Link), {
                                    // eslint-disable-next-line rulesdir/do-not-manually-build-jsm-agent-view-url
                                    href: `/jira/servicedesk/projects/${projectKey}/issue/${issueKey}`,
                                    target: "_blank",
                                    actionSubjectId: "viewWorkItemFromPortalSuccessPopup"
                                }, /*#__PURE__*/ $fc4bM.createElement((0, $lgMZ2.Inline), {
                                    space: "space.050",
                                    alignBlock: "center"
                                }, intl.formatMessage((0, $4TGvK.default).requestSubmittedAction), /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hQjsl))), {
                                    label: ''
                                })))
                            }
                        ]);
                        else showSuccessFlagAction((0, $4TGvK.default).requestSubmittedMessage);
                    }
                    if (createAnalyticsEvent) {
                        const rovoAnalyticsAttributes = this.getRovoAnalyticsAttributes(formInput, searchParams);
                        (0, $4MjGQ.trackIssueEventNext)({
                            projectId: projectId,
                            issueId: issue.id,
                            action: 'created',
                            attributes: {
                                ...rovoAnalyticsAttributes,
                                ...analyticsMentions,
                                requestTypeId: String(requestTypeId),
                                portalId: String(portalId),
                                issueTypeId: String(issueType),
                                richTextEditorShown: richTextAnalyticsPayload === null || richTextAnalyticsPayload === void 0 ? void 0 : richTextAnalyticsPayload.shown,
                                richTextEditorFilled: richTextAnalyticsPayload === null || richTextAnalyticsPayload === void 0 ? void 0 : richTextAnalyticsPayload.filled,
                                entitlementPickerShown: entitlementPickerAnalyticsPayload === null || entitlementPickerAnalyticsPayload === void 0 ? void 0 : entitlementPickerAnalyticsPayload.shown,
                                entitlementPickerFilled: entitlementPickerAnalyticsPayload === null || entitlementPickerAnalyticsPayload === void 0 ? void 0 : entitlementPickerAnalyticsPayload.filled,
                                createdWithinEmbedWindow: this.props.isEmbeddedRoute,
                                requestFormSource: searchParams.get('source') ?? '',
                                hasProformaForm: this.props.hasProformaForm
                            }
                        }, analyticsPayload.user, createAnalyticsEvent, analyticsPayload.portal);
                    }
                    this.setState({
                        complete: completeData
                    });
                } catch (errors) {
                    const { submissionError: submissionError, traceId: traceId, fieldErrors: fieldErrorsReceived } = errors;
                    const shouldNotifyFAMAFailure = submissionError === null || submissionError === void 0 ? void 0 : submissionError.isGeneric;
                    if (shouldNotifyFAMAFailure) {
                        if (submissionError !== null && submissionError !== void 0 && submissionError.statusCode) this.props.notifyFailure(`Failed to submit form (${String(submissionError.statusCode).charAt(0)}xx error): ${JSON.stringify({
                            submissionError: submissionError,
                            fieldErrors: fieldErrorsReceived
                        })}`, traceId);
                        else this.props.notifyFailure(`Unknown Exception: Failed to submit form (5xx error): ${JSON.stringify({
                            submissionError: submissionError,
                            fieldErrors: fieldErrorsReceived
                        })}`, traceId);
                    } else (0, $4MjGQ.trackRequestCreateNonGenericErrors)(errors, createAnalyticsEvent);
                    if (!this.isUnmounted) // We use this count as a unique key to make sure the error message autofocuses on every error
                    this.setState((previousState)=>({
                            submissionErrorCount: submissionError ? previousState.submissionErrorCount + 1 : previousState.submissionErrorCount,
                            // Suppressing existing violation. Please fix this.
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                            errors: {
                                ...errors,
                                contactLink: contactLink
                            },
                            submitting: false,
                            isFormExpanded: true
                        }));
                }
                this.props.onSubmitComplete && this.props.onSubmitComplete();
            }
        }, this.disableSubmitButton = ()=>{
            this.setState({
                submitDisabled: true
            });
        }, this.preloadRequestDetails = ()=>{
            // this check is added to fix the chunk load issue in fedramp environment for preloaded script
            if ((0, $7rEw1.isFedRamp) && (0, $7rEw1.isFedRamp)()) return;
            (0, $b9KEh.default).preload();
        }, this.enableSubmitButton = ()=>{
            this.setState({
                submitDisabled: false
            });
        }, this.blockFormSubmission = (blocking)=>{
            this.setState({
                isAttachmentUploading: blocking
            });
        }, this.registerProformaForm = (validateProformaForm, serializeProformaForm)=>{
            this.validateProformaForm = validateProformaForm;
            this.serializeProformaForm = serializeProformaForm;
            this.proformaSerializationTraceAttributes = {
                ...this.proformaSerializationTraceAttributes,
                registerProformaForm_invoked: true
            };
        }, this.onProformaFormRendered = ()=>{
            this.proformaSerializationTraceAttributes = {
                ...this.proformaSerializationTraceAttributes,
                renderForm_completed: true
            };
        }, this.setResolveForgeCustomFields = (fn)=>{
            this.setState({
                resolveForgeCustomFields: fn
            });
        }, this.setFailedOrTimedOutForgeCustomFields = (fields)=>{
            this.setState({
                failedOrTimedOutForgeCustomFields: fields
            });
        }, this.resolveForgeCustomFields = async ()=>{
            return this.state.resolveForgeCustomFields();
        }, /**
   * Focuses an element by ID or selector, with automatic retry logic.
   * Uses the form ref to scope queries (more React-idiomatic than document queries).
   * Uses requestAnimationFrame to sync with browser paint cycles instead of arbitrary timeouts.
   */ this.focusElement = (identifier, options = {})=>{
            const { useSelector: useSelector = false, retries: retries = 2, scrollBehavior: scrollBehavior = 'smooth', scrollBlock: scrollBlock = 'center' } = options;
            const focusAndScroll = (element)=>{
                element.focus();
                element.scrollIntoView({
                    behavior: scrollBehavior,
                    block: scrollBlock
                });
            };
            const attemptFocus = (retriesLeft)=>{
                let element = null;
                // Try to find element within the form first (scoped to our component)
                if (this.formRef.current) element = useSelector ? this.formRef.current.querySelector(identifier) : this.formRef.current.querySelector(`#${identifier}`);
                if (element) {
                    focusAndScroll(element);
                    return;
                }
                // Retry if element not yet in DOM (for slow renders)
                if (retriesLeft > 0) requestAnimationFrame(()=>attemptFocus(retriesLeft - 1));
            };
            // Use requestAnimationFrame to wait for next paint cycle
            requestAnimationFrame(()=>attemptFocus(retries));
        }, this.focusFirstErrorField = (fieldErrors)=>{
            var _Object$keys;
            const firstErrorFieldId = (_Object$keys = Object.keys(fieldErrors)) === null || _Object$keys === void 0 ? void 0 : _Object$keys[0];
            if (!firstErrorFieldId) return;
            this.focusElement(firstErrorFieldId);
        }, this.renderForm = ({ values: values, initialValues: initialValues, setFieldValue: setFieldValue, handleSubmit: handleSubmit })=>{
            const { formData: formData, onFieldChangedByUser: onFieldChangedByUser, accountId: accountId, portalId: portalId, requestTypeId: requestTypeId, projectId: projectId, canCreateUsers: canCreateUsers, dateFormat: dateFormat, dateTimeFormat: dateTimeFormat, firstDay: firstDay, useISO8601WeekNumbers: useISO8601WeekNumbers, isDirtyCheckDisabled: isDirtyCheckDisabled, hasProformaForm: hasProformaForm, proformaFormIsDirty: proformaFormIsDirty, intl: intl, locale: locale } = this.props;
            // TODO: Move this into <Formik /> when upgraded to formik@1.x.x
            // See: https://github.com/jaredpalmer/formik#the-gist
            const { errors: errors, submitting: submitting, submitDisabled: submitDisabled, submissionErrorCount: submissionErrorCount, isAttachmentUploading: isAttachmentUploading } = this.state;
            if (!portalId || !requestTypeId || !formData) return null;
            const { fields: fields, form: form, knowledgeBase: knowledgeBase } = formData;
            if (!form) return null;
            if (fields !== undefined) this.checkIfFormIsDirty(values, initialValues, fields);
            // We use any for value here to maintain consistency with the type signature for setFieldValue
            const onFieldChange = (field, value, notFromUserInteraction, additionalFieldData)=>{
                if (!notFromUserInteraction) {
                    (0, $4MjGQ.firstInteraction)({
                        actionSubject: (0, $4MjGQ.AnalyticsActionSubjects).FORM,
                        source: 'portalScreen',
                        isNewPortal: true
                    });
                    // on user interaction, clear Forge UIM field override
                    onFieldChangedByUser === null || onFieldChangedByUser === void 0 || onFieldChangedByUser({
                        field: field,
                        notFromUserInteraction: notFromUserInteraction,
                        additionalFieldData: additionalFieldData,
                        value: value
                    });
                }
                return setFieldValue(field, value);
            };
            const onCancel = ()=>{
                const cancelPath = (0, $cf3fd.getIsHelpHub)() ? `/portal/${portalId}` : `/portal/${portalId}/group/-1`;
                if ((0, $cf3fd.getIsHelpHub)() && (0, $4N8Pa.canNavigateBackFromRequestCreate)()) {
                    (0, $diqlM.default).goBack();
                    return;
                }
                (0, $diqlM.default).push(cancelPath);
            };
            const updateForgeRequestPropertyData = (payload)=>{
                this.setState((prevState)=>({
                        forgeFormData: {
                            ...prevState.forgeFormData,
                            [payload.extensionId]: payload.data
                        }
                    }));
            };
            const preventNavigation = (this.state.isDirty || proformaFormIsDirty) && !isDirtyCheckDisabled;
            return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, (0, $hN5YJ.isUiModificationsSupportEnabled)() && /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement((0, $htET6.UiModificationsSectionsMessages), null), /*#__PURE__*/ $fc4bM.createElement((0, $faYOh.UiModificationsFormValuesApplier), {
                fieldValues: values,
                setFieldValue: setFieldValue,
                fields: fields
            })), /*#__PURE__*/ $fc4bM.createElement((0, $2iPie.ForgeCustomFieldsResolver), {
                setResolve: this.setResolveForgeCustomFields,
                setFailedOrTimedOut: this.setFailedOrTimedOutForgeCustomFields,
                requestTypeId: requestTypeId,
                fields: fields
            }), /*#__PURE__*/ $fc4bM.createElement((0, $4biMY.default), {
                accountId: accountId,
                canCreateUsers: canCreateUsers,
                projectId: projectId,
                portalId: portalId,
                requestTypeId: requestTypeId,
                knowledgeBase: knowledgeBase,
                fields: fields,
                fieldValues: values,
                urlParamFieldValueOverrides: formData.urlParamFieldValueOverrides,
                onFieldChange: onFieldChange,
                onFieldBlurredByUser: this.props.onFieldBlurredByUser,
                onCancel: onCancel,
                onSubmit: handleSubmit,
                errors: errors,
                submissionErrorCount: submissionErrorCount,
                submitting: submitting,
                submitDisabled: submitDisabled,
                captchaEnabled: form.captchaEnabled,
                sitekey: form.sitekey,
                enableSubmitButton: this.enableSubmitButton,
                disableSubmitButton: this.disableSubmitButton,
                onHoverSubmitButton: this.preloadRequestDetails,
                onToggleFormExpanded: this.onToggleFormExpanded,
                isFormExpanded: this.state.isFormExpanded,
                dateFormat: dateFormat,
                dateTimeFormat: dateTimeFormat,
                firstDay: firstDay,
                useISO8601WeekNumbers: useISO8601WeekNumbers,
                isAttachmentUploading: isAttachmentUploading,
                blockFormSubmission: this.blockFormSubmission,
                registerProformaForm: hasProformaForm ? this.registerProformaForm : undefined,
                onProformaFormRendered: this.onProformaFormRendered,
                locale: locale ? locale : intl.locale,
                updateForgeRequestPropertyData: updateForgeRequestPropertyData,
                formRef: this.formRef,
                proformaField: this.props.proformaField
            }), /*#__PURE__*/ $fc4bM.createElement((0, $9VJCP.default), {
                preventNavigation: preventNavigation
            }));
        };
    }
}
const $7bd48a934ff29c0f$var$selector = (0, $2n2bS.createSelector)((state, props)=>{
    const accountId = (0, $b46ZL.getAccountId)(state);
    const portalId = (0, $g81wt.toNumber)(props.portalId);
    const requestTypeId = (0, $g81wt.toNumber)(props.requestTypeId);
    const xsrfToken = (0, $68iI4.getXsrfToken)(state);
    const contactLink = (0, $68iI4.getContactLink)(state);
    const userAuthenticated = (0, $b46ZL.isLoggedIn)(state);
    const canAdministerJira = (0, $b46ZL.getCanAdministerJIRA)(state);
    const locale = (0, $b46ZL.getLocale)(state).trim();
    let formData;
    let projectId;
    let dateFormat;
    let dateTimeFormat;
    let canCreateUsers = false;
    let firstDay;
    let useISO8601WeekNumbers;
    let hasProformaForm;
    let proformaFormIsDirty = false;
    let error = false;
    let projectKey;
    let isProjectAdmin = false;
    let isProjectSimplified;
    let isPrefillPending = false;
    if (portalId && requestTypeId) {
        const requestData = (0, $1xUIS.getRequestCreateOrError)(state, portalId, requestTypeId);
        formData = requestData && 'error' in requestData ? undefined : requestData;
        error = !!(requestData && 'error' in requestData) ? true : false;
        canCreateUsers = (0, $1xUIS.getCanCreateUsers)(state, portalId, requestTypeId);
        dateFormat = (0, $1xUIS.getDateFormat)(state, portalId, requestTypeId);
        dateTimeFormat = (0, $1xUIS.getDateTimeFormat)(state, portalId, requestTypeId);
        firstDay = (0, $1xUIS.getFirstDay)(state, portalId, requestTypeId);
        useISO8601WeekNumbers = (0, $1xUIS.getUseISO8601WeekNumbers)(state, portalId, requestTypeId);
        projectId = (0, $g81wt.toString)((0, $1xUIS.getProjectId)(state, portalId, requestTypeId));
        hasProformaForm = (0, $1xUIS.getRequestTypeHasProformaForm)(state, portalId, requestTypeId);
        proformaFormIsDirty = (0, $1xUIS.getIsProformaFormDirty)(state, portalId, requestTypeId);
        if ((0, $dRkX9.fg)('jsm_portal_rovo_integration')) isPrefillPending = (0, $1xUIS.getIsPrefillPending)(state, portalId, requestTypeId);
        projectKey = (0, $57GTn.getProjectKey)(state, portalId);
        isProjectSimplified = (0, $57GTn.getIsProjectSimplified)(state, portalId);
        isProjectAdmin = (0, $57GTn.getCanAdministerProject)(state, portalId) ?? false;
    }
    const analyticsPayload = (0, $bo2GC.getIssueAnalyticsContext)(state, portalId);
    return {
        accountId: accountId,
        portalId: portalId,
        requestTypeId: requestTypeId,
        formData: formData,
        xsrfToken: xsrfToken,
        projectId: projectId,
        contactLink: contactLink,
        canCreateUsers: canCreateUsers,
        dateFormat: dateFormat,
        dateTimeFormat: dateTimeFormat,
        firstDay: firstDay,
        useISO8601WeekNumbers: useISO8601WeekNumbers,
        userAuthenticated: userAuthenticated,
        analyticsPayload: analyticsPayload,
        hasProformaForm: hasProformaForm,
        proformaFormIsDirty: proformaFormIsDirty,
        canAdministerJira: canAdministerJira,
        locale: locale,
        error: error,
        projectKey: projectKey,
        isProjectSimplified: isProjectSimplified,
        isProjectAdmin: isProjectAdmin,
        isPrefillPending: isPrefillPending
    };
}, (requestFormData)=>requestFormData);
const $7bd48a934ff29c0f$var$RequestCreateFormWithAnalyticsNextOld = (0, $9XZeF.connect)($7bd48a934ff29c0f$var$selector, {
    fetchRequestCreate: (0, $ljSph.fetchRequestCreateAction),
    shareRequestAction: (0, $kjNSL.shareRequest),
    showSuccessFlagAction: (0, $5kfOu.showSuccessFlag),
    showWarningFlagAction: (0, $5kfOu.showWarningFlag)
})((0, $613oU.default)({
    source: 'portalScreen'
})((0, $azARG.default)()((0, $csJp9.default)((0, $fcCIH.default)($7bd48a934ff29c0f$export$23aadacdae45e79)))));
const $7bd48a934ff29c0f$var$RequestCreateFormWithAnalyticsNextNew = (0, $9XZeF.connect)($7bd48a934ff29c0f$var$selector, {
    fetchRequestCreate: (0, $ljSph.fetchRequestCreateAction),
    shareRequestAction: (0, $kjNSL.shareRequest),
    showSuccessFlagAction: (0, $5kfOu.showSuccessFlag),
    showWarningFlagAction: (0, $5kfOu.showWarningFlag)
})((0, $613oU.default)({
    source: 'portalScreen'
})((0, $azARG.default)()((0, $csJp9.default)((0, $fcCIH.default)((0, $c6H8P.withUiModificationsFormDecorator)()($7bd48a934ff29c0f$export$23aadacdae45e79))))));
var $7bd48a934ff29c0f$export$2e2bcd8739ae039 = (0, $k6bCh.componentWithCondition)((0, $hN5YJ.isUiModificationsSupportEnabled), $7bd48a934ff29c0f$var$RequestCreateFormWithAnalyticsNextNew, $7bd48a934ff29c0f$var$RequestCreateFormWithAnalyticsNextOld);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $7bd48a934ff29c0f$var$Root = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-bucp0v-0"
})`position:relative;min-height:${$fOCtI.multiple(50).px};`;

});
parcelRegister("aQ7pU", function(module, exports) {
$parcel$export(module.exports, "createRequest", () => $05ea911a2ec8a9d5$export$72e3afa9ac8966be);

var $bTjsX = parcelRequire("bTjsX");

var $aYMdQ = parcelRequire("aYMdQ");

var $17nJI = parcelRequire("17nJI");

var $diqlM = parcelRequire("diqlM");
const $05ea911a2ec8a9d5$export$72e3afa9ac8966be = (portalId, requestId, projectId, xsrfToken, formInput, proformaFormInput)=>{
    const url = `${(0, $diqlM.contextPath)}${(0, $diqlM.getRelativeBasePath)()}/portal/${portalId}/create/${requestId}`;
    const body = $05ea911a2ec8a9d5$var$serializeFormInput(formInput, projectId, xsrfToken, proformaFormInput);
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded;'
    };
    return (0, $bTjsX.post)(url, body, headers).map(({ response: response })=>response).toPromise().catch((err)=>$05ea911a2ec8a9d5$var$handleSubmissionErrors(err));
};
/** Turns a potentially undefined or null input and outputs a string */ const $05ea911a2ec8a9d5$var$handleUndefinedInput = (input)=>!(0, $aYMdQ.isNil)(input) ? input : '';
const $05ea911a2ec8a9d5$export$36be7bd82d456d61 = (fieldId, fieldValue)=>{
    let result = [];
    // If fieldValue is undefined or null it'll be sent as an empty string
    const value = $05ea911a2ec8a9d5$var$handleUndefinedInput(fieldValue);
    // If the value is an array we want to handle it, each value of the array will be added as a separate entry
    // all with the same field id
    if (Array.isArray(value)) {
        if (fieldId === 'attachment') value.forEach((val)=>{
            result.push({
                name: 'filetoconvert',
                value: val.id
            });
        });
        else value.forEach((val)=>{
            result.push({
                name: fieldId,
                value: $05ea911a2ec8a9d5$var$handleUndefinedInput(val)
            });
        });
        return result;
    }
    if ((0, $aYMdQ.has)(value, 'children')) {
        // For nested fields like cascading select, we add both the value of the primary select as well
        // as the value of any nested children. The field id of child field is the field id of the primary field
        // appended with ':1'
        const { primaryValue: primaryValue, children: children } = value;
        result.push({
            name: fieldId,
            value: $05ea911a2ec8a9d5$var$handleUndefinedInput(primaryValue)
        });
        result = result.concat($05ea911a2ec8a9d5$export$36be7bd82d456d61(`${fieldId}:1`, children));
        return result;
    }
    // If the field is neither an object nor an array we will serialise the value into a string, undefined and null
    // values will be sent too as empty strings
    result.push({
        value: value,
        name: fieldId
    });
    return result;
};
// Some fields require mulitple values for the same key - which can't be handled by a plain JS object.
// here fieldValues is an array with the shape [ { fieldId: fieldValue } ], which gets transformed into a x-www-form-urlencoded string.
function $05ea911a2ec8a9d5$var$serializeFormInput(formInput, projectId, xsrfToken, proformaFormInput) {
    const fieldValues = Object.keys(formInput).reduce((result, fieldId)=>result.concat($05ea911a2ec8a9d5$export$36be7bd82d456d61(fieldId, formInput[fieldId])), []);
    fieldValues.push({
        name: 'atl_token',
        value: xsrfToken
    });
    fieldValues.push({
        name: 'projectId',
        value: projectId
    });
    const formUrlEncoded = fieldValues.map(({ name: name, value: value })=>{
        return `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
    }).join('&');
    // Append proforma form fields JSON if there is a proforma form in this request type.
    if (proformaFormInput) return `${formUrlEncoded}&proformaFormData=${encodeURIComponent(JSON.stringify(proformaFormInput))}`;
    return formUrlEncoded;
}
function $05ea911a2ec8a9d5$var$handleSubmissionErrors({ response: response, xhr: xhr, ...err }) {
    const DEFAULT_ERROR_MESSAGES = [];
    const errorMessages = (0, $aYMdQ.get)(response, 'errors', DEFAULT_ERROR_MESSAGES);
    const errorReasonKey = (0, $aYMdQ.get)(response, 'reasonKey', undefined);
    const RATE_LIMITING_STATUS_CODE = 429;
    const fieldErrorsList = errorMessages.filter((error)=>!!error.field);
    const submissionErrors = errorMessages.filter((error)=>!error.field);
    const hasFieldErrors = fieldErrorsList.length > 0;
    const hasSubmissionError = submissionErrors.length > 0;
    const fieldErrors = hasFieldErrors ? fieldErrorsList.reduce((allErrors, error)=>{
        allErrors[error.field] = error.errorMessage;
        return allErrors;
    }, {}) : {};
    const traceId = xhr.getResponseHeader('Atl-Traceid');
    if (hasSubmissionError) // oxlint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({
        fieldErrors: fieldErrors,
        errorReasonKey: errorReasonKey,
        traceId: traceId,
        submissionError: submissionErrors[0]
    });
    if (hasFieldErrors) // Suppressing existing violation. Please fix this.
    // oxlint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({
        fieldErrors: fieldErrors,
        errorReasonKey: errorReasonKey,
        traceId: traceId,
        submissionError: undefined
    });
    if (err.status === 0) // oxlint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({
        fieldErrors: fieldErrors,
        traceId: traceId,
        submissionError: {
            isOfflineError: true
        }
    });
    /* Any errors between Status code 400 and 499 are considered client errors. */ const isClientError = (0, $17nJI.isClientErrorCode)(err.status);
    const isThrottled = err.status === RATE_LIMITING_STATUS_CODE;
    /* If the traceId is null, that means that the request never reached Atlassian network.
     So, we will not log it as an error since its not from our systems. */ const hasEmptyTraceId = traceId === null;
    const isGeneric = !(isThrottled || isClientError || hasEmptyTraceId);
    const submissionError = {
        isGeneric: isGeneric,
        statusCode: err.status
    };
    // oxlint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({
        fieldErrors: fieldErrors,
        submissionError: submissionError,
        traceId: traceId
    });
}

});

parcelRegister("lJ9q5", function(module, exports) {
$parcel$export(module.exports, "ConnectFields", () => $503d5df9e4248cdc$export$724cef702e79a3fb);
$parcel$export(module.exports, "withConnectFieldSupport", () => (parcelRequire("csJp9")).default);

var $9XZeF = parcelRequire("9XZeF");

var $2n2bS = parcelRequire("2n2bS");

var $lgOtA = parcelRequire("lgOtA");

var $1Qg1o = parcelRequire("1Qg1o");

var $613oU = parcelRequire("613oU");

var $azARG = parcelRequire("azARG");

var $aYdrn = parcelRequire("aYdrn");
parcelRequire("lw5Kx");
var $fXGKd = parcelRequire("fXGKd");
parcelRequire("73edv");
var $csJp9 = parcelRequire("csJp9");
const $503d5df9e4248cdc$export$aea217a45095ce11 = (0, $2n2bS.createSelector)((state, props)=>(0, $1Qg1o.getConnectAddonPanels)({
        state: state,
        pageName: 'CREATE_REQUEST',
        location: 'propertyPanels',
        portalId: props.portalId,
        requestTypeId: props.requestTypeId
    }), (connectFragments)=>({
        connectFragments: connectFragments
    }));
const $503d5df9e4248cdc$export$724cef702e79a3fb = (0, $613oU.default)({
    componentName: 'ConnectFields'
})((0, $azARG.default)({})((0, $9XZeF.connect)($503d5df9e4248cdc$export$aea217a45095ce11, {
    fetchConnectFragments: (0, $lgOtA.fetchConnectFragmentsAction)
})((0, $fXGKd.asConnectFields)((0, $aYdrn.default)))));

});
parcelRegister("aYdrn", function(module, exports) {
$parcel$export(module.exports, "default", () => $db4758108e108364$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $eENmG = parcelRequire("eENmG");

var $4MjGQ = parcelRequire("4MjGQ");

var $eFuYD = parcelRequire("eFuYD");
parcelRequire("jyJYa");
var $fw2zx = parcelRequire("fw2zx");
class $db4758108e108364$var$ConnectFields extends $fc4bM.PureComponent {
    componentDidMount() {
        const { fetchConnectFragments: fetchConnectFragments, connectFragments: connectFragments, requestTypeId: requestTypeId, portalId: portalId } = this.props;
        if (!connectFragments) {
            fetchConnectFragments({
                portalId: portalId,
                requestTypeId: requestTypeId,
                portalPage: 'CREATE_REQUEST'
            });
            this.fireConnectFragmentsDataFetchAnalytics();
        } else this.fireConnectFragmentAnalytics();
        this.props.onConnectFieldMount(this);
    }
    componentDidUpdate(prevProps) {
        const { fetchConnectFragments: fetchConnectFragments, connectFragments: connectFragments, requestTypeId: requestTypeId, portalId: portalId } = this.props;
        const requestTypeUpdated = prevProps.requestTypeId !== requestTypeId || prevProps.portalId !== portalId;
        if (requestTypeUpdated) fetchConnectFragments({
            portalId: portalId,
            requestTypeId: requestTypeId,
            portalPage: 'CREATE_REQUEST'
        });
        if (!prevProps.connectFragments && connectFragments) this.fireConnectFragmentAnalytics();
        else if (prevProps.connectFragments && connectFragments) {
            const previouslyErrored = 'error' in prevProps.connectFragments;
            const currentlyErrored = 'error' in connectFragments;
            if (previouslyErrored !== currentlyErrored) this.fireConnectFragmentAnalytics();
        }
    }
    render() {
        const { connectFragments: connectFragments, className: className, location: location } = this.props;
        if (!!connectFragments && !('error' in connectFragments) && connectFragments.length) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        /*#__PURE__*/ $fc4bM.createElement($db4758108e108364$var$Root, {
            className: className
        }, connectFragments.map((fragment)=>/*#__PURE__*/ $fc4bM.createElement((0, $fw2zx.default), {
                ref: this.onRef,
                key: fragment.key,
                connectKey: fragment.key,
                fragmentHtml: fragment.html,
                location: location
            }))));
        return null;
    }
    constructor(...args){
        super(...args), this.connectFieldRefs = [], this.fireConnectFragmentsDataFetchAnalytics = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent, location: location } = this.props;
            if (createAnalyticsEvent) {
                const analyticsEvent = createAnalyticsEvent({
                    location: location,
                    analyticsType: (0, $eENmG.OPERATIONAL_EVENT_TYPE),
                    action: 'data_fetched'
                });
                // Hack to override the componentName set in ./index.tsx. We do this to offer consistent naming across all Connect fragment operational events
                analyticsEvent.context.push({
                    componentName: 'ConnectFragment'
                });
                analyticsEvent.fire();
            }
        }, this.fireConnectFragmentAnalytics = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent, connectFragments: connectFragments, location: location, portalId: portalId, requestTypeId: requestTypeId } = this.props;
            if (!createAnalyticsEvent || !connectFragments) return;
            const isError = 'error' in connectFragments;
            if (!isError && connectFragments.length === 0) return;
            const uniqueAppKeys = !isError ? (0, $eFuYD.getUniqueAppKeysFromConnectFragments)(connectFragments) : [];
            const analyticsEvent = createAnalyticsEvent({
                portalId: portalId,
                requestTypeId: requestTypeId,
                location: location,
                analyticsType: (0, $eENmG.OPERATIONAL_EVENT_TYPE),
                action: isError ? 'failed' : 'loaded',
                appKeys: uniqueAppKeys
            });
            // Hack to override the componentName set in ./index.tsx. We do this to offer consistent naming across all Connect fragment operational events
            analyticsEvent.context.push({
                componentName: 'ConnectFragment'
            });
            analyticsEvent.fire();
        }, this.onRef = (el)=>{
            el && this.connectFieldRefs.push(el);
        }, this.validate = (requestTypeId)=>{
            return Promise.all(this.connectFieldRefs.map((ref)=>ref.validate())).then((validateResults)=>{
                this.sendConnectTimeoutEventForTimedOutResults((0, $4MjGQ.ConnectRequestCreateEventType).VALIDATE, validateResults, requestTypeId);
                return validateResults.map((result)=>{
                    return {
                        connectKey: result.connectKey,
                        valid: Boolean(result.data),
                        timedOut: result.timedOut
                    };
                });
            });
        }, this.serialize = (validatedConnectFields, requestTypeId)=>{
            const serializeValidatedRefs = this.connectFieldRefs.filter((ref)=>validatedConnectFields.includes(ref.props.connectKey)).map((ref)=>ref.serialize());
            return Promise.all(serializeValidatedRefs).then((allData)=>{
                this.sendConnectTimeoutEventForTimedOutResults((0, $4MjGQ.ConnectRequestCreateEventType).SERIALIZE, allData, requestTypeId);
                // This used to return stringified serialized data, but now we are returning the data in array form
                // which is then used in src/view/request-create-form/request-create-form.tsx to and allows us to
                // add additional data from Forge apps.
                return allData.filter((result)=>result && !result.timedOut).map((result)=>result.data);
            });
        }, this.sendConnectTimeoutEventForTimedOutResults = (eventType, results, requestTypeId)=>{
            results.forEach((result)=>result.timedOut && (0, $4MjGQ.sendConnectTimeoutEventForRequestCreation)(eventType, result.connectKey, requestTypeId));
        };
    }
}
var $db4758108e108364$export$2e2bcd8739ae039 = $db4758108e108364$var$ConnectFields;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $db4758108e108364$var$Root = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-h6iqb8-0"
})`margin-top:${"var(--ds-space-400, 32px)"};`;

});
parcelRegister("jyJYa", function(module, exports) {
$parcel$export(module.exports, "ConnectField", () => (parcelRequire("fw2zx")).default);

var $fw2zx = parcelRequire("fw2zx");

});
parcelRegister("fw2zx", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0abe91869826530$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $8qhwO = parcelRequire("8qhwO");

var $jFk35 = parcelRequire("jFk35");
var $aSveF = parcelRequire("aSveF");

var $eFuYD = parcelRequire("eFuYD");
class $a0abe91869826530$var$ConnectFieldDumb extends $fc4bM.PureComponent {
    validate() {
        if (this.validateSubject) this.validateSubject.unsubscribe();
        this.validateSubject = new (0, $aSveF.Subject)();
        (0, $eFuYD.validate)(this.props.connectKey);
        return this.validateSubject.race(this.timeOutHandler()).first().toPromise();
    }
    serialize() {
        if (this.serializeSubject) this.serializeSubject.unsubscribe();
        this.serializeSubject = new (0, $aSveF.Subject)();
        (0, $eFuYD.serialize)(this.props.connectKey);
        return this.serializeSubject.race(this.timeOutHandler()).first().toPromise();
    }
    componentDidMount() {
        (0, $eFuYD.register)(this.props.connectKey, this.onSerialized, this.onValidated);
    }
    componentWillUnmount() {
        (0, $eFuYD.unregister)(this.props.connectKey);
    }
    render() {
        const { fragmentHtml: fragmentHtml, location: location, connectKey: connectKey } = this.props;
        return /*#__PURE__*/ $fc4bM.createElement((0, $8qhwO.ConnectFragmentDumb), {
            fragmentHtml: fragmentHtml,
            location: location,
            fullKey: connectKey
        });
    }
    constructor(...args){
        super(...args), this.onValidated = (isValid)=>{
            this.validateSubject && this.validateSubject.next(this.connectFieldResult(isValid, false));
        }, this.onSerialized = (data)=>{
            this.serializeSubject && this.serializeSubject.next(this.connectFieldResult(data, false));
        }, this.connectFieldResult = (data, timedOut = false)=>({
                data: data,
                timedOut: timedOut,
                connectKey: this.props.connectKey
            }), this.timeOutHandler = ()=>{
            const emitWhenTimeOut = (0, $jFk35.Observable).of(this.connectFieldResult(undefined, true));
            return (0, $jFk35.Observable).never().timeoutWith(1000, emitWhenTimeOut);
        };
    }
}
var $a0abe91869826530$export$2e2bcd8739ae039 = $a0abe91869826530$var$ConnectFieldDumb;

});



parcelRegister("lw5Kx", function(module, exports) {
$parcel$export(module.exports, "ConnectFieldContext", () => (parcelRequire("fXGKd")).default);
$parcel$export(module.exports, "asConnectFields", () => (parcelRequire("fXGKd")).asConnectFields);

var $fXGKd = parcelRequire("fXGKd");

});
parcelRegister("fXGKd", function(module, exports) {
$parcel$export(module.exports, "asConnectFields", () => $d1536426660a9a87$export$eea0f4ab01eeb10e);
$parcel$export(module.exports, "default", () => $d1536426660a9a87$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $aYMdQ = parcelRequire("aYMdQ");
const $d1536426660a9a87$var$ConnectFieldContext = /*#__PURE__*/ $fc4bM.createContext({
    onConnectFieldMount: (0, $aYMdQ.noop)
});
const $d1536426660a9a87$export$eea0f4ab01eeb10e = (options)=>{
    const Child = options;
    const Component = (props)=>/*#__PURE__*/ $fc4bM.createElement($d1536426660a9a87$var$ConnectFieldContext.Consumer, null, (value)=>/*#__PURE__*/ $fc4bM.createElement(Child, {
                ...props,
                onConnectFieldMount: value.onConnectFieldMount
            }));
    const childDisplayName = Child.displayName ?? Child.name ?? 'Component';
    Component.displayName = `asConnectFields(${childDisplayName})`;
    return Component;
};
var $d1536426660a9a87$export$2e2bcd8739ae039 = $d1536426660a9a87$var$ConnectFieldContext;

});


parcelRegister("73edv", function(module, exports) {
$parcel$export(module.exports, "withConnectFieldSupport", () => (parcelRequire("csJp9")).default);

var $csJp9 = parcelRequire("csJp9");

});
parcelRegister("csJp9", function(module, exports) {
$parcel$export(module.exports, "default", () => $156255a4e3378ccf$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("lw5Kx");
var $fXGKd = parcelRequire("fXGKd");
const $156255a4e3378ccf$var$withConnectFieldSupport = (options)=>{
    return class ConnectFieldSupport extends $fc4bM.PureComponent {
        render() {
            const Child = options;
            return /*#__PURE__*/ $fc4bM.createElement((0, $fXGKd.default).Provider, {
                value: this.contextValue
            }, /*#__PURE__*/ $fc4bM.createElement(Child, {
                ...this.props,
                onSubmit: this.onSubmit
            }));
        }
        constructor(...args){
            super(...args), this.onConnectFieldMount = (el)=>{
                this.connectFieldApi = el;
            }, this.contextValue = {
                onConnectFieldMount: this.onConnectFieldMount
            }, this.onSubmit = async ()=>{
                const { portalId: portalId, requestTypeId: requestTypeId, projectId: projectId, xsrfToken: xsrfToken } = this.props;
                if (this.connectFieldApi && portalId && requestTypeId && projectId && xsrfToken) return Promise.resolve(this.connectFieldApi.validate(requestTypeId)).then((allConnectFieldValid)=>{
                    if (!this.connectFieldApi) throw new Error('connect field unavailable');
                    const validatedItems = allConnectFieldValid.filter((validationResult)=>!validationResult.timedOut);
                    if (validatedItems.every((validationResult)=>Boolean(validationResult.valid))) {
                        const validConnectKeys = validatedItems.map((validationResult)=>validationResult.connectKey);
                        return this.connectFieldApi.serialize(validConnectKeys, requestTypeId);
                    }
                    throw new Error('validation failed');
                }).then((data)=>{
                    return data;
                }).catch((e)=>{
                    throw e;
                });
                return [];
            };
        }
    };
};
var $156255a4e3378ccf$export$2e2bcd8739ae039 = $156255a4e3378ccf$var$withConnectFieldSupport;

});



parcelRegister("9dIFA", function(module, exports) {
$parcel$export(module.exports, "ForgeCustomFieldsResolver", () => (parcelRequire("2iPie")).ForgeCustomFieldsResolver);

var $2iPie = parcelRequire("2iPie");

});
parcelRegister("2iPie", function(module, exports) {
$parcel$export(module.exports, "ForgeCustomFieldsResolver", () => $307e53e95da0f180$export$51f6c5a4a6ee455d);
/* oxlint-disable no-void */ 
var $fc4bM = parcelRequire("fc4bM");

var $aYMdQ = parcelRequire("aYMdQ");

var $iSFD9 = parcelRequire("iSFD9");

var $67A4I = parcelRequire("67A4I");

var $dkKKz = parcelRequire("dkKKz");
parcelRequire("kNbIT");
var $ht37w = parcelRequire("ht37w");
const $307e53e95da0f180$export$51f6c5a4a6ee455d = ({ setResolve: setResolve, setFailedOrTimedOut: setFailedOrTimedOut, fields: fields, requestTypeId: requestTypeId })=>{
    const [, { resetState: resetState }] = (0, $dkKKz.useInlineFields)();
    const [failedOrTimedOutInlineFields] = (0, $dkKKz.useFailedOrTimedOutInlineFields)();
    const [resolver, setResolver] = (0, $fc4bM.useState)();
    const resolverRef = (0, $fc4bM.useRef)(resolver);
    const resetStateRef = (0, $fc4bM.useRef)(resetState);
    const prevRequestTypeId = (0, $iSFD9.usePrevious)(requestTypeId);
    const failedOrTimedOutFieldLabels = (0, $fc4bM.useMemo)(()=>failedOrTimedOutInlineFields.map((fieldId)=>{
            var _fields$find;
            return ((_fields$find = fields.find((field)=>field.id === fieldId)) === null || _fields$find === void 0 ? void 0 : _fields$find.label) || fieldId;
        }), [
        fields,
        failedOrTimedOutInlineFields
    ]);
    (0, $ht37w.useForgeCustomFieldsResolver)(resolver);
    const resolve = (0, $fc4bM.useCallback)(async ()=>{
        // In case the form was previously re-submitted, the next resolution should take that into account (to avoid looping).
        // We have to be careful here, because the previous promise might have been rejected (no matter what the reason was), thus a separate try/catch block is needed.
        // We also want to void the previous promise to entering this check again.
        try {
            var _resolverRef$current;
            const prevValue = await ((_resolverRef$current = resolverRef.current) === null || _resolverRef$current === void 0 ? void 0 : _resolverRef$current.promise);
            if (prevValue === (0, $67A4I.FORM_SUBMISSION_RE_SUBMIT_AND_PROCEED)) {
                setResolver(undefined);
                return 0, $67A4I.FORM_SUBMISSION_PROCEED;
            }
        } catch  {
        // nothing to do here
        }
        // Create a new promise and set the resolver to the state.
        // Later on it is used to resolve or reject the promise during the form submission to reflect Forge custom fields status.
        try {
            // Setting default values to avoid TS errors, they are overridden in the next block
            const newResolver = {
                promise: Promise.resolve((0, $67A4I.FORM_SUBMISSION_PROCEED)),
                resolve: (0, $aYMdQ.noop),
                reject: (0, $aYMdQ.noop)
            };
            const promise = new Promise((res, rej)=>{
                newResolver.resolve = res;
                newResolver.reject = rej;
            });
            newResolver.promise = promise;
            setResolver(newResolver);
            return await promise;
        } catch (error) {
            return 0, $67A4I.FORM_SUBMISSION_PROCEED;
        }
    }, []);
    (0, $fc4bM.useEffect)(()=>{
        setResolve(resolve);
    }, [
        setResolve,
        resolve
    ]);
    (0, $fc4bM.useEffect)(()=>{
        setFailedOrTimedOut(failedOrTimedOutFieldLabels);
    }, [
        setFailedOrTimedOut,
        failedOrTimedOutFieldLabels
    ]);
    (0, $fc4bM.useEffect)(()=>{
        resolverRef.current = resolver;
        resetStateRef.current = resetState;
    }, [
        resolver,
        resetState
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (prevRequestTypeId && prevRequestTypeId !== requestTypeId) resetState();
    }, [
        prevRequestTypeId,
        requestTypeId,
        resetState
    ]);
    // Reset on unmount, do not add any dependencies to avoid resetting when not needed
    (0, $fc4bM.useEffect)(()=>()=>void resetStateRef.current(), []);
    return null;
};

});
parcelRegister("67A4I", function(module, exports) {
$parcel$export(module.exports, "FORM_SUBMISSION_PROCEED", () => $c6e9ac3fcf147170$export$15defefb49c55d9b);
$parcel$export(module.exports, "FORM_SUBMISSION_RE_SUBMIT_AND_PROCEED", () => $c6e9ac3fcf147170$export$305cd9e043ace5dc);
$parcel$export(module.exports, "FORM_SUBMISSION_TIMEOUT", () => $c6e9ac3fcf147170$export$51b463f57ef72b72);
/**
 * Indicates that the form submission should proceed without interruption.
 */ const $c6e9ac3fcf147170$export$15defefb49c55d9b = 'PROCEED';
const $c6e9ac3fcf147170$export$305cd9e043ace5dc = 'RE-SUBMIT-AND-PROCEED';
const $c6e9ac3fcf147170$export$51b463f57ef72b72 = 10000;

});

parcelRegister("kNbIT", function(module, exports) {
$parcel$export(module.exports, "useForgeCustomFieldsResolver", () => (parcelRequire("ht37w")).useForgeCustomFieldsResolver);

var $ht37w = parcelRequire("ht37w");

});
parcelRegister("ht37w", function(module, exports) {
$parcel$export(module.exports, "useForgeCustomFieldsResolver", () => $766f9f56a39db029$export$eb2be9f18555934e);
/* oxlint-disable no-void */ 
var $fc4bM = parcelRequire("fc4bM");

var $dkKKz = parcelRequire("dkKKz");

var $67A4I = parcelRequire("67A4I");

var $j4xhN = parcelRequire("j4xhN");
const $766f9f56a39db029$export$eb2be9f18555934e = (resolver)=>{
    const [fieldsState, { setFieldState: setFieldState }] = (0, $dkKKz.useInlineFields)();
    const fieldsStateRef = (0, $fc4bM.useRef)(fieldsState);
    const timeoutRef = (0, $fc4bM.useRef)();
    const [shouldResolveWhenSettled, setShouldResolveWhenSettled] = (0, $fc4bM.useState)(false);
    const areFieldsReadyToBeSubmitted = (0, $fc4bM.useMemo)(()=>$766f9f56a39db029$var$areAllResolved(Object.values(fieldsState)), [
        fieldsState
    ]);
    (0, $fc4bM.useEffect)(()=>{
        fieldsStateRef.current = fieldsState;
    }, [
        fieldsState
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (shouldResolveWhenSettled && areFieldsReadyToBeSubmitted) {
            clearTimeout(timeoutRef.current);
            resolver === null || resolver === void 0 || resolver.resolve((0, $67A4I.FORM_SUBMISSION_RE_SUBMIT_AND_PROCEED));
        }
    }, [
        shouldResolveWhenSettled,
        areFieldsReadyToBeSubmitted,
        resolver
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (!resolver) return undefined;
        // No Forge custom fields to wait for (well, there might be some, but they are all already resolved).
        if ($766f9f56a39db029$var$areAllResolved(Object.values(fieldsStateRef.current))) {
            resolver.resolve((0, $67A4I.FORM_SUBMISSION_PROCEED));
            return undefined;
        }
        // Marking that we should resolve once the fields are settled.
        setShouldResolveWhenSettled(true);
        // Let all the fields with a form submission handler to submit their values.
        Object.values(fieldsStateRef.current).forEach(({ onFormSubmit: onFormSubmit })=>onFormSubmit === null || onFormSubmit === void 0 ? void 0 : onFormSubmit());
        // It might be the case that some field goes crazy and does not submit its value.
        // In this case we will resolve the promise after the timeout to unblock the request creation.
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(()=>{
            Object.entries(fieldsStateRef.current).forEach(([fieldId, fieldState])=>{
                if (fieldState.status === (0, $j4xhN.FIELD_STATE_PENDING)) setFieldState({
                    fieldId: fieldId,
                    status: (0, $j4xhN.FIELD_STATE_TIMED_OUT)
                });
            });
            resolver === null || resolver === void 0 || resolver.resolve((0, $67A4I.FORM_SUBMISSION_RE_SUBMIT_AND_PROCEED));
        }, (0, $67A4I.FORM_SUBMISSION_TIMEOUT));
        return ()=>{
            resolver === null || resolver === void 0 || resolver.reject();
            setShouldResolveWhenSettled(false);
            clearTimeout(timeoutRef.current);
        };
    }, // The only dependency that could be added here is the resolver.
    // We do not want the timeout to randomly restart.
    // If you need to add more dependencies, please use refs.
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    [
        resolver
    ]);
};
const $766f9f56a39db029$var$UNRESOLVED_STATES = [
    (0, $j4xhN.FIELD_STATE_PENDING),
    (0, $j4xhN.FIELD_STATE_FOCUSED)
];
const $766f9f56a39db029$var$areAllResolved = (fieldsState)=>{
    return fieldsState.every(({ status: status })=>!$766f9f56a39db029$var$UNRESOLVED_STATES.includes(status));
};

});




parcelRegister("fvRm5", function(module, exports) {
$parcel$export(module.exports, "FormHeader", () => $0c2e5c7d811412f6$export$97ee2cbf37e5ebfe);
/* form-header.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $1hJdJ = parcelRequire("1hJdJ");
const $0c2e5c7d811412f6$var$formHeaderContentStyles = null;
const $0c2e5c7d811412f6$var$formHeaderDescriptionStyles = null;
const $0c2e5c7d811412f6$export$97ee2cbf37e5ebfe = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
        children: [
            title && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $1hJdJ.default), {
                size: "large",
                children: title
            }),
            description && /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                className: (0, $2R2iS.default)([
                    "_1pfhu2gc"
                ]),
                children: description
            }),
            children && /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                className: (0, $2R2iS.default)([
                    "_1ul91osq _1pfhu2gc"
                ]),
                children: children
            })
        ]
    });
};

});

parcelRegister("j6GtF", function(module, exports) {
$parcel$export(module.exports, "ProformaSerializationTraceStep", () => $19a354569ecccf91$export$1b2fc3d8d738811d);
$parcel$export(module.exports, "traceProformaSerialization", () => $19a354569ecccf91$export$23d4470250746a0f);

var $k2M4v = parcelRequire("k2M4v");

var $4MjGQ = parcelRequire("4MjGQ");
/**
 * Gates the operational analytics events that trace the Proforma form
 * serialization flow during Help Center request creation. Used to diagnose an
 * intermittent bug where a request submitted with a Proforma form omits the
 * form data on submission even though a form is rendered.
 */ const $19a354569ecccf91$var$PROFORMA_TRACK_PORTAL_CREATE_FORM_SERIALIZATION = 'proforma_track_portal_create_form_serialisation';
const $19a354569ecccf91$export$e6a10ff12951a5f8 = ()=>(0, $k2M4v.default).checkGate($19a354569ecccf91$var$PROFORMA_TRACK_PORTAL_CREATE_FORM_SERIALIZATION);
const $19a354569ecccf91$export$1b2fc3d8d738811d = {
    PreSubmit: 'preSubmit',
    PostSerialization: 'postSerialization'
};
const $19a354569ecccf91$export$23d4470250746a0f = (step, attributes = {})=>{
    if (!$19a354569ecccf91$export$e6a10ff12951a5f8()) return;
    (0, $4MjGQ.operationalEvent)({
        action: 'traced',
        actionSubject: 'proformaFormSerializationTrace',
        source: 'proforma-serialization-trace',
        attributes: {
            step: step,
            ...attributes
        }
    });
};

});

parcelRegister("faYOh", function(module, exports) {
$parcel$export(module.exports, "UiModificationsFormValuesApplier", () => $4fab49ae4c9efcf0$export$62bec47a1e660aed);

var $fc4bM = parcelRequire("fc4bM");

var $kzQWi = parcelRequire("kzQWi");

var $5YXrV = parcelRequire("5YXrV");

var $bfYTF = parcelRequire("bfYTF");
const $4fab49ae4c9efcf0$export$62bec47a1e660aed = ({ fieldValues: fieldValues, setFieldValue: setFieldValue, fields: fields })=>{
    const [overrides] = (0, $kzQWi.useAdjustedFields)();
    const fieldValuesRef = (0, $fc4bM.useRef)(fieldValues);
    // always refresh fieldValuesRef with the latest value
    fieldValuesRef.current = fieldValues;
    const fieldConfigurations = (0, $fc4bM.useMemo)(()=>{
        const configs = {};
        fields.filter(({ jiraFieldType: jiraFieldType })=>(0, $5YXrV.isFieldTypeSupported)((0, $bfYTF.REQUEST_CREATE_VIEW_TYPE), jiraFieldType)).forEach(({ id: id, jiraFieldType: jiraFieldType })=>{
            configs[id] = (0, $5YXrV.getSupportedFieldConfiguration)((0, $bfYTF.REQUEST_CREATE_VIEW_TYPE), jiraFieldType);
        });
        return configs;
    }, [
        fields
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (!overrides || Object.keys(fieldConfigurations).length === 0) return;
        for (const [fieldId, override] of Object.entries(overrides)){
            const fieldConfig = fieldConfigurations[fieldId];
            // Only process if field is supported, has override value, and transformation function is available
            if (fieldConfig !== null && fieldConfig !== void 0 && fieldConfig.modifyValueToBasic && (override === null || override === void 0 ? void 0 : override.value) !== undefined) {
                const transformedValue = fieldConfig.modifyValueToBasic(override.value);
                if (transformedValue !== fieldValuesRef.current[fieldId]) setFieldValue(fieldId, transformedValue);
            }
        }
    }, [
        overrides,
        fieldConfigurations,
        setFieldValue
    ]);
    return null;
};

});

parcelRegister("htET6", function(module, exports) {
$parcel$export(module.exports, "UiModificationsSectionsMessages", () => $9a2cdc2b4a0c28a3$export$28416a123e56ccab);

var $fc4bM = parcelRequire("fc4bM");

var $dtvmL = parcelRequire("dtvmL");

var $hFK5U = parcelRequire("hFK5U");

var $16U19 = parcelRequire("16U19");
function $9a2cdc2b4a0c28a3$export$28416a123e56ccab() {
    const [uiModificationError] = (0, $hFK5U.useUiModificationsErrors)();
    const [uiModificationsNotification] = (0, $16U19.useUiModificationsNotifications)();
    const hasError = uiModificationError !== null;
    const hasNotification = uiModificationsNotification !== null;
    if (!hasError && !hasNotification) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dtvmL.default), {
        appearance: "error",
        testId: "issue-create.ui.modal.create-form.section-messages.ui-modifications-error-message"
    }, uiModificationError.message), hasNotification && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dtvmL.default), {
        appearance: uiModificationsNotification.type,
        testId: "issue-create.ui.modal.create-form.section-messages.ui-modifications-notification-message"
    }, uiModificationsNotification.message));
}

});
parcelRegister("hFK5U", function(module, exports) {
$parcel$export(module.exports, "useUiModificationsErrors", () => $63a912a1de4601a3$export$72f28c8f041a8bab);

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $7GLtP = parcelRequire("7GLtP");

var $di8GY = parcelRequire("di8GY");
const $63a912a1de4601a3$export$72f28c8f041a8bab = ()=>{
    const error = (0, $7GLtP.useError)();
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const [errorMessage, setErrorMessage] = (0, $fc4bM.useState)(null);
    (0, $fc4bM.useEffect)(()=>{
        if (!error) setErrorMessage(null);
        else {
            const message = (0, $di8GY.errorCodeToErrorMessageMap)[error.errorCode];
            const formattedMessage = formatMessage(message);
            setErrorMessage(formattedMessage);
        }
    }, [
        error,
        formatMessage
    ]);
    return errorMessage ? [
        {
            message: errorMessage
        }
    ] : [
        null
    ];
};

});
parcelRegister("7GLtP", function(module, exports) {
$parcel$export(module.exports, "useError", () => $0b512a3db5d47075$export$5027865de34f9ec6);

var $5nVr1 = parcelRequire("5nVr1");

var $kzQWi = parcelRequire("kzQWi");
const $0b512a3db5d47075$export$5027865de34f9ec6 = (0, $5nVr1.createStateHook)((0, $kzQWi.store), {
    selector: (state)=>state.error
});

});

parcelRegister("di8GY", function(module, exports) {
$parcel$export(module.exports, "errorCodeToErrorMessageMap", () => $140dfd6aac3ed244$export$c36ca6969b1c2a38);

var $6RqhJ = parcelRequire("6RqhJ");
const $140dfd6aac3ed244$export$c36ca6969b1c2a38 = {
    ON_BRIDGE_ERROR_ERROR_CODE: (0, $6RqhJ.default).applyingUimFailed,
    USE_REGISTER_FIELDS_ERROR_CODE: (0, $6RqhJ.default).applyingUimFailed,
    USE_SUBMIT_ERROR_CODE: (0, $6RqhJ.default).applyingUimFailed,
    PER_FIELD_HOOK_ERROR_CODE: (0, $6RqhJ.default).applyingUimFailed,
    SCOPES_MISSING_ERROR_CODE: (0, $6RqhJ.default).appDoesNotHaveRequiredScopes,
    ERROR_BOUNDARY_HANDLER_ERROR_CODE: (0, $6RqhJ.default).applyingUimFailed,
    ON_INIT_FIELDS_INITIALIZATION_TIMEOUT: (0, $6RqhJ.default).loadingUimFailed
};

});
parcelRegister("6RqhJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd8b0bc8a85d0b56$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $cd8b0bc8a85d0b56$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    loadingUimFailed: {
        id: 'ui-modifications-view-request-create.use-ui-modifications-errors.loading-uim-failed',
        defaultMessage: "We couldn't load the UI modifications for this form.",
        description: 'A warning that gets displayed when unknown error occurred during UI modifications processing in Jira'
    },
    loadingUimDataFailed: {
        id: 'ui-modifications-view-request-create.use-ui-modifications-errors.loading-uim-data-failed',
        defaultMessage: "We couldn't load the UI modifications configuration for this form.",
        description: 'A warning that gets displayed when known error occurred during UI modifications data loading in Jira'
    },
    applyingUimFailed: {
        id: 'ui-modifications-view-request-create.use-ui-modifications-errors.applying-uim-failed',
        defaultMessage: 'We encountered an error while applying UI modifications to this form.',
        description: 'A warning that gets displayed when known error occurred during UI modifications processing in Jira'
    },
    appDoesNotHaveRequiredScopes: {
        id: 'ui-modifications-view-request-create.use-ui-modifications-errors.app-does-not-have-required-scopes',
        defaultMessage: "We couldn't load some of the UI modifications apps for this page, because they don't have required scopes.",
        description: 'A warning that gets displayed when an app with UI modifications module does not have required scopes in the manifest'
    }
});

});



parcelRegister("16U19", function(module, exports) {
$parcel$export(module.exports, "useUiModificationsNotifications", () => $6d063232469afa68$export$3a867504a28cd936);

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $fLxXd = parcelRequire("fLxXd");

var $d5j6m = parcelRequire("d5j6m");
const $6d063232469afa68$export$3a867504a28cd936 = ()=>{
    const notification = (0, $fLxXd.useNotification)();
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const [notificationProperties, setNotificationProperties] = (0, $fc4bM.useState)(null);
    (0, $fc4bM.useEffect)(()=>{
        if (!notification) setNotificationProperties(null);
        else {
            const properties = (0, $d5j6m.notificationTypeToNotificationProperties)[notification.type];
            const formattedMessage = formatMessage(properties.message);
            setNotificationProperties({
                message: formattedMessage,
                type: properties.type
            });
        }
    }, [
        notification,
        formatMessage
    ]);
    return notificationProperties ? [
        notificationProperties
    ] : [
        null
    ];
};

});
parcelRegister("fLxXd", function(module, exports) {
$parcel$export(module.exports, "useNotification", () => $27d663e71c48ef91$export$9949bd9c713ba425);

var $5nVr1 = parcelRequire("5nVr1");

var $kzQWi = parcelRequire("kzQWi");
const $27d663e71c48ef91$export$9949bd9c713ba425 = (0, $5nVr1.createStateHook)((0, $kzQWi.store), {
    selector: (state)=>state.notification
});

});

parcelRegister("d5j6m", function(module, exports) {
$parcel$export(module.exports, "notificationTypeToNotificationProperties", () => $de0ecb179d9c0a3f$export$3dd11dfb655fc1de);

var $2EmiG = parcelRequire("2EmiG");
const $de0ecb179d9c0a3f$export$3dd11dfb655fc1de = {
    MULTIPLE_APPS_CONFLICTS: {
        message: (0, $2EmiG.default).multipleAppsConflicted,
        type: 'warning'
    }
};

});
parcelRegister("2EmiG", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5ab926dffeadf96$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $a5ab926dffeadf96$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    multipleAppsConflicted: {
        id: 'ui-modifications-view-gic.use-ui-modifications-notifications.multiple-apps-conflicted',
        defaultMessage: 'Multiple UI modification apps are trying to change the same field property. If you see unexpected changes to a field, report them to your Jira admin.',
        description: 'A information that gets displayed when UI modifications misconfiguration was detected'
    }
});

});




parcelRegister("c6H8P", function(module, exports) {
$parcel$export(module.exports, "withUiModificationsFormDecorator", () => $2048b903de42a944$export$da1a7ee776db6dec);

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $kzQWi = parcelRequire("kzQWi");

var $g4H12 = parcelRequire("g4H12");

var $huP9n = parcelRequire("huP9n");

var $ltOLQ = parcelRequire("ltOLQ");

var $4LbOA = parcelRequire("4LbOA");
const $2048b903de42a944$export$a16989d3bc106880 = /*#__PURE__*/ (0, $fc4bM.memo)(({ formData: formData, setOverrideProps: setOverrideProps })=>{
    (0, $ltOLQ.useInitializeFields)({
        fields: formData.fields,
        urlParamFieldValueOverrides: formData.urlParamFieldValueOverrides
    });
    (0, $4LbOA.useInitializeNoScreenTab)();
    const { fields: fields } = (0, $huP9n.useFieldsOverrides)({
        fields: formData.fields
    });
    const { clearAppliedValue: clearAppliedValue, processChange: processChange } = (0, $kzQWi.useIssueAdjustmentsActions)();
    const formDataWithOverrides = (0, $fc4bM.useMemo)(()=>{
        return {
            ...formData,
            fields: fields
        };
    }, [
        formData,
        fields
    ]);
    const onFieldChangedByUser = (0, $fc4bM.useCallback)(({ field: field, additionalFieldData: additionalFieldData })=>{
        processChange({
            fieldId: field,
            fieldValue: additionalFieldData === null || additionalFieldData === void 0 ? void 0 : additionalFieldData.rawValue,
            eventType: 'change'
        });
        // Once we have applied the value, we clear it from the state, so we don't apply it again
        // in the future and overwrite whatever the user has changed between now and then
        clearAppliedValue(field);
    }, [
        clearAppliedValue,
        processChange
    ]);
    const onFieldBlurredByUser = (0, $fc4bM.useCallback)(({ field: field, additionalFieldData: additionalFieldData })=>{
        processChange({
            fieldId: field,
            fieldValue: additionalFieldData === null || additionalFieldData === void 0 ? void 0 : additionalFieldData.rawValue,
            eventType: 'blur'
        });
        // Once we have applied the value, we clear it from the state, so we don't apply it again
        // in the future and overwrite whatever the user has changed between now and then
        clearAppliedValue(field);
    }, [
        clearAppliedValue,
        processChange
    ]);
    (0, $fc4bM.useEffect)(()=>{
        setOverrideProps({
            onFieldChangedByUser: onFieldChangedByUser,
            onFieldBlurredByUser: onFieldBlurredByUser,
            formData: formDataWithOverrides
        });
    }, [
        formDataWithOverrides,
        setOverrideProps,
        onFieldChangedByUser,
        onFieldBlurredByUser
    ]);
    return null;
});
$2048b903de42a944$export$a16989d3bc106880.displayName = 'EnabledUiModificationsDecorator';
const $2048b903de42a944$export$396c5968a56552f2 = (props)=>{
    const [overrideProps, setOverrideProps] = (0, $fc4bM.useState)({});
    const isUiModificationsEnabled = (0, $g4H12.useAdjustmentsEnabled)();
    const { RequestCreateForm: RequestCreateForm, ...requestCreateFormProps } = props;
    const { formData: formData, portalId: portalId, requestTypeId: requestTypeId, isPrefillPending: isPrefillPending } = requestCreateFormProps;
    // Do not mount EnabledUiModificationsDecorator while URL-param pre-fill is still being
    // resolved by the epic (isPrefillPending === true). useInitializeFields fires its effect
    // only once (on mount), so if it mounts before hydratedUrlParamOverrides arrives from the
    // epic, it will initialise UIM with an empty urlParamFieldValueOverrides and getValue()
    // will return null in onInit even though the field visually shows the pre-selected value.
    // Delaying the mount until isPrefillPending is false ensures the correct values are
    // available on the first (and only) call to initializeFields.
    const isReadyToMount = !(0, $dRkX9.fg)('jsm_uim_queryparam_prefill_fix') || !isPrefillPending;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(RequestCreateForm, {
        ...requestCreateFormProps,
        ...overrideProps
    }), isUiModificationsEnabled && formData && portalId && requestTypeId && isReadyToMount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($2048b903de42a944$export$a16989d3bc106880, {
        setOverrideProps: setOverrideProps,
        formData: formData
    }));
};
const $2048b903de42a944$export$da1a7ee776db6dec = ()=>{
    return (RequestCreateForm)=>{
        const Decorator = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($2048b903de42a944$export$396c5968a56552f2, {
                RequestCreateForm: RequestCreateForm,
                ...props
            });
        Decorator.displayName = `withUiModificationsFormDecorator(${RequestCreateForm.displayName || RequestCreateForm.name})`;
        return Decorator;
    };
};

});
parcelRegister("huP9n", function(module, exports) {
$parcel$export(module.exports, "useFieldsOverrides", () => $7644a5b984bdd3e3$export$38f8a49b78f98f9f);

var $fc4bM = parcelRequire("fc4bM");

var $97kDt = parcelRequire("97kDt");

var $bezhE = parcelRequire("bezhE");

var $5W771 = parcelRequire("5W771");

var $kzQWi = parcelRequire("kzQWi");
const $7644a5b984bdd3e3$var$pickPropertiesToOverride = (field)=>{
    const overrideProperties = {
        fieldName: 'label',
        description: 'description',
        descriptionRaw: 'description',
        isReadOnly: 'disabled',
        isRequired: 'required',
        isVisible: 'displayed',
        value: 'valueOverride',
        // For options visibility, field like select uses options.
        options: 'options',
        // For options visibility, field like radio uses items.
        items: 'items'
    };
    return Object.entries(overrideProperties).reduce((acc, [uimProperty, jsmProperty])=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($bezhE)))(field, uimProperty)) acc[jsmProperty] = (0, (/*@__PURE__*/$parcel$interopDefault($97kDt)))(field, uimProperty);
        return acc;
    }, {});
};
const $7644a5b984bdd3e3$export$38f8a49b78f98f9f = ({ fields: fields })=>{
    const [overrides] = (0, $kzQWi.useAdjustedFields)();
    return (0, $fc4bM.useMemo)(()=>{
        if (!overrides) return {
            fields: fields
        };
        const overridenFields = fields.map((field)=>{
            const fieldOverrides = overrides[field.id];
            if (!fieldOverrides) return field;
            const supportedOverrides = $7644a5b984bdd3e3$var$pickPropertiesToOverride(fieldOverrides);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($5W771)))(supportedOverrides)) return field;
            return {
                ...field,
                ...supportedOverrides
            };
        });
        return {
            fields: overridenFields
        };
    }, [
        overrides,
        fields
    ]);
};

});
parcelRegister("bezhE", function(module, exports) {

var $6kbYR = parcelRequire("6kbYR");

var $a98KV = parcelRequire("a98KV");
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $82dc5f1b1467e41e$var$has(object, path) {
    return object != null && $a98KV(object, path, $6kbYR);
}
module.exports = $82dc5f1b1467e41e$var$has;

});
parcelRegister("6kbYR", function(module, exports) {
/** Used for built-in method references. */ var $49ade76da233400c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $49ade76da233400c$var$hasOwnProperty = $49ade76da233400c$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $49ade76da233400c$var$baseHas(object, key) {
    return object != null && $49ade76da233400c$var$hasOwnProperty.call(object, key);
}
module.exports = $49ade76da233400c$var$baseHas;

});



parcelRegister("ltOLQ", function(module, exports) {
$parcel$export(module.exports, "useInitializeFields", () => $68058df872be204f$export$869a1c0d0d07c224);

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $5YXrV = parcelRequire("5YXrV");

var $kzQWi = parcelRequire("kzQWi");

var $hN5YJ = parcelRequire("hN5YJ");

var $bfYTF = parcelRequire("bfYTF");

var $4KZo2 = parcelRequire("4KZo2");
const $68058df872be204f$var$hasRendererType = (field)=>{
    // Indeed it is typed as any, replace with Object.hasOwn once available in help-center.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return Object.prototype.hasOwnProperty.call(field, 'rendererType');
};
const $68058df872be204f$var$getFieldConfigId = (field)=>'fieldConfigId' in field && typeof field.fieldConfigId === 'string' ? field.fieldConfigId : undefined;
/**
 * Extra field data for the field configuration's transformers. It is never sent to apps.
 * The user picker passes `fieldConfigId` to the Portal user search, which uses it to apply
 * the field's user filter. Typed with `UserPickerExtraData`, which the user picker's transformer
 * reads with the same type.
 */ const $68058df872be204f$var$getExtraData = (field)=>{
    const fieldConfigId = $68058df872be204f$var$getFieldConfigId(field);
    return (0, $hN5YJ.isUserPickerEmailSupportEnabled)() && fieldConfigId ? {
        fieldConfigId: fieldConfigId
    } : undefined;
};
const $68058df872be204f$export$869a1c0d0d07c224 = ({ fields: fields, urlParamFieldValueOverrides: urlParamFieldValueOverrides = {} })=>{
    const { initializeFields: initializeFields } = (0, $kzQWi.useIssueAdjustmentsActions)();
    (0, $fc4bM.useEffect)(()=>{
        const fieldsToInitialize = fields// Remove 'as string' on isUiModificationsSupportEnabled, ditto_uim_-_jsm_support_main FF cleanup
        .filter(({ jiraFieldType: jiraFieldType })=>(0, $5YXrV.isFieldTypeSupported)((0, $bfYTF.REQUEST_CREATE_VIEW_TYPE), jiraFieldType)).map((field)=>{
            // When a field value was pre-populated via a URL query parameter, the URL param
            // override (already parsed into the correct internal shape by parseFieldUrlParams /
            // hydrateUrlParamOverrides) takes precedence over the field's server-side default.
            // This is necessary because some field types (e.g. select, multiselect,
            // cascadingselect) store their UIM-visible value in `field.defaultValue` rather
            // than `field.value` (via initializeFieldPropertyMapping), but `defaultValue` is
            // never populated for URL-param-only pre-fills — only `initialFieldValues` is
            // updated in the reducer. Without this override, getValue() returns null in onInit
            // even though the field visually shows the pre-selected option.
            const urlParamOverrideValue = urlParamFieldValueOverrides[field.id];
            const hasUrlParamOverride = (0, $dRkX9.fg)('jsm_uim_queryparam_prefill_fix') && urlParamOverrideValue !== undefined;
            const fieldType = field.jiraFieldType;
            const initializedValue = (0, $4KZo2.getValueByInitializeFieldPropertyMapping)({
                field: field,
                fieldType: fieldType,
                property: 'value',
                defaultValue: null
            });
            const value = hasUrlParamOverride ? (0, $4KZo2.transformUrlParamValueForField)(urlParamOverrideValue, field, fieldType) : (0, $4KZo2.transformInitialValueForField)(initializedValue, field, fieldType);
            return {
                field: {
                    value: value,
                    allowedValues: (0, $4KZo2.getValueByInitializeFieldPropertyMapping)({
                        field: field,
                        fieldType: field.jiraFieldType,
                        property: 'allowedValues',
                        defaultValue: undefined
                    }),
                    fieldName: field.label,
                    fieldId: field.id,
                    description: field.description,
                    descriptionRaw: field.description,
                    isRequired: field.required ?? false,
                    isVisible: field.displayed,
                    isReadOnly: field.disabled ?? false,
                    // Remove 'as string' on isUiModificationsSupportEnabled, ditto_uim_-_jsm_support_main FF cleanup
                    fieldType: field.jiraFieldType
                },
                metadata: {
                    fieldRenderer: $68058df872be204f$var$hasRendererType(field) ? field.rendererType : undefined,
                    extraData: $68058df872be204f$var$getExtraData(field)
                }
            };
        });
        initializeFields(fieldsToInitialize);
    // No deps, intialize once
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

});
parcelRegister("4KZo2", function(module, exports) {
$parcel$export(module.exports, "getValueByInitializeFieldPropertyMapping", () => $22c7a64d62ab5fd5$export$6f6ce0daf6a52c22);
$parcel$export(module.exports, "transformUrlParamValueForField", () => $22c7a64d62ab5fd5$export$15779ca21f2894e1);
$parcel$export(module.exports, "transformInitialValueForField", () => $22c7a64d62ab5fd5$export$ef1e272266d3e8f7);

var $5YXrV = parcelRequire("5YXrV");

var $bfYTF = parcelRequire("bfYTF");
const $22c7a64d62ab5fd5$export$6f6ce0daf6a52c22 = ({ field: field, fieldType: fieldType, property: property, defaultValue: defaultValue })=>{
    var _getSupportedFieldCon;
    const mappedProperty = ((_getSupportedFieldCon = (0, $5YXrV.getSupportedFieldConfiguration)((0, $bfYTF.REQUEST_CREATE_VIEW_TYPE), fieldType)) === null || _getSupportedFieldCon === void 0 || (_getSupportedFieldCon = _getSupportedFieldCon.initializeFieldPropertyMapping) === null || _getSupportedFieldCon === void 0 ? void 0 : _getSupportedFieldCon[property]) ?? property;
    return (field === null || field === void 0 ? void 0 : field[mappedProperty]) ?? defaultValue;
};
const $22c7a64d62ab5fd5$export$15779ca21f2894e1 = (urlParamValue, field, fieldType)=>{
    var _getSupportedFieldCon2;
    const transformer = (_getSupportedFieldCon2 = (0, $5YXrV.getSupportedFieldConfiguration)((0, $bfYTF.REQUEST_CREATE_VIEW_TYPE), fieldType)) === null || _getSupportedFieldCon2 === void 0 ? void 0 : _getSupportedFieldCon2.transformUrlParamValue;
    return transformer ? transformer(urlParamValue, field) : urlParamValue;
};
const $22c7a64d62ab5fd5$export$ef1e272266d3e8f7 = (value, field, fieldType)=>{
    var _getSupportedFieldCon3;
    const transformer = (_getSupportedFieldCon3 = (0, $5YXrV.getSupportedFieldConfiguration)((0, $bfYTF.REQUEST_CREATE_VIEW_TYPE), fieldType)) === null || _getSupportedFieldCon3 === void 0 ? void 0 : _getSupportedFieldCon3.transformInitialValue;
    return transformer ? transformer(value, field) : value;
};

});


parcelRegister("4LbOA", function(module, exports) {
$parcel$export(module.exports, "useInitializeNoScreenTab", () => $f8ff869edea850cf$export$ce80bc59af7f0b45);

var $fc4bM = parcelRequire("fc4bM");

var $kzQWi = parcelRequire("kzQWi");
const $f8ff869edea850cf$export$ce80bc59af7f0b45 = ()=>{
    const { initializeNoScreenTab: initializeNoScreenTab } = (0, $kzQWi.useIssueAdjustmentsActions)();
    (0, $fc4bM.useEffect)(()=>{
        initializeNoScreenTab();
    // No deps, intialize once
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

});


parcelRegister("1xSlZ", function(module, exports) {
$parcel$export(module.exports, "notifyRovoRequestCreated", () => $c0d5f4e347eef107$export$cf40d32161311763);

var $aIVqJ = parcelRequire("aIVqJ");

var $jgb8T = parcelRequire("jgb8T");

var $drfAm = parcelRequire("drfAm");

var $50eQO = parcelRequire("50eQO");

var $eMjX0 = parcelRequire("eMjX0");

var $3xCxz = parcelRequire("3xCxz");
function $c0d5f4e347eef107$export$cf40d32161311763(portalUrl, action) {
    // Notify Rovo Chat about successful request creation
    try {
        const bridge = (0, $drfAm.getBrowserBridgeAPI)();
        bridge.ready((0, $eMjX0.HELP_CENTER_FORM_REQUEST_CLIENT_ID));
        bridge.send((0, $3xCxz.NotifySuccessCommand), {
            message: portalUrl,
            requestUrl: portalUrl,
            action: action || '',
            senderId: (0, $eMjX0.HELP_CENTER_FORM_REQUEST_CLIENT_ID),
            receiverId: (0, $50eQO.ROVO_CHAT_CLIENT_ID)
        });
    } catch (e) {
        (0, $aIVqJ.trackError)('Error notifying Rovo Chat of successful request creation', {
            command: 'notify-success-command'
        }, e);
        (0, $jgb8T.devLog)('Error notifying Rovo Chat of successful request creation', e);
    }
}

});
parcelRegister("drfAm", function(module, exports) {
$parcel$export(module.exports, "getBrowserBridgeAPI", () => $e1162ecd7df56149$export$948c8d79381235ac);

var $76wuA = parcelRequire("76wuA");

var $8Ns1i = parcelRequire("8Ns1i");

var $8C3Ey = parcelRequire("8C3Ey");
/**
 * A singleton instance to the Rovo bridge API, for bidirectional communication between Rovo Chat and fully immersive content
 * representations. Available in the scope of a single JavaScript context.
 *
 * @description For browser use cases, use {@link getBrowserBridgeAPI}.
 *
 * @description Note: A content frame in this context can refer to either (1) preview of content in a 'staging' view (
 * see @atlassian/smart-creation), or (2) the content actually rendered in an application (e.g. a Confluence page).
 *
 * @description Note: Here, a single JavaScript context can mean any of the following scenarios:
 * - a web application and React component mounted inside of it (e.g. Confluence + Confluence Pages)
 * - a web application and same-origin `<iframe>` mounted inside of it (e.g. Confluence + Confluence Whiteboards / Databases)
 *
 * The following cases represent distinct JavaScript contexts:
 * - a web application and a cross-origin `<iframe>` mounted inside of it (e.g. a third-party Smart Link embed)
 * - the main thread and a worker thread in a web application
 * - the main thread and renderer thread in a desktop application
 *
 * In the case that you have a distinct JavaScript context, ensure you use a transport protocol optimised for your use case.
 * @see {@link getBrowserBridgeAPI} for usage in a browser context.
 */ let $e1162ecd7df56149$var$bridgeApiInstance = null;
const $e1162ecd7df56149$export$948c8d79381235ac = (options = {})=>{
    // 1) read singleton instance
    if ($e1162ecd7df56149$var$bridgeApiInstance) return $e1162ecd7df56149$var$bridgeApiInstance;
    // 2) read singleton instance from window.top
    const api = (0, $8Ns1i.readAPI)();
    if (api) return api;
    // 3) create and yield
    const source = window.origin;
    $e1162ecd7df56149$var$bridgeApiInstance = new (0, $76wuA.RovoContentBridgeAPI)(source, new (0, $8C3Ey.BrowserTransport)(source, {
        resolveTarget: options.resolveTarget,
        allowedOrigins: options.allowedOrigins
    }));
    (0, $8Ns1i.mountAPI)($e1162ecd7df56149$var$bridgeApiInstance);
    return $e1162ecd7df56149$var$bridgeApiInstance;
};
const $e1162ecd7df56149$export$ba1db4e691f11d50 = ()=>{
    // Ensure bridge instance is fully destroyed first to clean up all internal state
    if ($e1162ecd7df56149$var$bridgeApiInstance) $e1162ecd7df56149$var$bridgeApiInstance.destroy();
    $e1162ecd7df56149$var$bridgeApiInstance = null;
    (0, $8Ns1i.clearAPI)();
};

});
parcelRegister("76wuA", function(module, exports) {
$parcel$export(module.exports, "RovoContentBridgeAPI", () => $2a758ca465f8eb18$export$d90806e6eab0cb0a);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $eUgRu = parcelRequire("eUgRu");

var $dRkX9 = parcelRequire("dRkX9");

var $4I8N2 = parcelRequire("4I8N2");

var $ed6Lc = parcelRequire("ed6Lc");

var $dqOCK = parcelRequire("dqOCK");

var $ddfTi = parcelRequire("ddfTi");

var $6aaaN = parcelRequire("6aaaN");

var $6I4zX = parcelRequire("6I4zX");

var $hjIC3 = parcelRequire("hjIC3");

var $92S6u = parcelRequire("92S6u");

var $i0f0B = parcelRequire("i0f0B");

var $bnlQq = parcelRequire("bnlQq");

var $UaE7E = parcelRequire("UaE7E");

var $6tOyF = parcelRequire("6tOyF");
class $2a758ca465f8eb18$export$d90806e6eab0cb0a {
    constructor(instanceId, transport){
        this.registry = new (0, $4I8N2.ClientRegistry)();
        this.queue = new (0, $i0f0B.BufferedInvocationQueue)();
        this.transport = transport;
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.identifier = (0, $ed6Lc.client)(instanceId ? instanceId : `bridge-api-${(0, $eUgRu.default)()}`);
        this.rpc = {
            request: new (0, $UaE7E.RequestHandler)(this.transport),
            response: new (0, $6tOyF.ResponseHandler)()
        };
        // setup emitter for all events
        (0, $hjIC3.emitter)().setBridgeId(this.identifier);
        // start listening for any incoming messages
        this.transport.onMessage(this.onMessage.bind(this));
        // setup tick handler for sending discovery commands to pending clients
        this.queue.onTick((pendingConnections)=>{
            for (const { senderId: senderId, receiverId: receiverId } of pendingConnections)this.sendCommand((0, $6aaaN.DiscoveryCommand), {
                senderId: senderId,
                receiverId: receiverId
            });
        });
        // setup dropped message handler to cancel orphaned promises
        this.queue.onInvocationDroppped((m)=>{
            this.rpc.response.cancel(m.invocationId);
            (0, $hjIC3.emitter)().emit({
                type: 'message-dropped',
                messageCount: this.queue.messageCount,
                messageId: m.invocationId,
                message: {
                    ...m.params
                },
                clientId: m.senderId,
                reason: 'queue-overflow'
            });
        });
        // setup client added handler to drain commands when clients are ready
        this.registry.onClientAdded((clientId)=>{
            this.drainCommands(clientId);
        });
        // observe readiness of bridge API
        (0, $hjIC3.emitter)().emit({
            type: 'bridge-ready'
        });
    }
    /**
   * Unique ID for this specific bridge API instance.
   *
   * @description Should be the 1 instance in a given JS context.
   */ get id() {
        return this.identifier;
    }
    /**
   * Indicates a specific client is ready to start sending and accepting messages.
   *
   * @param clientId unique identifier for the client.
   */ ready(clientId) {
        this.registry.addLocalClient(clientId);
        // client-specific handlers - sent by a remote client -> this bridge API instance,
        // targeting the client which we are setting up in this method
        this.createDiscoveryHandler(clientId);
        this.createReachableHandler(clientId);
        this.createTeardownHandler(clientId);
        // emit client registration event
        (0, $hjIC3.emitter)().emit({
            type: 'client-registered',
            clientId: clientId
        });
    }
    /**
   * Send a command with strongly-typed parameters to a recipient.
   *
   * @description It is possible to wait for the response of a command via the following:
   * ```typescript
   * const command = send(MyCommand, {});
   * await command.result(); // promise with result of the command
   * // optionally, to cancel:
   * command.cancel();
   * ```
   * Command invocations should be treated similarly in concept to network requests to an upstream system.
   * The upstream system can time out, disappear, crash, etc. Hence, all command results yield an optional
   * result, with resiliency baked in for connectivity with a client see {@link BufferedInvocationQueue}.
   *
   * Deferrables are used to expose a stable promise API for the result of a command. I.e., if the receiver
   * of a command is not seen as 'ready' yet, commands will be buffered until a time limit. Once that time
   * limit is expended, the message will be dropped, and its associated deferrable cancelled.
   *
   * @returns {CommandInvocation} api for handling the response of the command.
   */ send(command, params) {
        // assign a unique ID to this command invocation
        if (!params._invocationId) // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        params._invocationId = (0, $eUgRu.default)();
        // unique, stable ID for this command
        const id = (0, $bnlQq.createInvocationId)(command, params);
        const message = (0, $bnlQq.rpcCommand)(id, command, params);
        const senderId = params.senderId;
        const receiverId = params.receiverId;
        // emit command creation event
        (0, $hjIC3.emitter)().emit({
            type: 'command-created',
            commandId: id,
            commandType: command.identifier,
            senderId: senderId,
            receiverId: receiverId,
            properties: {
                ...params
            },
            groupId: params.groupId
        });
        let promise;
        // not ready to send to a known, communicable client yet - buffer & defer (if allowed)
        if (!this.registry.has(receiverId) || !this.transport.canSend(message) || this.registry.isPendingClient(receiverId)) {
            // default to buffering the sending of all commands
            const buffer = params.buffer ?? true;
            if (buffer) {
                this.queue.enqueue(id, senderId, receiverId, command, params);
                promise = this.rpc.response.getOrCreate(id, senderId, receiverId);
            } else // opted out of buffering - resolve immediately to undefined
            promise = Promise.resolve(undefined);
        } else if (this.registry.isLocalClient(receiverId)) {
            // emit command sent event for local invocation
            (0, $hjIC3.emitter)().emit({
                type: 'command-sent',
                commandId: id,
                commandType: command.identifier,
                senderId: senderId,
                receiverId: receiverId,
                properties: params,
                groupId: params.groupId
            });
            const result = this.rpc.request.invoke(command, params);
            const existing = this.rpc.response.get(id);
            // if a local client was not ready yet and we tried to communicate with it,
            // we do not want to instantiate a new promise. Hence, we need to latch onto
            // the same deferrable as before, and yield it with the result of invoking the
            // handler provided by the local client which is ready & we are communicating to
            if (existing) {
                existing.resolve(result);
                promise = existing.promise;
            } else promise = result;
        } else {
            // emit command sent event
            (0, $hjIC3.emitter)().emit({
                type: 'command-sent',
                commandId: id,
                commandType: command.identifier,
                senderId: senderId,
                receiverId: receiverId,
                properties: params,
                groupId: params.groupId
            });
            this.transport.send(message);
            promise = this.rpc.response.getOrCreate(id, senderId, receiverId);
        }
        return new (0, $ddfTi.CommandInvocation)(id, promise, (invocationId)=>this.cancel(invocationId), (groupId)=>this.cancelGroup(groupId));
    }
    /**
   * Broadcasts a command to all registered clients except those that are pending or filtered out.
   *
   * @typeParam C - The type of command properties, which must include a `receiverId` of type `ClientId`.
   * @param command - The constructor for the broadcastable command to be sent.
   * @param params - The parameters for the command, excluding the `receiverId` which will be set for each recipient.
   * @param options - Optional broadcast options, including a filter function to select specific clients.
   *
   * @remarks
   * - Only commands that pass `isBroadcastableCommand` are sent.
   * - The method retrieves all client IDs from the registry, filters out pending clients, and applies any additional filter provided in `options`.
   * - For each eligible client, the command is sent with the appropriate `receiverId`.
   * - Errors during broadcasting are caught and logged to the console.
   */ broadcast(command, params, options) {
        try {
            var _this$registry$getAll;
            if (!(0, $dqOCK.isBroadcastableCommand)(command)) return;
            const receiverIds = ((_this$registry$getAll = this.registry.getAllClientIds()) === null || _this$registry$getAll === void 0 || (_this$registry$getAll = _this$registry$getAll.filter((clientId)=>!this.registry.isPendingClient(clientId) && String(params.senderId) !== clientId)) === null || _this$registry$getAll === void 0 ? void 0 : _this$registry$getAll.filter((clientId)=>options !== null && options !== void 0 && options.filter ? options.filter(clientId) : true)) ?? [];
            for (const receiverId of receiverIds)this.send(command, {
                ...params,
                receiverId: receiverId
            });
            if (receiverIds.length) (0, $hjIC3.emitter)().emit({
                type: 'command-broadcast',
                senderId: params.senderId,
                receiverIds: receiverIds,
                commandType: command.identifier
            });
        } catch (err) {
            console.error('broadcast failed', err);
        }
    }
    /**
   * Register a handler for a specific command type for a specific client.
   */ on(clientId, Command, handler) {
        this.rpc.request.register(clientId, Command, handler);
        (0, $hjIC3.emitter)().emit({
            type: 'handler-registered',
            clientId: clientId,
            commandType: Command.identifier
        });
    }
    /**
   * Unregister a handler for a specific command type for a specific client.
   */ off(clientId, Command) {
        this.rpc.request.unregister(clientId, Command);
        (0, $hjIC3.emitter)().emit({
            type: 'handler-unregistered',
            clientId: clientId,
            commandType: Command.identifier
        });
    }
    /**
   * Tears down a specific client, removing it from the registry and notifying all remote clients.
   *
   * @description This method performs the following actions:
   * 1. Removes the client from the local registry
   * 2. Sends teardown commands to all known remote clients
   * 3. Drops all buffered messages for the client
   * 4. Unregisters all command handlers for the client
   * 5. Clears any pending response handlers for the client
   * 6. Removes transport target references for the client
   *
   * @param clientId unique identifier for the client to tear down
   */ teardown(clientId) {
        // 1. remove the client from the registry
        const wasRemoved = this.registry.removeClient(clientId);
        if (!wasRemoved) return;
        // 2. notify all remote clients about the teardown
        const allClientIds = this.registry.getAllClientIds();
        for (const otherClientId of allClientIds)// irrespective of state, we should communicate we are tearing down
        // this handles any potential race conditions with in-flight messages
        // across JS contexts (e.g., actively shaking hands with a pending client)
        if (this.registry.isPendingClient(otherClientId) || this.registry.isRemoteClient(otherClientId)) this.sendCommand((0, $6aaaN.TeardownCommand), {
            senderId: clientId,
            receiverId: otherClientId
        });
        // 3. drop all buffered messages for this client
        this.queue.clear(clientId);
        // 4. unregister all command handlers for this client
        this.rpc.request.unregisterAll(clientId);
        // 5. clear any pending response handlers for this client
        this.rpc.response.teardown(clientId);
        // 6. remove transport target references (Window/WebContents) for this client
        this.transport.teardown(clientId);
        // 7. emit client teardown event
        (0, $hjIC3.emitter)().emit({
            type: 'client-teardown',
            clientId: clientId
        });
    }
    /**
   * Clear all state prior to the application being destroyed.
   *
   * @description NOTE: Ensure all containing state is destroyed to avoid memory leaks during
   * SPA transitions away from application contexts which use the bridge API.
   */ destroy() {
        this.queue.destroy();
        this.rpc.request.destroy();
        this.rpc.response.clear();
        this.registry.destroy();
        this.transport.destroy();
        // stop emitting any events & drop memory
        (0, $hjIC3.emitter)().emit({
            type: 'bridge-destroyed'
        });
        // clean up all event emitter state
        (0, $hjIC3.destroyGlobalEventEmitter)();
        (0, $6I4zX.destroyGlobalDebugConsumer)();
        (0, $92S6u.destroyGlobalObservabilityConsumer)();
    }
    /**
   * Registers a message listener for RPC events received over {@link transport}.
   * @param data RPC message received by this JS context
   */ async onMessage(data) {
        try {
            if ((0, $bnlQq.isRPCRequest)(data)) return await this.rpc.request.handleRequest(data);
            if ((0, $bnlQq.isRPCResponse)(data)) return this.rpc.response.resolveWithResponse(data);
        } catch (err) {
            console.error('failed to handle message:', err);
        }
    }
    /**
   * Sets up a reachable handler for a specific client ID
   * @summary the {@link senderId} is the remote client who sent this command, expressing they are now reachable.
   * @param senderId
   */ createReachableHandler(senderId) {
        this.on(senderId, (0, $6aaaN.ReachableCommand), (params)=>{
            this.registry.addRemoteClient(params.senderId);
            (0, $hjIC3.emitter)().emit({
                type: 'client-discovered',
                clientId: params.senderId,
                metadata: {
                    discoveryMethod: 'reachable-command',
                    localClientId: senderId
                }
            });
        });
    }
    /**
   * Sets up a discoverable handler for a specific client ID
   * @summary the {@link senderId} is the remote client who sent this command, expressing they are looking for {@link senderId}.
   * @param senderId
   */ createDiscoveryHandler(senderId) {
        this.on(senderId, (0, $6aaaN.DiscoveryCommand), (params)=>{
            this.sendCommand((0, $6aaaN.ReachableCommand), {
                senderId: params.receiverId,
                receiverId: params.senderId
            });
            this.registry.addRemoteClient(params.senderId);
            (0, $hjIC3.emitter)().emit({
                type: 'client-discovered',
                clientId: params.senderId,
                metadata: {
                    discoveryMethod: 'discovery-command',
                    localClientId: senderId
                }
            });
        });
    }
    /**
   * Sets up a teardown handler for a specific client ID
   * @summary the {@link senderId} is the remote client who sent this command, expressing they are shutting down.
   * @param receiverId the local client that should handle teardown notifications
   */ createTeardownHandler(receiverId) {
        this.on(receiverId, (0, $6aaaN.TeardownCommand), (params)=>{
            // remove the client that is tearing down from our registry
            this.registry.removeClient(params.senderId);
            // drop all buffered messages for the client that is tearing down
            this.queue.clear(params.senderId);
            if ((0, $dRkX9.fg)('rovo_bridge_remote_teardown_cleanup')) this.transport.teardown(params.senderId);
        });
    }
    /**
   * Immediately send a command over the configured {@link transport}.
   *
   * @description Used for handshake between clients, to simplify logic.
   * @description Re-used to send all commands in the bridge API.
   *
   * @param command command to send
   * @param params command properties to provide
   */ sendCommand(command, params) {
        const id = (0, $bnlQq.createInvocationId)(command, params);
        const message = (0, $bnlQq.rpcCommand)(id, command, params);
        this.transport.send(message);
    }
    /**
   * Drain commands for a given client ID from the queue.
   * @param clientId unique identifier for the client
   */ drainCommands(clientId) {
        const messages = this.queue.flush(clientId);
        if (!messages) return;
        for (const message of messages)this.send(message.command, message.params);
    }
    /**
   * Cancel all commands in a specific group.
   *
   * @param groupId The group identifier of commands to cancel
   * @returns number of commands that were cancelled
   */ cancelGroup(groupId) {
        // remove the buffered commands with this group ID from the queue, if they exist; will also clean up
        // the RPC response handler deferrable for each command
        return this.queue.cancelGroup(groupId);
    }
    /**
   * Cancel a specific command invocation by its ID.
   *
   * @param invocationId The unique identifier of the command invocation to cancel
   * @returns true if the command was found and cancelled, false otherwise
   */ cancel(invocationId) {
        // remove the buffered command from the queue, if it exists on it; this will also clean up
        // the RPC response handler deferrable for this command
        return this.queue.cancel(invocationId);
    }
}

});
parcelRegister("4I8N2", function(module, exports) {
$parcel$export(module.exports, "ClientRegistry", () => $681f5c1c7e6916ff$export$c7eb95d2cb93befa);
class $681f5c1c7e6916ff$export$c7eb95d2cb93befa {
    /**
   * Yields the current state of a client.
   * @param clientId
   * @returns current state
   */ get(clientId) {
        return this.registry.get(clientId);
    }
    /**
   * Yields whether a given client is known or not to the registry.
   * @param clientId unique identifier for the client
   */ has(clientId) {
        return this.registry.has(clientId);
    }
    /**
   * Adds an entry for a new, pending client. It will be marked as `ready` once a successful handshake transpires.
   *
   * @description Will early exit with a warning if the client being marked as `pending` is already `ready`. This
   * is an anomalous state transition which we do not expect.
   *
   * @param clientId unique identifier for the client
   * @returns void
   */ addPendingClient(clientId) {
        const client = this.get(clientId);
        if (client && client.state === 'ready') {
            console.warn('tried to mark', clientId, 'as `pending` when already in `ready` state');
            return;
        }
        this.registry.set(clientId, {
            id: clientId,
            state: 'pending'
        });
    }
    /**
   * Adds an entry for a local client. It will be immediately ready for direct communication in the same JS context.
   *
   * @description Will early exit with a warning if the client being marked as `local` if already `remote`. This
   * is an anomalous state transition which we do not expect.
   *
   * @param clientId unique identifier for the client
   * @returns void
   */ addLocalClient(clientId) {
        if (this.isRemoteClient(clientId)) {
            console.warn('tried to mark', clientId, 'as `local` when already tracked as `remote`');
            return;
        }
        const wasAlreadyPresent = this.has(clientId);
        this.registry.set(clientId, {
            id: clientId,
            type: 'local',
            state: 'ready'
        });
        // only emit the event if this is a new client
        if (!wasAlreadyPresent) this.emitClientAdded(clientId);
    }
    /**
   * Adds an entry for a remote client. It will be ready for asynchronous communication once a handshake transpires.
   *
   * @description Will early exit with a warning if the client being marked as `remote` if already `local`. This
   * is an anomalous state transition which we do not expect.
   *
   * @param clientId unique identifier for the client
   * @returns void
   */ addRemoteClient(clientId) {
        if (this.isLocalClient(clientId)) {
            console.warn('tried to mark', clientId, 'as `remote` when already tracked as `local`');
            return;
        }
        const wasAlreadyPresent = this.has(clientId);
        this.registry.set(clientId, {
            id: clientId,
            type: 'remote',
            state: 'ready'
        });
        // only emit the event if this is a new client
        if (!wasAlreadyPresent) this.emitClientAdded(clientId);
    }
    isPendingClient(clientId) {
        const client = this.get(clientId);
        return (client === null || client === void 0 ? void 0 : client.state) === 'pending';
    }
    isLocalClient(clientId) {
        const client = this.get(clientId);
        return (client === null || client === void 0 ? void 0 : client.state) === 'ready' && client.type === 'local';
    }
    isRemoteClient(clientId) {
        const client = this.get(clientId);
        return (client === null || client === void 0 ? void 0 : client.state) === 'ready' && client.type === 'remote';
    }
    get size() {
        return this.registry.size;
    }
    /**
   * Removes a client from the registry.
   *
   * @param clientId unique identifier for the client to remove
   * @returns true if the client was removed, false if it wasn't found
   */ removeClient(clientId) {
        return this.registry.delete(clientId);
    }
    /**
   * Gets all client IDs currently in the registry.
   *
   * @returns array of all client IDs
   */ getAllClientIds() {
        return Array.from(this.registry.keys());
    }
    /**
   * Register a handler to be called when a client is added to the registry.
   *
   * @param handler Function to call when a client is added
   */ onClientAdded(handler) {
        this.onClientAddedHandlers.add(handler);
    }
    /**
   * Emit client added event to all registered handlers.
   *
   * @param clientId The client ID that was added
   */ emitClientAdded(clientId) {
        for (const handler of this.onClientAddedHandlers)try {
            handler(clientId);
        } catch (error) {
            console.error('Error in client added handler:', error);
        }
    }
    /**
   * Clean up all event handlers.
   */ destroy() {
        this.onClientAddedHandlers.clear();
        this.registry.clear();
    }
    constructor(){
        /**
   * A registry of all clients known to the current bridge API instance.
   *
   * @description NOTE: Clients undergo state transitions from pending -> ready until the current bridge
   * API instance is able to communicate with them.
   */ this.registry = new Map();
        /**
   * Event handlers for when clients are added to the registry.
   */ this.onClientAddedHandlers = new Set();
    }
}

});

parcelRegister("ed6Lc", function(module, exports) {
$parcel$export(module.exports, "client", () => $585bf86d8d6db8d1$export$388e0302ca0d9a41);
/**
 * A unique ID for referring to a client of the bridge API.
 *
 * @description Can either be a producer or receiver of events.
 */ const $585bf86d8d6db8d1$export$388e0302ca0d9a41 = (s)=>s;

});

parcelRegister("dqOCK", function(module, exports) {
$parcel$export(module.exports, "isBroadcastableCommand", () => $660b3d0ff07f2299$export$761a9dd8b8d30326);
function $660b3d0ff07f2299$export$761a9dd8b8d30326(command) {
    return typeof command === 'function' && command.__broadcastable === true;
}

});

parcelRegister("ddfTi", function(module, exports) {
$parcel$export(module.exports, "CommandInvocation", () => $d6ecdb6dad275afa$export$aa5e57f9f8c1afec);
class $d6ecdb6dad275afa$export$aa5e57f9f8c1afec {
    constructor(invocationId, resultPromise, cancelCallback, cancelGroupCallback){
        this.invocationId = invocationId;
        this.resultPromise = resultPromise;
        this.cancelCallback = cancelCallback;
        this.cancelGroupCallback = cancelGroupCallback;
    }
    /**
   * Get the result of the command invocation.
   *
   * @description Returns a promise that resolves to the command result, or undefined if cancelled.
   *
   * @returns Promise that resolves to the command result, or undefined if cancelled
   */ result() {
        return this.resultPromise;
    }
    /**
   * Cancel this specific command invocation.
   *
   * @description Attempts to cancel the command if it's still buffered or in-flight.
   * If the command has already completed, this will have no effect.
   *
   * @returns true if the command was found and cancelled, false if it was already completed/cancelled
   */ cancel() {
        return this.cancelCallback(this.invocationId);
    }
    /**
   * Cancel all commands in a specific group.
   *
   * @description Cancels all buffered commands that share the same groupId.
   * This is useful for cancelling related commands that were sent as part of the same operation.
   *
   * @param groupId The group identifier of commands to cancel
   * @returns number of commands that were cancelled
   */ cancelGroup(groupId) {
        return this.cancelGroupCallback(groupId);
    }
}

});

parcelRegister("6aaaN", function(module, exports) {
$parcel$export(module.exports, "DiscoveryCommand", () => $a36a4169ba3734f4$export$ae5619804e22bb3b);
$parcel$export(module.exports, "ReachableCommand", () => $a36a4169ba3734f4$export$bf4ce67fda5f9b9f);
$parcel$export(module.exports, "TeardownCommand", () => $a36a4169ba3734f4$export$6884e468caa75174);

var $4IjT0 = parcelRequire("4IjT0");
const $a36a4169ba3734f4$export$ae5619804e22bb3b = (0, $4IjT0.createCommand)('discovery-command');
const $a36a4169ba3734f4$export$bf4ce67fda5f9b9f = (0, $4IjT0.createCommand)('reachable-command');
const $a36a4169ba3734f4$export$6884e468caa75174 = (0, $4IjT0.createCommand)('teardown-command');

});
parcelRegister("4IjT0", function(module, exports) {
$parcel$export(module.exports, "createCommand", () => $6c54f3a9e0daf1f6$export$8d4021544bdece00);

var $6AAKa = parcelRequire("6AAKa");
function $6c54f3a9e0daf1f6$export$8d4021544bdece00(commandName) {
    return class NamedCommand extends (0, $6AAKa.Command) {
        static #_ = /**
     * @see {@link Command.identifier}
     */ this.identifier = commandName;
    };
}
function $6c54f3a9e0daf1f6$export$87c8f2eea65200a8(commandName) {
    // We create a class and then assert the broadcastable marker.
    return class NamedBroadcastCommand extends (0, $6AAKa.Command) {
        static #_ = this.identifier = commandName;
        static #_2 = this.__broadcastable = true;
    };
}

});
parcelRegister("6AAKa", function(module, exports) {
$parcel$export(module.exports, "Command", () => $58a3a3a4aae3ef29$export$cc7e12c76513e857);
class $58a3a3a4aae3ef29$export$cc7e12c76513e857 {
    constructor(properties, result){
        this.properties = properties;
        this.result = result;
    }
}

});



parcelRegister("6I4zX", function(module, exports) {
$parcel$export(module.exports, "getDebugConsumer", () => $42d20f2ad3c3b49f$export$f646f8b6276e8a5d);
$parcel$export(module.exports, "destroyGlobalDebugConsumer", () => $42d20f2ad3c3b49f$export$7e0c663a378d377a);

var $hjIC3 = parcelRequire("hjIC3");
/**
 * Default debug configuration.
 */ const $42d20f2ad3c3b49f$var$DEFAULT_CONFIG = {
    enabled: false,
    maxHistory: 1000
};
class $42d20f2ad3c3b49f$export$6144c928b2a81851 {
    /**
   * Start consuming and logging bridge API events.
   */ enable() {
        if (this.subscription) return; // Already enabled
        this.config.enabled = true;
        this.subscription = (0, $hjIC3.emitter)().onAny((event)=>{
            if (this.config.enabled && this.shouldLogEvent(event)) {
                this.logEvent(event);
                this.addToHistory(event);
            }
        });
        console.log("%c\uD83C\uDF09 Rovo Bridge API Debug Mode Enabled", 'color: #4ECDC4; font-weight: bold; font-size: 14px;');
    }
    /**
   * Stop consuming bridge API events.
   */ disable() {
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = null;
        }
        this.config.enabled = false;
        console.log("%c\uD83C\uDF09 Rovo Bridge API Debug Mode Disabled", 'color: #FF6B6B; font-weight: bold; font-size: 14px;');
    }
    /**
   * Update debug configuration.
   */ configure(newConfig) {
        this.config = {
            ...this.config,
            ...newConfig
        };
        console.log("%c\uD83D\uDD27 Debug configuration updated", 'color: #96CEB4; font-weight: bold;', this.config);
    }
    /**
   * Get current configuration.
   */ getConfig() {
        return {
            ...this.config
        };
    }
    /**
   * Get event history.
   */ getHistory() {
        return [
            ...this.eventHistory
        ];
    }
    /**
   * Clear event history.
   */ clearHistory() {
        this.eventHistory = [];
        console.log("%c\uD83E\uDDF9 Event history cleared", 'color: #FFEAA7; font-weight: bold;');
    }
    /**
   * Get debug statistics.
   */ getStats() {
        const eventCounts = this.eventHistory.reduce((counts, event)=>{
            counts[event.type] = (counts[event.type] || 0) + 1;
            return counts;
        }, {});
        return {
            enabled: this.config.enabled,
            totalEvents: this.eventHistory.length,
            eventCounts: eventCounts,
            uniqueClients: new Set(this.eventHistory.filter((e)=>'clientId' in e).map((e)=>e.clientId)).size,
            uniqueCommands: new Set(this.eventHistory.filter((e)=>'commandType' in e).map((e)=>e.commandType)).size
        };
    }
    /**
   * Export event history as JSON.
   */ exportHistory() {
        return JSON.stringify({
            exportedAt: new Date().toISOString(),
            config: this.config,
            events: this.eventHistory,
            stats: this.getStats()
        }, null, 2);
    }
    /**
   * Log an event to the console with simple formatting.
   */ logEvent(event) {
        const icon = this.eventIcons[event.type] || "\uD83D\uDCCB";
        const timestamp = this.formatTimestamp(event.timestamp);
        const bridgeId = event.bridgeId;
        // Create collapsible group with basic info
        const groupTitle = `${icon} ${timestamp} ${event.type} [${bridgeId}]`;
        console.groupCollapsed(`%c${groupTitle}`, this.getEventTypeStyle(event.type));
        // Add key details in a simple format
        this.logKeyDetails(event);
        // Log raw event data
        console.log('%cRaw Event:', 'color: #888; font-style: italic;', event);
        console.groupEnd();
    }
    /**
   * Log key event details in a simple format.
   */ logKeyDetails(event) {
        // Client ID (if present)
        if ('clientId' in event) {
            const clientEvent = event;
            console.log(`%c\u{1F464} Client: %c${clientEvent.clientId}`, 'font-weight: bold;', this.getClientStyle(clientEvent.clientId));
        }
        // Command details (if present)
        if ('commandType' in event) {
            const cmdEvent = event;
            console.log(`%c\u{26A1} Command: %c${cmdEvent.commandType}`, 'font-weight: bold;', this.getCommandStyle(cmdEvent.commandType));
            if (cmdEvent.senderId && cmdEvent.receiverId) console.log(`%c\u{1F4E4} %c${cmdEvent.senderId} %c\u{2192} %c\u{1F4E5} %c${cmdEvent.receiverId}`, 'font-weight: bold;', this.getClientStyle(cmdEvent.senderId), 'color: #888;', 'font-weight: bold;', this.getClientStyle(cmdEvent.receiverId));
            if (cmdEvent.duration !== undefined) console.log(`%c\u{23F1}\u{FE0F} Duration: %c${this.formatDuration(cmdEvent.duration)}`, 'font-weight: bold;', this.getDurationStyle(cmdEvent.duration));
        }
        // Error (if present)
        if ('error' in event && event.error) {
            const errorEvent = event;
            console.log("%c\u274C Error:", 'color: #FF6B6B; font-weight: bold;', errorEvent.error);
        }
        // Queue size (if present)
        if ('queueSize' in event) {
            const queueEvent = event;
            console.log(`%c\u{1F4CB} Queue Size: %c${queueEvent.queueSize}`, 'font-weight: bold;', this.getQueueSizeStyle(queueEvent.queueSize));
        }
    }
    /**
   * Check if an event should be logged (with debouncing for transport errors).
   */ shouldLogEvent(event) {
        // Apply event filter if configured
        if (this.config.eventFilter && this.config.eventFilter.length > 0) {
            const matchesFilter = this.config.eventFilter.some((filter)=>{
                // Support category filters
                if (filter === 'commands') return event.type.startsWith('command-');
                if (filter === 'clients') return event.type.startsWith('client-');
                if (filter === 'transport') return event.type.startsWith('transport-');
                if (filter === 'queue') return event.type.includes('queue') || event.type.includes('message-');
                if (filter === 'handlers') return event.type.startsWith('handler-');
                if (filter === 'bridge') return event.type.startsWith('bridge-');
                if (filter === 'errors') return event.type.includes('error') || event.type.includes('failed') || event.type.includes('dropped');
                // Support exact event type matching
                return event.type === filter;
            });
            if (!matchesFilter) return false;
        }
        // Debounce transport errors to prevent spam during tick loops
        if (event.type === 'transport-error') {
            var _transportEvent$error;
            const transportEvent = event;
            const errorKey = `${event.type}-${transportEvent.messageId || 'unknown'}-${((_transportEvent$error = transportEvent.error) === null || _transportEvent$error === void 0 ? void 0 : _transportEvent$error.message) || 'unknown'}`;
            const lastLogged = this.recentErrors.get(errorKey) || 0;
            const now = Date.now();
            if (now - lastLogged < this.ERROR_DEBOUNCE_MS) return false; // Skip this duplicate error
            this.recentErrors.set(errorKey, now);
        }
        return true;
    }
    /**
   * Add event to history with size management.
   */ addToHistory(event) {
        this.eventHistory.push(event);
        // Trim history if it exceeds max size
        if (this.eventHistory.length > this.config.maxHistory) this.eventHistory.shift();
    }
    /**
   * Get color for a client ID.
   */ getClientColor(clientId) {
        if (!this.clientColors.has(clientId)) {
            const colorIndex = this.clientColors.size % this.colors.length;
            this.clientColors.set(clientId, this.colors[colorIndex]);
        }
        return this.clientColors.get(clientId);
    }
    /**
   * Get color for a command type.
   */ getCommandColor(commandType) {
        if (!this.commandColors.has(commandType)) {
            const colorIndex = this.commandColors.size % this.colors.length;
            this.commandColors.set(commandType, this.colors[colorIndex]);
        }
        return this.commandColors.get(commandType);
    }
    /**
   * Get CSS style for event type.
   */ getEventTypeStyle(eventType) {
        const baseStyle = 'font-weight: bold; font-size: 12px;';
        if (eventType.includes('error') || eventType.includes('failed')) return `${baseStyle} color: #FF6B6B;`;
        if (eventType.includes('completed') || eventType.includes('ready')) return `${baseStyle} color: #4ECDC4;`;
        if (eventType.includes('created') || eventType.includes('sent')) return `${baseStyle} color: #45B7D1;`;
        return `${baseStyle} color: #666;`;
    }
    /**
   * Get CSS style for client ID.
   */ getClientStyle(clientId) {
        return `color: ${this.getClientColor(clientId)}; font-weight: bold;`;
    }
    /**
   * Get CSS style for command type.
   */ getCommandStyle(commandType) {
        return `color: ${this.getCommandColor(commandType)}; font-weight: bold;`;
    }
    /**
   * Get CSS style for duration based on performance.
   */ getDurationStyle(duration) {
        if (duration < 10) return 'color: #4ECDC4; font-weight: bold;';
         // Fast
        if (duration < 100) return 'color: #FFEAA7; font-weight: bold;';
         // Medium
        return 'color: #FF6B6B; font-weight: bold;'; // Slow
    }
    /**
   * Get CSS style for queue size.
   */ getQueueSizeStyle(size) {
        if (size === 0) return 'color: #4ECDC4; font-weight: bold;';
        if (size < 5) return 'color: #FFEAA7; font-weight: bold;';
        return 'color: #FF6B6B; font-weight: bold;';
    }
    /**
   * Format timestamp for display.
   */ formatTimestamp(timestamp) {
        const date = new Date(timestamp);
        return date.toLocaleTimeString('en-US', {
            hour12: false
        });
    }
    /**
   * Format duration in milliseconds.
   */ formatDuration(ms) {
        if (ms < 1) return `${(ms * 1000).toFixed(0)}\u{3BC}s`;
        if (ms < 1000) return `${ms.toFixed(1)}ms`;
        return `${(ms / 1000).toFixed(2)}s`;
    }
    constructor(){
        this.config = {
            ...$42d20f2ad3c3b49f$var$DEFAULT_CONFIG
        };
        this.subscription = null;
        this.eventHistory = [];
        this.clientColors = new Map();
        this.commandColors = new Map();
        this.recentErrors = new Map();
        this.ERROR_DEBOUNCE_MS = 5000; // 5 seconds
        /**
   * Color palette for consistent coloring.
   */ this.colors = [
            '#FF6B6B',
            '#4ECDC4',
            '#45B7D1',
            '#96CEB4',
            '#FFEAA7',
            '#DDA0DD',
            '#98D8C8',
            '#F7DC6F',
            '#BB8FCE',
            '#85C1E9'
        ];
        /**
   * Event type icons for visual distinction.
   */ this.eventIcons = {
            // Bridge events
            'bridge-ready': "\uD83C\uDF09",
            'bridge-destroyed': "\uD83D\uDCA5",
            // Client events
            'client-registered': "\uD83D\uDCDD",
            'client-ready': "\u2705",
            'client-discovered': "\uD83D\uDD0D",
            'client-teardown': "\uD83D\uDD04",
            // Command events
            'command-created': "\u26A1",
            'command-sent': "\uD83D\uDCE4",
            'command-received': "\uD83D\uDCE5",
            'command-completed': "\u2705",
            'command-failed': "\u274C",
            // Queue events
            'message-queued': "\uD83D\uDCCB",
            'queue-flushed': "\uD83D\uDE80",
            'queue-cleared': "\uD83E\uDDF9",
            'message-dropped': "\uD83D\uDDD1\uFE0F",
            // Transport events
            'transport-ready': "\uD83D\uDE9B",
            'transport-message-sent': "\uD83D\uDCE1",
            'transport-message-received': "\uD83D\uDCFB",
            'transport-error': "\u26A0\uFE0F",
            'transport-destroyed': "\uD83D\uDC80",
            // Handler events
            'handler-registered': "\uD83D\uDD27",
            'handler-unregistered': "\uD83D\uDD13",
            // Broadcast events
            'command-broadcast': "\uD83D\uDCE2"
        };
    }
}
/**
 * Global debug consumer instance.
 */ let $42d20f2ad3c3b49f$var$globalDebugConsumer = null;
function $42d20f2ad3c3b49f$export$f646f8b6276e8a5d() {
    if (!$42d20f2ad3c3b49f$var$globalDebugConsumer) $42d20f2ad3c3b49f$var$globalDebugConsumer = new $42d20f2ad3c3b49f$export$6144c928b2a81851();
    return $42d20f2ad3c3b49f$var$globalDebugConsumer;
}
function $42d20f2ad3c3b49f$export$7e0c663a378d377a() {
    if ($42d20f2ad3c3b49f$var$globalDebugConsumer) {
        $42d20f2ad3c3b49f$var$globalDebugConsumer.disable();
        $42d20f2ad3c3b49f$var$globalDebugConsumer = null;
    }
}

});
parcelRegister("hjIC3", function(module, exports) {
$parcel$export(module.exports, "emitter", () => $df86a3fb6cb2aeb3$export$bad24218ebd77223);
$parcel$export(module.exports, "destroyGlobalEventEmitter", () => $df86a3fb6cb2aeb3$export$9e5e7c9e5a788cf7);
class $df86a3fb6cb2aeb3$export$543ba59d3cb254aa {
    constructor(config = {}){
        this.handlers = new Map();
        this.globalHandlers = new Set();
        this.bridgeId = null;
        this.config = {
            enabled: true,
            ...config
        };
    }
    /**
   * Set the bridge ID for this emitter instance.
   * Should be called once when the bridge API is initialized.
   *
   * @param bridgeId The unique identifier for the bridge API instance
   */ setBridgeId(bridgeId) {
        this.bridgeId = bridgeId;
    }
    /**
   * Emit an event to all registered handlers.
   * Automatically adds timestamp and bridge ID to the event.
   *
   * @param event The event to emit (without timestamp and bridgeId)
   */ emit(event) {
        // Early return if emitter is disabled
        if (!this.config.enabled) return;
        // Automatically add timestamp and bridge ID
        const fullEvent = {
            ...event,
            timestamp: Date.now(),
            bridgeId: this.bridgeId ?? 'unknown-bridge'
        };
        // Emit to type-specific handlers
        const typeHandlers = this.handlers.get(fullEvent.type);
        if (typeHandlers) for (const handler of typeHandlers)this.safeInvoke(handler, fullEvent);
        // Emit to global handlers
        for (const handler of this.globalHandlers)this.safeInvoke(handler, fullEvent);
    }
    /**
   * Listen for events of a specific type.
   *
   * @param eventType The type of event to listen for
   * @param handler The handler function to call when the event occurs
   * @returns A subscription handle
   */ on(eventType, handler) {
        if (!this.handlers.has(eventType)) this.handlers.set(eventType, new Set());
        const handlers = this.handlers.get(eventType);
        handlers.add(handler);
        return this.createSubscription(()=>{
            handlers.delete(handler);
            if (handlers.size === 0) this.handlers.delete(eventType);
        });
    }
    /**
   * Listen for all events regardless of type.
   *
   * @param handler The handler function to call for any event
   * @returns A subscription handle
   */ onAny(handler) {
        this.globalHandlers.add(handler);
        return this.createSubscription(()=>{
            this.globalHandlers.delete(handler);
        });
    }
    /**
   * Remove a specific handler for an event type.
   *
   * @param eventType The event type to remove the handler from
   * @param handler The handler to remove
   */ off(eventType, handler) {
        const handlers = this.handlers.get(eventType);
        if (handlers) {
            handlers.delete(handler);
            if (handlers.size === 0) this.handlers.delete(eventType);
        }
    }
    /**
   * Remove all handlers for a specific event type.
   *
   * @param eventType The event type to clear handlers for
   */ removeAllListeners(eventType) {
        if (eventType) this.handlers.delete(eventType);
        else {
            this.handlers.clear();
            this.globalHandlers.clear();
        }
    }
    /**
   * Update emitter configuration.
   *
   * @param config New configuration options
   */ configure(config) {
        this.config = {
            ...this.config,
            ...config
        };
    }
    /**
   * Enable or disable the emitter.
   *
   * @param enabled Whether to enable event emission
   */ setEnabled(enabled) {
        this.config.enabled = enabled;
    }
    /**
   * Check if the emitter is currently enabled.
   */ isEnabled() {
        return this.config.enabled;
    }
    /**
   * Destroy the emitter and clean up all resources.
   */ destroy() {
        this.handlers.clear();
        this.globalHandlers.clear();
        this.config.enabled = false;
    }
    /**
   * Safely invoke a handler, catching any errors.
   */ safeInvoke(handler, event) {
        try {
            handler(event);
        } catch  {
        // we do not want to produce error logs for the observer
        // if you need to add logs, go for it - just remove them afterwards!
        }
    }
    /**
   * Create a subscription handle.
   */ createSubscription(unsubscribeFn) {
        let active = true;
        return {
            unsubscribe: ()=>{
                if (active) {
                    unsubscribeFn();
                    active = false;
                }
            },
            isActive: ()=>active
        };
    }
}
/**
 * Default global event emitter instance.
 *
 * This can be used as a singleton across the bridge API, or individual
 * bridge instances can create their own emitters.
 */ let $df86a3fb6cb2aeb3$var$globalEmitter = null;
function $df86a3fb6cb2aeb3$export$bad24218ebd77223() {
    if (!$df86a3fb6cb2aeb3$var$globalEmitter) $df86a3fb6cb2aeb3$var$globalEmitter = new $df86a3fb6cb2aeb3$export$543ba59d3cb254aa();
    return $df86a3fb6cb2aeb3$var$globalEmitter;
}
function $df86a3fb6cb2aeb3$export$9e5e7c9e5a788cf7() {
    if ($df86a3fb6cb2aeb3$var$globalEmitter) {
        $df86a3fb6cb2aeb3$var$globalEmitter.destroy();
        $df86a3fb6cb2aeb3$var$globalEmitter = null;
    }
}

});


parcelRegister("92S6u", function(module, exports) {
$parcel$export(module.exports, "destroyGlobalObservabilityConsumer", () => $79e240c6406b54ae$export$19aa922f09a1d9de);

var $hjIC3 = parcelRequire("hjIC3");
const $79e240c6406b54ae$var$DEFAULT_CONFIG = {
    registrationGapThresholdMs: 10000,
    queueDepthWarningThreshold: 50,
    registrationGapDebounceMs: 60000
};
class $79e240c6406b54ae$export$43f799969b7f8bad {
    enable(sink, config) {
        if (this.subscription) return;
        if (config) this.config = {
            ...$79e240c6406b54ae$var$DEFAULT_CONFIG,
            ...config
        };
        this.sink = sink;
        this.subscription = (0, $hjIC3.emitter)().onAny((event)=>this.handle(event));
    }
    disable() {
        var _this$subscription;
        (_this$subscription = this.subscription) === null || _this$subscription === void 0 || _this$subscription.unsubscribe();
        this.subscription = null;
        this.sink = null;
        for (const { timer: timer } of this.pendingReceivers.values())clearTimeout(timer);
        this.pendingReceivers.clear();
        this.registeredClients.clear();
        this.lastGapEmittedAt.clear();
    }
    isEnabled() {
        return this.subscription !== null;
    }
    handle(event) {
        switch(event.type){
            case 'client-registered':
            case 'client-discovered':
                {
                    const { clientId: clientId } = event;
                    this.registeredClients.add(clientId);
                    this.resolvePendingReceiver(clientId, 'registration-succeeded');
                    break;
                }
            case 'client-teardown':
                {
                    const { clientId: clientId } = event;
                    this.registeredClients.delete(clientId);
                    this.resolvePendingReceiver(clientId, 'registration-aborted');
                    break;
                }
            case 'message-queued':
                {
                    const queueEvent = event;
                    const receiverId = queueEvent.clientId;
                    if (receiverId && !this.registeredClients.has(receiverId)) this.trackPendingReceiver(receiverId);
                    if ((queueEvent.messageCount ?? 0) >= this.config.queueDepthWarningThreshold) this.forward('message-queued', event, {
                        clientId: receiverId,
                        reason: queueEvent.reason,
                        queueDepth: queueEvent.messageCount
                    });
                    break;
                }
            case 'queue-flushed':
                {
                    const receiverId = event.clientId;
                    if (receiverId) this.resolvePendingReceiver(receiverId, 'registration-succeeded');
                    break;
                }
            case 'queue-cleared':
                {
                    const receiverId = event.clientId;
                    if (receiverId) this.resolvePendingReceiver(receiverId, 'registration-aborted');
                    break;
                }
            case 'message-dropped':
                {
                    const queueEvent = event;
                    this.forward('message-dropped', event, {
                        clientId: queueEvent.clientId,
                        reason: queueEvent.reason,
                        queueDepth: queueEvent.messageCount
                    });
                    break;
                }
            default:
                break;
        }
    }
    trackPendingReceiver(receiverId) {
        var _this$sink;
        if (this.pendingReceivers.has(receiverId)) return;
        const timer = setTimeout(()=>this.emitRegistrationGap(receiverId), this.config.registrationGapThresholdMs);
        this.pendingReceivers.set(receiverId, {
            firstQueuedAt: Date.now(),
            timer: timer
        });
        (_this$sink = this.sink) === null || _this$sink === void 0 || _this$sink.call(this, {
            signal: 'registration-pending',
            clientId: receiverId,
            timestamp: Date.now()
        });
    }
    resolvePendingReceiver(receiverId, outcome) {
        var _this$sink2;
        const pending = this.pendingReceivers.get(receiverId);
        if (!pending) return;
        clearTimeout(pending.timer);
        this.pendingReceivers.delete(receiverId);
        const now = Date.now();
        (_this$sink2 = this.sink) === null || _this$sink2 === void 0 || _this$sink2.call(this, {
            signal: outcome,
            clientId: receiverId,
            waitedMs: now - pending.firstQueuedAt,
            timestamp: now
        });
    }
    emitRegistrationGap(receiverId) {
        var _this$sink3;
        const pending = this.pendingReceivers.get(receiverId);
        this.pendingReceivers.delete(receiverId);
        if (!pending || this.registeredClients.has(receiverId)) return;
        const now = Date.now();
        const lastEmitted = this.lastGapEmittedAt.get(receiverId);
        if (lastEmitted !== undefined && now - lastEmitted < this.config.registrationGapDebounceMs) return;
        this.lastGapEmittedAt.set(receiverId, now);
        (_this$sink3 = this.sink) === null || _this$sink3 === void 0 || _this$sink3.call(this, {
            signal: 'registration-gap',
            clientId: receiverId,
            waitedMs: now - pending.firstQueuedAt,
            timestamp: now
        });
    }
    forward(signal, source, fields) {
        var _this$sink4;
        (_this$sink4 = this.sink) === null || _this$sink4 === void 0 || _this$sink4.call(this, {
            signal: signal,
            timestamp: source.timestamp ?? Date.now(),
            bridgeId: source.bridgeId,
            ...fields
        });
    }
    constructor(){
        this.subscription = null;
        this.sink = null;
        this.config = {
            ...$79e240c6406b54ae$var$DEFAULT_CONFIG
        };
        this.registeredClients = new Set();
        this.pendingReceivers = new Map();
        this.lastGapEmittedAt = new Map();
    }
}
let $79e240c6406b54ae$var$globalObservabilityConsumer = null;
function $79e240c6406b54ae$export$4c639b188cc02177() {
    if (!$79e240c6406b54ae$var$globalObservabilityConsumer) $79e240c6406b54ae$var$globalObservabilityConsumer = new $79e240c6406b54ae$export$43f799969b7f8bad();
    return $79e240c6406b54ae$var$globalObservabilityConsumer;
}
function $79e240c6406b54ae$export$19aa922f09a1d9de() {
    if ($79e240c6406b54ae$var$globalObservabilityConsumer) {
        $79e240c6406b54ae$var$globalObservabilityConsumer.disable();
        $79e240c6406b54ae$var$globalObservabilityConsumer = null;
    }
}

});

parcelRegister("i0f0B", function(module, exports) {
$parcel$export(module.exports, "BufferedInvocationQueue", () => $57a9ea72fbaedd55$export$b0fcb10052c4c5ff);

var $hjIC3 = parcelRequire("hjIC3");

var $gVHZB = parcelRequire("gVHZB");
class $57a9ea72fbaedd55$export$b0fcb10052c4c5ff {
    /**
   * Buffers an invocation into a queue tied to the intended {@link receiverId}.
   *
   * @description Once the receiver is reachable, this message will be flushed alongside any other messages
   * which were previously enqueued against the provided {@link receiverId}.
   *
   * @param invocationId
   * @param senderId
   * @param receiverId
   * @param command
   * @param params
   */ enqueue(invocationId, senderId, receiverId, command, params) {
        const queue = this.queue.get(receiverId) ?? [];
        const now = performance.now();
        const groupId = params.groupId;
        // check the receiver is not overwhelmed with too many pending messages; if it is, drop the oldest message
        if (queue.length >= (0, $gVHZB.MAX_MESSAGES_PER_RECEIVER)) {
            console.warn(`Message queue for receiver ${receiverId} is full, dropping oldest message`);
            const expired = queue.shift();
            if (expired) {
                var _this$onInvocationDro;
                (_this$onInvocationDro = this.onInvocationDropped) === null || _this$onInvocationDro === void 0 || _this$onInvocationDro.call(this, expired);
            }
        }
        // check if the overall queue isn't overwhelmed; if it is, drop the oldest message from each receiver
        if (this.messageCount >= (0, $gVHZB.MAX_TOTAL_MESSAGES)) {
            console.warn('Total message queue is full, dropping oldest messages');
            this.checkAndDropOldestMessage();
        }
        // If this command has a groupId, reset the timer for all commands with the same groupId
        if (groupId) this.resetGroupTimers(groupId, now);
        queue.push({
            invocationId: invocationId,
            senderId: senderId,
            receiverId: receiverId,
            command: command,
            params: params,
            enqueuedAt: now
        });
        this.queue.set(receiverId, queue);
        (0, $hjIC3.emitter)().emit({
            type: 'message-queued',
            messageCount: this.messageCount,
            messageId: invocationId,
            clientId: receiverId,
            reason: 'receiver-not-ready'
        });
        // now that we have >1 message (at least), start a tick which executes every N millis
        // and drop any messages which go beyond the lifetime limit
        this.startTick();
    }
    /**
   * Flush all messages associated with a speciifc receiver.
   *
   * @description Typically called once the receiver is marked as ready.
   *
   * @param receiverId unique identifier for the receiver
   */ flush(receiverId) {
        const messages = this.queue.get(receiverId);
        // no messages found
        if (!messages) return;
        // we know we have a reference in the message list now - remove it
        this.deleteClientFromQueue(receiverId);
        // empty message list
        if (messages.length === 0) return;
        // emit queue flush event
        (0, $hjIC3.emitter)().emit({
            type: 'queue-flushed',
            clientId: receiverId,
            messageCount: messages.length,
            reason: 'client-ready'
        });
        // return no-empty message list
        return messages;
    }
    /**
   * Returns the total number of messages across all receivers.
   * @returns count of messages across all buffered receivers
   */ get messageCount() {
        return Array.from(this.queue.values()).reduce((sum, q)=>sum + q.length, 0);
    }
    /**
   * Registers a callback to be called on every tick with unique senderId/receiverId pairs
   * for clients that are still waiting to connect.
   *
   * @param callback Function to call with pending connection pairs
   */ onTick(callback) {
        this.onTickCallback = callback;
    }
    /**
   * Registers a callback to be called when a message is dropped due to expiration or queue overflow.
   *
   * @param callback Callback to invoke with the dropped message
   */ onInvocationDroppped(callback) {
        this.onInvocationDropped = callback;
    }
    /**
   * Drops all buffered messages for a specific client (both as sender and receiver).
   *
   * @param clientId unique identifier for the client whose messages should be dropped
   * @returns number of messages that were dropped
   */ clear(clientId) {
        let droppedCount = 0;
        const toDelete = new Set();
        // remove all messages where this client is the receiver
        if (this.queue.has(clientId)) {
            const messages = this.queue.get(clientId) ?? [];
            if (messages.length > 0) (0, $hjIC3.emitter)().emit({
                type: 'queue-cleared',
                clientId: clientId,
                messageCount: this.messageCount - messages.length,
                reason: 'client-teardown'
            });
            // notify before dropping messages
            if (this.onInvocationDropped) for (const message of messages)this.onInvocationDropped(message);
            droppedCount += messages.length;
            // delete immediately - we do not want to process this queue below
            this.queue.delete(clientId);
        }
        // remove all messages where this client is the sender
        for (const [receiverId, messages] of this.queue){
            const messagesLength = messages.length;
            const messagesToKeep = messages.filter((message)=>{
                if (message.senderId === clientId) {
                    // notify before dropping message
                    if (this.onInvocationDropped) this.onInvocationDropped(message);
                    return false;
                }
                return true;
            });
            const removedCount = messagesLength - messagesToKeep.length;
            if (removedCount > 0) {
                droppedCount += removedCount;
                if (messagesToKeep.length === 0) toDelete.add(receiverId);
                else this.queue.set(receiverId, messagesToKeep);
            }
        }
        // clean up empty queues and stop tick
        this.deleteClientsFromQueue(toDelete);
        return droppedCount;
    }
    /**
   * Drops a specific buffered message by its invocation ID.
   *
   * @param invocationId The unique identifier of the message to drop
   * @returns true if the message was found and dropped, false otherwise
   */ cancel(invocationId) {
        for (const [receiverId, messages] of this.queue){
            const messageIndex = messages.findIndex((msg)=>msg.invocationId === invocationId);
            if (messageIndex !== -1) {
                const droppedMessage = messages[messageIndex];
                // notify before dropping message
                if (this.onInvocationDropped) this.onInvocationDropped(droppedMessage);
                // remove the message
                messages.splice(messageIndex, 1);
                // if no more messages for this receiver, clean up
                if (messages.length === 0) this.deleteClientFromQueue(receiverId);
                return true;
            }
        }
        return false;
    }
    /**
   * Cancels all buffered messages that match a specific group ID.
   *
   * @param groupId The group identifier of messages to cancel
   * @returns number of messages that were cancelled
   */ cancelGroup(groupId) {
        let droppedCount = 0;
        const toDelete = new Set();
        for (const [receiverId, messages] of this.queue){
            const messagesToKeep = messages.filter((message)=>{
                if (message.params.groupId === groupId) {
                    // notify before dropping message
                    if (this.onInvocationDropped) this.onInvocationDropped(message);
                    droppedCount++;
                    return false;
                }
                return true;
            });
            if (messagesToKeep.length === 0) toDelete.add(receiverId);
            else if (messagesToKeep.length !== messages.length) this.queue.set(receiverId, messagesToKeep);
        }
        // clean up empty queues
        this.deleteClientsFromQueue(toDelete);
        return droppedCount;
    }
    /**
   * Clear all state relevant to the queue.
   */ destroy() {
        this.queue.clear();
        if (this.tick) {
            clearInterval(this.tick);
            this.tick = undefined;
        }
        // clear callback references
        this.onTickCallback = undefined;
        this.onInvocationDropped = undefined;
    }
    /**
   * Checks the lifetime of all messages in the queue and drops them if they have exceeded their
   * maximum allowed lifetime of {@link MESSAGE_LIFETIME_IN_MILLIS}.
   */ checkLifetimeAndDrop() {
        const now = performance.now();
        const toDelete = new Set();
        // cull all messages for each receiver which have expired
        for (const [receiverId, messages] of this.queue){
            let needle = 0;
            // find the first message that has not expired (since messages are chronologically ordered)
            for(let idx = 0; idx < messages.length; idx++){
                const waitTime = now - messages[idx].enqueuedAt;
                if (waitTime <= (0, $gVHZB.MESSAGE_LIFETIME_IN_MILLIS)) {
                    needle = idx;
                    break;
                } else needle = messages.length;
            }
            // remove all expired messages in one sweep
            if (needle > 0) {
                // notify before dropping messages
                if (this.onInvocationDropped) for(let idx = 0; idx < needle; idx++)this.onInvocationDropped(messages[idx]);
                // remove expired messages
                messages.splice(0, needle);
            }
            // if we no longer have any messages, we should clear this entry entirely
            if (messages.length === 0) toDelete.add(receiverId);
        }
        // clean up all empty entries
        this.deleteClientsFromQueue(toDelete);
    }
    /**
   * Drops the oldest messages across all receivers when the total queue size is exceeded.
   */ checkAndDropOldestMessage() {
        let oldest = Infinity;
        let receiver = null;
        for (const [receiverId, messages] of this.queue)if (messages.length > 0 && messages[0].enqueuedAt < oldest) {
            oldest = messages[0].enqueuedAt;
            receiver = receiverId;
        }
        // drop the oldest message
        if (receiver) {
            const queue = this.queue.get(receiver) ?? [];
            queue.shift();
            // if no more messages - clean up
            if (queue.length === 0) this.deleteClientFromQueue(receiver);
        }
    }
    /**
   * Resets the enqueuedAt time for all messages with the specified groupId across all receivers.
   * This ensures that when a new message with a groupId is enqueued, all messages in the same
   * group get their timer reset, allowing the entire group to stay alive for MESSAGE_LIFETIME_IN_MILLIS
   * after the last message in the group.
   *
   * @param groupId The group identifier to reset timers for
   * @param newTime The new enqueuedAt time to set for all messages in the group
   */ resetGroupTimers(groupId, newTime) {
        for (const messages of this.queue.values()){
            for (const message of messages)if (message.params.groupId === groupId) message.enqueuedAt = newTime;
        }
    }
    /**
   * Extracts unique senderId/receiverId pairs from all buffered messages.
   * @returns Array of unique sender/receiver pairs that are still waiting to connect
   */ getUniquePendingConnections() {
        const uniquePairs = new Map();
        for (const messages of this.queue.values())for (const message of messages){
            const key = `${message.senderId}:${message.receiverId}`;
            if (!uniquePairs.has(key)) uniquePairs.set(key, {
                senderId: message.senderId,
                receiverId: message.receiverId
            });
        }
        return Array.from(uniquePairs.values());
    }
    /**
   * Safely deletes a single client from the queue and handles cleanup.
   *
   * @param clientId The client to remove from the queue
   * @private
   */ deleteClientFromQueue(clientId) {
        this.queue.delete(clientId);
        this.stopTick();
    }
    /**
   * Safely deletes multiple clients from the queue and handles cleanup.
   *
   * @param clientIds Set of client IDs to remove from the queue
   * @private
   */ deleteClientsFromQueue(clientIds) {
        for (const clientId of clientIds)this.queue.delete(clientId);
        this.stopTick();
    }
    constructor(){
        /**
   * A queue of messages keyed against a recipient client ID.
   *
   * @description Once the receiver is ready, we will flush all messages to them, IF they have not expired.
   */ this.queue = new Map();
        /**
   * A lazy tick which is executed only if there are buffered messages, and cleans up a message after
   * {@link MESSAGE_LIFETIME_IN_MILLIS} have elapsed since the message was enqueued.
   *
   * @description NOTE: It is important to ensure there is only one interval which can run at any given time.
   * Too many timers can clog up the event loop and slow execution:
   */ this.tick = undefined;
        /**
   * Starts an interval which does a full sweep every {@link MESSAGE_TICK_TIME_IN_MILLIS} to drop messages
   * which have gone beyond their lifetime.
   *
   * @description NOTE: The use of {@link setInterval} is deliberate here, as browsers will try their best
   * to continue executing {@link setInterval} callbacks even if a tab is unfocused. If the tab enters the
   * 'frozen' state in Chromium browsers, then execution is completely paused as per:
   * @see {@link https://developer.chrome.com/docs/web-platform/page-lifecycle-api}
   */ this.startTick = ()=>{
            if (this.tick) return;
            this.tick = setInterval(()=>{
                this.checkLifetimeAndDrop();
                // Call the onTick callback if registered and there are buffered messages
                if (this.onTickCallback && this.queue.size > 0) {
                    const pendingConnections = this.getUniquePendingConnections();
                    this.onTickCallback(pendingConnections);
                }
            }, (0, $gVHZB.MESSAGE_TICK_TIME_IN_MILLIS));
        };
        /**
   * Stops the tick if there are no more messages to process.
   */ this.stopTick = ()=>{
            if (this.queue.size > 0) return;
            clearInterval(this.tick);
            this.tick = undefined;
        };
    }
}

});
parcelRegister("gVHZB", function(module, exports) {
$parcel$export(module.exports, "MESSAGE_LIFETIME_IN_MILLIS", () => $70fa18ab367ea899$export$ac4b6c122e5e5626);
$parcel$export(module.exports, "MESSAGE_TICK_TIME_IN_MILLIS", () => $70fa18ab367ea899$export$5176aa4eceb2405e);
$parcel$export(module.exports, "MAX_MESSAGES_PER_RECEIVER", () => $70fa18ab367ea899$export$1552419560d53c41);
$parcel$export(module.exports, "MAX_TOTAL_MESSAGES", () => $70fa18ab367ea899$export$2805cdefd9b18065);
// Max time in millis an enqueued invocation message is allowed to live on the queue.
// NOTE: we choose a number which represents a reasonable portion of a user's session.
// I.e., if a user is SPA navigating a web / desktop app, we expect them to stick around
// for more than a typical web page. The longer they stay, the more the probability of objects
// starting to hang around in memory. But also: we don't want to clean up too soon in case we
// have a flakey receiver / want to peform a full event replay / rehydration. Hence the number
// chosen below. For future readers consider AI networking streams & events (long-running).
const $70fa18ab367ea899$export$ac4b6c122e5e5626 = 90000;
const $70fa18ab367ea899$export$5176aa4eceb2405e = 100;
const $70fa18ab367ea899$export$1552419560d53c41 = 1000;
const $70fa18ab367ea899$export$2805cdefd9b18065 = 10000;

});


parcelRegister("bnlQq", function(module, exports) {
$parcel$export(module.exports, "createInvocationId", () => $51223af2e6609e8c$export$4f25fe9107a7301c);
$parcel$export(module.exports, "rpcCommand", () => $51223af2e6609e8c$export$e414fa4333835a96);
$parcel$export(module.exports, "rpcSuccess", () => $51223af2e6609e8c$export$8dddc5c53da4c063);
$parcel$export(module.exports, "rpcError", () => $51223af2e6609e8c$export$97e0f665ead0e435);
$parcel$export(module.exports, "isRPCRequest", () => $51223af2e6609e8c$export$94e3360fcddccc76);
$parcel$export(module.exports, "isRPCResponse", () => $51223af2e6609e8c$export$c2a53faed5b3a8da);

var $lvlN8 = parcelRequire("lvlN8");
function $51223af2e6609e8c$export$4f25fe9107a7301c(commandClass, commandProperties) {
    const parts = [
        'rovo-bridge-api',
        commandProperties.senderId,
        commandProperties.receiverId,
        commandClass.identifier,
        commandProperties._invocationId ?? 'unspecified-id'
    ];
    return parts.join(':');
}
function $51223af2e6609e8c$export$e414fa4333835a96(id, commandClass, commandProperties) {
    return (0, $lvlN8.createJSONRPCRequest)(id, commandClass.identifier, commandProperties);
}
function $51223af2e6609e8c$export$8dddc5c53da4c063(id, senderId, receiverId, result) {
    const response = (0, $lvlN8.createJSONRPCSuccessResponse)(id, result);
    return {
        ...response,
        params: {
            senderId: senderId,
            receiverId: receiverId
        }
    };
}
function $51223af2e6609e8c$export$97e0f665ead0e435(id, senderId, receiverId, code = (0, $lvlN8.JSONRPCErrorCode).InternalError, error) {
    const response = (0, $lvlN8.createJSONRPCErrorResponse)(id, code, error.message, error.stack);
    return {
        ...response,
        params: {
            senderId: senderId,
            receiverId: receiverId
        }
    };
}
function $51223af2e6609e8c$export$94e3360fcddccc76(request) {
    return Boolean((0, $lvlN8.isJSONRPCRequest)(request) && request.id && typeof request.id === 'string');
}
function $51223af2e6609e8c$export$c2a53faed5b3a8da(response) {
    return Boolean((0, $lvlN8.isJSONRPCResponse)(response) && response.id && typeof response.id === 'string');
}

});
parcelRegister("lvlN8", function(module, exports) {
"use strict";
var $fa7d6594ac57b65d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fa7d6594ac57b65d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fa7d6594ac57b65d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$fa7d6594ac57b65d$var$__exportStar((parcelRequire("kUrxr")), module.exports);

$fa7d6594ac57b65d$var$__exportStar((parcelRequire("cWQs9")), module.exports);

$fa7d6594ac57b65d$var$__exportStar((parcelRequire("6Mt5O")), module.exports);

$fa7d6594ac57b65d$var$__exportStar((parcelRequire("9qMgf")), module.exports);

$fa7d6594ac57b65d$var$__exportStar((parcelRequire("7kNhW")), module.exports);

});
parcelRegister("kUrxr", function(module, exports) {
"use strict";
var $f38e66286e9ced66$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f38e66286e9ced66$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JSONRPCClient = void 0;

var $6Mt5O = parcelRequire("6Mt5O");

var $a9Khi = parcelRequire("a9Khi");
var $f38e66286e9ced66$var$JSONRPCClient = /** @class */ function() {
    function JSONRPCClient(_send, createID) {
        this._send = _send;
        this.createID = createID;
        this.idToResolveMap = new Map();
        this.id = 0;
    }
    JSONRPCClient.prototype._createID = function() {
        if (this.createID) return this.createID();
        else return ++this.id;
    };
    JSONRPCClient.prototype.timeout = function(delay, overrideCreateJSONRPCErrorResponse) {
        var _this = this;
        if (overrideCreateJSONRPCErrorResponse === void 0) overrideCreateJSONRPCErrorResponse = function(id) {
            return (0, $6Mt5O.createJSONRPCErrorResponse)(id, $a9Khi.DefaultErrorCode, "Request timeout");
        };
        var timeoutRequest = function(ids, request) {
            var timeoutID = setTimeout(function() {
                ids.forEach(function(id) {
                    var resolve = _this.idToResolveMap.get(id);
                    if (resolve) {
                        _this.idToResolveMap.delete(id);
                        resolve(overrideCreateJSONRPCErrorResponse(id));
                    }
                });
            }, delay);
            return request().then(function(result) {
                clearTimeout(timeoutID);
                return result;
            }, function(error) {
                clearTimeout(timeoutID);
                return Promise.reject(error);
            });
        };
        var requestAdvanced = function(request, clientParams) {
            var ids = (!Array.isArray(request) ? [
                request
            ] : request).map(function(request) {
                return request.id;
            }).filter($f38e66286e9ced66$var$isDefinedAndNonNull);
            return timeoutRequest(ids, function() {
                return _this.requestAdvanced(request, clientParams);
            });
        };
        return {
            request: function(method, params, clientParams) {
                var id = _this._createID();
                return timeoutRequest([
                    id
                ], function() {
                    return _this.requestWithID(method, params, clientParams, id);
                });
            },
            requestAdvanced: function(request, clientParams) {
                return requestAdvanced(request, clientParams);
            }
        };
    };
    JSONRPCClient.prototype.request = function(method, params, clientParams) {
        return this.requestWithID(method, params, clientParams, this._createID());
    };
    JSONRPCClient.prototype.requestWithID = function(method, params, clientParams, id) {
        return $f38e66286e9ced66$var$__awaiter(this, void 0, void 0, function() {
            var request, response;
            return $f38e66286e9ced66$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        request = (0, $6Mt5O.createJSONRPCRequest)(id, method, params);
                        return [
                            4 /*yield*/ ,
                            this.requestAdvanced(request, clientParams)
                        ];
                    case 1:
                        response = _a.sent();
                        if (response.result !== undefined && !response.error) return [
                            2 /*return*/ ,
                            response.result
                        ];
                        else if (response.result === undefined && response.error) return [
                            2 /*return*/ ,
                            Promise.reject(new $6Mt5O.JSONRPCErrorException(response.error.message, response.error.code, response.error.data))
                        ];
                        else return [
                            2 /*return*/ ,
                            Promise.reject(new Error("An unexpected error occurred"))
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    JSONRPCClient.prototype.requestAdvanced = function(requests, clientParams) {
        var _this = this;
        var areRequestsOriginallyArray = Array.isArray(requests);
        if (!Array.isArray(requests)) requests = [
            requests
        ];
        var requestsWithID = requests.filter(function(request) {
            return $f38e66286e9ced66$var$isDefinedAndNonNull(request.id);
        });
        var promises = requestsWithID.map(function(request) {
            return new Promise(function(resolve) {
                return _this.idToResolveMap.set(request.id, resolve);
            });
        });
        var promise = Promise.all(promises).then(function(responses) {
            if (areRequestsOriginallyArray || !responses.length) return responses;
            else return responses[0];
        });
        return this.send(areRequestsOriginallyArray ? requests : requests[0], clientParams).then(function() {
            return promise;
        }, function(error) {
            requestsWithID.forEach(function(request) {
                _this.receive((0, $6Mt5O.createJSONRPCErrorResponse)(request.id, $a9Khi.DefaultErrorCode, error && error.message || "Failed to send a request"));
            });
            return promise;
        });
    };
    JSONRPCClient.prototype.notify = function(method, params, clientParams) {
        var request = (0, $6Mt5O.createJSONRPCNotification)(method, params);
        this.send(request, clientParams).then(undefined, function() {
            return undefined;
        });
    };
    JSONRPCClient.prototype.send = function(payload, clientParams) {
        return $f38e66286e9ced66$var$__awaiter(this, void 0, void 0, function() {
            return $f38e66286e9ced66$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this._send(payload, clientParams)
                ];
            });
        });
    };
    JSONRPCClient.prototype.rejectAllPendingRequests = function(message) {
        this.idToResolveMap.forEach(function(resolve, id) {
            return resolve((0, $6Mt5O.createJSONRPCErrorResponse)(id, $a9Khi.DefaultErrorCode, message));
        });
        this.idToResolveMap.clear();
    };
    JSONRPCClient.prototype.receive = function(responses) {
        var _this = this;
        if (!Array.isArray(responses)) responses = [
            responses
        ];
        responses.forEach(function(response) {
            var resolve = _this.idToResolveMap.get(response.id);
            if (resolve) {
                _this.idToResolveMap.delete(response.id);
                resolve(response);
            }
        });
    };
    return JSONRPCClient;
}();
module.exports.JSONRPCClient = $f38e66286e9ced66$var$JSONRPCClient;
var $f38e66286e9ced66$var$isDefinedAndNonNull = function(value) {
    return value !== undefined && value !== null;
};

});
parcelRegister("6Mt5O", function(module, exports) {
"use strict";
var $4efdcb021f669a43$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createJSONRPCNotification = module.exports.createJSONRPCRequest = module.exports.createJSONRPCSuccessResponse = module.exports.createJSONRPCErrorResponse = module.exports.JSONRPCErrorCode = module.exports.JSONRPCErrorException = module.exports.isJSONRPCResponses = module.exports.isJSONRPCResponse = module.exports.isJSONRPCRequests = module.exports.isJSONRPCRequest = module.exports.isJSONRPCID = module.exports.JSONRPC = void 0;
module.exports.JSONRPC = "2.0";
var $4efdcb021f669a43$var$isJSONRPCID = function(id) {
    return typeof id === "string" || typeof id === "number" || id === null;
};
module.exports.isJSONRPCID = $4efdcb021f669a43$var$isJSONRPCID;
var $4efdcb021f669a43$var$isJSONRPCRequest = function(payload) {
    return payload.jsonrpc === module.exports.JSONRPC && payload.method !== undefined && payload.result === undefined && payload.error === undefined;
};
module.exports.isJSONRPCRequest = $4efdcb021f669a43$var$isJSONRPCRequest;
var $4efdcb021f669a43$var$isJSONRPCRequests = function(payload) {
    return Array.isArray(payload) && payload.every(module.exports.isJSONRPCRequest);
};
module.exports.isJSONRPCRequests = $4efdcb021f669a43$var$isJSONRPCRequests;
var $4efdcb021f669a43$var$isJSONRPCResponse = function(payload) {
    return payload.jsonrpc === module.exports.JSONRPC && payload.id !== undefined && (payload.result !== undefined || payload.error !== undefined);
};
module.exports.isJSONRPCResponse = $4efdcb021f669a43$var$isJSONRPCResponse;
var $4efdcb021f669a43$var$isJSONRPCResponses = function(payload) {
    return Array.isArray(payload) && payload.every(module.exports.isJSONRPCResponse);
};
module.exports.isJSONRPCResponses = $4efdcb021f669a43$var$isJSONRPCResponses;
var $4efdcb021f669a43$var$createJSONRPCError = function(code, message, data) {
    var error = {
        code: code,
        message: message
    };
    if (data != null) error.data = data;
    return error;
};
var $4efdcb021f669a43$var$JSONRPCErrorException = /** @class */ function(_super) {
    $4efdcb021f669a43$var$__extends(JSONRPCErrorException, _super);
    function JSONRPCErrorException(message, code, data) {
        var _this = _super.call(this, message) || this;
        // Manually set the prototype to fix TypeScript issue:
        // https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, JSONRPCErrorException.prototype);
        _this.code = code;
        _this.data = data;
        return _this;
    }
    JSONRPCErrorException.prototype.toObject = function() {
        return $4efdcb021f669a43$var$createJSONRPCError(this.code, this.message, this.data);
    };
    return JSONRPCErrorException;
}(Error);
module.exports.JSONRPCErrorException = $4efdcb021f669a43$var$JSONRPCErrorException;
var $4efdcb021f669a43$var$JSONRPCErrorCode;
(function(JSONRPCErrorCode) {
    JSONRPCErrorCode[JSONRPCErrorCode["ParseError"] = -32700] = "ParseError";
    JSONRPCErrorCode[JSONRPCErrorCode["InvalidRequest"] = -32600] = "InvalidRequest";
    JSONRPCErrorCode[JSONRPCErrorCode["MethodNotFound"] = -32601] = "MethodNotFound";
    JSONRPCErrorCode[JSONRPCErrorCode["InvalidParams"] = -32602] = "InvalidParams";
    JSONRPCErrorCode[JSONRPCErrorCode["InternalError"] = -32603] = "InternalError";
})($4efdcb021f669a43$var$JSONRPCErrorCode = module.exports.JSONRPCErrorCode || (module.exports.JSONRPCErrorCode = {}));
var $4efdcb021f669a43$var$createJSONRPCErrorResponse = function(id, code, message, data) {
    return {
        jsonrpc: module.exports.JSONRPC,
        id: id,
        error: $4efdcb021f669a43$var$createJSONRPCError(code, message, data)
    };
};
module.exports.createJSONRPCErrorResponse = $4efdcb021f669a43$var$createJSONRPCErrorResponse;
var $4efdcb021f669a43$var$createJSONRPCSuccessResponse = function(id, result) {
    return {
        jsonrpc: module.exports.JSONRPC,
        id: id,
        result: result !== null && result !== void 0 ? result : null
    };
};
module.exports.createJSONRPCSuccessResponse = $4efdcb021f669a43$var$createJSONRPCSuccessResponse;
var $4efdcb021f669a43$var$createJSONRPCRequest = function(id, method, params) {
    return {
        jsonrpc: module.exports.JSONRPC,
        id: id,
        method: method,
        params: params
    };
};
module.exports.createJSONRPCRequest = $4efdcb021f669a43$var$createJSONRPCRequest;
var $4efdcb021f669a43$var$createJSONRPCNotification = function(method, params) {
    return {
        jsonrpc: module.exports.JSONRPC,
        method: method,
        params: params
    };
};
module.exports.createJSONRPCNotification = $4efdcb021f669a43$var$createJSONRPCNotification;

});

parcelRegister("a9Khi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultErrorCode = void 0;
module.exports.DefaultErrorCode = 0;

});


parcelRegister("cWQs9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9qMgf", function(module, exports) {
"use strict";
var $6ddbfa65d1e0a63a$var$__assign = module.exports && module.exports.__assign || function() {
    $6ddbfa65d1e0a63a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6ddbfa65d1e0a63a$var$__assign.apply(this, arguments);
};
var $6ddbfa65d1e0a63a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6ddbfa65d1e0a63a$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $6ddbfa65d1e0a63a$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JSONRPCServer = void 0;

var $6Mt5O = parcelRequire("6Mt5O");

var $a9Khi = parcelRequire("a9Khi");
var $6ddbfa65d1e0a63a$var$createParseErrorResponse = function() {
    return (0, $6Mt5O.createJSONRPCErrorResponse)(null, $6Mt5O.JSONRPCErrorCode.ParseError, "Parse error");
};
var $6ddbfa65d1e0a63a$var$createInvalidRequestResponse = function(request) {
    return (0, $6Mt5O.createJSONRPCErrorResponse)((0, $6Mt5O.isJSONRPCID)(request.id) ? request.id : null, $6Mt5O.JSONRPCErrorCode.InvalidRequest, "Invalid Request");
};
var $6ddbfa65d1e0a63a$var$createMethodNotFoundResponse = function(id) {
    return (0, $6Mt5O.createJSONRPCErrorResponse)(id, $6Mt5O.JSONRPCErrorCode.MethodNotFound, "Method not found");
};
var $6ddbfa65d1e0a63a$var$JSONRPCServer = /** @class */ function() {
    function JSONRPCServer(options) {
        if (options === void 0) options = {};
        var _a;
        this.mapErrorToJSONRPCErrorResponse = $6ddbfa65d1e0a63a$var$defaultMapErrorToJSONRPCErrorResponse;
        this.nameToMethodDictionary = {};
        this.middleware = null;
        this.errorListener = (_a = options.errorListener) !== null && _a !== void 0 ? _a : console.warn;
    }
    JSONRPCServer.prototype.hasMethod = function(name) {
        return !!this.nameToMethodDictionary[name];
    };
    JSONRPCServer.prototype.addMethod = function(name, method) {
        this.addMethodAdvanced(name, this.toJSONRPCMethod(method));
    };
    JSONRPCServer.prototype.removeMethod = function(name) {
        delete this.nameToMethodDictionary[name];
    };
    JSONRPCServer.prototype.toJSONRPCMethod = function(method) {
        return function(request, serverParams) {
            var response = method(request.params, serverParams);
            return Promise.resolve(response).then(function(result) {
                return $6ddbfa65d1e0a63a$var$mapResultToJSONRPCResponse(request.id, result);
            });
        };
    };
    JSONRPCServer.prototype.addMethodAdvanced = function(name, method) {
        var _a;
        this.nameToMethodDictionary = $6ddbfa65d1e0a63a$var$__assign($6ddbfa65d1e0a63a$var$__assign({}, this.nameToMethodDictionary), (_a = {}, _a[name] = method, _a));
    };
    JSONRPCServer.prototype.receiveJSON = function(json, serverParams) {
        var request = this.tryParseRequestJSON(json);
        if (request) return this.receive(request, serverParams);
        else return Promise.resolve($6ddbfa65d1e0a63a$var$createParseErrorResponse());
    };
    JSONRPCServer.prototype.tryParseRequestJSON = function(json) {
        try {
            return JSON.parse(json);
        } catch (_a) {
            return null;
        }
    };
    JSONRPCServer.prototype.receive = function(request, serverParams) {
        if (Array.isArray(request)) return this.receiveMultiple(request, serverParams);
        else return this.receiveSingle(request, serverParams);
    };
    JSONRPCServer.prototype.receiveMultiple = function(requests, serverParams) {
        return $6ddbfa65d1e0a63a$var$__awaiter(this, void 0, void 0, function() {
            var responses;
            var _this = this;
            return $6ddbfa65d1e0a63a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            Promise.all(requests.map(function(request) {
                                return _this.receiveSingle(request, serverParams);
                            }))
                        ];
                    case 1:
                        responses = _a.sent().filter($6ddbfa65d1e0a63a$var$isNonNull);
                        if (responses.length === 1) return [
                            2 /*return*/ ,
                            responses[0]
                        ];
                        else if (responses.length) return [
                            2 /*return*/ ,
                            responses
                        ];
                        else return [
                            2 /*return*/ ,
                            null
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    JSONRPCServer.prototype.receiveSingle = function(request, serverParams) {
        return $6ddbfa65d1e0a63a$var$__awaiter(this, void 0, void 0, function() {
            var method, response;
            return $6ddbfa65d1e0a63a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        method = this.nameToMethodDictionary[request.method];
                        if (!!(0, $6Mt5O.isJSONRPCRequest)(request)) return [
                            3 /*break*/ ,
                            1
                        ];
                        return [
                            2 /*return*/ ,
                            $6ddbfa65d1e0a63a$var$createInvalidRequestResponse(request)
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            this.callMethod(method, request, serverParams)
                        ];
                    case 2:
                        response = _a.sent();
                        return [
                            2 /*return*/ ,
                            $6ddbfa65d1e0a63a$var$mapResponse(request, response)
                        ];
                }
            });
        });
    };
    JSONRPCServer.prototype.applyMiddleware = function() {
        var middlewares = [];
        for(var _i = 0; _i < arguments.length; _i++)middlewares[_i] = arguments[_i];
        if (this.middleware) this.middleware = this.combineMiddlewares($6ddbfa65d1e0a63a$var$__spreadArray([
            this.middleware
        ], middlewares, true));
        else this.middleware = this.combineMiddlewares(middlewares);
    };
    JSONRPCServer.prototype.combineMiddlewares = function(middlewares) {
        if (!middlewares.length) return null;
        else return middlewares.reduce(this.middlewareReducer);
    };
    JSONRPCServer.prototype.middlewareReducer = function(prevMiddleware, nextMiddleware) {
        return function(next, request, serverParams) {
            return prevMiddleware(function(request, serverParams) {
                return nextMiddleware(next, request, serverParams);
            }, request, serverParams);
        };
    };
    JSONRPCServer.prototype.callMethod = function(method, request, serverParams) {
        var _this = this;
        var callMethod = function(request, serverParams) {
            if (method) return method(request, serverParams);
            else if (request.id !== undefined) return Promise.resolve($6ddbfa65d1e0a63a$var$createMethodNotFoundResponse(request.id));
            else return Promise.resolve(null);
        };
        var onError = function(error) {
            _this.errorListener("An unexpected error occurred while executing \"".concat(request.method, "\" JSON-RPC method:"), error);
            return Promise.resolve(_this.mapErrorToJSONRPCErrorResponseIfNecessary(request.id, error));
        };
        try {
            return (this.middleware || $6ddbfa65d1e0a63a$var$noopMiddleware)(callMethod, request, serverParams).then(undefined, onError);
        } catch (error) {
            return onError(error);
        }
    };
    JSONRPCServer.prototype.mapErrorToJSONRPCErrorResponseIfNecessary = function(id, error) {
        if (id !== undefined) return this.mapErrorToJSONRPCErrorResponse(id, error);
        else return null;
    };
    return JSONRPCServer;
}();
module.exports.JSONRPCServer = $6ddbfa65d1e0a63a$var$JSONRPCServer;
var $6ddbfa65d1e0a63a$var$isNonNull = function(value) {
    return value !== null;
};
var $6ddbfa65d1e0a63a$var$noopMiddleware = function(next, request, serverParams) {
    return next(request, serverParams);
};
var $6ddbfa65d1e0a63a$var$mapResultToJSONRPCResponse = function(id, result) {
    if (id !== undefined) return (0, $6Mt5O.createJSONRPCSuccessResponse)(id, result);
    else return null;
};
var $6ddbfa65d1e0a63a$var$defaultMapErrorToJSONRPCErrorResponse = function(id, error) {
    var _a;
    var message = (_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : "An unexpected error occurred";
    var code = $a9Khi.DefaultErrorCode;
    var data;
    if (error instanceof $6Mt5O.JSONRPCErrorException) {
        code = error.code;
        data = error.data;
    }
    return (0, $6Mt5O.createJSONRPCErrorResponse)(id, code, message, data);
};
var $6ddbfa65d1e0a63a$var$mapResponse = function(request, response) {
    if (response) return response;
    else if (request.id !== undefined) return (0, $6Mt5O.createJSONRPCErrorResponse)(request.id, $6Mt5O.JSONRPCErrorCode.InternalError, "Internal error");
    else return null;
};

});

parcelRegister("7kNhW", function(module, exports) {
"use strict";
var $5570a24a5adb698e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5570a24a5adb698e$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JSONRPCServerAndClient = void 0;

var $6Mt5O = parcelRequire("6Mt5O");
var $5570a24a5adb698e$var$JSONRPCServerAndClient = /** @class */ function() {
    function JSONRPCServerAndClient(server, client, options) {
        if (options === void 0) options = {};
        var _a;
        this.server = server;
        this.client = client;
        this.errorListener = (_a = options.errorListener) !== null && _a !== void 0 ? _a : console.warn;
    }
    JSONRPCServerAndClient.prototype.applyServerMiddleware = function() {
        var _a;
        var middlewares = [];
        for(var _i = 0; _i < arguments.length; _i++)middlewares[_i] = arguments[_i];
        (_a = this.server).applyMiddleware.apply(_a, middlewares);
    };
    JSONRPCServerAndClient.prototype.hasMethod = function(name) {
        return this.server.hasMethod(name);
    };
    JSONRPCServerAndClient.prototype.addMethod = function(name, method) {
        this.server.addMethod(name, method);
    };
    JSONRPCServerAndClient.prototype.addMethodAdvanced = function(name, method) {
        this.server.addMethodAdvanced(name, method);
    };
    JSONRPCServerAndClient.prototype.removeMethod = function(name) {
        this.server.removeMethod(name);
    };
    JSONRPCServerAndClient.prototype.timeout = function(delay) {
        return this.client.timeout(delay);
    };
    JSONRPCServerAndClient.prototype.request = function(method, params, clientParams) {
        return this.client.request(method, params, clientParams);
    };
    JSONRPCServerAndClient.prototype.requestAdvanced = function(jsonRPCRequest, clientParams) {
        return this.client.requestAdvanced(jsonRPCRequest, clientParams);
    };
    JSONRPCServerAndClient.prototype.notify = function(method, params, clientParams) {
        this.client.notify(method, params, clientParams);
    };
    JSONRPCServerAndClient.prototype.rejectAllPendingRequests = function(message) {
        this.client.rejectAllPendingRequests(message);
    };
    JSONRPCServerAndClient.prototype.receiveAndSend = function(payload, serverParams, clientParams) {
        return $5570a24a5adb698e$var$__awaiter(this, void 0, void 0, function() {
            var response, message;
            return $5570a24a5adb698e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!((0, $6Mt5O.isJSONRPCResponse)(payload) || (0, $6Mt5O.isJSONRPCResponses)(payload))) return [
                            3 /*break*/ ,
                            1
                        ];
                        this.client.receive(payload);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 1:
                        if (!((0, $6Mt5O.isJSONRPCRequest)(payload) || (0, $6Mt5O.isJSONRPCRequests)(payload))) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.server.receive(payload, serverParams)
                        ];
                    case 2:
                        response = _a.sent();
                        if (response) return [
                            2 /*return*/ ,
                            this.client.send(response, clientParams)
                        ];
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        message = "Received an invalid JSON-RPC message";
                        this.errorListener(message, payload);
                        return [
                            2 /*return*/ ,
                            Promise.reject(new Error(message))
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return JSONRPCServerAndClient;
}();
module.exports.JSONRPCServerAndClient = $5570a24a5adb698e$var$JSONRPCServerAndClient;

});



parcelRegister("UaE7E", function(module, exports) {
$parcel$export(module.exports, "RequestHandler", () => $b8767c9102116bea$export$d51c578aa8736606);

var $lvlN8 = parcelRequire("lvlN8");

var $dRkX9 = parcelRequire("dRkX9");

var $hjIC3 = parcelRequire("hjIC3");

var $bnlQq = parcelRequire("bnlQq");
class $b8767c9102116bea$export$d51c578aa8736606 {
    constructor(transport){
        this.transport = transport;
        /**
   * A mapping from clientId:commandName -> handlers for those commands.
   *
   * @description We enforce only 1 handler per clientId+command pair, so that callees can listen for responses to a command.
   * This allows multiple clients to register handlers for the same command type.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // oxlint-disable-next-line typescript-eslint/no-explicit-any
        this.handlers = new Map();
    }
    /**
   * Register a handler for a specific command type for a specific client.
   *
   * @description When a command of type {@link CommandClass} is received, the handler will be invoked in a 1-1 manner.
   * This is to ensure the result of the command invocation can be cleanly passed to the callee.
   *
   * @param clientId The client identifier that this handler is registered for
   * @param CommandClass The command class to register a handler for
   * @param handler The handler function to invoke when the command is received
   * @returns void
   */ register(clientId, CommandClass, handler) {
        const handlerKey = this.createHandlerKey(clientId, CommandClass.identifier);
        this.handlers.set(handlerKey, handler);
    }
    /**
   * Unregisters a handler for a specific command type for a specific client.
   */ unregister(clientId, CommandClass) {
        const handlerKey = this.createHandlerKey(clientId, CommandClass.identifier);
        this.handlers.delete(handlerKey);
    }
    /**
   * Unregisters all handlers for a specific client.
   *
   * @param clientId The client identifier to remove all handlers for
   * @returns number of handlers removed
   */ unregisterAll(clientId) {
        const keysToDelete = [];
        const prefix = `${clientId}:`;
        // find all relevant keys
        for (const key of this.handlers.keys())if (key.startsWith(prefix)) keysToDelete.push(key);
        // drop them
        for (const key of keysToDelete)this.handlers.delete(key);
        return keysToDelete.length;
    }
    /**
   * Invokes the appropriate handler for a given {@link RPCRequest}, and yields the result via
   * {@link transport} to the appropriate JavaScript context. If the handler throws, propagates an
   * {@link RPCResponse} with an error body. Vice versa for a successful handler response.
   *
   * @param request incoming RPC request (delegated method call, as a command)
   */ async handleRequest(request) {
        const params = request.params;
        const handlerKey = this.createHandlerKey(params.receiverId, request.method);
        const handler = this.handlers.get(handlerKey);
        (0, $hjIC3.emitter)().emit({
            type: 'command-received',
            commandId: request.id,
            commandType: request.method,
            senderId: params.senderId,
            receiverId: params.receiverId,
            properties: {
                ...params
            },
            groupId: params.groupId
        });
        if (!handler) {
            const err = `handler not found for ${request.method} with clientId ${params.receiverId}`;
            console.warn(err);
            // emit command failed event
            (0, $hjIC3.emitter)().emit({
                type: 'command-failed',
                commandId: request.id,
                commandType: request.method,
                senderId: params.senderId,
                receiverId: params.receiverId,
                error: {
                    message: err,
                    code: 'METHOD_NOT_FOUND'
                },
                groupId: params.groupId
            });
            // communicate to sender that handler failed
            this.sendResponse(request, (0, $bnlQq.rpcError)(request.id, params.receiverId, params.senderId, (0, $lvlN8.JSONRPCErrorCode).MethodNotFound, new Error(err)));
            return;
        }
        const startTime = performance.now();
        try {
            const result = await handler(request.params);
            const duration = performance.now() - startTime;
            // emit command completed event
            (0, $hjIC3.emitter)().emit({
                type: 'command-completed',
                commandId: request.id,
                commandType: request.method,
                senderId: params.senderId,
                receiverId: params.receiverId,
                result: result,
                duration: duration,
                groupId: params.groupId
            });
            this.sendResponse(request, (0, $bnlQq.rpcSuccess)(request.id, params.receiverId, params.senderId, result));
        } catch (error) {
            const err = error instanceof Error ? error : new Error(String(error));
            const duration = performance.now() - startTime;
            // emit command failed event
            (0, $hjIC3.emitter)().emit({
                type: 'command-failed',
                commandId: request.id,
                commandType: request.method,
                senderId: params.senderId,
                receiverId: params.receiverId,
                error: {
                    message: err.message,
                    code: 'HANDLER_ERROR',
                    stack: err.stack
                },
                duration: duration,
                groupId: params.groupId
            });
            this.sendResponse(request, (0, $bnlQq.rpcError)(request.id, params.receiverId, params.senderId, (0, $lvlN8.JSONRPCErrorCode).InternalError, err));
            console.error(err);
        }
    }
    sendResponse(request, response) {
        if ((0, $dRkX9.fg)('rovo_bridge_validate_message_origin')) this.transport.send(response, request);
        else this.transport.send(response);
    }
    /**
   * Directly invoke a handler of a specific command for a specific client.
   */ async invoke(command, params) {
        const handlerKey = this.createHandlerKey(params.receiverId, command.identifier);
        const handler = this.handlers.get(handlerKey);
        (0, $hjIC3.emitter)().emit({
            type: 'command-received',
            commandId: params._invocationId ?? 'local-invocation',
            commandType: command.identifier,
            senderId: params.senderId,
            receiverId: params.receiverId,
            properties: params,
            groupId: params.groupId
        });
        if (!handler) {
            const err = `handler not found for command ${command.identifier} with clientId ${params.receiverId}`;
            console.error(err);
            // emit command failed event
            (0, $hjIC3.emitter)().emit({
                type: 'command-failed',
                commandId: params._invocationId ?? 'local-invocation',
                commandType: command.identifier,
                senderId: params.senderId,
                receiverId: params.receiverId,
                error: {
                    message: err,
                    code: 'METHOD_NOT_FOUND'
                },
                groupId: params.groupId
            });
            return undefined;
        }
        const startTime = performance.now();
        try {
            const result = handler === null || handler === void 0 ? void 0 : handler(params);
            const duration = performance.now() - startTime;
            // emit command completed event
            (0, $hjIC3.emitter)().emit({
                type: 'command-completed',
                commandId: params._invocationId || 'local-invocation',
                commandType: command.identifier,
                senderId: params.senderId,
                receiverId: params.receiverId,
                result: result,
                duration: duration,
                groupId: params.groupId
            });
            return result;
        } catch (error) {
            const err = error instanceof Error ? error : new Error(String(error));
            const duration = performance.now() - startTime;
            // emit command failed event
            (0, $hjIC3.emitter)().emit({
                type: 'command-failed',
                commandId: params._invocationId || 'local-invocation',
                commandType: command.identifier,
                senderId: params.senderId,
                receiverId: params.receiverId,
                error: {
                    message: err.message,
                    code: 'HANDLER_ERROR',
                    stack: err.stack
                },
                duration: duration,
                groupId: params.groupId
            });
            throw err;
        }
    }
    /**
   * Clear all relevant state for handling of responses.
   */ destroy() {
        this.handlers.clear();
    }
    /**
   * Creates a unique key for the handler mapping using clientId and command name.
   */ createHandlerKey(clientId, commandName) {
        return `${clientId}:${commandName}`;
    }
}

});

parcelRegister("6tOyF", function(module, exports) {
$parcel$export(module.exports, "ResponseHandler", () => $57513878a8adeb9a$export$f456c9835cc63582);
class $57513878a8adeb9a$export$f456c9835cc63582 {
    /**
   * Creates a deferred promise handler for a given command invocation.
   * @param id unique ID for the command invocation
   * @param senderId the callee
   * @param receiverId the receiver which implements a handler for the command
   * @returns a deferrable which is resolved upon a response being yielded by the receiver
   */ getOrCreate(id, senderId, receiverId) {
        // if we already have a deferred promise waiting for this specific invocation, we do not need another one.
        const existing = this.get(id);
        if (existing) return existing.promise;
        let deferredResolve;
        let deferredReject;
        const promise = new Promise((resolve, reject)=>{
            deferredResolve = resolve;
            deferredReject = reject;
        });
        const result = {
            senderId: senderId,
            receiverId: receiverId,
            promise: promise,
            // @ts-expect-error - Promise executor runs synchronously so deferredResolve is guaranteed assigned; TypeScript cannot infer this
            resolve: deferredResolve,
            // @ts-expect-error - Promise executor runs synchronously so deferredReject is guaranteed assigned; TypeScript cannot infer this
            reject: deferredReject
        };
        this.responses.set(id, result);
        return promise;
    }
    /**
   * Yields the current deferrable state for a command invocation.
   * @param id unique ID for the command invocation.
   * @returns deferrable state for a command invocation.
   */ get(id) {
        return this.responses.get(id);
    }
    /**
   * Resolves a promise reference based upon the ID of an RPC response.
   *
   * @description If the RPC response is successful, will resolve the promise with the expected return shape.
   * @description If the RPC response is unsuccessful, will reject the promise with an error.
   *
   * @param _response response yielded by the receiver of the original message.
   */ resolveWithResponse(response) {
        const id = response.id;
        const deferred = this.responses.get(id);
        // no one waiting - exit
        if (!deferred) return;
        // drop the deferrable from storage now
        this.responses.delete(id);
        // yield correct outcome
        if (response.error) deferred.reject(new Error(response.error.message));
        else deferred.resolve(response.result);
    }
    /**
   * Cancels a specific promise by resolving it to undefined to avoid unhandled rejections
   * in fire-and-forget scenarios.
   *
   * @description In JavaScript if you do the following:
   * ```typescript
   * const promise = () => new Promise((_, reject) => reject(new Error('oh boy')));
   * promise();
   * ```
   * Even though you are not explicitly calling `await` on the result of the promise, it will
   * reject and result in an unhandled rejection. Specifically when working with commands, we
   * often want to send them in a fire-and-forget manner. When a 'cancellation' takes place,
   * we therefore DO NOT want an unhandled rejection to result. Hence, we treat all command
   * results similar to distributed system communications - as always nullable.
   *
   * Cancellation events to consider: component unmounts, route transitions.
   *
   * For more, see:
   * - {@link https://developer.mozilla.org/en-US/docs/Web/API/Window/unhandledrejection_event}
   * - {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Using_promises#promise_rejection_events}
   * - {@link https://typescript-eslint.io/rules/no-floating-promises/}
   *
   * @param id unique ID for the command invocation to cancel
   */ cancel(id) {
        const deferred = this.responses.get(id);
        if (!deferred) return;
        // clear out in-memory reference
        this.responses.delete(id);
        // resolve to undefined to avoid unhandled promise rejections
        deferred.resolve(undefined);
    }
    /**
   * Clears response handlers for a specific client to prevent memory leaks during client teardown.
   *
   * @param clientId The client ID to clear responses for (as sender or receiver)
   */ teardown(clientId) {
        const toDelete = [];
        for (const [id, deferred] of this.responses)if (deferred.senderId === clientId || deferred.receiverId === clientId) {
            // Resolve to undefined to avoid unhandled promise rejections
            deferred.resolve(undefined);
            toDelete.push(id);
        }
        for (const id of toDelete)this.responses.delete(id);
    }
    /**
   * Destroy all relevant state.
   */ clear() {
        // Resolve all pending promises to avoid unhandled rejections
        for (const deferred of this.responses.values())deferred.resolve(undefined);
        this.responses.clear();
    }
    constructor(){
        /**
   * A mapping from unique command invocations to deferred promises waiting
   * for their result. Used for match-making the result of a delegated RPC call
   * back to its callee. TODO - hook up to methods in CNS-18261.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // oxlint-disable-next-line typescript-eslint/no-explicit-any
        this.responses = new Map();
    }
}

});


parcelRegister("8Ns1i", function(module, exports) {
$parcel$export(module.exports, "mountAPI", () => $4e2076cb48ec5e2f$export$aca538b4585bd0c8);
$parcel$export(module.exports, "readAPI", () => $4e2076cb48ec5e2f$export$7f2206c1a009e207);
$parcel$export(module.exports, "clearAPI", () => $4e2076cb48ec5e2f$export$d61f9ff9c1abb253);

var $9AOUT = parcelRequire("9AOUT");
const $4e2076cb48ec5e2f$export$aca538b4585bd0c8 = (bridgeAPI)=>{
    try {
        const topmostSameOriginWindow = (0, $9AOUT.findTopmostSameOriginWindow)(window);
        // do not override if already existing on topmost same-origin window
        if (topmostSameOriginWindow.__rovoContentBridgeAPI__) return;
        topmostSameOriginWindow.__rovoContentBridgeAPI__ = bridgeAPI;
        topmostSameOriginWindow.__rovoBridgeDebuggerStart__ = $4e2076cb48ec5e2f$var$startDebugger;
    } catch  {
        // bail out if any errors take place (browser quirks on accessing window.top from a cross-origin frame)
        return;
    }
};
const $4e2076cb48ec5e2f$export$7f2206c1a009e207 = ()=>{
    try {
        const topmostSameOriginWindow = (0, $9AOUT.findTopmostSameOriginWindow)(window);
        return topmostSameOriginWindow.__rovoContentBridgeAPI__ ?? null;
    } catch  {
        return null;
    }
};
const $4e2076cb48ec5e2f$export$d61f9ff9c1abb253 = ()=>{
    try {
        const topmostSameOriginWindow = (0, $9AOUT.findTopmostSameOriginWindow)(window);
        topmostSameOriginWindow.__rovoContentBridgeAPI__ = undefined;
        // Also clear debug API to prevent memory leaks
        topmostSameOriginWindow.__rovoBridgeDebuggerStart__ = undefined;
    } catch  {
        return;
    }
};

async function $4e2076cb48ec5e2f$var$startDebugger() {
    try {
        await (parcelRequire("kK5td"));
    } catch (err) {
        console.error('failed to initialise rovo-debug API', err);
    }
}

});
parcelRegister("9AOUT", function(module, exports) {
$parcel$export(module.exports, "isSameOrigin", () => $7b0ae1551ec5695a$export$655d79b04044cb4a);
$parcel$export(module.exports, "isTop", () => $7b0ae1551ec5695a$export$9be37efcc8d5d23a);
$parcel$export(module.exports, "findTopmostSameOriginWindow", () => $7b0ae1551ec5695a$export$8d6146aae4595d39);
/**
 * Utility which computes whether a target window and {@link window.top} conform to the same origin policy.
 *
 * @description If they do, then they share JavaScript execution contexts.
 * @description If they do not, they are the traditional cross-origin `iframe` and host.
 *
 * @param window
 * @returns true if same origin, false if not - if true, then {@link window.top} must be defined.
 */ const $7b0ae1551ec5695a$export$655d79b04044cb4a = (window)=>{
    try {
        var _window$top;
        return Boolean(window.origin && window.origin === ((_window$top = window.top) === null || _window$top === void 0 ? void 0 : _window$top.origin));
    } catch  {
        return false;
    }
};
const $7b0ae1551ec5695a$export$9be37efcc8d5d23a = (window)=>{
    try {
        return Boolean(window.top && window === window.top);
    } catch  {
        return false;
    }
};
/**
 * Maximum depth to traverse when finding topmost same-origin window.
 * Prevents infinite loops in edge cases while supporting deep nesting.
 */ const $7b0ae1551ec5695a$var$MAX_PARENT_TRAVERSAL_DEPTH = 16;
const $7b0ae1551ec5695a$export$8d6146aae4595d39 = (window)=>{
    let current = window;
    let depth = 0;
    while(depth < $7b0ae1551ec5695a$var$MAX_PARENT_TRAVERSAL_DEPTH)try {
        // If we're at the top, return current
        if (current.parent === current) return current;
        // Try to access parent.origin (will throw SecurityError if cross-origin)
        const parentOrigin = current.parent.origin;
        // Check if parent is same origin
        if (current.origin !== parentOrigin) return current;
        // Parent is same-origin, keep going up
        current = current.parent;
        depth++;
    } catch  {
        // Parent is cross-origin (accessing parent.origin threw)
        return current;
    }
    // Safety: return current window if max depth reached
    return current;
};

});

parcelRegister("kK5td", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("bZLxo").then(()=>parcelRequire('ayPeZ'));

});


parcelRegister("8C3Ey", function(module, exports) {
$parcel$export(module.exports, "BrowserTransport", () => $4a3c59ba143118c1$export$7f6b50c45cbf4d90);

var $dRkX9 = parcelRequire("dRkX9");

var $hjIC3 = parcelRequire("hjIC3");

var $bnlQq = parcelRequire("bnlQq");

var $e6L5N = parcelRequire("e6L5N");

var $9AOUT = parcelRequire("9AOUT");

var $it1iL = parcelRequire("it1iL");

var $kfCZv = parcelRequire("kfCZv");
const $4a3c59ba143118c1$var$MESSAGE_ORIGIN_VALIDATION_GATE = 'rovo_bridge_validate_message_origin';
const $4a3c59ba143118c1$var$DEDUPE_TARGET_WARNING_GATE = 'rovo_bridge_dedupe_target_warning';
const $4a3c59ba143118c1$var$normaliseOrigins = (origins)=>{
    const result = new Set();
    for (const value of origins ?? [])try {
        const origin = new URL(value).origin;
        if (origin !== 'null') result.add(origin);
    } catch  {
    // An invalid value must not accidentally widen the trust boundary.
    }
    return result;
};
/**
 * Narrows a {@link MessageEvent.source} to a window.
 *
 * @description A window proxy exposes `window` as a self-reference even across an origin boundary,
 * which message ports and service workers do not.
 */ const $4a3c59ba143118c1$var$isWindowSource = (source)=>{
    try {
        return Boolean(source) && source.window === source;
    } catch  {
        return false;
    }
};
class $4a3c59ba143118c1$export$7f6b50c45cbf4d90 {
    constructor(source, options = {}){
        this.source = source;
        this.options = options;
        /**
   * A mapping of receiver IDs to known targets.
   *
   * Communication will ultimately take place with this target, via the {@link HTMLIFrameElement.contentWindow} property.
   */ this.targets = new Map();
        /**
   * Receivers whose missing target has already been logged.
   *
   * @description Discovery retries a pending receiver every tick, so without this a receiver which never mounts
   * (e.g. Rovo chat before its panel is opened) logs a warning every 100ms until its messages expire.
   */ this.unreachableReceivers = new Set();
        // New requests can use an authenticated peer origin; replies retain their own request's destination.
        this.authenticatedOrigins = new WeakMap();
        this.replyTargets = new WeakMap();
        /**
   * Handles incoming messages received via {@link window.postMessage}.
   */ this.handler = undefined;
        /**
   * Cleanup handler registered for incoming messages
   */ this.cleanup = undefined;
        this.allowedOrigins = $4a3c59ba143118c1$var$normaliseOrigins(options.allowedOrigins);
        (0, $hjIC3.emitter)().emit({
            type: 'transport-ready',
            transportType: this.source
        });
    }
    /**
   * Check to see if this message can be sent to its intended cross-origin target currently.
   *
   * @description Determined by availability of the target window in the DOM.
   * @description If this method does not yield true, the message will be buffered & tried again later.
   *
   * @param message intended RPC message for the receiver
   * @returns true if the transport target is queryable via DOM, otherwise false
   */ canSend(message) {
        // trying to communicate with desktop process
        if ((0, $it1iL.isWebviewContext)()) return true;
        // passthrough for same-origin communication
        if ((0, $9AOUT.isSameOrigin)(window)) return true;
        // otherwise find the cross-origin target & communicate with it
        const target = this.findTarget(message.params.receiverId);
        return Boolean(target);
    }
    /**
   * Sends a cross-origin message using {@link window.postMessage}.
   * @param message intended RPC message for the receiver
   * @param replyTo original accepted request, required for browser replies while origin validation is enabled
   * @returns void
   */ send(message, replyTo) {
        // in a webview context and trying to communicate with main process
        if ((0, $it1iL.isWebviewContext)()) {
            (0, $it1iL.sendToMainProcess)(message, this.source);
            return;
        }
        const validateOrigin = (0, $dRkX9.fg)($4a3c59ba143118c1$var$MESSAGE_ORIGIN_VALIDATION_GATE);
        const target = validateOrigin && (0, $bnlQq.isRPCResponse)(message) ? replyTo && this.replyTargets.get(replyTo) : this.findTarget(message.params.receiverId);
        if (!target) {
            (0, $hjIC3.emitter)().emit({
                type: 'transport-error',
                transportType: this.source,
                direction: 'outbound',
                messageId: message.id,
                error: {
                    message: `Transport target not found for receiver: ${message.params.receiverId}`,
                    code: 'TARGET_NOT_FOUND'
                }
            });
            return;
        }
        const envelope = {
            version: 1,
            source: this.source,
            message: message
        };
        (0, $hjIC3.emitter)().emit({
            type: 'transport-message-sent',
            transportType: this.source,
            direction: 'outbound',
            messageId: message.id,
            message: {
                ...envelope
            }
        });
        target.target.postMessage(envelope, validateOrigin ? this.outboundOrigin(target) : '*');
        if (validateOrigin && replyTo) this.replyTargets.delete(replyTo);
        return;
    }
    /**
   * Handles incoming events from other bridge API clients.
   * @param handler responds to a given RPC message from a remote client.
   */ onMessage(handler) {
        // do not allow overriding of handlers.
        if (this.handler) return;
        // stable reference so we can destroy it later
        this.handler = (envelope)=>this.handleEnvelope(envelope, handler);
        // listen for messsages from webview context
        if ((0, $it1iL.isWebviewContext)()) {
            const webviewAPI = (0, $it1iL.getWebviewAPI)();
            if (!webviewAPI) return;
            this.cleanup = webviewAPI.onMessageFromMain((envelope)=>{
                var _this$handler;
                return (_this$handler = this.handler) === null || _this$handler === void 0 ? void 0 : _this$handler.call(this, envelope);
            });
        } else {
            // Find topmost same-origin window to listen on
            const targetWindow = (0, $9AOUT.findTopmostSameOriginWindow)(window);
            // web-compatible handler
            const handler = (event)=>{
                if (!(0, $dRkX9.fg)($4a3c59ba143118c1$var$MESSAGE_ORIGIN_VALIDATION_GATE)) {
                    var _this$handler2;
                    (_this$handler2 = this.handler) === null || _this$handler2 === void 0 || _this$handler2.call(this, event.data);
                    return;
                }
                if (this.isTrustedSender(event, targetWindow)) {
                    var _this$handler3;
                    this.recordAuthenticatedPeer(event);
                    (_this$handler3 = this.handler) === null || _this$handler3 === void 0 || _this$handler3.call(this, event.data);
                }
            };
            targetWindow.addEventListener('message', handler);
            this.cleanup = ()=>targetWindow.removeEventListener('message', handler);
        }
    }
    /**
   * Tears down a specific client by removing its target reference.
   * @description This is important to release iframe / window references fully.
   */ teardown(clientId) {
        this.targets.delete(clientId);
        this.unreachableReceivers.delete(clientId);
    }
    /**
   * Clears all relevant state.
   */ destroy() {
        // clean up handler
        if (this.cleanup) {
            this.cleanup();
            this.cleanup = undefined;
        }
        // clean up handler reference
        if (this.handler) this.handler = undefined;
        // clear all target references
        this.targets.clear();
        this.unreachableReceivers.clear();
        this.authenticatedOrigins = new WeakMap();
        this.replyTargets = new WeakMap();
        // emit transport destroyed event
        (0, $hjIC3.emitter)().emit({
            type: 'transport-destroyed',
            transportType: this.source
        });
    }
    /**
   * Find a target for the given receiver in one of three ways:
   * - Using the existing mapping of known targets ({@link #targets})
   * - Using a DOM query for a cross-origin `iframe`, based on a specific DOM selector contract
   * - Using {@link window.top} if communicating cross-origin from inside of a frame
   *
   * @description If a target is find with one of the latter strategies, it is added to {@link #targets} for subsequent reads.
   *
   * @param receiverId intended target of the current message
   * @returns target if found, otherwise undefined
   */ findTarget(receiverId) {
        var _this$options$resolve, _this$options;
        // if existing, return
        const target = this.targets.get(receiverId);
        if (target) {
            if (!(0, $dRkX9.fg)('rovo_bridge_remote_teardown_cleanup') || !target.target.closed) return target;
            // A teardown reply can recache a target before its iframe is removed.
            // Discard destroyed browsing contexts, including those without a teardown.
            this.targets.delete(receiverId);
        }
        // Find target using a provided resolution strategy
        const resolvedTarget = (_this$options$resolve = (_this$options = this.options).resolveTarget) === null || _this$options$resolve === void 0 ? void 0 : _this$options$resolve.call(_this$options, {
            receiverId: receiverId,
            source: this.source
        });
        if (resolvedTarget) {
            const resolved = {
                target: resolvedTarget
            };
            this.targets.set(receiverId, resolved);
            return resolved;
        }
        // Find target using resolution strategies
        const browserTarget = (0, $kfCZv.findCrossOriginTarget)(receiverId);
        if (browserTarget) {
            this.targets.set(receiverId, browserTarget);
            return browserTarget;
        }
        if (!(0, $dRkX9.fg)($4a3c59ba143118c1$var$DEDUPE_TARGET_WARNING_GATE) || !this.unreachableReceivers.has(receiverId)) {
            this.unreachableReceivers.add(receiverId);
            console.warn(`transport target not found for message with intended recipient: ${receiverId}`);
        }
        return undefined;
    }
    recordAuthenticatedPeer(event) {
        if (!$4a3c59ba143118c1$var$isWindowSource(event.source)) return;
        this.authenticatedOrigins.set(event.source, event.origin);
        if ((0, $bnlQq.isRPCRequest)(event.data.message)) this.replyTargets.set(event.data.message, {
            target: event.source,
            origin: event.origin
        });
    }
    outboundOrigin(target) {
        return target.origin ?? this.authenticatedOrigins.get(target.target) ?? '*';
    }
    /**
   * Whether the envelope's self-declared source agrees with the origin the browser stamped on the event.
   */ hasAttestedOrigin(event) {
        return (0, $e6L5N.isTransportEnvelope)(event.data) && event.data.source === event.origin;
    }
    /**
   * Whether an inbound message satisfies the transport's origin and peer checks.
   *
   * Same-origin messages are accepted after their envelope source is checked. Cross-origin messages
   * must also match a resolved peer using two fields supplied by the browser:
   * - {@link MessageEvent.source}: a live reference to the actual sending window. Compared by identity
   *   against the window resolved by {@link findTarget}, so another window cannot claim its identity.
   * - {@link MessageEvent.origin}: the sender's origin when the message was sent. Matched against
   *   the peer origin we derived ourselves (an iframe `src` or ancestor origin) or, only when unknown, an origin in
   *   {@link BrowserTransportOptions.allowedOrigins}.
   *
   * @description Everything inside {@link MessageEvent.data} is attacker-controlled and treated only as
   * a claim: the self-declared envelope `source` and the `senderId` / `receiverId`. `senderId` is used
   * purely as a lookup key whose result is then re-checked against the unforgeable fields above, and
   * {@link hasAttestedOrigin} ties the self-declared `source` back to the browser-stamped origin.
   */ isTrustedSender(event, targetWindow) {
        var _event$data$message$p;
        if (!this.hasAttestedOrigin(event)) return false;
        if (event.origin === targetWindow.location.origin) return true;
        const senderId = (_event$data$message$p = event.data.message.params) === null || _event$data$message$p === void 0 ? void 0 : _event$data$message$p.senderId;
        if (typeof senderId !== 'string') return false;
        const sender = this.findTarget(senderId);
        const trustedOrigin = (sender === null || sender === void 0 ? void 0 : sender.origin) !== undefined ? sender.origin === event.origin : this.allowedOrigins.has(event.origin);
        return Boolean(event.source && sender && event.source === sender.target && trustedOrigin);
    }
    /**
   * Handles a transport envelope received from a remote source.
   * @param envelope the transport envelope containing the RPC message
   * @param handler the handler to invoke for the RPC message contained in the envelope
   * @returns void
   */ handleEnvelope(envelope, handler) {
        // always validate first - if invalid, ignore
        if (!(0, $e6L5N.isTransportEnvelope)(envelope)) return;
        // ensure message is not from the current window to itself
        if (envelope.source === this.source) return;
        (0, $hjIC3.emitter)().emit({
            type: 'transport-message-received',
            transportType: this.source,
            direction: 'inbound',
            messageId: envelope.message.id,
            transportData: {
                source: envelope.source,
                version: envelope.version,
                message: envelope.message
            }
        });
        handler(envelope.message);
    }
}

});
parcelRegister("e6L5N", function(module, exports) {
$parcel$export(module.exports, "isTransportEnvelope", () => $845a602b2e89104d$export$d22e131e673e4be0);

var $bnlQq = parcelRequire("bnlQq");
const $845a602b2e89104d$export$d22e131e673e4be0 = (envelope)=>{
    return Boolean(envelope && typeof envelope.version === 'number' && typeof envelope.source === 'string' && envelope.message && typeof envelope.message === 'object' && ((0, $bnlQq.isRPCRequest)(envelope.message) || (0, $bnlQq.isRPCResponse)(envelope.message)));
};

});

parcelRegister("it1iL", function(module, exports) {
$parcel$export(module.exports, "isWebviewContext", () => $bf6a6fccb888669e$export$a06801d4af98f3a3);
$parcel$export(module.exports, "getWebviewAPI", () => $bf6a6fccb888669e$export$60ac5c5fdfd88da);
$parcel$export(module.exports, "sendToMainProcess", () => $bf6a6fccb888669e$export$7f13f4efe0e0c1f3);

var $hjIC3 = parcelRequire("hjIC3");
const $bf6a6fccb888669e$export$a06801d4af98f3a3 = ()=>{
    try {
        return Boolean(typeof window !== 'undefined' && window.webviewAPI && typeof window.webviewAPI.isElectron === 'function' && window.webviewAPI.isElectron());
    } catch  {
        return false;
    }
};
const $bf6a6fccb888669e$export$60ac5c5fdfd88da = ()=>{
    try {
        if ($bf6a6fccb888669e$export$a06801d4af98f3a3()) return window.webviewAPI;
        return undefined;
    } catch  {
        return undefined;
    }
};
const $bf6a6fccb888669e$export$7f13f4efe0e0c1f3 = (message, transportSource)=>{
    const electronAPI = $bf6a6fccb888669e$export$60ac5c5fdfd88da();
    if (!electronAPI) {
        (0, $hjIC3.emitter)().emit({
            type: 'transport-error',
            transportType: transportSource,
            direction: 'outbound',
            messageId: message.id,
            error: {
                message: 'Webview API not available',
                code: 'WEBVIEW_API_UNAVAILABLE'
            }
        });
        return;
    }
    const envelope = {
        version: 1,
        source: transportSource,
        message: message
    };
    (0, $hjIC3.emitter)().emit({
        type: 'transport-message-sent',
        transportType: transportSource,
        direction: 'outbound',
        messageId: message.id,
        message: {
            ...envelope
        }
    });
    // use the exposed to send to main
    electronAPI.postMessageToMain(envelope);
};
const $bf6a6fccb888669e$export$206d5b20b7c5c9d6 = 'rovo-bridge-message-channel';
const $bf6a6fccb888669e$export$c2e3eb4b2d131505 = 'desktop-main';

});

parcelRegister("kfCZv", function(module, exports) {
$parcel$export(module.exports, "findCrossOriginTarget", () => $c758b7dcfc19f80a$export$6052a3134234724b);

var $dRkX9 = parcelRequire("dRkX9");

var $9AOUT = parcelRequire("9AOUT");
const $c758b7dcfc19f80a$var$MAX_FRAME_TRAVERSAL_DEPTH = 16;
const $c758b7dcfc19f80a$var$findIframe = (targetDocument, receiverId)=>{
    if ((0, $dRkX9.fg)('rovo_bridge_validate_message_origin')) // Client IDs come from messages and must not be interpreted as selector syntax.
    return Array.from((targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.querySelectorAll('iframe[data-rovo-receiver-id]')) ?? []).find((frame)=>frame.getAttribute('data-rovo-receiver-id') === receiverId);
    return (targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.querySelector(`[data-rovo-receiver-id="${receiverId}"]`)) ?? undefined;
};
const $c758b7dcfc19f80a$var$getDocument = (targetWindow)=>{
    try {
        return targetWindow.document;
    } catch  {
        return undefined;
    }
};
const $c758b7dcfc19f80a$var$getFrames = (targetWindow)=>{
    try {
        return Array.from(targetWindow.frames);
    } catch  {
        return [];
    }
};
/**
 * Traverses through all child frames (same-origin) which the current window has access to.
 * Required to discover child frames which are deeply nested as transport targets.
 *
 * @param receiverId bridge API client we are attempting to communicate with
 * @param rootWindow the current host / root window we are traversing down
 * @param visited windows we have already searched through
 * @param depth current depth - to enforce a maximum depth in our DFS
 *
 * @returns the relevant window or undefined
 */ const $c758b7dcfc19f80a$var$resolveChildIframeFromWindow = (receiverId, rootWindow, visited, depth)=>{
    // if we have already searched this window, early exit
    if (visited.has(rootWindow)) return undefined;
    // if we can no longer traverse further downwards, early exit
    if (depth > $c758b7dcfc19f80a$var$MAX_FRAME_TRAVERSAL_DEPTH) return undefined;
    // mark as visited
    visited.add(rootWindow);
    // get hold of the document & look for the current receiver of interest
    const rootDocument = $c758b7dcfc19f80a$var$getDocument(rootWindow);
    const frame = $c758b7dcfc19f80a$var$findIframe(rootDocument, receiverId);
    if (frame !== null && frame !== void 0 && frame.contentWindow) return frame;
    // if not found at the top-level, traverse down
    for (const childWindow of $c758b7dcfc19f80a$var$getFrames(rootWindow)){
        const target = $c758b7dcfc19f80a$var$resolveChildIframeFromWindow(receiverId, childWindow, visited, depth + 1);
        // found in sub-frame
        if (target) return target;
    }
    // not found amongst this window & all of its sub-frames
    return undefined;
};
/**
 * Resolves a target window by querying same-origin reachable DOM trees for an iframe with a
 * specific data attribute.
 *
 * @description The bridge API is mounted on the topmost same-origin window, but the target iframe
 * may be nested inside another same-origin iframe. Starting from the topmost same-origin window and
 * walking accessible child frame documents lets the shared transport discover cross-origin frames
 * that are only present inside nested same-origin containers.
 *
 * @param receiverId - The receiver ID to search for
 * @returns The iframe's contentWindow if found, otherwise undefined
 */ const $c758b7dcfc19f80a$var$resolveChildIframe = (receiverId)=>{
    var _window;
    const frame = $c758b7dcfc19f80a$var$findIframe((_window = window) === null || _window === void 0 ? void 0 : _window.document, receiverId);
    if (!frame || !frame.contentWindow) return undefined;
    return $c758b7dcfc19f80a$var$resolveChildIframeFromWindow(receiverId, (0, $9AOUT.findTopmostSameOriginWindow)(window), new WeakSet(), 0);
};
const $c758b7dcfc19f80a$export$3888b6e26a971bed = (receiverId)=>{
    var _resolveChildIframe;
    return ((_resolveChildIframe = $c758b7dcfc19f80a$var$resolveChildIframe(receiverId)) === null || _resolveChildIframe === void 0 ? void 0 : _resolveChildIframe.contentWindow) ?? undefined;
};
const $c758b7dcfc19f80a$export$b2c3e80b3e42c109 = ()=>{
    if (window.top && !(0, $9AOUT.isTop)(window)) return window.top;
    return undefined;
};
const $c758b7dcfc19f80a$var$getOrigin = (url)=>{
    if (!url) return undefined;
    try {
        const origin = new URL(url, window.location.href).origin;
        return origin === 'null' ? undefined : origin;
    } catch  {
        return undefined;
    }
};
const $c758b7dcfc19f80a$var$getTopmostAncestorOrigin = ()=>{
    try {
        const { ancestorOrigins: ancestorOrigins } = window.location;
        if (ancestorOrigins.length > 0) return ancestorOrigins.item(ancestorOrigins.length - 1) ?? undefined;
    } catch  {}
    const referrerOrigin = $c758b7dcfc19f80a$var$getOrigin(window.document.referrer);
    return referrerOrigin === window.location.origin ? undefined : referrerOrigin;
};
const $c758b7dcfc19f80a$export$6052a3134234724b = (receiverId)=>{
    const frame = $c758b7dcfc19f80a$var$resolveChildIframe(receiverId);
    if (frame !== null && frame !== void 0 && frame.contentWindow) return {
        target: frame.contentWindow,
        origin: $c758b7dcfc19f80a$var$getOrigin(frame.src)
    };
    const parent = $c758b7dcfc19f80a$export$b2c3e80b3e42c109();
    return parent ? {
        target: parent,
        origin: $c758b7dcfc19f80a$var$getTopmostAncestorOrigin()
    } : undefined;
};

});



parcelRegister("50eQO", function(module, exports) {
$parcel$export(module.exports, "ROVO_CHAT_CLIENT_ID", () => $ee34b7220cd1e09f$export$849380b7ef7c6423);

var $ed6Lc = parcelRequire("ed6Lc");
const $ee34b7220cd1e09f$export$849380b7ef7c6423 = (0, $ed6Lc.client)('rovo-chat');

});

parcelRegister("eMjX0", function(module, exports) {
$parcel$export(module.exports, "HELP_CENTER_FORM_REQUEST_CLIENT_ID", () => $22fff9f9cff8a1a5$export$6c08ef6d43996fe4);

var $ed6Lc = parcelRequire("ed6Lc");
const $22fff9f9cff8a1a5$export$6c08ef6d43996fe4 = (0, $ed6Lc.client)('help-center-form-content-renderer');

});

parcelRegister("3xCxz", function(module, exports) {
$parcel$export(module.exports, "NotifySuccessCommand", () => $a7a5a9603635b35a$export$fa7e3d4efc038293);

var $4IjT0 = parcelRequire("4IjT0");
const $a7a5a9603635b35a$export$fa7e3d4efc038293 = (0, $4IjT0.createCommand)('notify-success-command');

});


parcelRegister("aHtaW", function(module, exports) {
$parcel$export(module.exports, "SimpleIconPage", () => (parcelRequire("5tElB")).default);

var $5tElB = parcelRequire("5tElB");

});
parcelRegister("5tElB", function(module, exports) {
$parcel$export(module.exports, "default", () => $bcf6cb2e2a595dc4$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $aHS3M = parcelRequire("aHS3M");

var $fRgxR = parcelRequire("fRgxR");

var $blonq = parcelRequire("blonq");

var $1hJdJ = parcelRequire("1hJdJ");

var $4T8rw = parcelRequire("4T8rw");
const $bcf6cb2e2a595dc4$var$SimpleIconPage = ({ actionHrefTarget: actionHrefTarget, title: title, header: header, description: description, callToActionHref: callToActionHref, callToActionText: callToActionText, dataTestId: dataTestId, icon: Icon })=>{
    return /*#__PURE__*/ $fc4bM.createElement((0, $aHS3M.default), {
        title: title
    }, /*#__PURE__*/ $fc4bM.createElement((0, $blonq.PaperContent), null, /*#__PURE__*/ $fc4bM.createElement($bcf6cb2e2a595dc4$export$e193322e8b0256b9, {
        "data-testId": dataTestId
    }, !!Icon && /*#__PURE__*/ $fc4bM.createElement(Icon, null), !!header && /*#__PURE__*/ $fc4bM.createElement((0, $1hJdJ.default), {
        as: "h1",
        size: "medium"
    }, header), !!description && /*#__PURE__*/ $fc4bM.createElement((0, $4T8rw.Text), null, description), !!callToActionHref && /*#__PURE__*/ $fc4bM.createElement($bcf6cb2e2a595dc4$export$5efa7f588d56dda0, {
        to: callToActionHref,
        actionSubjectId: "callToAction",
        target: actionHrefTarget
    }, callToActionText))));
};
var $bcf6cb2e2a595dc4$export$2e2bcd8739ae039 = $bcf6cb2e2a595dc4$var$SimpleIconPage;
const $bcf6cb2e2a595dc4$export$e193322e8b0256b9 = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1640ypc-0"
})({
    display: 'flex',
    flexFlow: 'column wrap',
    alignItems: 'center',
    gap: "var(--ds-space-100, 8px)",
    marginTop: "var(--ds-space-600, 48px)"
});
const $bcf6cb2e2a595dc4$export$5efa7f588d56dda0 = /*#__PURE__*/ (0, $luz1X.default)((0, $fRgxR.default)).withConfig({
    componentId: "sc-1640ypc-1"
})`text-align:center;text-decoration:underline;`;

});


parcelRegister("4TGvK", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec5f11883a0db4c0$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $ec5f11883a0db4c0$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    sendForm: {
        defaultMessage: 'Send',
        description: 'Send button for request create form',
        id: 'cv.request.create.form.button.send'
    },
    cancelForm: {
        defaultMessage: 'Cancel',
        description: 'Cancel button for request create form',
        id: 'cv.request.create.form.button.cancel'
    },
    fieldValidationError: {
        defaultMessage: `Please provide a value for required field \u2019{fieldLabel}\u2019`,
        description: 'Field error validation message shown under field when there is an error.',
        id: 'cv.request.create.field.validation.error.message'
    },
    fieldLimitExceededError: {
        defaultMessage: `This field can only store {objectLimit, plural, one {# object} other {# objects}}.`,
        description: 'Field error validation message shown under field when the field limit is exceeded.',
        id: 'cv.request.create.field.limit.exceeded.error.message'
    },
    fieldInvalidConfigError: {
        defaultMessage: 'This required field is missing configuration and therefore cannot be displayed.',
        description: 'Field error validation message shown under field when the field does not have a valid configuration.',
        id: 'cv.request.create.field.invalid.config.error.message'
    },
    affectedServicesFieldLimitError: {
        defaultMessage: 'This field can only store a maximum of {serviceLimit, plural, one {# service} other {# services}}.',
        description: 'Field error validation message shown under field when the field limit is exceeded.',
        id: 'cv.request.create.field.affected-services.limit.exceeded.error.message'
    },
    thanksTitle: {
        defaultMessage: 'Thanks',
        description: 'Header message for a page after they have successfully created a request.',
        id: 'cv.request.create.embeddable.create.success.title'
    },
    referenceDescription: {
        defaultMessage: 'Your request has been raised.',
        description: 'Description message for a page after they have successfully created a request.',
        id: 'cv.request.create.embeddable.create.success.description'
    },
    callToAction: {
        defaultMessage: 'View request',
        description: 'Call to action link that takes the user the help center in a new tab, after they have successfully created a request.',
        id: 'cv.request.create.embeddable.create.success.callToActionText'
    },
    instructionForMandatoryField: {
        defaultMessage: 'Required fields are marked with an asterisk',
        description: 'This is an instruction which states fields with an asterisk (*) are compulsary',
        id: 'cv.request.create.embeddable.instructionForMandatoryField'
    },
    requestSubmittedMessage: {
        defaultMessage: 'Request submitted successfully',
        description: 'The title shown in the flag when the request is submitted successfully',
        id: 'help-center.request-create-form.requestSubmittedMessage'
    },
    requestSubmittedDescription: {
        defaultMessage: 'Your request will show up in your project queues as a new work item.',
        description: 'The description shown in the flag when the request is submitted successfully',
        id: 'help-center.request-create-form.requestSubmittedDescription'
    },
    requestSubmittedAction: {
        defaultMessage: 'View work item',
        description: 'The link label to navigate user to newly created work item',
        id: 'help-center.request-create-form.requestSubmittedAction'
    },
    requestSubmittedFcfWarningTitle: {
        defaultMessage: 'Request submitted with exceptions',
        description: 'The message title shown in the flag when the request is submitted with warnings',
        id: 'help-center.request-create-form.requestSubmittedFcfWarningTitle'
    },
    requestSubmittedFcfWarningMessageDescription: {
        defaultMessage: 'We submitted your request but without the value of the {field} field. If this happens again, notify your admin.',
        description: 'The message description shown in the flag when the request is submitted with warnings',
        id: 'help-center.request-create-form.requestSubmittedFcfWarningMessageDescription'
    }
});

});

parcelRegister("4biMY", function(module, exports) {
$parcel$export(module.exports, "default", () => $643ee780069d5553$export$2e2bcd8739ae039);
// The code run in the case statements in this file should be wrapped in blocks.
/* eslint-disable no-case-declarations */ 
var $fc4bM = parcelRequire("fc4bM");

var $04E2Q = parcelRequire("04E2Q");

var $hN5YJ = parcelRequire("hN5YJ");

var $aUHFa = parcelRequire("aUHFa");

var $iK1uY = parcelRequire("iK1uY");

var $aYMdQ = parcelRequire("aYMdQ");

var $fd880 = parcelRequire("fd880");

var $5tbyV = parcelRequire("5tbyV");

var $fwgWP = parcelRequire("fwgWP");
parcelRequire("5bPxE");
var $cBCkX = parcelRequire("cBCkX");
parcelRequire("lzoGU");
var $bnNbm = parcelRequire("bnNbm");
parcelRequire("aoSIG");
var $50qKs = parcelRequire("50qKs");
parcelRequire("lq05G");
var $4FGhU = parcelRequire("4FGhU");

var $lJ9q5 = parcelRequire("lJ9q5");
parcelRequire("bGND9");
var $58I7T = parcelRequire("58I7T");
var $bGND9 = parcelRequire("bGND9");

var $gD7pJ = parcelRequire("gD7pJ");
var $1MEdu = parcelRequire("1MEdu");
parcelRequire("9BcFH");
var $5uTDB = parcelRequire("5uTDB");
parcelRequire("l6jYy");
var $7NGwE = parcelRequire("7NGwE");
parcelRequire("k7LqY");
var $kW8X3 = parcelRequire("kW8X3");
parcelRequire("ck5CW");
var $iQR8K = parcelRequire("iQR8K");
parcelRequire("7nzE8");
var $ak5IU = parcelRequire("ak5IU");
parcelRequire("42ctQ");
var $6fJnq = parcelRequire("6fJnq");
parcelRequire("6lWzO");
var $eKHFe = parcelRequire("eKHFe");
parcelRequire("fgllb");
var $d1cEw = parcelRequire("d1cEw");
parcelRequire("hr0iK");
var $1DirA = parcelRequire("1DirA");
parcelRequire("lyyNE");
var $lgEHL = parcelRequire("lgEHL");
parcelRequire("f4Pmo");
var $ksO0j = parcelRequire("ksO0j");
parcelRequire("fgxkG");
var $1TcxL = parcelRequire("1TcxL");

var $3BNzL = parcelRequire("3BNzL");
parcelRequire("hgg7x");
var $czFqK = parcelRequire("czFqK");
parcelRequire("kGj1m");
var $h3NhD = parcelRequire("h3NhD");

var $2N4Ib = parcelRequire("2N4Ib");
parcelRequire("9AOAz");
var $fxF7L = parcelRequire("fxF7L");
parcelRequire("gl25y");
var $bE4v0 = parcelRequire("bE4v0");
parcelRequire("eGyNW");
var $2c0lV = parcelRequire("2c0lV");

var $axCcv = parcelRequire("axCcv");

var $4TGvK = parcelRequire("4TGvK");

var $fLu4j = parcelRequire("fLu4j");

var $613oU = parcelRequire("613oU");

var $azARG = parcelRequire("azARG");

var $k2M4v = parcelRequire("k2M4v");

var $d7r8x = parcelRequire("d7r8x");

var $hculA = parcelRequire("hculA");

var $eENmG = parcelRequire("eENmG");
parcelRequire("6Cpd6");
var $36Ozg = parcelRequire("36Ozg");

var $lvRbB = parcelRequire("lvRbB");

var $apqs2 = parcelRequire("apqs2");

var $8PRsU = parcelRequire("8PRsU");

var $ik8St = parcelRequire("ik8St");
parcelRequire("v2bn4");
var $b64HO = parcelRequire("b64HO");
/**
 * Feature gate: block_request_create_submit_for_form_loading
 *
 * Disables the Send/Cancel buttons on portal request create while the Proforma form
 * has not finished rendering, so requests can't be submitted without form answers.
 */ const $643ee780069d5553$var$BLOCK_REQUEST_CREATE_SUBMIT_FOR_FORM_LOADING = 'block_request_create_submit_for_form_loading';
const $643ee780069d5553$var$isBlockRequestCreateSubmitForFormLoadingEnabled = ()=>(0, $k2M4v.default).checkGate($643ee780069d5553$var$BLOCK_REQUEST_CREATE_SUBMIT_FOR_FORM_LOADING);
class $643ee780069d5553$export$d3eed393162f64da extends $fc4bM.Component {
    static #_ = this.defaultProps = {
        errors: {
            fieldErrors: {}
        }
    };
    shouldComponentUpdate(nextProps, nextState) {
        // shouldComponentUpdate override is implemented for performance improvement, see FSD-2741
        const { fieldValues: nextFieldValues, ...nextRemainingProps } = nextProps;
        const { fieldValues: fieldValues, ...remainingProps } = this.props;
        if (!(0, $aYMdQ.isEqual)(this.state, nextState) || !(0, $aYMdQ.isEqual)(remainingProps, nextRemainingProps)) return true;
        // The organisation picker is dependent on the reporter field, so we should rerender in this case
        return nextFieldValues.reporter !== fieldValues.reporter;
    }
    componentDidMount() {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) {
            const analyticsEvent = createAnalyticsEvent({
                analyticsType: (0, $eENmG.OPERATIONAL_EVENT_TYPE),
                action: this.unknownField ? 'failed' : 'loaded',
                actionSubjectId: 'fields',
                attributes: {
                    unknownField: this.unknownField
                }
            });
            analyticsEvent.fire();
        }
    }
    renderFields(fields, submitting) {
        return fields.filter((field)=>field.displayed).map((field)=>this.renderField(field, submitting));
    }
    renderReporterField(reporterState, baseProps, submitting, fieldErrors, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    urlParamValueOverride, canCreateUsers) {
        const defaultReporter = reporterState.defaultReporter ? {
            email: reporterState.defaultReporter.emailAddress,
            iconUrl: reporterState.defaultReporter.avatar,
            value: reporterState.defaultReporter.id,
            label: reporterState.defaultReporter.displayName,
            accountId: reporterState.defaultReporter.accountId
        } : undefined;
        const defaultReporterOverride = (0, $hN5YJ.isJsmPortalRovoIntegrationEnabled)() ? urlParamValueOverride : undefined;
        return /*#__PURE__*/ $fc4bM.createElement((0, $1DirA.default), {
            ...baseProps,
            portalId: this.props.portalId,
            label: reporterState.label || '',
            onChange: this.onReporterFieldChange,
            key: reporterState.id,
            errorMessage: fieldErrors[reporterState.id],
            disabled: submitting || !!reporterState.disabled,
            defaultReporter: defaultReporterOverride ?? defaultReporter,
            canCreateUser: canCreateUsers,
            createLabelType: "create",
            fieldConfigId: reporterState.fieldConfigId
        });
    }
    renderField(fieldState, submitting) {
        const { type: type, value: _, valueOverride: __, ...baseProps } = fieldState;
        const { projectId: projectId, portalId: portalId, requestTypeId: requestTypeId, onFieldChange: onFieldChange, knowledgeBase: knowledgeBase, enableSubmitButton: enableSubmitButton, disableSubmitButton: disableSubmitButton, canCreateUsers: canCreateUsers, locale: locale, dateFormat: dateFormat, dateTimeFormat: dateTimeFormat, firstDay: firstDay, useISO8601WeekNumbers: useISO8601WeekNumbers, fieldValues: fieldValues, urlParamFieldValueOverrides: urlParamFieldValueOverrides, fields: fields } = this.props;
        const fieldErrors = this.props.errors && this.props.errors.fieldErrors || {};
        const errorReasonKey = this.props.errors && this.props.errors.errorReasonKey;
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const urlParamValueOverride = urlParamFieldValueOverrides[fieldState.id];
        const { reporter: reporter } = this.props.fieldValues;
        const shouldAttachmentRender = fields.some((field)=>field.type === 'attachment' && field.displayed);
        switch(type){
            case 'text':
                const textState = fieldState;
                if (textState.id === 'summary') return /*#__PURE__*/ $fc4bM.createElement((0, $czFqK.default), {
                    ...baseProps,
                    requestTypeId: requestTypeId,
                    knowledgeBase: knowledgeBase,
                    // We need to rehydrate the default value if its defined.
                    // If we don't do this the internal state is thrown away when re-rendered
                    // and the field can never get back the current value.
                    // This is currently handling the case when the summary field re-renders
                    // from request tour onboarding dismissal.
                    defaultValue: $643ee780069d5553$var$calculateDefaultSummaryValue(urlParamValueOverride, fieldValues[textState.id], textState.value),
                    valueOverride: (0, $hN5YJ.isUiModificationsSupportEnabled)() ? textState.valueOverride : undefined,
                    onChange: onFieldChange,
                    onFieldBlurredByUser: this.props.onFieldBlurredByUser,
                    key: textState.id,
                    errorMessage: fieldErrors[textState.id],
                    disabled: submitting || !!textState.disabled
                });
                if (textState.id === 'email') return /*#__PURE__*/ $fc4bM.createElement((0, $cBCkX.default), {
                    ...baseProps,
                    key: textState.id,
                    // Suppressing existing violation. Please fix this.
                    defaultValue: // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    urlParamValueOverride === undefined ? textState.value : urlParamValueOverride,
                    onChange: onFieldChange,
                    errorMessage: fieldErrors.email,
                    disabled: submitting || !!textState.disabled,
                    errorReasonKey: errorReasonKey
                });
                if ((0, $hN5YJ.isTextFieldSupportEnabled)()) return /*#__PURE__*/ $fc4bM.createElement((0, $2N4Ib.ControlledTextField), {
                    ...baseProps,
                    // Suppressing existing violation. Please fix this.
                    defaultValue: // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    urlParamValueOverride === undefined ? textState.value : urlParamValueOverride,
                    valueOverride: (0, $hN5YJ.isUiModificationsSupportEnabled)() ? textState.valueOverride : undefined,
                    onChange: onFieldChange,
                    onFieldBlurredByUser: this.props.onFieldBlurredByUser,
                    key: textState.id,
                    errorMessage: fieldErrors[textState.id],
                    disabled: submitting || !!textState.disabled,
                    testId: 'request-create-form-text-field'
                });
                return /*#__PURE__*/ $fc4bM.createElement((0, $2N4Ib.TextField), {
                    ...baseProps,
                    // Suppressing existing violation. Please fix this.
                    defaultValue: // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    urlParamValueOverride === undefined ? textState.value : urlParamValueOverride,
                    onChange: onFieldChange,
                    key: textState.id,
                    errorMessage: fieldErrors[textState.id],
                    disabled: submitting || !!textState.disabled,
                    testId: 'request-create-form-text-field'
                });
            case 'checkbox':
                {
                    const checkboxState = fieldState;
                    const checkboxItems = checkboxState.items.map((item)=>({
                            label: item.label,
                            value: item.value
                        }));
                    const checkboxProps = {
                        ...baseProps,
                        items: checkboxItems,
                        // Suppressing existing violation. Please fix this.
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                        defaultValue: urlParamValueOverride || checkboxState.value,
                        onChange: onFieldChange,
                        key: checkboxState.id,
                        errorMessage: fieldErrors[checkboxState.id],
                        disabled: submitting || !!checkboxState.disabled
                    };
                    return (0, $hN5YJ.isMultiCheckboxSupportEnabled)() ? /*#__PURE__*/ $fc4bM.createElement((0, $4FGhU.ControlledCheckboxGroup), {
                        ...checkboxProps,
                        valueOverride: (0, $hN5YJ.isUiModificationsSupportEnabled)() ? checkboxState.valueOverride : undefined
                    }) : /*#__PURE__*/ $fc4bM.createElement((0, $4FGhU.default), checkboxProps);
                }
            case 'textarea':
                const textAreaState = fieldState;
                const hasMediaContext = (0, $k2M4v.default).checkGate('request_create_inline_attachment') && shouldAttachmentRender;
                if ((0, $hN5YJ.isRichTextAreaEnabled)() && textAreaState.rendererType === 'atlassian-wiki-renderer') {
                    const mediaContextProps = hasMediaContext && portalId ? {
                        mediaContext: {
                            portalId: portalId,
                            requestId: undefined
                        }
                    } : {};
                    return /*#__PURE__*/ $fc4bM.createElement((0, $ksO0j.FormRichTextArea), {
                        ...baseProps,
                        onChange: onFieldChange,
                        defaultValue: $643ee780069d5553$var$calculateDefaultRichTextValue(urlParamValueOverride, fieldValues[textAreaState.id], textAreaState.value),
                        key: textAreaState.id,
                        errorMessage: fieldErrors[textAreaState.id],
                        disabled: submitting || !!textAreaState.disabled,
                        fieldConfigs: {
                            portalId: this.props.portalId,
                            fieldConfigId: textAreaState.fieldConfigId,
                            fieldName: textAreaState.id
                        },
                        valueOverride: (0, $hN5YJ.isUiModificationsSupportEnabled)() ? textAreaState.valueOverride : undefined,
                        onFieldBlurredByUser: (0, $hN5YJ.isUiModificationsSupportEnabled)() ? this.props.onFieldBlurredByUser : undefined,
                        ...mediaContextProps
                    });
                }
                return /*#__PURE__*/ $fc4bM.createElement((0, $h3NhD.FormTextArea), {
                    ...baseProps,
                    minimumRows: 6,
                    onChange: onFieldChange,
                    // Suppressing existing violation. Please fix this.
                    defaultValue: // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    urlParamValueOverride === undefined ? textAreaState.value : urlParamValueOverride,
                    key: textAreaState.id,
                    errorMessage: fieldErrors[textAreaState.id],
                    disabled: submitting || !!textAreaState.disabled,
                    valueOverride: (0, $hN5YJ.isUiModificationsSupportEnabled)() ? textAreaState.valueOverride : undefined,
                    onFieldBlurredByUser: (0, $hN5YJ.isUiModificationsSupportEnabled)() ? this.props.onFieldBlurredByUser : undefined
                });
            case 'radio':
                const radioGroupState = fieldState;
                const radioItems = radioGroupState.items.map((item)=>{
                    return {
                        label: item.label,
                        name: item.name,
                        value: item.value
                    };
                });
                const radioProps = {
                    ...baseProps,
                    items: radioItems,
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    defaultValue: urlParamValueOverride || radioGroupState.value,
                    onChange: onFieldChange,
                    key: radioGroupState.id,
                    errorMessage: fieldErrors[radioGroupState.id],
                    disabled: submitting || !!radioGroupState.disabled
                };
                return (0, $hN5YJ.isRadioButtonsSupportEnabled)() ? /*#__PURE__*/ $fc4bM.createElement((0, $d1cEw.ControlledRadioGroup), {
                    ...radioProps,
                    valueOverride: (0, $hN5YJ.isUiModificationsSupportEnabled)() ? radioGroupState.valueOverride : undefined
                }) : /*#__PURE__*/ $fc4bM.createElement((0, $d1cEw.default), radioProps);
            case 'date':
                const dateState = fieldState;
                return /*#__PURE__*/ $fc4bM.createElement((0, $58I7T.ConditionalDatepicker), {
                    ...baseProps,
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    defaultValue: urlParamValueOverride || dateState.defaultDate,
                    valueOverride: (0, $hN5YJ.isUiModificationsSupportEnabled)() ? dateState.valueOverride : undefined,
                    onChange: onFieldChange,
                    key: dateState.id,
                    errorMessage: fieldErrors[dateState.id],
                    disabled: submitting || !!dateState.disabled,
                    dateFormat: dateFormat,
                    firstDay: firstDay,
                    locale: locale,
                    useISO8601WeekNumbers: useISO8601WeekNumbers
                });
            case 'duedate':
                const dueDateState = fieldState;
                return (0, $hN5YJ.isDueDateSupportEnabled)() ? /*#__PURE__*/ $fc4bM.createElement((0, $bGND9.ControlledDatePicker), {
                    ...baseProps,
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    defaultValue: urlParamValueOverride || dueDateState.defaultDate,
                    valueOverride: (0, $hN5YJ.isUiModificationsSupportEnabled)() ? dueDateState.valueOverride : undefined,
                    onChange: onFieldChange,
                    key: dueDateState.id,
                    errorMessage: fieldErrors[dueDateState.id],
                    disabled: submitting || !!dueDateState.disabled,
                    dateFormat: dateFormat,
                    firstDay: firstDay,
                    locale: locale,
                    useISO8601WeekNumbers: useISO8601WeekNumbers
                }) : /*#__PURE__*/ $fc4bM.createElement((0, $58I7T.default), {
                    ...baseProps,
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    defaultValue: urlParamValueOverride || dueDateState.defaultDate,
                    onChange: onFieldChange,
                    key: dueDateState.id,
                    errorMessage: fieldErrors[dueDateState.id],
                    disabled: submitting || !!dueDateState.disabled,
                    dateFormat: dateFormat,
                    firstDay: firstDay,
                    locale: locale,
                    useISO8601WeekNumbers: useISO8601WeekNumbers
                });
            case 'datetime':
                const dateTimeState = fieldState;
                return (0, $hN5YJ.isDateTimeSupportEnabled)() ? /*#__PURE__*/ $fc4bM.createElement((0, $gD7pJ.ControlledDateTimePicker), {
                    ...baseProps,
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    defaultValue: urlParamValueOverride || dateTimeState.defaultDate,
                    valueOverride: (0, $hN5YJ.isUiModificationsSupportEnabled)() ? dateTimeState.valueOverride : undefined,
                    onChange: onFieldChange,
                    key: dateTimeState.id,
                    errorMessage: fieldErrors[dateTimeState.id],
                    disabled: submitting || !!dateTimeState.disabled,
                    dateTimeFormat: dateTimeFormat,
                    firstDay: firstDay,
                    useISO8601WeekNumbers: useISO8601WeekNumbers,
                    locale: locale
                }) : /*#__PURE__*/ $fc4bM.createElement((0, $1MEdu.default), {
                    ...baseProps,
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    defaultValue: urlParamValueOverride || dateTimeState.defaultDate,
                    onChange: onFieldChange,
                    key: dateTimeState.id,
                    errorMessage: fieldErrors[dateTimeState.id],
                    disabled: submitting || !!dateTimeState.disabled,
                    dateTimeFormat: dateTimeFormat,
                    firstDay: firstDay,
                    useISO8601WeekNumbers: useISO8601WeekNumbers,
                    locale: locale
                });
            case 'attachment':
                const attachmentState = fieldState;
                return /*#__PURE__*/ $fc4bM.createElement((0, $lgEHL.default), {
                    ...baseProps,
                    onChange: onFieldChange,
                    key: attachmentState.id,
                    disabled: submitting || !!attachmentState.disabled,
                    errorMessage: fieldErrors[attachmentState.id],
                    portalId: this.props.portalId,
                    blockFormSubmission: this.props.blockFormSubmission
                });
            case 'reporter':
                return this.renderReporterField(fieldState, baseProps, submitting, fieldErrors, urlParamValueOverride, canCreateUsers);
            case 'userpicker':
                const userPickerState = fieldState;
                const defaultUser = userPickerState.defaultUser ? {
                    email: userPickerState.defaultUser.emailAddress,
                    iconUrl: userPickerState.defaultUser.avatar,
                    value: userPickerState.defaultUser.id,
                    label: userPickerState.defaultUser.displayName,
                    accountId: userPickerState.defaultUser.accountId
                } : undefined;
                const defaultUserOverride = (0, $hN5YJ.isJsmPortalRovoIntegrationEnabled)() ? urlParamValueOverride : undefined;
                return /*#__PURE__*/ $fc4bM.createElement((0, $bE4v0.default), {
                    ...baseProps,
                    portalId: this.props.portalId,
                    label: userPickerState.label || '',
                    onChange: onFieldChange,
                    key: userPickerState.id,
                    errorMessage: fieldErrors[userPickerState.id],
                    disabled: submitting || !!userPickerState.disabled,
                    defaultUser: defaultUserOverride ?? defaultUser,
                    canCreateUser: canCreateUsers,
                    createLabelType: "add",
                    fieldConfigId: userPickerState.fieldConfigId,
                    valueOverride: (0, $hN5YJ.isUiModificationsSupportEnabled)() ? userPickerState.valueOverride : undefined
                });
            case 'multiuserpicker':
                const multiUserPickerState = fieldState;
                const defaultUsers = (multiUserPickerState.defaultUsers || []).map((user)=>({
                        email: user.emailAddress,
                        iconUrl: user.avatar,
                        value: user.id,
                        label: user.displayName
                    }));
                const defaultMultiUsersOverride = (0, $hN5YJ.isJsmPortalRovoIntegrationEnabled)() ? urlParamValueOverride : undefined;
                const mergedDefaultUsers = defaultMultiUsersOverride ?? defaultUsers;
                return /*#__PURE__*/ $fc4bM.createElement((0, $6fJnq.default), {
                    ...baseProps,
                    portalId: this.props.portalId,
                    label: multiUserPickerState.label || '',
                    onChange: onFieldChange,
                    key: multiUserPickerState.id,
                    errorMessage: fieldErrors[multiUserPickerState.id],
                    disabled: submitting || !!multiUserPickerState.disabled,
                    defaultUsers: mergedDefaultUsers,
                    fieldConfigId: multiUserPickerState.fieldConfigId,
                    canAddUserByEmailAddress: canCreateUsers
                });
            case 'organduserpicker':
                // Note: We are returning an empty fragment here to avoid rendering the unknown field.
                return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null);
            case 'labelpicker':
                const labelPickerState = fieldState;
                return /*#__PURE__*/ $fc4bM.createElement((0, $kW8X3.default), {
                    ...baseProps,
                    customFieldId: labelPickerState.customFieldId,
                    portalId: portalId,
                    requestTypeId: requestTypeId,
                    onChange: onFieldChange,
                    key: labelPickerState.id,
                    errorMessage: fieldErrors[labelPickerState.id],
                    disabled: submitting || !!labelPickerState.disabled,
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    defaultLabels: urlParamValueOverride || labelPickerState.defaultLabels,
                    valueOverride: (0, $hN5YJ.isUiModificationsSupportEnabled)() ? labelPickerState.valueOverride : undefined
                });
            case 'organisationpicker':
                const orgState = fieldState;
                const defaultOrganisationOverride = (0, $hN5YJ.isJsmPortalRovoIntegrationEnabled)() ? urlParamValueOverride : undefined;
                return(// @ts-ignore
                /*#__PURE__*/ $fc4bM.createElement((0, $eKHFe.default), {
                    ...baseProps,
                    projectId: projectId,
                    portalId: portalId,
                    requestTypeId: requestTypeId,
                    onChange: onFieldChange,
                    key: orgState.id,
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    organisationUserEmail: reporter,
                    isNewReporter: this.state.isNewReporter,
                    disabled: submitting || !!orgState.disabled,
                    enableSubmitButton: enableSubmitButton,
                    disableSubmitButton: disableSubmitButton,
                    shareWithOrgByDefault: orgState.shareWithOrgByDefault,
                    defaultOrganisation: defaultOrganisationOverride
                }));
            case 'assetspicker':
                const assetPickerState = fieldState;
                return /*#__PURE__*/ $fc4bM.createElement((0, $bnNbm.default), {
                    ...baseProps,
                    label: assetPickerState.label || '',
                    onChange: onFieldChange,
                    key: assetPickerState.id,
                    disabled: submitting || !!assetPickerState.disabled,
                    fieldConfigId: assetPickerState.fieldConfigId,
                    accountId: this.state.accountId,
                    portalId: portalId,
                    errorMessage: fieldErrors[assetPickerState.id]
                });
            case 'multiservicepicker':
                const multiServicePickerState = fieldState;
                let defaultMultiServicesOverride;
                if ((0, $hN5YJ.isJsmPortalRovoIntegrationEnabled)() && urlParamValueOverride) {
                    // Handle both string and array formats
                    if (Array.isArray(urlParamValueOverride)) defaultMultiServicesOverride = urlParamValueOverride;
                    else if (typeof urlParamValueOverride === 'string') defaultMultiServicesOverride = [
                        urlParamValueOverride
                    ];
                }
                return /*#__PURE__*/ $fc4bM.createElement((0, $ak5IU.default), {
                    ...baseProps,
                    label: multiServicePickerState.label || '',
                    onChange: onFieldChange,
                    key: multiServicePickerState.id,
                    disabled: submitting || !!multiServicePickerState.disabled,
                    errorMessage: fieldErrors[multiServicePickerState.id],
                    defaultServices: defaultMultiServicesOverride,
                    value: fieldValues[multiServicePickerState.id]
                });
            case 'cmdbobjectpicker':
                const cmdbObjectPickerState = fieldState;
                const fieldValueMapReducer = (accumulator, currentField)=>{
                    var _fieldValues$currentF;
                    // Suppressing existing violation. Please fix this.
                    return accumulator.concat([
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
                        [
                            currentField.id,
                            ((_fieldValues$currentF = fieldValues[currentField.id]) === null || _fieldValues$currentF === void 0 ? void 0 : _fieldValues$currentF.toString()) || ''
                        ]
                    ]);
                };
                // Disable field if form is submitting
                // OR if the field does not have a valid configuration (and therefore, cannot provide any values to pick)
                const isCmdbObjectPickerDisabled = submitting || !cmdbObjectPickerState.hasValidConfig || !!cmdbObjectPickerState.disabled;
                return /*#__PURE__*/ $fc4bM.createElement((0, $36Ozg.default), {
                    ...baseProps,
                    ...cmdbObjectPickerState,
                    onChange: onFieldChange,
                    key: cmdbObjectPickerState.id,
                    disabled: isCmdbObjectPickerDisabled,
                    errorMessage: fieldErrors[cmdbObjectPickerState.id],
                    portalId: portalId,
                    requestTypeId: requestTypeId,
                    fieldValueMap: fields.reduce(fieldValueMapReducer, []),
                    placeholderValues: (0, $apqs2.createPlaceholderValueMap)(fieldValues, cmdbObjectPickerState.placeholderKeys),
                    initialValues: urlParamValueOverride
                });
            case 'select':
                const selectState = fieldState;
                return /*#__PURE__*/ $fc4bM.createElement((0, $3BNzL.SingleSelectField), {
                    ...baseProps,
                    label: selectState.label || '',
                    onChange: onFieldChange,
                    key: selectState.id,
                    errorMessage: fieldErrors[selectState.id],
                    disabled: submitting || !!selectState.disabled,
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    defaultValue: urlParamValueOverride || selectState.defaultValue,
                    valueOverride: (0, $hN5YJ.isUiModificationsSupportEnabled)() ? selectState.valueOverride : undefined,
                    options: selectState.options
                });
            case 'multiselect':
                const multiSelectState = fieldState;
                return /*#__PURE__*/ $fc4bM.createElement((0, $iQR8K.default), {
                    ...baseProps,
                    label: multiSelectState.label || '',
                    onChange: onFieldChange,
                    key: multiSelectState.id,
                    errorMessage: fieldErrors[multiSelectState.id],
                    disabled: submitting || !!multiSelectState.disabled,
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    defaultValue: urlParamValueOverride || multiSelectState.defaultValue,
                    valueOverride: (0, $hN5YJ.isMultiSelectEnabled)() ? multiSelectState.valueOverride : undefined,
                    options: multiSelectState.options
                });
            case 'cascadingselect':
                const cascadingSelectState = fieldState;
                return /*#__PURE__*/ $fc4bM.createElement((0, $50qKs.FormCascadingSelect), {
                    ...baseProps,
                    actionSubjectId: "cascadingSelectField",
                    label: cascadingSelectState.label || '',
                    onChange: onFieldChange,
                    key: cascadingSelectState.id,
                    errorMessage: fieldErrors[cascadingSelectState.id],
                    disabled: submitting || !!cascadingSelectState.disabled,
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    defaultValue: urlParamValueOverride || cascadingSelectState.value,
                    options: cascadingSelectState.options,
                    valueOverride: (0, $hN5YJ.isUiModificationsSupportEnabled)() ? cascadingSelectState.valueOverride : undefined
                });
            case 'cardnumber':
                const sdCardNumberState = fieldState;
                return /*#__PURE__*/ $fc4bM.createElement((0, $1TcxL.PciSecureTextPicker), {
                    ...baseProps,
                    label: sdCardNumberState.label || '',
                    defaultValue: // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    urlParamValueOverride || sdCardNumberState.value,
                    onChange: onFieldChange,
                    key: sdCardNumberState.id,
                    errorMessage: fieldErrors[sdCardNumberState.id],
                    disabled: submitting || !!sdCardNumberState.disabled
                });
            case 'entitlementpicker':
                const entitlementState = fieldState;
                const defaultEntitlementOverride = (0, $hN5YJ.isJsmPortalRovoIntegrationEnabled)() ? urlParamValueOverride : undefined;
                return /*#__PURE__*/ $fc4bM.createElement((0, $5uTDB.EntitlementPicker), {
                    ...baseProps,
                    onChange: onFieldChange,
                    label: entitlementState.label || '',
                    value: fieldValues[entitlementState.id],
                    key: entitlementState.id,
                    reporterId: reporter,
                    isNewReporter: this.state.isNewReporter,
                    disabled: submitting || !!entitlementState.disabled,
                    enableSubmitButton: enableSubmitButton,
                    disableSubmitButton: disableSubmitButton,
                    errorMessage: fieldErrors[entitlementState.id],
                    defaultEntitlement: defaultEntitlementOverride
                });
            case 'forge':
                const forgeState = fieldState;
                return /*#__PURE__*/ $fc4bM.createElement((0, $7NGwE.ForgeField), {
                    ...baseProps,
                    jiraFieldType: (0, $hN5YJ.isForgeCustomFieldsOnPortalViewEnabled)() ? undefined : forgeState.jiraFieldType,
                    extension: (0, $hN5YJ.isForgeCustomFieldsOnPortalViewEnabled)() ? forgeState.extension : undefined,
                    key: forgeState.id,
                    portalId: this.props.portalId,
                    requestTypeId: this.props.requestTypeId,
                    projectId: this.props.projectId,
                    errorMessage: fieldErrors[forgeState.id],
                    value: fieldValues[forgeState.id],
                    fallbackRender: (newType)=>{
                        return this.renderField({
                            ...fieldState,
                            type: newType
                        }, submitting);
                    },
                    disabled: submitting || !!fieldState.disabled,
                    enableSubmitButton: enableSubmitButton,
                    disableSubmitButton: disableSubmitButton,
                    onChange: onFieldChange
                });
            default:
                const unknownFieldProps = fieldState;
                this.unknownField = type;
                return this.renderUnknownField(unknownFieldProps);
        }
    }
    renderUnknownField(fieldState) {
        return /*#__PURE__*/ $fc4bM.createElement((0, $fxF7L.default), {
            id: fieldState.id,
            key: fieldState.id
        });
    }
    renderErrorMessage() {
        const { submissionErrorCount: submissionErrorCount, errors: errors } = this.props;
        if (errors && errors.submissionError) return /*#__PURE__*/ $fc4bM.createElement((0, $fwgWP.AutoFocus), {
            key: submissionErrorCount
        }, /*#__PURE__*/ $fc4bM.createElement((0, $b64HO.default), {
            errors: errors
        }));
        return null;
    }
    renderFormFinished() {
        var _this$props$onProform, _this$props;
        (_this$props$onProform = (_this$props = this.props).onProformaFormRendered) === null || _this$props$onProform === void 0 || _this$props$onProform.call(_this$props);
        if (this.state.shouldHoldUFO) this.setState({
            shouldHoldUFO: false
        });
        if (!this.state.isProformaFormRendered) this.setState({
            isProformaFormRendered: true
        });
    }
    render() {
        const { accountId: accountId, fields: fields, fieldValues: fieldValues, errors: errors, className: className, submitting: submitting, submitDisabled: submitDisabled, onSubmit: onSubmit, onCancel: onCancel, sitekey: sitekey, requestTypeId: requestTypeId, portalId: portalId, isFormExpanded: isFormExpanded, isAttachmentUploading: isAttachmentUploading, registerProformaForm: registerProformaForm, locale: locale, knowledgeBase: knowledgeBase, updateForgeRequestPropertyData: updateForgeRequestPropertyData, formRef: formRef } = this.props;
        const hasProformaForm = !!registerProformaForm;
        // Disable submission while the Proforma form has not finished rendering.
        const isProformaFormPending = hasProformaForm && !this.state.isProformaFormRendered && $643ee780069d5553$var$isBlockRequestCreateSubmitForFormLoadingEnabled();
        const AsyncProformaRequestCreateInternal = this.AsyncProformaRequestCreateInternal;
        const FormCreateApp = this.props.proformaField;
        let renderJiraFields = Boolean(FormCreateApp);
        if (!renderJiraFields) // If Proforma is on the page, display the Jira and Proforma fields at the same time
        renderJiraFields = hasProformaForm ? this.state.asyncFormCreateAppLoaded : true;
        const ProformaView = FormCreateApp ?? AsyncProformaRequestCreateInternal; // This is using root app component from the Locally Consumable version of the package for Proforma Request Create
        return /*#__PURE__*/ $fc4bM.createElement((0, $2c0lV.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: className,
            recaptchaEnabled: this.props.captchaEnabled,
            onSubmit: onSubmit,
            sitekey: sitekey,
            onTokenChange: this.onRecaptchaTokenChange,
            formRef: formRef,
            noValidate: true
        }, ({ isExecuting: isExecuting })=>{
            const isProcessing = submitting || isExecuting;
            const isButtonDisable = isProcessing || submitDisabled || isAttachmentUploading || isProformaFormPending;
            // Reporter of issue is the one selected in the reporter user picker.
            // If reporter user picker is not displayed, then the reporter is the current user.
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const reporterAccountId = fieldValues.reporter ?? accountId;
            const renderProformaFormView = hasProformaForm && /*#__PURE__*/ $fc4bM.createElement(ProformaView, {
                blockFormSubmission: this.props.blockFormSubmission,
                "data-testid": 'AsyncProformaRequestCreate',
                fieldErrors: errors === null || errors === void 0 ? void 0 : errors.fieldErrors,
                knowledgeBase: knowledgeBase,
                locale: locale,
                portalId: portalId,
                registerProformaForm: registerProformaForm,
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                renderFormFinished: this.renderFormFinished.bind(this),
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                reporterAccountId: reporterAccountId,
                requestTypeId: requestTypeId
            });
            return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, this.renderErrorMessage(), /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tbyV))), {
                allowOverflowWhenOpen: (0, $hN5YJ.isRichTextAreaEnabled)(),
                expanded: !!isFormExpanded
            }, renderJiraFields && this.renderFields(fields, isProcessing), !(0, $hN5YJ.isProformaTTVCUpdateMeasureEnabled)() && renderProformaFormView, (0, $hN5YJ.isProformaTTVCUpdateMeasureEnabled)() && /*#__PURE__*/ $fc4bM.createElement((0, $d7r8x.default), {
                name: "proforma-jira-portal-create",
                hold: this.state.shouldHoldUFO
            }, renderProformaFormView), /*#__PURE__*/ $fc4bM.createElement((0, $lJ9q5.ConnectFields), {
                requestTypeId: requestTypeId,
                portalId: portalId,
                location: (0, $04E2Q.REQUEST_CREATE_PANEL)
            }), /*#__PURE__*/ $fc4bM.createElement((0, $axCcv.RequestCreatePropertyPanelModule), {
                portalId: this.props.portalId,
                projectId: (0, $aYMdQ.toNumber)(this.props.projectId),
                requestTypeId: this.props.requestTypeId,
                onUpdateRequestPropertyData: updateForgeRequestPropertyData
            }), renderJiraFields && /*#__PURE__*/ $fc4bM.createElement((0, $fLu4j.ButtonGroup), null, /*#__PURE__*/ $fc4bM.createElement((0, $iK1uY.ThemedButton), {
                appearance: "primary",
                type: "submit",
                isDisabled: isButtonDisable,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                className: "request-create-form-submit",
                actionSubjectId: "submitRequest",
                interactionName: "request-create-submit",
                onMouseEnter: this.props.onHoverSubmitButton,
                testId: "request-create-form-submit-button"
            }, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $4TGvK.default).sendForm)), /*#__PURE__*/ $fc4bM.createElement((0, $lvRbB.FireScreenEventOnMount), null), /*#__PURE__*/ $fc4bM.createElement((0, $iK1uY.ThemedButton), {
                appearance: "subtle",
                isDisabled: isButtonDisable,
                onClick: onCancel,
                actionSubjectId: "cancelRequest",
                testId: "request-create-form-cancel-button"
            }, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $4TGvK.default).cancelForm)), (isProcessing || isAttachmentUploading) && /*#__PURE__*/ $fc4bM.createElement((0, $hculA.default), {
                size: "small"
            }))));
        });
    }
    constructor(...args){
        super(...args), this.state = {
            accountId: undefined,
            isNewReporter: undefined,
            asyncFormCreateAppLoaded: false,
            shouldHoldUFO: true,
            isProformaFormRendered: false
        }, this.unknownField = null, this.AsyncProformaRequestCreateInternal = (0, $ik8St.createAsyncProformaRequestCreate)({
            LoadingSkeleton: (0, $aUHFa.SkeletonLoadingWrapper),
            onLoaded: ()=>{
                this.setState({
                    asyncFormCreateAppLoaded: true
                });
            }
        }), this.onReporterFieldChange = (name, value, _ = false, additionalFieldData)=>{
            var _additionalFieldData$;
            const accountId = additionalFieldData && additionalFieldData.rawObject && additionalFieldData.rawObject.accountId;
            const isNewReporter = name === 'reporter' && (additionalFieldData === null || additionalFieldData === void 0 || (_additionalFieldData$ = additionalFieldData.rawObject) === null || _additionalFieldData$ === void 0 ? void 0 : _additionalFieldData$.isNew);
            this.setState({
                accountId: accountId,
                isNewReporter: isNewReporter
            });
            this.props.onFieldChange(name, value);
        }, this.onRecaptchaTokenChange = (token)=>{
            this.props.onFieldChange('g-recaptcha-response', token);
        };
    }
}
var $643ee780069d5553$export$2e2bcd8739ae039 = (0, $613oU.default)({
    componentName: 'requestCreateForm'
})((0, $azARG.default)()($643ee780069d5553$export$d3eed393162f64da));
const $643ee780069d5553$var$calculateDefaultSummaryValue = (urlParamOverride, fieldValue, defaultValueFromState)=>{
    return urlParamOverride ?? fieldValue ?? defaultValueFromState;
};
const $643ee780069d5553$var$getRichTextAreaFieldValue = (urlParamOverride, fieldValue, defaultValueFromState)=>{
    return urlParamOverride || fieldValue || defaultValueFromState || undefined;
};
const $643ee780069d5553$var$calculateDefaultRichTextValue = (0, $8PRsU.default)($643ee780069d5553$var$getRichTextAreaFieldValue);

});
parcelRegister("5bPxE", function(module, exports) {
$parcel$export(module.exports, "AnonymousEmailField", () => (parcelRequire("cBCkX")).default);

var $cBCkX = parcelRequire("cBCkX");

});
parcelRegister("cBCkX", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b21558ff4114a62$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $aYMdQ = parcelRequire("aYMdQ");

var $9DSUc = parcelRequire("9DSUc");

var $ch1yB = parcelRequire("ch1yB");

var $2N4Ib = parcelRequire("2N4Ib");
parcelRequire("52Uk2");
var $iaVgA = parcelRequire("iaVgA");

var $azARG = parcelRequire("azARG");

var $613oU = parcelRequire("613oU");
parcelRequire("16ETU");
var $7lyTS = parcelRequire("7lyTS");

var $gwdtf = parcelRequire("gwdtf");
const $9b21558ff4114a62$var$REQUIRED = 'REQUIRED';
const $9b21558ff4114a62$export$97afc76c65b5683b = (props)=>{
    const { id: id, label: label, required: required, defaultValue: defaultValue, description: description, errorMessage: errorMessage, disabled: disabled, shouldFitContainer: shouldFitContainer, placeholder: placeholder, isLabelHidden: isLabelHidden, type: type, autoFocus: autoFocus, onFocus: onFocus, onChange: onChange } = props;
    const [showWarningMessage, setShowWarningMessage] = $fc4bM.useState(false);
    const [email, setEmail] = $fc4bM.useState(defaultValue || '');
    const onBlur = $fc4bM.useCallback(()=>{
        if ((0, $iaVgA.isEmail)(email)) // Disabling existing violations, should be fixed when revisited.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $9DSUc.checkSignupStatus)(email).map((response)=>{
            if (response.status === $9b21558ff4114a62$var$REQUIRED) setShowWarningMessage(true);
            else setShowWarningMessage(false);
        }).toPromise();
    }, [
        email,
        setShowWarningMessage
    ]);
    const onChangeCallback = $fc4bM.useCallback((name, value)=>{
        if (onChange) onChange(name, value);
        setEmail(value);
    }, [
        onChange
    ]);
    const isSignupRequiredError = props.errorReasonKey === (0, $gwdtf.ERROR_REASON_KEYS).SIGNUP_REQUIRED;
    const isInvalid = !(0, $aYMdQ.isEmpty)(errorMessage);
    const inputType = type;
    const field = /*#__PURE__*/ $fc4bM.createElement((0, $2N4Ib.TextField), {
        id: id,
        label: '',
        isLabelHidden: true,
        defaultValue: defaultValue,
        value: email,
        onChange: onChangeCallback,
        isInvalid: isInvalid,
        shouldFitContainer: shouldFitContainer,
        disabled: disabled,
        placeholder: placeholder,
        type: inputType,
        autoFocus: autoFocus,
        onFocus: onFocus,
        onBlur: onBlur,
        "aria-describedby": `${id}-field-description`
    });
    return /*#__PURE__*/ $fc4bM.createElement((0, $ch1yB.FieldBase), {
        htmlFor: id,
        label: label,
        required: required,
        description: description,
        noLabel: isLabelHidden,
        errorMessage: isSignupRequiredError ? '' : errorMessage
    }, field, (showWarningMessage || isSignupRequiredError) && /*#__PURE__*/ $fc4bM.createElement((0, $7lyTS.default), {
        isError: isSignupRequiredError
    }));
};
$9b21558ff4114a62$export$97afc76c65b5683b.defaultProps = {
    shouldFitContainer: true,
    type: 'text'
};
var $9b21558ff4114a62$export$2e2bcd8739ae039 = (0, $613oU.default)({
    componentName: 'AnonymousEmailField'
})((0, $azARG.default)()($9b21558ff4114a62$export$97afc76c65b5683b));

});
parcelRegister("9DSUc", function(module, exports) {
$parcel$export(module.exports, "checkSignupStatus", () => $65f59fb93ed088a6$export$661ddfa66e89c4e8);

var $bTjsX = parcelRequire("bTjsX");

var $jFk35 = parcelRequire("jFk35");

var $aIVqJ = parcelRequire("aIVqJ");

var $diqlM = parcelRequire("diqlM");
const $65f59fb93ed088a6$export$661ddfa66e89c4e8 = (email)=>{
    const body = {
        email: email
    };
    const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    };
    const uri = `${(0, $diqlM.contextPath)}/rest/servicedesk/1/customer/user/signup-status`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.post)(uri, body, headers).map((ajaxResponse)=>{
        return ajaxResponse.response;
    }).catch((e)=>{
        (0, $aIVqJ.trackError)('signup-status.fetch.failed', {}, e);
        return (0, $jFk35.Observable).throw(e);
    });
};

});

parcelRegister("52Uk2", function(module, exports) {
$parcel$export(module.exports, "isEmail", () => (parcelRequire("iaVgA")).isEmail);

var $iaVgA = parcelRequire("iaVgA");

});
parcelRegister("iaVgA", function(module, exports) {
$parcel$export(module.exports, "isEmail", () => $04a05041e5397dab$export$7fbbfbca30081d0);
// eslint-disable-next-line no-useless-escape
const $04a05041e5397dab$var$EMAIL_PATTERN = /^[a-zA-Z0-9_\-\+'`\?=\*%\$#!/^\{\|}~\.]+@([a-zA-Z0-9\-]+\.)+([a-zA-Z0-9]+)$/;
const $04a05041e5397dab$export$7fbbfbca30081d0 = (inputValue)=>{
    let valid = false;
    // limit the number of matches required by a complicated regex, and make it simple, with some full stop checks
    // for good measure, to be certain we should be dealing with a valid looking email address.
    // this mirrors the approach in EmailUtil.java
    if ($04a05041e5397dab$var$EMAIL_PATTERN.test(inputValue)) {
        const name = inputValue.split('@')[0].trim();
        valid = !name.startsWith('.') && !name.endsWith('.') && !name.includes('..');
    }
    return valid;
};

});


parcelRegister("16ETU", function(module, exports) {
$parcel$export(module.exports, "AnonymousEmailSignupMessage", () => (parcelRequire("7lyTS")).default);

var $7lyTS = parcelRequire("7lyTS");

});
parcelRegister("7lyTS", function(module, exports) {
$parcel$export(module.exports, "default", () => $c318b36b3fe205e8$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $imLe4 = parcelRequire("imLe4");

var $fRgxR = parcelRequire("fRgxR");

var $fd880 = parcelRequire("fd880");
var $fcCIH = parcelRequire("fcCIH");

var $gDsF8 = parcelRequire("gDsF8");

var $7ZdBj = parcelRequire("7ZdBj");

var $1hmIR = parcelRequire("1hmIR");
const $c318b36b3fe205e8$export$631c5895a8697bfd = ({ isError: isError, intl: intl })=>{
    return /*#__PURE__*/ $fc4bM.createElement($c318b36b3fe205e8$var$Wrapper, null, isError ? /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDsF8))), {
        label: "error",
        color: "var(--ds-icon-danger, #FF5630)"
    }) : /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ZdBj))), {
        label: "warning",
        color: "var(--ds-icon-warning, #FFAB00)"
    }), /*#__PURE__*/ $fc4bM.createElement($c318b36b3fe205e8$var$SignupMessage, {
        isError: isError
    }, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), {
        ...(0, $1hmIR.default).signupWarningMessage,
        values: {
            signUpLink: // eslint-disable-next-line @atlassian/i18n/no-unsafe-message-composition -- Pre-existing; to be migrated
            /*#__PURE__*/ $fc4bM.createElement((0, $fRgxR.default), {
                to: '/user/login',
                target: "_blank",
                actionSubjectId: "signupLink"
            }, intl.formatMessage((0, $1hmIR.default).signupLink))
        }
    })));
};
var $c318b36b3fe205e8$export$2e2bcd8739ae039 = (0, $fcCIH.default)($c318b36b3fe205e8$export$631c5895a8697bfd);
const $c318b36b3fe205e8$var$requestCreateFieldErrorColor = "var(--ds-text-danger, #BF2600)";
const $c318b36b3fe205e8$var$anonymousEmailSignupWarningTextColor = "var(--ds-text-subtlest, #6B778C)";
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $c318b36b3fe205e8$var$SignupMessage = /*#__PURE__*/ (0, $luz1X.default).span.withConfig({
    componentId: "sc-1xptymo-0"
})`${$imLe4.xsmall};color:${(props)=>props.isError ? $c318b36b3fe205e8$var$requestCreateFieldErrorColor : $c318b36b3fe205e8$var$anonymousEmailSignupWarningTextColor};font-weight:500;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $c318b36b3fe205e8$var$Wrapper = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1xptymo-1"
})`display:flex;margin-top:${"var(--ds-space-050, 4px)"};`;

});
parcelRegister("1hmIR", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b1c9ca321763ad1$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $6b1c9ca321763ad1$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    signupWarningMessage: {
        defaultMessage: 'Before you can send this request, {signUpLink} to continue',
        description: 'Message to redirect to sign up page before creating request.',
        id: 'cv.request.create.form.anonymousEmail.signupWarningMessage'
    },
    signupLink: {
        defaultMessage: 'sign up',
        description: 'Label for the sign up link in the anonymous email signup warning message.',
        id: 'cv.request.create.form.anonymousEmail.signupLink'
    }
});

});



parcelRegister("gwdtf", function(module, exports) {
$parcel$export(module.exports, "ERROR_REASON_KEYS", () => $25fb19ccd8e915ed$export$c9847750ab7b4d36);
var $25fb19ccd8e915ed$export$c9847750ab7b4d36 = /*#__PURE__*/ function(ERROR_REASON_KEYS) {
    // Note: These error reason keys are not exhaustive
    // When the recaptcha validation fails
    ERROR_REASON_KEYS["RECAPTCHA_ERROR"] = "sd.recaptcha.user.may.be.a.robot";
    // when the user is raising a request anonymously in the portal using an domain that requires signing up
    ERROR_REASON_KEYS["SIGNUP_REQUIRED"] = "signup.required.error";
    ERROR_REASON_KEYS["SIGNUP_VALIDATION_ERROR"] = "signup.validation.errors";
    ERROR_REASON_KEYS["RECAPTCHA_SHARED_KEY_NOT_SET"] = "sd.recaptcha.shared.key.not.set";
    ERROR_REASON_KEYS["RECAPTCHA_DOMAIN_MISMATCH"] = "sd.recaptcha.domain.not.match";
    // When the user do not have permission to create requests using the Portal
    ERROR_REASON_KEYS["NEED_PERMISSION"] = "sd.request.create.error.permission";
    // When the user do not have permission to create requests on behalf of other users
    ERROR_REASON_KEYS["NEED_PERMISSION_ON_BEHALF_OF"] = "sd.request.create.error.permission.onbehalfof";
    // When user can't raise a request on behalf of a user as they need the customer role on their site managed by their organization's admins
    ERROR_REASON_KEYS["NEED_PERMISSION_REQUESTOR"] = "sd.request.create.error.permission.requestor";
    // When user does not have permission to set issue property
    ERROR_REASON_KEYS["NEED_PERMISSION_SET_ISSUE_PROPERTY"] = "sd.request.create.error.permission.setIssueProperty";
    // When the issue type of the request raised isn't found
    ERROR_REASON_KEYS["ISSUE_TYPE_NOT_FOUND"] = "sd.request.create.error.issuetype.not.found";
    // When default value for a field is missing
    ERROR_REASON_KEYS["NO_DEFAULT_FOUND"] = "sd.request.create.error.no.default.found";
    // When certain fields have errors
    ERROR_REASON_KEYS["FAILED_FIELD_OPERATION"] = "sd.request.create.error.failed.field.operation";
    // Unable to create request because of some errors
    ERROR_REASON_KEYS["FAILED_MSG"] = "sd.request.create.error.failed.msg";
    // When account id is not valid user's id
    ERROR_REASON_KEYS["UNKNOWN_ACCOUNT_ID"] = "sd.request.create.error.unknown.account.id";
    // When proforma form properties are not valid
    ERROR_REASON_KEYS["PROFORMA_FORM_PROPERTIES_ERROR"] = "sd.request.create.error.proforma.form.properties.error";
    // When user does not have permission to view the request
    ERROR_REASON_KEYS["NO_PERMISSION"] = "sd.request.view.error.no.permission";
    return ERROR_REASON_KEYS;
}({});

});



parcelRegister("lzoGU", function(module, exports) {
$parcel$export(module.exports, "AssetsPicker", () => (parcelRequire("bnNbm")).default);

var $bnNbm = parcelRequire("bnNbm");

});
parcelRegister("bnNbm", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a54b2d2c74e01eb$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $9XZeF = parcelRequire("9XZeF");

var $2n2bS = parcelRequire("2n2bS");

var $aYMdQ = parcelRequire("aYMdQ");

var $dl80T = parcelRequire("dl80T");

var $b46ZL = parcelRequire("b46ZL");
parcelRequire("i8wfi");
var $8D6V7 = parcelRequire("8D6V7");
class $7a54b2d2c74e01eb$export$ea034712530a02d4 extends $fc4bM.PureComponent {
    static #_ = this.searchAssetDebounceWaitTime = 400;
    componentDidMount() {
        return (0, $dl80T.getFieldConfig)(this.props.fieldConfigId, this.props.portalId).toPromise().then((fieldConfig)=>this.setState({
                fieldConfig: fieldConfig,
                isFieldConfigLoaded: true
            })).catch((_)=>{
            // TODO: Consider re-visiting this error handling. If the field config exists and fails for some
            // unknown reason, the search will potentially fetch incorrectly typed assets.
            this.setState({
                isFieldConfigLoaded: true
            });
        });
    }
    render() {
        return /*#__PURE__*/ $fc4bM.createElement((0, $8D6V7.default), {
            ...this.props,
            loadOptions: this.loadOptions,
            isFieldConfigLoaded: this.state.isFieldConfigLoaded,
            doInitialSearch: true
        });
    }
    constructor(...args){
        super(...args), this.state = {
            fieldConfig: {
                types: []
            },
            isFieldConfigLoaded: false
        }, this.loadOptions = (inputValue, callback)=>{
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.searchAssetsDebounced(inputValue, callback);
        }, this.fetchAssets = (inputValue, callback)=>{
            if (!this.state.isFieldConfigLoaded) // We can't fetch assets until the field config is loaded.
            return Promise.resolve([]);
            const { accountId: accountId } = this.props;
            if (!accountId) return Promise.resolve();
            return (0, $dl80T.searchAssets)(accountId, inputValue, this.state.fieldConfig).map((response)=>response.values.map((asset)=>({
                        label: asset.label.value,
                        value: `${asset.origin.appKey}/${asset.origin.originId}`,
                        origin: asset.origin
                    }))).toPromise().then(callback);
        }, this.searchAssetsDebounced = (0, $aYMdQ.debounce)(this.fetchAssets, $7a54b2d2c74e01eb$export$ea034712530a02d4.searchAssetDebounceWaitTime);
    }
}
const $7a54b2d2c74e01eb$var$selector = (0, $2n2bS.createSelector)((state, props)=>props.accountId || (0, $b46ZL.getAccountId)(state), (accountId)=>({
        accountId: accountId
    }));
var $7a54b2d2c74e01eb$export$2e2bcd8739ae039 = (0, $9XZeF.connect)($7a54b2d2c74e01eb$var$selector)($7a54b2d2c74e01eb$export$ea034712530a02d4);

});
parcelRegister("dl80T", function(module, exports) {
$parcel$export(module.exports, "searchAssets", () => $857461811e56c3d3$export$d3522f67fd6c26f9);
$parcel$export(module.exports, "getFieldConfig", () => $857461811e56c3d3$export$1fafb7a30b5a01b3);

var $bTjsX = parcelRequire("bTjsX");

var $6dipk = parcelRequire("6dipk");

var $jFk35 = parcelRequire("jFk35");

var $aIVqJ = parcelRequire("aIVqJ");

var $diqlM = parcelRequire("diqlM");
const $857461811e56c3d3$export$d3522f67fd6c26f9 = (assignee, query, fieldConfig, context = (0, $diqlM.contextPath))=>{
    var _fieldConfig$types;
    const assignees = [
        assignee
    ];
    assignees.push('unassigned');
    const queryString = $6dipk.stringify({
        query: query,
        // get assets assigned to user and all other unassigned assets
        assignee: assignees,
        prioritizedAssignee: assignee,
        type: fieldConfig === null || fieldConfig === void 0 || (_fieldConfig$types = fieldConfig.types) === null || _fieldConfig$types === void 0 ? void 0 : _fieldConfig$types.map((type)=>{
            // type to serialized type origin
            return `${type.appKey}/${type.originId}`.toLowerCase();
        })
    });
    const uri = `${context}/rest/assetapi/asset/search?${queryString}`;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.get)(uri)// eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        (0, $aIVqJ.trackError)('search.assets.failed', {}, e);
        // Rethrow error
        return (0, $jFk35.Observable).throw(e);
    });
};
const $857461811e56c3d3$export$1fafb7a30b5a01b3 = (fieldConfigId, portalId)=>{
    const uri = `${(0, $diqlM.contextPath)}/rest/assetinternalapi/1/field/portal/${portalId}/config/${fieldConfigId}`;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.get)(uri)// eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        (0, $aIVqJ.trackError)('assets.get.field.config.id.failed', {}, e);
        // Rethrow error
        return (0, $jFk35.Observable).throw(e);
    });
};

});

parcelRegister("i8wfi", function(module, exports) {
$parcel$export(module.exports, "AssetsPickerDumb", () => (parcelRequire("8D6V7")).default);

var $8D6V7 = parcelRequire("8D6V7");

});
parcelRegister("8D6V7", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6114e0e91475898$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $cBmRF = parcelRequire("cBmRF");

var $fcCIH = parcelRequire("fcCIH");

var $6oof1 = parcelRequire("6oof1");

var $ea8AG = parcelRequire("ea8AG");
class $b6114e0e91475898$export$91d8c4dc52817ba2 extends $fc4bM.Component {
    render() {
        const { disabled: disabled, doInitialSearch: doInitialSearch, intl: intl, isLoading: isLoading, isFieldConfigLoaded: isFieldConfigLoaded, accountId: accountId, ...otherProps } = this.props;
        return /*#__PURE__*/ $fc4bM.createElement((0, $cBmRF.FormAsyncMultiSelect), {
            ...otherProps,
            actionSubjectId: "assetsPickerField",
            // We set a key on this component so that it re-mounts when the field configuration is loaded, or,
            // the account id changes. The re-mounting triggers the initial search, which is skipped when the
            // field configuration is not loaded.
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            key: `asset-loaded-${isFieldConfigLoaded}-${accountId}`,
            placeholder: intl.formatMessage((0, $ea8AG.default).searchPlaceholder),
            noOptionsMessage: this.noOpt,
            isDisabled: disabled,
            isLoading: isLoading,
            onChange: this.onChangeForMultiSelect,
            defaultOptions: doInitialSearch
        });
    }
    constructor(...args){
        super(...args), this.onChangeForMultiSelect = (options)=>{
            var _this$props$onChange, _this$props;
            (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, this.props.id, (0, $6oof1.toMultiSelectValue)(options).map((v)=>v.value));
        }, this.noOpt = (inputValues)=>{
            return inputValues.inputValue === '' ? this.props.intl.formatMessage((0, $ea8AG.default).typeToSearch) : this.props.intl.formatMessage((0, $ea8AG.default).noOptions);
        };
    }
}
var $b6114e0e91475898$export$2e2bcd8739ae039 = (0, $fcCIH.default)($b6114e0e91475898$export$91d8c4dc52817ba2);

});
parcelRegister("cBmRF", function(module, exports) {
$parcel$export(module.exports, "FormMultiSelect", () => $2e6a54f2f9ce1d0f$export$8cf908d07cc79854);
$parcel$export(module.exports, "FormAsyncMultiSelect", () => $2e6a54f2f9ce1d0f$export$285798b94a2121fb);
$parcel$export(module.exports, "FormAsyncCreatableMultiSelect", () => $2e6a54f2f9ce1d0f$export$9a1bea4037f21326);

var $fc4bM = parcelRequire("fc4bM");

var $hN5YJ = parcelRequire("hN5YJ");

var $fO5DL = parcelRequire("fO5DL");

var $6wHv6 = parcelRequire("6wHv6");

var $k6bCh = parcelRequire("k6bCh");

var $iRlFU = parcelRequire("iRlFU");
const $2e6a54f2f9ce1d0f$var$FieldMultiSelect = (0, $iRlFU.default)((0, $fO5DL.ThemedSelect));
const $2e6a54f2f9ce1d0f$var$FieldAsyncCreatableMultiSelect = (0, $iRlFU.default)((0, $fO5DL.ThemedAsyncCreatableSelect));
const $2e6a54f2f9ce1d0f$var$FieldAsyncMultiSelect = (0, $iRlFU.default)((0, $fO5DL.ThemedAsyncSelect));
const $2e6a54f2f9ce1d0f$var$FormMultiSelectWithControlledValue = (0, $6wHv6.withControlledFormComponentValue)((options)=>options)((props)=>/*#__PURE__*/ $fc4bM.createElement($2e6a54f2f9ce1d0f$var$FieldMultiSelect, {
        ...props,
        isMulti: true,
        isClearable: true
    }));
const $2e6a54f2f9ce1d0f$export$8cf908d07cc79854 = (0, $k6bCh.componentWithCondition)((0, $hN5YJ.isMultiSelectEnabled), $2e6a54f2f9ce1d0f$var$FormMultiSelectWithControlledValue, (props)=>/*#__PURE__*/ $fc4bM.createElement($2e6a54f2f9ce1d0f$var$FieldMultiSelect, {
        ...props,
        isMulti: true,
        isClearable: true
    }));
const $2e6a54f2f9ce1d0f$export$285798b94a2121fb = (props)=>/*#__PURE__*/ $fc4bM.createElement($2e6a54f2f9ce1d0f$var$FieldAsyncMultiSelect, {
        ...props,
        isMulti: true,
        isClearable: true
    });
const $2e6a54f2f9ce1d0f$var$FormAsyncCreatableMultiSelectUncontrolled = (props)=>/*#__PURE__*/ $fc4bM.createElement($2e6a54f2f9ce1d0f$var$FieldAsyncCreatableMultiSelect, {
        ...props,
        isMulti: true,
        isClearable: true
    });
const $2e6a54f2f9ce1d0f$var$FormAsyncCreatableMultiSelectControlled = (0, $6wHv6.withControlledFormComponentValue)((options)=>options)($2e6a54f2f9ce1d0f$var$FormAsyncCreatableMultiSelectUncontrolled);
const $2e6a54f2f9ce1d0f$export$9a1bea4037f21326 = $2e6a54f2f9ce1d0f$var$FormAsyncCreatableMultiSelectControlled;

});

parcelRegister("ea8AG", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8c0293a5453023a$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $d8c0293a5453023a$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    searchPlaceholder: {
        defaultMessage: 'Search all',
        description: 'Placeholder for assets picker field to advise the user to search for all assets (even after an initial load of assets)',
        id: 'cv.request.create.form.assets.picker.search'
    },
    noOptions: {
        defaultMessage: 'No options',
        description: 'Text that appears in the dropdown for the assets picker if there are no assets to select',
        id: 'cv.request.create.form.assets.picker.no.options'
    },
    typeToSearch: {
        defaultMessage: 'Type to search',
        description: 'Text that appears in the dropdown for the assets picker if the user needs to search to find assets',
        id: 'cv.request.create.form.assets.picker.type.to.search'
    }
});

});





parcelRegister("aoSIG", function(module, exports) {
$parcel$export(module.exports, "CascadingSelect", () => (parcelRequire("50qKs")).default);
$parcel$export(module.exports, "FormCascadingSelect", () => (parcelRequire("50qKs")).FormCascadingSelect);

var $50qKs = parcelRequire("50qKs");

});
parcelRegister("50qKs", function(module, exports) {
$parcel$export(module.exports, "FormCascadingSelect", () => $4b210b0eaf03bcc7$export$94e649b5ff9739c1);
$parcel$export(module.exports, "default", () => $4b210b0eaf03bcc7$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $hN5YJ = parcelRequire("hN5YJ");

var $fOCtI = parcelRequire("fOCtI");

var $ch1yB = parcelRequire("ch1yB");

var $fO5DL = parcelRequire("fO5DL");

var $k6bCh = parcelRequire("k6bCh");

var $6oof1 = parcelRequire("6oof1");

var $juzow = parcelRequire("juzow");

var $6wHv6 = parcelRequire("6wHv6");
class $4b210b0eaf03bcc7$var$ThemedSelectGroup extends $fc4bM.PureComponent {
    constructor(props){
        super(props), this.state = {}, this.onGroupSelected = (groupSelected)=>{
            var _toSingleSelectValue;
            const groupValue = (_toSingleSelectValue = (0, $6oof1.toSingleSelectValue)(groupSelected)) === null || _toSingleSelectValue === void 0 ? void 0 : _toSingleSelectValue.value;
            this.setState({
                groupValue: groupValue,
                childValue: undefined
            });
            if ((0, $hN5YJ.isCascadingSelectSupportEnabled)()) {
                var _this$props$onChange, _this$props;
                (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, this.props.id, {
                    primaryValue: groupValue ?? null,
                    children: undefined
                }, false, {
                    rawObject: {},
                    rawValue: {
                        primaryValue: groupSelected,
                        children: undefined
                    }
                });
            } else {
                var _this$props$onChange2, _this$props2;
                (_this$props$onChange2 = (_this$props2 = this.props).onChange) === null || _this$props$onChange2 === void 0 || _this$props$onChange2.call(_this$props2, this.props.id, {
                    primaryValue: groupValue ?? null,
                    children: undefined
                });
            }
        }, this.onChildSelected = (childSelected)=>{
            var _toSingleSelectValue2;
            const groupValue = this.getGroupStateValue();
            const childValue = (_toSingleSelectValue2 = (0, $6oof1.toSingleSelectValue)(childSelected)) === null || _toSingleSelectValue2 === void 0 ? void 0 : _toSingleSelectValue2.value;
            const selectedGroup = this.getSelectedGroup();
            if (groupValue) {
                this.setState({
                    childValue: childValue
                });
                if ((0, $hN5YJ.isCascadingSelectSupportEnabled)()) {
                    var _this$props$onChange3, _this$props3;
                    (_this$props$onChange3 = (_this$props3 = this.props).onChange) === null || _this$props$onChange3 === void 0 || _this$props$onChange3.call(_this$props3, this.props.id, {
                        primaryValue: groupValue,
                        children: childValue ?? null
                    }, false, {
                        rawObject: {},
                        rawValue: {
                            primaryValue: selectedGroup,
                            children: childSelected
                        }
                    });
                } else {
                    var _this$props$onChange4, _this$props4;
                    (_this$props$onChange4 = (_this$props4 = this.props).onChange) === null || _this$props$onChange4 === void 0 || _this$props$onChange4.call(_this$props4, this.props.id, {
                        primaryValue: groupValue,
                        children: childValue ?? null
                    });
                }
            }
        };
        const { defaultValue: defaultValue, options: options } = this.props;
        if (defaultValue) {
            const defaultGroup = options.find((group)=>group.value === defaultValue.primaryValue);
            const defaultChild = defaultGroup && defaultGroup.children.find((g)=>g.value === defaultValue.children);
            this.state = {
                groupValue: defaultGroup && defaultGroup.value,
                childValue: defaultChild && defaultChild.value
            };
        }
    }
    getGroupStateValue() {
        const { value: value } = this.props;
        return value === undefined ? this.state.groupValue : value.primaryValue;
    }
    getChildStateValue() {
        const { value: value } = this.props;
        return value === undefined ? this.state.childValue : value.children;
    }
    getSelectedGroup() {
        const { options: options } = this.props;
        const groupValue = this.getGroupStateValue();
        // We make sure to set null instead of undefined here to ensure value is updated correctly;
        return groupValue && options.find((group)=>group.value === groupValue) || null;
    }
    getSelectedChild(selectedGroup) {
        const childValue = this.getChildStateValue();
        // We make sure to set null instead of undefined here to ensure value is updated correctly;
        return selectedGroup && selectedGroup.children.find((g)=>g.value === childValue) || null;
    }
    render() {
        const { actionSubjectId: actionSubjectId, label: label, required: required, errorMessage: errorMessage, description: description, id: id, options: options, disabled: disabled, isClearable: isClearable, selectWidth: selectWidth } = this.props;
        const selectedGroup = this.getSelectedGroup();
        const selectedChild = this.getSelectedChild(selectedGroup);
        const validationState = !!errorMessage ? 'error' : 'default';
        const clearable = isClearable === undefined ? true : isClearable;
        return /*#__PURE__*/ $fc4bM.createElement((0, $ch1yB.FieldBase), {
            htmlFor: id,
            label: label,
            required: required,
            errorMessage: errorMessage,
            description: description
        }, /*#__PURE__*/ $fc4bM.createElement($4b210b0eaf03bcc7$var$Container, null, /*#__PURE__*/ $fc4bM.createElement($4b210b0eaf03bcc7$var$SelectContainer, {
            marginRight: "var(--ds-space-100, 8px)",
            selectWidth: selectWidth,
            "data-test-id": `select-container-${id}`,
            "aria-describedby": `${id}-field-description`
        }, /*#__PURE__*/ $fc4bM.createElement((0, $fO5DL.ThemedSelect), {
            actionSubjectId: `${actionSubjectId}PrimarySelect`,
            inputId: id,
            options: options,
            value: selectedGroup,
            onChange: this.onGroupSelected,
            validationState: validationState,
            isDisabled: disabled,
            isClearable: clearable
        })), /*#__PURE__*/ $fc4bM.createElement($4b210b0eaf03bcc7$var$SelectContainer, {
            selectWidth: selectWidth,
            "data-test-id": `select-container-${id}:1`,
            "aria-describedby": `${id}-field-description`
        }, /*#__PURE__*/ $fc4bM.createElement((0, $fO5DL.ThemedSelect), {
            actionSubjectId: `${actionSubjectId}SecondarySelect`,
            inputId: `${id}:1`,
            options: selectedGroup ? selectedGroup.children : [],
            value: selectedChild,
            onChange: this.onChildSelected,
            validationState: validationState,
            isDisabled: disabled,
            isClearable: clearable
        }))));
    }
}
const $4b210b0eaf03bcc7$var$ControlledCascadingSelect = (0, $6wHv6.withControlledFormComponentValue)((_field, value)=>value, (0, $juzow.normalizeCascadingSelectValue))($4b210b0eaf03bcc7$var$ThemedSelectGroup);
const $4b210b0eaf03bcc7$export$94e649b5ff9739c1 = (0, $k6bCh.componentWithCondition)(()=>(0, $hN5YJ.isCascadingSelectSupportEnabled)(), $4b210b0eaf03bcc7$var$ControlledCascadingSelect, $4b210b0eaf03bcc7$var$ThemedSelectGroup);
var $4b210b0eaf03bcc7$export$2e2bcd8739ae039 = $4b210b0eaf03bcc7$var$ThemedSelectGroup;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $4b210b0eaf03bcc7$var$Container = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1r04av8-0"
})`display:flex;flex-wrap:wrap;width:100%;margin-top:${"var(--ds-space-negative-050, -4px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $4b210b0eaf03bcc7$var$SelectContainer = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1r04av8-1"
})`width:${(props)=>`${props && props.selectWidth ? `${props.selectWidth}px` : `calc(50% - ${$fOCtI.multiple(0.5).px})`}`};margin-top:${"var(--ds-space-050, 4px)"};margin-right:${(props)=>`${props && props.marginRight ? props.marginRight : '0px'}`};`;

});


parcelRegister("lq05G", function(module, exports) {
$parcel$export(module.exports, "CheckboxGroup", () => (parcelRequire("4FGhU")).default);
$parcel$export(module.exports, "ControlledCheckboxGroup", () => (parcelRequire("4FGhU")).ControlledCheckboxGroup);

var $4FGhU = parcelRequire("4FGhU");

});
parcelRegister("4FGhU", function(module, exports) {
$parcel$export(module.exports, "ControlledCheckboxGroup", () => $a57a1c42e0696dae$export$c1e527161a9140d6);
$parcel$export(module.exports, "default", () => $a57a1c42e0696dae$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $ch1yB = parcelRequire("ch1yB");

var $kDn5h = parcelRequire("kDn5h");

var $2HMpF = parcelRequire("2HMpF");

var $6wHv6 = parcelRequire("6wHv6");
class $a57a1c42e0696dae$var$CustomCheckboxGroup extends $fc4bM.PureComponent {
    constructor(props){
        super(props), this.onChange = (e)=>{
            if (this.props.onChange) {
                const currentValue = e.currentTarget.value;
                const selectedValues = this.props.value ?? this.checkedValues;
                const nextValues = selectedValues.includes(currentValue) ? selectedValues.filter((value)=>value !== currentValue) : [
                    ...selectedValues,
                    currentValue
                ];
                this.checkedValues = nextValues;
                if (this.props.value !== undefined) {
                    const selectedItems = this.props.items.filter((item)=>nextValues.includes(item.value));
                    this.props.onChange(this.props.id, nextValues, false, {
                        rawObject: selectedItems,
                        rawValue: selectedItems
                    });
                    return;
                }
                this.props.onChange(this.props.id, nextValues);
            }
        };
        this.checkedValues = props.defaultValue || [];
    }
    render() {
        const { label: label, required: required, description: description, id: id, items: items, errorMessage: errorMessage, disabled: disabled, value: value } = this.props;
        const selectedValues = value ?? this.checkedValues;
        return /*#__PURE__*/ $fc4bM.createElement((0, $ch1yB.FieldBase), {
            htmlFor: id,
            labelId: id,
            label: label,
            required: required,
            description: description,
            errorMessage: errorMessage
        }, /*#__PURE__*/ $fc4bM.createElement($a57a1c42e0696dae$var$CheckboxGroup, {
            role: "group",
            "aria-labelledby": id,
            "aria-describedby": `${id}-field-description`
        }, items.map((item)=>/*#__PURE__*/ $fc4bM.createElement((0, $kDn5h.Checkbox), {
                isDisabled: disabled,
                key: item.label,
                name: item.label,
                label: item.label,
                value: item.value,
                ...value === undefined ? {
                    defaultChecked: this.checkedValues.includes(item.value)
                } : {
                    isChecked: selectedValues.includes(item.value)
                },
                onChange: this.onChange
            }))));
    }
}
const $a57a1c42e0696dae$export$c1e527161a9140d6 = (0, $6wHv6.withControlledFormComponentValue)((_field, value)=>value, (0, $2HMpF.normalizeMultiCheckboxValue))($a57a1c42e0696dae$var$CustomCheckboxGroup);
var $a57a1c42e0696dae$export$2e2bcd8739ae039 = $a57a1c42e0696dae$var$CustomCheckboxGroup;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $a57a1c42e0696dae$var$CheckboxGroup = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-mclhti-0"
})`display:flex;flex-direction:column;`;

});


parcelRegister("bGND9", function(module, exports) {
$parcel$export(module.exports, "ControlledDatePicker", () => $c6f7004aa8f9bca1$export$54c001387125b016);
$parcel$export(module.exports, "DatePicker", () => (parcelRequire("58I7T")).default);
$parcel$export(module.exports, "ConditionalDatepicker", () => (parcelRequire("58I7T")).ConditionalDatepicker);

var $58I7T = parcelRequire("58I7T");

var $6wHv6 = parcelRequire("6wHv6");
const $c6f7004aa8f9bca1$export$54c001387125b016 = (0, $6wHv6.withControlledFormComponentValue)((_field, value)=>value)((0, $58I7T.default));

});
parcelRegister("58I7T", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d296f1a700e17fb$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ConditionalDatepicker", () => $4d296f1a700e17fb$export$c4aede8d1c6e88b);
/* date-picker.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $hN5YJ = parcelRequire("hN5YJ");

var $cwnd9 = parcelRequire("cwnd9");
var $abJ7q = parcelRequire("abJ7q");
var $2vjAH = parcelRequire("2vjAH");
var $4o5S4 = parcelRequire("4o5S4");

var $aYMdQ = parcelRequire("aYMdQ");

var $fcCIH = parcelRequire("fcCIH");

var $ch1yB = parcelRequire("ch1yB");
parcelRequire("3AN4U");
var $bkuBa = parcelRequire("bkuBa");

var $8cyx6 = parcelRequire("8cyx6");

var $4MjGQ = parcelRequire("4MjGQ");

var $7SNzi = parcelRequire("7SNzi");

var $76pXf = parcelRequire("76pXf");

var $k6bCh = parcelRequire("k6bCh");

var $6wHv6 = parcelRequire("6wHv6");
parcelRequire("fghV6");
var $j3i1C = parcelRequire("j3i1C");
const $4d296f1a700e17fb$var$IsoDateFormat = /^\d{4}-\d{2}-\d{2}$/;
const $4d296f1a700e17fb$export$240ff04a48ca99e9 = (value)=>{
    try {
        if (!value || !(0, $abJ7q.default)(new Date(value))) return undefined;
        // Fix for the one-day-off issue with new Date()
        // Link: [DateTime Picker One Day Off Issue](https://hello.atlassian.net/wiki/x/zwTjxw)
        const processedValue = value.match($4d296f1a700e17fb$var$IsoDateFormat) ? (0, $cwnd9.default)(new Date(value.replace(/-/g, '/'))) : (0, $cwnd9.default)(new Date(value));
        // Fix for range time error when the string date passed to the date picker is not valid
        return (0, $abJ7q.default)(new Date(processedValue)) ? processedValue : undefined;
    } catch (error) {
        (0, $4MjGQ.operationalEvent)({
            action: `processDateValueFailed`,
            actionSubject: 'datePicker',
            attributes: {
                inputValue: value,
                error: error instanceof Error ? error.message : 'unknown'
            }
        });
        return undefined;
    }
};
const $4d296f1a700e17fb$export$c4cebce289a65263 = (date, dateFormat)=>{
    let parsedDate;
    try {
        parsedDate = (0, $2vjAH.default)(date, dateFormat, new Date());
    } catch (error) {
        // fire operational event with step information
        (0, $4MjGQ.operationalEvent)({
            action: `dateParseFailed`,
            actionSubject: 'datePicker',
            attributes: {
                dateFormat: dateFormat,
                inputValue: date,
                error: error instanceof Error ? error.message : 'unknown'
            }
        });
    }
    if (parsedDate && (0, $abJ7q.default)(parsedDate)) return parsedDate;
    if ((0, $abJ7q.default)(new Date(date))) return (0, $4o5S4.default)(new Date(date).toISOString());
    return (0, $4o5S4.default)(new Date().toISOString());
};
class $4d296f1a700e17fb$export$f846ef91367704d3 extends $fc4bM.PureComponent {
    render() {
        const { id: id, label: label, required: required, defaultValue: defaultValue, description: description, errorMessage: errorMessage, disabled: disabled, locale: locale, firstDay: firstDay, useISO8601WeekNumbers: useISO8601WeekNumbers, value: value, intl: intl, dateFormat: dateFormat = 'yyyy-MM-dd' } = this.props;
        const isInvalid = !(0, $aYMdQ.isEmpty)(errorMessage);
        // Need to refer to id like this.
        // See: https://atlaskit.atlassian.com/packages/core/datetime-picker
        const inputId = `react-select-${id}-input`;
        const defaultDateValue = $4d296f1a700e17fb$export$240ff04a48ca99e9(defaultValue);
        let processedValue = '';
        if (value && (0, $hN5YJ.isDueDateSupportEnabled)()) processedValue = $4d296f1a700e17fb$export$240ff04a48ca99e9(value) ?? '';
        /**
     * Support both controlled and uncontrolled component behavior.
     *
     * When UI Modifications (UIM) feature flag is enabled, the component uses the `value` prop (controlled).
     * When disabled, it falls back to `defaultValue` prop (uncontrolled).
     *
     * This dual behavior will be removed once the UIM feature flag (ditto_uim_-_jsm_support_main)
     * is fully rolled out and the component becomes fully controlled.
     */ const isValueDefined = (0, $hN5YJ.isDueDateSupportEnabled)() && typeof value === 'string';
        const dateFieldValueProps = isValueDefined ? {
            value: processedValue
        } : {
            defaultValue: defaultDateValue
        };
        return /*#__PURE__*/ $fc4bM.createElement((0, $ch1yB.FieldBase), {
            htmlFor: inputId,
            label: label,
            required: required,
            description: description,
            errorMessage: errorMessage
        }, /*#__PURE__*/ $fc4bM.createElement("div", {
            className: (0, $2R2iS.default)([
                "_1bsb1lit"
            ])
        }, /*#__PURE__*/ $fc4bM.createElement((0, $8cyx6.default), {
            id: inputId,
            name: id,
            locale: locale,
            ...dateFieldValueProps,
            onChange: this.onChange,
            isInvalid: isInvalid,
            isDisabled: !!disabled,
            formatDisplayLabel: this.parseDateLabel,
            placeholder: intl.formatMessage((0, $bkuBa.default).forExample, {
                text: (0, $76pXf.format)((0, $7SNzi.default)(), dateFormat)
            }),
            dateFormat: dateFormat,
            weekStartDay: (0, $76pXf.getWeekStartDay)(firstDay, useISO8601WeekNumbers),
            parseInputValue: $4d296f1a700e17fb$export$c4cebce289a65263,
            "aria-describedby": `${inputId}-field-description`
        })));
    }
    constructor(...args){
        super(...args), this.onChange = (isoTime)=>{
            const { onChange: onChange } = this.props;
            if ((0, $hN5YJ.isDueDateSupportEnabled)()) onChange && onChange(this.props.id, isoTime, false, {
                rawObject: {},
                rawValue: isoTime
            });
            else onChange && onChange(this.props.id, isoTime, false);
        }, this.parseDateLabel = (isoTime, dateFormat)=>{
            return isoTime && dateFormat ? (0, $76pXf.format)((0, $4o5S4.default)(isoTime), dateFormat) : isoTime;
        };
    }
}
const $4d296f1a700e17fb$var$wrappedDatePicker = (0, $j3i1C.withPortalLocale)((0, $fcCIH.default)($4d296f1a700e17fb$export$f846ef91367704d3));
var $4d296f1a700e17fb$export$2e2bcd8739ae039 = $4d296f1a700e17fb$var$wrappedDatePicker;
const $4d296f1a700e17fb$export$54c001387125b016 = (0, $6wHv6.withControlledFormComponentValue)((_field, value)=>value)($4d296f1a700e17fb$var$wrappedDatePicker);
const $4d296f1a700e17fb$export$c4aede8d1c6e88b = (0, $k6bCh.componentWithCondition)(()=>(0, $hN5YJ.isDatePickerSupportEnabled)(), $4d296f1a700e17fb$export$54c001387125b016, $4d296f1a700e17fb$var$wrappedDatePicker);
const $4d296f1a700e17fb$var$datePickerContainerCss = null;

});
parcelRegister("cwnd9", function(module, exports) {
$parcel$export(module.exports, "default", () => $91da7a6c3491e92b$export$2e2bcd8739ae039);

var $a3cTc = parcelRequire("a3cTc");

var $8MI6h = parcelRequire("8MI6h");

var $3mokv = parcelRequire("3mokv");
function $91da7a6c3491e92b$export$2e2bcd8739ae039(date, options) {
    var _options$format, _options$representati;
    (0, $3mokv.default)(1, arguments);
    var originalDate = (0, $a3cTc.default)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError('Invalid time value');
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
    if (format !== 'extended' && format !== 'basic') throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== 'date' && representation !== 'time' && representation !== 'complete') throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = '';
    var tzOffset = '';
    var dateDelimiter = format === 'extended' ? '-' : '';
    var timeDelimiter = format === 'extended' ? ':' : '';
    // Representation is either 'date' or 'complete'
    if (representation !== 'time') {
        var day = (0, $8MI6h.default)(originalDate.getDate(), 2);
        var month = (0, $8MI6h.default)(originalDate.getMonth() + 1, 2);
        var year = (0, $8MI6h.default)(originalDate.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== 'date') {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, $8MI6h.default)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, $8MI6h.default)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? '+' : '-';
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = 'Z';
        var hour = (0, $8MI6h.default)(originalDate.getHours(), 2);
        var minute = (0, $8MI6h.default)(originalDate.getMinutes(), 2);
        var second = (0, $8MI6h.default)(originalDate.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === '' ? '' : 'T';
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}

});

parcelRegister("3AN4U", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("bkuBa")).default);

var $bkuBa = parcelRequire("bkuBa");

});
parcelRegister("bkuBa", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6412c109de7a0d4$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $b6412c109de7a0d4$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    forExample: {
        defaultMessage: 'e.g. {text}',
        description: 'Example text used in various places, for example the date picker placeholder. "e.g. 02/12/1990"',
        id: 'cv.portal.generic.for.example'
    }
});

});


parcelRegister("7SNzi", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb8095b2d415cf09$export$2e2bcd8739ae039);
var $fb8095b2d415cf09$export$2e2bcd8739ae039 = ()=>new Date();

});

parcelRegister("76pXf", function(module, exports) {
$parcel$export(module.exports, "format", () => $b649e6d2adccc6a5$export$d9468344d3651243);
$parcel$export(module.exports, "getWeekStartDay", () => $b649e6d2adccc6a5$export$99291c0265ff1d37);
/**
 * The following things will need to be fixed:
 *  - Async loading of the locales or only include the locale necessary for a bundle
 *  - Grab the user locale from somewhere other than the AJS meta.
 */ 
var $iY5sc = parcelRequire("iY5sc");

var $88nZz = parcelRequire("88nZz");

var $eLqcu = parcelRequire("eLqcu");

var $anB32 = parcelRequire("anB32");

var $1I9Ga = parcelRequire("1I9Ga");

var $aA59Q = parcelRequire("aA59Q");

var $7MpTG = parcelRequire("7MpTG");

var $bPhCV = parcelRequire("bPhCV");

var $QQXxB = parcelRequire("QQXxB");

var $jPBT1 = parcelRequire("jPBT1");

var $ejBXU = parcelRequire("ejBXU");

var $9MXAM = parcelRequire("9MXAM");

var $ftOhr = parcelRequire("ftOhr");

var $ljuVT = parcelRequire("ljuVT");

var $gIJv1 = parcelRequire("gIJv1");

var $6QbV1 = parcelRequire("6QbV1");

var $6oDYY = parcelRequire("6oDYY");

var $ko9yy = parcelRequire("ko9yy");

var $juYbe = parcelRequire("juYbe");

var $bBvvF = parcelRequire("bBvvF");

var $6LH8a = parcelRequire("6LH8a");
const $b649e6d2adccc6a5$var$supportedLocales = [
    'cs',
    'da',
    'de',
    'en',
    'es',
    'fi',
    'fr',
    'hu',
    'is',
    'it',
    'ja',
    'ko',
    'nl',
    'pl',
    'pt',
    'ro',
    'ru',
    'sk',
    'sv'
];
const $b649e6d2adccc6a5$var$supportedLocale = {
    cs: $88nZz.default,
    da: $eLqcu.default,
    de: $anB32.default,
    en: $1I9Ga.default,
    es: $aA59Q.default,
    fi: $7MpTG.default,
    fr: $bPhCV.default,
    hu: $QQXxB.default,
    is: $jPBT1.default,
    it: $ejBXU.default,
    ja: $9MXAM.default,
    ko: $ftOhr.default,
    nl: $ljuVT.default,
    pl: $gIJv1.default,
    pt: $6QbV1.default,
    ro: $6oDYY.default,
    ru: $ko9yy.default,
    sk: $juYbe.default,
    sv: $bBvvF.default
};
const $b649e6d2adccc6a5$var$isValidLocale = (str)=>{
    return $b649e6d2adccc6a5$var$supportedLocales.includes(str);
};
const $b649e6d2adccc6a5$export$d9468344d3651243 = (date, dateTimeFormat)=>{
    var _getMetaData;
    const localeKeys = (((_getMetaData = (0, $6LH8a.getMetaData)()) === null || _getMetaData === void 0 ? void 0 : _getMetaData.userLocale) || '').replace('_', '-').split('-');
    if (localeKeys && localeKeys.length > 0 && $b649e6d2adccc6a5$var$isValidLocale(localeKeys[0])) {
        const localeToUse = $b649e6d2adccc6a5$var$supportedLocale[localeKeys[0]];
        return (0, $iY5sc.default)(date, dateTimeFormat, {
            locale: localeToUse
        });
    }
    return (0, $iY5sc.default)(date, dateTimeFormat);
};
const $b649e6d2adccc6a5$var$isValidWeekRange = (firstDay)=>{
    return firstDay >= 0 && firstDay <= 6;
};
const $b649e6d2adccc6a5$export$43286948a3d8ddc7 = (firstDay)=>{
    if ($b649e6d2adccc6a5$var$isValidWeekRange(firstDay)) return firstDay;
    return undefined;
};
const $b649e6d2adccc6a5$export$99291c0265ff1d37 = (firstDay, useISO8601WeekNumbers)=>{
    return useISO8601WeekNumbers ? 1 : $b649e6d2adccc6a5$export$43286948a3d8ddc7(firstDay);
};

});

parcelRegister("fghV6", function(module, exports) {
$parcel$export(module.exports, "withPortalLocale", () => (parcelRequire("j3i1C")).withPortalLocale);

var $j3i1C = parcelRequire("j3i1C");

});
parcelRegister("j3i1C", function(module, exports) {
$parcel$export(module.exports, "withPortalLocale", () => $2afd744251f9c76c$export$c58622ebd53d6350);

var $fc4bM = parcelRequire("fc4bM");

var $h6Bv6 = parcelRequire("h6Bv6");
const $2afd744251f9c76c$export$c58622ebd53d6350 = (LocaleAwareComponent)=>{
    const WithPortalLocale = (props)=>{
        const portalLocale = (0, $h6Bv6.usePortalLocale)();
        return /*#__PURE__*/ $fc4bM.createElement(LocaleAwareComponent, {
            ...props,
            locale: portalLocale ?? props.locale
        });
    };
    WithPortalLocale.displayName = `withPortalLocale(${LocaleAwareComponent.displayName || LocaleAwareComponent.name || 'Component'})`;
    return WithPortalLocale;
};

});




parcelRegister("gD7pJ", function(module, exports) {
$parcel$export(module.exports, "ControlledDateTimePicker", () => $7efd6d6e4b2bd391$export$3f58a178208b4384);
$parcel$export(module.exports, "DateTimePicker", () => (parcelRequire("1MEdu")).default);

var $6wHv6 = parcelRequire("6wHv6");

var $1MEdu = parcelRequire("1MEdu");
const $7efd6d6e4b2bd391$export$3f58a178208b4384 = (0, $6wHv6.withControlledFormComponentValue)((_field, value)=>value)((0, $1MEdu.default));

});
parcelRegister("1MEdu", function(module, exports) {
$parcel$export(module.exports, "default", () => $22eb9fa1b98f90a7$export$2e2bcd8739ae039);
/* date-time-picker.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $hN5YJ = parcelRequire("hN5YJ");

var $cwnd9 = parcelRequire("cwnd9");
var $abJ7q = parcelRequire("abJ7q");
var $4o5S4 = parcelRequire("4o5S4");

var $aYMdQ = parcelRequire("aYMdQ");

var $fcCIH = parcelRequire("fcCIH");

var $ch1yB = parcelRequire("ch1yB");
parcelRequire("3AN4U");
var $bkuBa = parcelRequire("bkuBa");

var $6YOZk = parcelRequire("6YOZk");

var $7SNzi = parcelRequire("7SNzi");

var $76pXf = parcelRequire("76pXf");

var $giewv = parcelRequire("giewv");
parcelRequire("fghV6");
var $j3i1C = parcelRequire("j3i1C");
const $22eb9fa1b98f90a7$export$bd63dbd4f777763 = (value)=>{
    if (!value || !(0, $abJ7q.default)(new Date(value))) return undefined;
    return (0, $cwnd9.default)(new Date(value));
};
const $22eb9fa1b98f90a7$var$AVAILABLE_TIMES = [
    '00:00',
    '00:30',
    '01:00',
    '01:30',
    '02:00',
    '02:30',
    '03:00',
    '03:30',
    '04:00',
    '04:30',
    '05:00',
    '05:30',
    '06:00',
    '06:30',
    '07:00',
    '07:30',
    '08:00',
    '08:30',
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
    '18:30',
    '19:00',
    '19:30',
    '20:00',
    '20:30',
    '21:00',
    '21:30',
    '22:00',
    '22:30',
    '23:00',
    '23:30'
];
// TODO: Add proper locale support so that this workaround to fix date parsing isn't needed
const $22eb9fa1b98f90a7$var$parseInputValue = (date)=>{
    if ((0, $abJ7q.default)(new Date(date))) return (0, $4o5S4.default)(new Date(date).toISOString());
    return (0, $4o5S4.default)(new Date().toISOString());
};
class $22eb9fa1b98f90a7$export$fdacf42198d490fd extends $fc4bM.PureComponent {
    render() {
        const { id: id, label: label, locale: locale, required: required, defaultValue: defaultValue, description: description, errorMessage: errorMessage, disabled: disabled, firstDay: firstDay, useISO8601WeekNumbers: useISO8601WeekNumbers, intl: intl, value: value, dateTimeFormat: dateTimeFormat = 'yyyy-MM-dd hh:mm a' } = this.props;
        const isInvalid = !(0, $aYMdQ.isEmpty)(errorMessage);
        const { dateFormat: dateFormat, timeFormat: timeFormat } = (0, $giewv.splitDateTimeFormat)(dateTimeFormat);
        // Need to refer to id like this.
        // See: https://atlaskit.atlassian.com/packages/core/datetime-picker
        const inputId = `react-select-${id}-input`;
        const defaultDateTimeValue = $22eb9fa1b98f90a7$export$bd63dbd4f777763(defaultValue);
        // this logic is derived from the default value logic above
        const processedValue = value && (0, $hN5YJ.isDateTimeSupportEnabled)() ? $22eb9fa1b98f90a7$export$bd63dbd4f777763(value) : undefined;
        const datePickerProps = {
            dateFormat: dateFormat,
            parseInputValue: $22eb9fa1b98f90a7$var$parseInputValue,
            formatDisplayLabel: this.parseDateLabel,
            placeholder: intl.formatMessage((0, $bkuBa.default).forExample, {
                text: (0, $76pXf.format)((0, $7SNzi.default)(), dateFormat)
            }),
            weekStartDay: (0, $76pXf.getWeekStartDay)(firstDay, useISO8601WeekNumbers)
        };
        const timePickerProps = {
            timeFormat: timeFormat,
            timeIsEditable: true,
            formatDisplayLabel: this.parseTimeLabel,
            times: $22eb9fa1b98f90a7$var$AVAILABLE_TIMES,
            placeholder: intl.formatMessage((0, $bkuBa.default).forExample, {
                text: (0, $76pXf.format)((0, $7SNzi.default)(), timeFormat)
            })
        };
        return /*#__PURE__*/ $fc4bM.createElement((0, $ch1yB.FieldBase), {
            htmlFor: inputId,
            label: label,
            required: required,
            errorMessage: errorMessage,
            description: description
        }, /*#__PURE__*/ $fc4bM.createElement("div", {
            className: (0, $2R2iS.default)([
                "_1bsb1178"
            ])
        }, /*#__PURE__*/ $fc4bM.createElement((0, $6YOZk.default), {
            id: inputId,
            name: id,
            defaultValue: defaultDateTimeValue,
            onChange: this.onChange,
            isInvalid: isInvalid,
            // Assertions necessary due to broken types in @atlaskit/datetime-picker
            // requiring extra props to be passed even though they have defaults
            datePickerProps: datePickerProps,
            timePickerProps: timePickerProps,
            isDisabled: !!disabled,
            locale: locale,
            "aria-describedby": `${inputId}-field-description`,
            value: (0, $hN5YJ.isDateTimeSupportEnabled)() ? processedValue : undefined
        })));
    }
    constructor(...args){
        super(...args), this.onChange = (isoTime)=>{
            const { onChange: onChange } = this.props;
            if ((0, $hN5YJ.isDateTimeSupportEnabled)()) onChange && onChange(this.props.id, isoTime ? (0, $76pXf.format)((0, $4o5S4.default)(isoTime), "yyyy-MM-dd'T'HH:mm") : isoTime, false, {
                rawObject: {},
                rawValue: isoTime
            });
            else onChange && onChange(this.props.id, isoTime ? (0, $76pXf.format)((0, $4o5S4.default)(isoTime), "yyyy-MM-dd'T'HH:mm") : isoTime, false);
        }, // We need custom parse date and parse time functions here so the date and time are displayed in the right locale
        this.parseDateLabel = (value, dateFormat)=>{
            return value && dateFormat ? (0, $76pXf.format)((0, $4o5S4.default)(value), dateFormat) : value;
        }, this.parseTimeLabel = (value, timeFormat)=>{
            // date-fns format can't parse a time without a date prefix, in this case we will manually append
            // a date to the time so that it will format it correctly
            return value && timeFormat ? (0, $76pXf.format)((0, $4o5S4.default)(`1970-01-01 ${value}`), timeFormat) : value;
        };
    }
}
var $22eb9fa1b98f90a7$export$2e2bcd8739ae039 = (0, $j3i1C.withPortalLocale)((0, $fcCIH.default)($22eb9fa1b98f90a7$export$fdacf42198d490fd));
const $22eb9fa1b98f90a7$var$dataTimePickerContainer = null;

});
parcelRegister("6YOZk", function(module, exports) {
$parcel$export(module.exports, "default", () => $52b84e49362e309c$export$2e2bcd8739ae039);
/* date-time-picker.tsx generated by @compiled/babel-plugin v3.0.2 */ /// <reference types="node" />
// for typing `process`

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $iY5sc = parcelRequire("iY5sc");
var $abJ7q = parcelRequire("abJ7q");
var $4o5S4 = parcelRequire("4o5S4");

var $7iKPB = parcelRequire("7iKPB");

var $fRCnG = parcelRequire("fRCnG");

var $48hlF = parcelRequire("48hlF");

var $dRkX9 = parcelRequire("dRkX9");

var $dBtOK = parcelRequire("dBtOK");

var $i3riz = parcelRequire("i3riz");

var $c7F99 = parcelRequire("c7F99");

var $5GHSM = parcelRequire("5GHSM");

var $7ilNQ = parcelRequire("7ilNQ");

var $dYjcd = parcelRequire("dYjcd");

var $8cyx6 = parcelRequire("8cyx6");

var $6MmGs = parcelRequire("6MmGs");
const $52b84e49362e309c$var$packageName = undefined;
const $52b84e49362e309c$var$packageVersion = undefined;
const $52b84e49362e309c$var$analyticsAttributes = {
    componentName: 'dateTimePicker',
    packageName: $52b84e49362e309c$var$packageName,
    packageVersion: $52b84e49362e309c$var$packageVersion
};
const $52b84e49362e309c$var$compiledStyles = {
    datePickerContainerStyles: "_i0dl1ssb _16jlkb7n _1o9zidpf",
    timePickerContainerStyles: "_i0dl1ssb _16jlkb7n",
    iconContainerStyles: "_1e0c1txw _4cvr1h6o _i0dl1kw7"
};
const $52b84e49362e309c$var$innerCornerRadius = `calc(${"var(--ds-radius-medium, 6px)"} - ${"var(--ds-border-width, 1px)"})`;
const $52b84e49362e309c$var$cornerRadiusStyles = {
    start: {
        borderStartStartRadius: $52b84e49362e309c$var$innerCornerRadius,
        borderEndStartRadius: $52b84e49362e309c$var$innerCornerRadius
    },
    end: {
        borderStartEndRadius: $52b84e49362e309c$var$innerCornerRadius,
        borderEndEndRadius: $52b84e49362e309c$var$innerCornerRadius
    },
    none: {}
};
// react-select overrides (via @atlaskit/select).
const $52b84e49362e309c$var$getStyles = (isInputMotionEnabled, roundedCorners)=>({
        control: (style, { isDisabled: isDisabled, isFocused: isFocused })=>({
                ...style,
                ...isInputMotionEnabled && !isDisabled ? {
                    transition: "var(--ds-input, background-color border-color box-shadow 150ms cubic-bezier(0.4, 1, 0.6, 1))"
                } : {},
                backgroundColor: 'transparent',
                border: 2,
                borderRadius: 0,
                ...isInputMotionEnabled ? {
                    ...$52b84e49362e309c$var$cornerRadiusStyles[roundedCorners],
                    boxShadow: isFocused ? `0 0 0 ${"var(--ds-border-width, 1px)"} ${"var(--ds-border-focused, #4688EC)"}, inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${"var(--ds-border-focused, #4688EC)"}` : 'none'
                } : {},
                paddingLeft: 0,
                ':hover': {
                    backgroundColor: 'transparent',
                    cursor: 'inherit'
                }
            })
    });
const $52b84e49362e309c$var$hasExplicitZone = (value)=>value.endsWith('Z') || Math.max(value.lastIndexOf('+'), value.lastIndexOf('-')) > 15;
const $52b84e49362e309c$var$parseDateTimeValueWithOffset = (value)=>{
    const parsed = (0, $4o5S4.default)(value);
    const zoneStart = value.endsWith('Z') ? value.length - 1 : Math.max(value.lastIndexOf('+'), value.lastIndexOf('-'));
    if (!(0, $abJ7q.default)(parsed) || value[10] !== 'T' || zoneStart <= 15) return undefined;
    const zoneValue = value.slice(zoneStart);
    if (!/^(?:Z|[+-]\d{2}(?::?\d{2})?)$/.test(zoneValue)) return undefined;
    return {
        dateValue: value.slice(0, 10),
        timeValue: value.slice(11, 16),
        zoneValue: zoneValue
    };
};
const $52b84e49362e309c$var$parseDateTimeValue = (value)=>{
    if ((0, $dRkX9.fg)('platform-dst-dtp-preserve-offset')) {
        if ($52b84e49362e309c$var$hasExplicitZone(value)) return $52b84e49362e309c$var$parseDateTimeValueWithOffset(value);
    }
    const parsed = (0, $4o5S4.default)(value);
    return (0, $abJ7q.default)(parsed) ? {
        dateValue: (0, $iY5sc.default)(parsed, (0, $dYjcd.convertTokens)('YYYY-MM-DD')),
        timeValue: (0, $iY5sc.default)(parsed, (0, $dYjcd.convertTokens)('HH:mm')),
        zoneValue: (0, $iY5sc.default)(parsed, (0, $dYjcd.convertTokens)('ZZ'))
    } : undefined;
};
const $52b84e49362e309c$export$3b559a1219cb3c27 = 'Date';
const $52b84e49362e309c$export$d82cc7e53d68a428 = 'Time';
/**
 * __Date time picker__
 *
 * A date time picker allows the user to select an associated date and time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/usage)
 */ const $52b84e49362e309c$var$DateTimePicker = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear', datePickerProps: datePickerPropsWithSelectProps = {}, defaultValue: defaultValue = '', id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, name: name = '', onBlur: // These disables are here for proper typing when used as defaults. They
// should *not* use the `noop` function.
/* eslint-disable @repo/internal/react/use-noop */ onBlur = (_event)=>{}, onChange: onChangeProp = (_value)=>{}, onFocus: onFocus = (_event)=>{}, /* eslint-enable @repo/internal/react/use-noop */ parseValue: providedParseValue, spacing: spacing = 'default', locale: locale = 'en-US', testId: testId, timePickerProps: timePickerPropsWithSelectProps = {}, value: providedValue }, ref)=>{
    const [isFocused, setIsFocused] = (0, $fc4bM.useState)(false);
    const isInputMotionEnabled = (0, $dRkX9.fg)('platform-dst-motion-uplift-input');
    const isZoneExplicitRef = (0, $fc4bM.useRef)(false);
    /**
   * Defined inside the component so the reducer closes over `providedParseValue`
   * without needing to smuggle it through every action payload. React always
   * calls the reducer from the latest render, so stale-closure is not a concern.
   */ const reducer = (state, action)=>{
        switch(action.type){
            case 'APPLY':
                return action.payload;
            case 'SET_VALUE':
                {
                    const newValue = action.payload;
                    // Explicit empty-string handling: clear all sub-fields so the date
                    // and time pickers visually reset when a controlled value is cleared.
                    if (!newValue) return {
                        value: '',
                        dateValue: '',
                        timeValue: '',
                        zoneValue: ''
                    };
                    if (providedParseValue) {
                        const parsed = providedParseValue(newValue, state.dateValue, state.timeValue, state.zoneValue);
                        return parsed ? {
                            value: newValue,
                            ...parsed
                        } : {
                            value: newValue,
                            dateValue: state.dateValue,
                            timeValue: state.timeValue,
                            zoneValue: state.zoneValue
                        };
                    }
                    const parsed = $52b84e49362e309c$var$parseDateTimeValue(newValue);
                    return parsed ? {
                        value: newValue,
                        ...parsed
                    } : {
                        value: newValue,
                        dateValue: '',
                        timeValue: '',
                        zoneValue: ''
                    };
                }
            default:
                return state;
        }
    };
    const [dtState, dispatch] = (0, $fc4bM.useReducer)(reducer, null, ()=>{
        const initialValue = providedValue ?? defaultValue ?? '';
        isZoneExplicitRef.current = $52b84e49362e309c$var$hasExplicitZone(initialValue);
        const initialDate = (datePickerPropsWithSelectProps === null || datePickerPropsWithSelectProps === void 0 ? void 0 : datePickerPropsWithSelectProps.defaultValue) || '';
        const initialTime = (timePickerPropsWithSelectProps === null || timePickerPropsWithSelectProps === void 0 ? void 0 : timePickerPropsWithSelectProps.defaultValue) || '';
        if (!initialValue) return {
            value: '',
            dateValue: initialDate,
            timeValue: initialTime,
            zoneValue: ''
        };
        if (providedParseValue) {
            const parsed = providedParseValue(initialValue, initialDate, initialTime, '');
            return parsed ? {
                value: initialValue,
                ...parsed
            } : {
                value: initialValue,
                dateValue: initialDate,
                timeValue: initialTime,
                zoneValue: ''
            };
        }
        const parsed = $52b84e49362e309c$var$parseDateTimeValue(initialValue);
        return parsed ? {
            value: initialValue,
            ...parsed
        } : {
            value: initialValue,
            dateValue: initialDate,
            timeValue: initialTime,
            zoneValue: ''
        };
    });
    // if a previously controlled value becomes undefined, it clears the reducer
    // state so the hidden input no longer keeps the stale ISO timestamp.
    // Without this, components that try to clear their components by providing
    // `undefined` to the `value` prop will not clear the hidden input and will
    // cause unexpected issues.
    const hasReceivedProvidedValue = (0, $fc4bM.useRef)(providedValue !== undefined);
    const lastEmittedValueRef = (0, $fc4bM.useRef)();
    // We don't want to set the state on the first render, as it would
    // needlessly be a duplicate.
    const isFirstRender = (0, $fc4bM.useRef)(true);
    (0, $fc4bM.useEffect)(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (providedValue !== undefined) {
            hasReceivedProvidedValue.current = true;
            if (providedValue !== lastEmittedValueRef.current) isZoneExplicitRef.current = $52b84e49362e309c$var$hasExplicitZone(providedValue);
            dispatch({
                type: 'SET_VALUE',
                payload: providedValue
            });
        } else if (hasReceivedProvidedValue.current) {
            hasReceivedProvidedValue.current = false;
            isZoneExplicitRef.current = false;
            lastEmittedValueRef.current = undefined;
            dispatch({
                type: 'SET_VALUE',
                payload: ''
            });
        }
    }, [
        providedValue
    ]);
    const parseValue = (0, $fc4bM.useCallback)((value, providedDateValue, providedTimeValue, providedZoneValue)=>{
        if (providedParseValue) {
            const parsedFromFn = providedParseValue(value, providedDateValue, providedTimeValue, providedZoneValue);
            // This handles cases found in Jira where the parse function actually does
            // nothing and returns undefined. The previous `getSafeState` function
            // just spread the values over the state, but if it returned `undefined`,
            // it would just rely on the previous state values. Considering this is
            // what is input to this function anyway, this is a safe way to handle
            // this, colocate the behavior, and not rely on `getSafeState`.
            return parsedFromFn || {
                dateValue: providedDateValue,
                timeValue: providedTimeValue,
                zoneValue: providedZoneValue
            };
        }
        const parsed = $52b84e49362e309c$var$parseDateTimeValue(value);
        return parsed || {
            dateValue: dtState.dateValue,
            timeValue: dtState.timeValue,
            zoneValue: dtState.zoneValue
        };
    }, [
        providedParseValue,
        dtState.dateValue,
        dtState.timeValue,
        dtState.zoneValue
    ]);
    const onDateBlur = (event)=>{
        setIsFocused(false);
        onBlur(event);
        if (datePickerPropsWithSelectProps !== null && datePickerPropsWithSelectProps !== void 0 && datePickerPropsWithSelectProps.onBlur) datePickerPropsWithSelectProps.onBlur(event);
    };
    const onTimeBlur = (event)=>{
        setIsFocused(false);
        onBlur(event);
        if (timePickerPropsWithSelectProps !== null && timePickerPropsWithSelectProps !== void 0 && timePickerPropsWithSelectProps.onBlur) timePickerPropsWithSelectProps.onBlur(event);
    };
    const onDateFocus = (event)=>{
        setIsFocused(false);
        onFocus(event);
        if (datePickerPropsWithSelectProps !== null && datePickerPropsWithSelectProps !== void 0 && datePickerPropsWithSelectProps.onFocus) datePickerPropsWithSelectProps.onFocus(event);
    };
    const onTimeFocus = (event)=>{
        setIsFocused(false);
        onFocus(event);
        if (timePickerPropsWithSelectProps !== null && timePickerPropsWithSelectProps !== void 0 && timePickerPropsWithSelectProps.onFocus) timePickerPropsWithSelectProps.onFocus(event);
    };
    const onDateChange = (newDateValue)=>{
        const parsedValues = parseValue(dtState.value, newDateValue, dtState.timeValue, dtState.zoneValue);
        onValueChange({
            providedDateValue: newDateValue,
            providedTimeValue: parsedValues.timeValue,
            providedZoneValue: parsedValues.zoneValue
        });
        if (datePickerPropsWithSelectProps !== null && datePickerPropsWithSelectProps !== void 0 && datePickerPropsWithSelectProps.onChange) datePickerPropsWithSelectProps.onChange(newDateValue);
    };
    const onTimeChange = (newTimeValue)=>{
        const parsedValues = parseValue(dtState.value, dtState.dateValue, newTimeValue, dtState.zoneValue);
        onValueChange({
            providedDateValue: parsedValues.dateValue,
            providedTimeValue: newTimeValue,
            providedZoneValue: parsedValues.zoneValue
        });
        if (timePickerPropsWithSelectProps !== null && timePickerPropsWithSelectProps !== void 0 && timePickerPropsWithSelectProps.onChange) timePickerPropsWithSelectProps.onChange(newTimeValue);
    };
    const onClear = ()=>{
        const parsedValues = parseValue(dtState.value, dtState.dateValue, dtState.timeValue, dtState.zoneValue);
        onValueChange({
            providedDateValue: '',
            providedTimeValue: '',
            providedZoneValue: parsedValues.zoneValue
        });
        if (datePickerPropsWithSelectProps !== null && datePickerPropsWithSelectProps !== void 0 && datePickerPropsWithSelectProps.onChange) datePickerPropsWithSelectProps.onChange('');
        if (timePickerPropsWithSelectProps !== null && timePickerPropsWithSelectProps !== void 0 && timePickerPropsWithSelectProps.onChange) timePickerPropsWithSelectProps.onChange('');
    };
    const onChangePropWithAnalytics = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'dateTimePicker',
        ...$52b84e49362e309c$var$analyticsAttributes
    });
    const onValueChange = ({ providedDateValue: providedDateValue, providedTimeValue: providedTimeValue, providedZoneValue: providedZoneValue })=>{
        if (providedDateValue && providedTimeValue) {
            const isoValue = (0, $7ilNQ.formatDateTimeZoneIntoIso)(providedDateValue, providedTimeValue, providedZoneValue);
            const valueToParse = (0, $dRkX9.fg)('platform-dst-dtp-preserve-offset') && !providedParseValue && !isZoneExplicitRef.current ? (0, $7ilNQ.formatDateTimeZoneIntoIso)(providedDateValue, providedTimeValue, '') : isoValue;
            const { zoneValue: parsedZone } = parseValue(valueToParse, providedDateValue, providedTimeValue, providedZoneValue);
            const valueWithValidZone = (0, $7ilNQ.formatDateTimeZoneIntoIso)(providedDateValue, providedTimeValue, parsedZone);
            dispatch({
                type: 'APPLY',
                payload: {
                    value: valueWithValidZone,
                    dateValue: providedDateValue,
                    timeValue: providedTimeValue,
                    zoneValue: parsedZone
                }
            });
            lastEmittedValueRef.current = valueWithValidZone;
            onChangePropWithAnalytics(valueWithValidZone);
        // If the date or time value was cleared when there is an existing datetime value, then clear the value.
        } else if (dtState.value) {
            dispatch({
                type: 'APPLY',
                payload: {
                    value: '',
                    dateValue: providedDateValue,
                    timeValue: providedTimeValue,
                    zoneValue: providedZoneValue
                }
            });
            onChangePropWithAnalytics('');
        } else dispatch({
            type: 'APPLY',
            payload: {
                value: '',
                dateValue: providedDateValue,
                timeValue: providedTimeValue,
                zoneValue: providedZoneValue
            }
        });
    };
    // Render DateTimePicker's IconContainer when a value has been filled
    // Don't use Date or TimePicker's because they can't be customised
    const isClearable = Boolean(dtState.dateValue || dtState.timeValue);
    const hasClearButton = isClearable && !isDisabled;
    const dateStyles = (0, $fc4bM.useMemo)(()=>$52b84e49362e309c$var$getStyles(isInputMotionEnabled, 'start'), [
        isInputMotionEnabled
    ]);
    const timeStyles = (0, $fc4bM.useMemo)(()=>$52b84e49362e309c$var$getStyles(isInputMotionEnabled, hasClearButton ? 'none' : 'end'), [
        isInputMotionEnabled,
        hasClearButton
    ]);
    const { selectProps: datePickerSelectProps, ...datePickerProps } = datePickerPropsWithSelectProps;
    const datePickerAriaDescribedBy = datePickerProps['aria-describedby'] || ariaDescribedBy;
    const datePickerLabel = datePickerProps.label || 'Date';
    const mergedDatePickerSelectProps = {
        ...datePickerSelectProps,
        styles: (0, $c7F99.mergeStyles)(dateStyles, datePickerSelectProps === null || datePickerSelectProps === void 0 ? void 0 : datePickerSelectProps.styles)
    };
    const { selectProps: timePickerSelectProps, ...timePickerProps } = timePickerPropsWithSelectProps;
    const timePickerAriaDescribedBy = timePickerProps['aria-describedby'] || ariaDescribedBy;
    const timePickerLabel = timePickerProps.label || 'Time';
    const mergedTimePickerSelectProps = {
        ...timePickerSelectProps,
        styles: (0, $c7F99.mergeStyles)(timeStyles, timePickerSelectProps === null || timePickerSelectProps === void 0 ? void 0 : timePickerSelectProps.styles)
    };
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $5GHSM.DateTimePickerContainer), {
        appearance: appearance,
        isDisabled: isDisabled,
        isFocused: isFocused,
        isInvalid: isInvalid,
        testId: testId,
        innerProps: innerProps,
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)("input", {
                name: name,
                type: "hidden",
                value: dtState.value,
                "data-testid": testId && `${testId}--input`
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
                xcss: $52b84e49362e309c$var$compiledStyles.datePickerContainerStyles,
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8cyx6.default), {
                    appearance: appearance,
                    "aria-describedby": datePickerAriaDescribedBy,
                    autoFocus: datePickerProps.autoFocus || autoFocus,
                    calendarLabel: datePickerProps.calendarLabel,
                    dateFormat: datePickerProps.dateFormat,
                    defaultIsOpen: datePickerProps.defaultIsOpen,
                    defaultValue: datePickerProps.defaultValue,
                    disabled: datePickerProps.disabled,
                    disabledDateFilter: datePickerProps.disabledDateFilter,
                    formatDisplayLabel: datePickerProps.formatDisplayLabel,
                    hideIcon: datePickerProps.hideIcon || true,
                    icon: datePickerProps.icon,
                    id: datePickerProps.id || id,
                    innerProps: datePickerProps.innerProps,
                    inputLabel: datePickerProps.inputLabel,
                    inputLabelId: datePickerProps.inputLabelId,
                    isDisabled: datePickerProps.isDisabled || isDisabled,
                    isInvalid: datePickerProps.isInvalid || isInvalid,
                    isOpen: datePickerProps.isOpen,
                    isRequired: datePickerProps.isRequired || isRequired,
                    label: datePickerLabel,
                    locale: datePickerProps.locale || locale,
                    maxDate: datePickerProps.maxDate,
                    minDate: datePickerProps.minDate,
                    name: datePickerProps.name,
                    nextMonthLabel: datePickerProps.nextMonthLabel,
                    onBlur: onDateBlur,
                    onChange: onDateChange,
                    onFocus: onDateFocus,
                    openCalendarLabel: datePickerProps.openCalendarLabel,
                    parseInputValue: datePickerProps.parseInputValue,
                    placeholder: datePickerProps.placeholder,
                    previousMonthLabel: datePickerProps.previousMonthLabel,
                    selectProps: mergedDatePickerSelectProps,
                    shouldShowCalendarButton: datePickerProps.shouldShowCalendarButton,
                    spacing: datePickerProps.spacing || spacing,
                    testId: testId && `${testId}--datepicker` || datePickerProps.testId,
                    value: dtState.dateValue,
                    weekStartDay: datePickerProps.weekStartDay
                })
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
                xcss: $52b84e49362e309c$var$compiledStyles.timePickerContainerStyles,
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6MmGs.default), {
                    appearance: timePickerProps.appearance || appearance,
                    "aria-describedby": timePickerAriaDescribedBy,
                    autoFocus: timePickerProps.autoFocus,
                    defaultIsOpen: timePickerProps.defaultIsOpen,
                    defaultValue: timePickerProps.defaultValue,
                    formatDisplayLabel: timePickerProps.formatDisplayLabel,
                    hideIcon: timePickerProps.hideIcon || true,
                    id: timePickerProps.id,
                    innerProps: timePickerProps.innerProps,
                    isDisabled: timePickerProps.isDisabled || isDisabled,
                    isInvalid: timePickerProps.isInvalid || isInvalid,
                    isOpen: timePickerProps.isOpen,
                    isRequired: timePickerProps.isRequired || isRequired,
                    label: timePickerLabel,
                    locale: timePickerProps.locale || locale,
                    name: timePickerProps.name,
                    openTimeLabel: timePickerProps.openTimeLabel,
                    onBlur: onTimeBlur,
                    onChange: onTimeChange,
                    onFocus: onTimeFocus,
                    parseInputValue: timePickerProps.parseInputValue,
                    placeholder: timePickerProps.placeholder,
                    selectProps: mergedTimePickerSelectProps,
                    shouldShowTimeButton: timePickerProps.shouldShowTimeButton,
                    spacing: timePickerProps.spacing || spacing,
                    testId: timePickerProps.testId || testId && `${testId}--timepicker`,
                    timeFormat: timePickerProps.timeFormat,
                    timeIsEditable: timePickerProps.timeIsEditable,
                    times: timePickerProps.times,
                    value: dtState.timeValue
                })
            }),
            hasClearButton ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $i3riz.Inline), {
                xcss: $52b84e49362e309c$var$compiledStyles.iconContainerStyles,
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fRCnG.default), {
                    appearance: "subtle",
                    label: clearControlLabel,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($48hlF))), {
                            ...iconProps,
                            color: "var(--ds-text-subtlest, #6B6E76)",
                            size: "small"
                        }),
                    onClick: onClear,
                    testId: testId && `${testId}--icon--container`,
                    tabIndex: -1
                })
            }) : null
        ]
    });
});
var $52b84e49362e309c$export$2e2bcd8739ae039 = $52b84e49362e309c$var$DateTimePicker;

});
parcelRegister("c7F99", function(module, exports) {
$parcel$export(module.exports, "mergeStyles", () => $ed8f11c0494948b8$export$e618dc39ac9ad607);
function $ed8f11c0494948b8$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

});

parcelRegister("5GHSM", function(module, exports) {
$parcel$export(module.exports, "DateTimePickerContainer", () => $613361c6273f89fc$export$83034b1f07ab0b20);
/* date-time-picker-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $dRkX9 = parcelRequire("dRkX9");
const $613361c6273f89fc$var$isInvalidBorderStyles = null;
const $613361c6273f89fc$var$isInvalidBorderWithShadowStyles = null;
const $613361c6273f89fc$var$isFocusedBorderStyles = null;
const $613361c6273f89fc$var$isFocusedStyles = null;
const $613361c6273f89fc$var$subtleBgStyles = null;
const $613361c6273f89fc$var$subtleFocusedBgStyles = null;
const $613361c6273f89fc$var$noBgStyles = null;
const $613361c6273f89fc$var$hoverStyles = null;
const $613361c6273f89fc$var$isInvalidHoverStyles = null;
const $613361c6273f89fc$var$isDisabledStyles = null;
const $613361c6273f89fc$var$newBorderStyles = null;
const $613361c6273f89fc$var$baseContainerStyles = null;
const $613361c6273f89fc$var$inputMotionStyles = {
    legacy: "_v564r5cv",
    base: "_v56497ke"
};
const $613361c6273f89fc$export$83034b1f07ab0b20 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ children: children, isDisabled: isDisabled, isFocused: isFocused, appearance: appearance, isInvalid: isInvalid, innerProps: innerProps, testId: testId }, ref)=>{
    const notFocusedOrIsDisabled = !(isFocused || isDisabled);
    const isInputMotionEnabled = (0, $dRkX9.fg)('platform-dst-motion-uplift-input');
    // we cannot use Box or Flex primitives because these do not allow ...innerProps to be passed
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        ...innerProps,
        "data-testid": testId,
        ref: ref,
        className: (0, $2R2iS.default)([
            "_2rko1qi0 _1e0c1txw _bfhk1j9a _d0altlke",
            !isInputMotionEnabled && $613361c6273f89fc$var$inputMotionStyles.legacy,
            isInputMotionEnabled && !isDisabled && $613361c6273f89fc$var$inputMotionStyles.base,
            "_19itno8c",
            isDisabled && "_1h6dbk0g _bfhk187o _d0al73ad",
            isFocused && "_bfhkr01l",
            appearance === 'subtle' && isFocused && "_1h6d1j28 _bfhkr01l",
            appearance === 'subtle' && !isFocused && "_1h6d1j28 _bfhk1j28",
            isFocused && "_1h6d1v1w _16qsvyy1",
            !isInputMotionEnabled && isInvalid && "_1h6d1bqt",
            isInputMotionEnabled && isInvalid && "_1h6d1bqt _16qsizbr",
            notFocusedOrIsDisabled && isInvalid && "_4cvx1bqt _irr3l4ek",
            notFocusedOrIsDisabled && !isInvalid && "_4cvxrsbi _irr3l4ek",
            appearance === 'none' && "_1h6d1j28 _bfhk1j28 _4cvx1j28 _irr31j28"
        ]),
        children: children
    });
});

});

parcelRegister("7ilNQ", function(module, exports) {
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $d10d2e78e91461d8$export$2eeb05a2ecc2ce0a);
/**
 * Formats a date, time, and zone into a ISO string.
 */ function $d10d2e78e91461d8$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});




parcelRegister("9BcFH", function(module, exports) {
$parcel$export(module.exports, "EntitlementPicker", () => (parcelRequire("5uTDB")).EntitlementPicker);

var $5uTDB = parcelRequire("5uTDB");

});
parcelRegister("5uTDB", function(module, exports) {
$parcel$export(module.exports, "EntitlementPicker", () => $8d5ef4bc0473123a$export$7c3ab7545fd6cd0d);

var $d1rFy = parcelRequire("d1rFy");

var $fc4bM = parcelRequire("fc4bM");

var $9XZeF = parcelRequire("9XZeF");

var $2n2bS = parcelRequire("2n2bS");

var $iya1I = parcelRequire("iya1I");

var $hN5YJ = parcelRequire("hN5YJ");

var $6LH8a = parcelRequire("6LH8a");

var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");

var $b46ZL = parcelRequire("b46ZL");

var $ch1yB = parcelRequire("ch1yB");

var $jEubQ = parcelRequire("jEubQ");

var $gDsF8 = parcelRequire("gDsF8");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $eENmG = parcelRequire("eENmG");

var $4LXAs = parcelRequire("4LXAs");

var $c0Y6o = parcelRequire("c0Y6o");

var $1xOZp = parcelRequire("1xOZp");

var $7wx9B = parcelRequire("7wx9B");
parcelRequire("bns2e");
var $beTNX = parcelRequire("beTNX");

var $8trfq = parcelRequire("8trfq");

var $hA8K4 = parcelRequire("hA8K4");
const $8d5ef4bc0473123a$export$fd42663b909f44cb = (0, $d1rFy.default);
const $8d5ef4bc0473123a$var$EntitlementPickerMain = (props)=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { reporterId: reporterId, onChange: onChange, isNewReporter: isNewReporter, disableSubmitButton: disableSubmitButton, enableSubmitButton: enableSubmitButton, value: value, defaultEntitlement: defaultEntitlement, ...fieldProps } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const cloudId = (0, $6LH8a.getCloudId)();
    const [prevReporterId, setPrevReporterId] = (0, $fc4bM.useState)(null);
    const [isLoading, setIsLoading] = (0, $fc4bM.useState)(false);
    const [entitlements, setEntitlements] = (0, $fc4bM.useState)([]);
    const [error, setError] = (0, $fc4bM.useState)(false);
    const [hasAppliedDefault, setHasAppliedDefault] = (0, $fc4bM.useState)(false);
    // When the rovo integration FG is enabled, rely solely on the useEffect below to apply
    // defaultEntitlement once via onChange (single source of truth). This lets the user clear
    // the field without it being re-populated. When the FG is off, preserve the old fallback.
    const effectiveValue = (0, $hN5YJ.isJsmPortalRovoIntegrationEnabled)() ? value : value || defaultEntitlement;
    // Try to match by ID first, then by product name if no match
    let selectedEntitlement = entitlements.find((entitlement)=>entitlement.value === effectiveValue) || null;
    if (!selectedEntitlement && effectiveValue) selectedEntitlement = entitlements.find((entitlement)=>entitlement.label.toLowerCase() === effectiveValue.toLowerCase()) || null;
    const updateSelectedEntitlement = (0, $fc4bM.useCallback)((option, notFromUserInteraction)=>{
        onChange === null || onChange === void 0 || onChange(props.id, (option === null || option === void 0 ? void 0 : option.value) || '', notFromUserInteraction);
    }, [
        props.id,
        onChange
    ]);
    const fetchEntitlements = (0, $fc4bM.useCallback)(async ()=>{
        if (!reporterId) return;
        setIsLoading(true);
        disableSubmitButton();
        try {
            var _data$customerService;
            const data = await (0, $3BZyK.fetchQuery)((0, $1xOZp.getRelayEnvironment)(), $8d5ef4bc0473123a$export$fd42663b909f44cb, {
                cloudId: cloudId,
                accountId: reporterId
            }).toPromise();
            if ((data === null || data === void 0 ? void 0 : data.customerService.individualByAccountId.__typename) === 'QueryError') throw new Error(data.customerService.individualByAccountId.message ?? 'entitlementPickerQuery failed');
            if ((data === null || data === void 0 ? void 0 : data.customerService.individualByAccountId.__typename) !== 'CustomerServiceIndividual') throw new Error('entitlementPickerQuery failed');
            const entitlementList = (_data$customerService = data.customerService) === null || _data$customerService === void 0 || (_data$customerService = _data$customerService.individualByAccountId) === null || _data$customerService === void 0 ? void 0 : _data$customerService.entitlementList;
            const entitlementOptions = entitlementList.map((entitlement)=>({
                    label: entitlement.product.name,
                    value: (0, $4LXAs.getEntitlementIdFromAri)(entitlement.id)
                }));
            setEntitlements(entitlementOptions);
            createAnalyticsEvent({
                action: 'fetched',
                analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
                actionSubject: 'entitlements',
                numberOfEntitlements: entitlementOptions.length
            }).fire();
        } catch (e) {
            setEntitlements([]);
            setError(true);
            (0, $7wx9B.reportError)(e, {
                teamName: 'boysenberry',
                errorBoundaryId: 'EntitlementPickerMain',
                errorBoundaryPackageName: 'jsd-portal-frontend'
            });
            if ((0, $c0Y6o.isFetchNetworkOrClientError)(e)) (0, $8trfq.entitlementPickerLoadExperience).abort();
            else (0, $8trfq.entitlementPickerLoadExperience).failure();
        } finally{
            updateSelectedEntitlement(null, true);
            setIsLoading(false);
            enableSubmitButton();
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        disableSubmitButton,
        enableSubmitButton,
        reporterId,
        updateSelectedEntitlement
    ]);
    const onNewReporter = (0, $fc4bM.useCallback)(()=>{
        setPrevReporterId(reporterId);
        setError(false);
        (0, $8trfq.entitlementPickerLoadExperience).start();
    }, [
        reporterId
    ]);
    const onNoEntitlements = (0, $fc4bM.useCallback)(()=>{
        setEntitlements([]);
        updateSelectedEntitlement(null, true);
        (0, $8trfq.entitlementPickerLoadExperience).success();
    }, [
        updateSelectedEntitlement
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (reporterId === prevReporterId) return;
        onNewReporter();
        // reporterId is '' if the reporter field has been cleared
        // reporterID is undefined if the user is anonymous
        if (isNewReporter || reporterId === '' || reporterId === undefined) {
            onNoEntitlements();
            return;
        }
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        fetchEntitlements();
    }, [
        cloudId,
        fetchEntitlements,
        isNewReporter,
        onNewReporter,
        onNoEntitlements,
        prevReporterId,
        reporterId,
        updateSelectedEntitlement
    ]);
    // When entitlements are loaded and defaultEntitlement is provided, select it.
    // When the rovo integration FG is enabled, only apply the default once so that
    // the user can clear the field without it being re-populated.
    (0, $fc4bM.useEffect)(()=>{
        const shouldApply = (0, $hN5YJ.isJsmPortalRovoIntegrationEnabled)() ? !hasAppliedDefault : true;
        if (shouldApply && defaultEntitlement && entitlements.length > 0) {
            // Try to match by ID first, then by product name if no match
            const matchedEntitlement = entitlements.find((entitlement)=>entitlement.value === defaultEntitlement) || entitlements.find((entitlement)=>entitlement.label.toLowerCase() === defaultEntitlement.toLowerCase());
            if (matchedEntitlement) {
                updateSelectedEntitlement(matchedEntitlement, true);
                setHasAppliedDefault(true);
            }
        }
    }, [
        defaultEntitlement,
        entitlements,
        hasAppliedDefault,
        updateSelectedEntitlement
    ]);
    (0, $fc4bM.useEffect)(()=>{
        createAnalyticsEvent({
            action: 'viewed',
            analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
            actionSubject: 'entitlementPicker'
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ch1yB.FieldBase), {
        label: fieldProps.label,
        htmlFor: "",
        required: fieldProps.required
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $8d5ef4bc0473123a$var$ErrorMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDsF8))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-danger, #c9372c)"
    }), formatMessage((0, $hA8K4.default).errorMessage)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $beTNX.EntitlementPickerDumb), {
        ...fieldProps,
        onChange: updateSelectedEntitlement,
        isLoading: isLoading,
        selectedEntitlement: selectedEntitlement,
        entitlements: entitlements
    });
};
const $8d5ef4bc0473123a$var$EntitlementPickerWithErrorBoundary = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iya1I.default), {
        id: "entitlement-picker",
        packageName: "portal-fields"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($8d5ef4bc0473123a$var$EntitlementPickerMain, props));
const $8d5ef4bc0473123a$var$selector = (0, $2n2bS.createSelector)(// if there is a reporter field in the form we use that value, otherwise we use the current user's account id
(state, props)=>props.reporterId === undefined ? (0, $b46ZL.getAccountId)(state) : props.reporterId, (reporterId)=>({
        reporterId: reporterId
    }));
const $8d5ef4bc0473123a$export$7c3ab7545fd6cd0d = (0, $9XZeF.connect)($8d5ef4bc0473123a$var$selector)($8d5ef4bc0473123a$var$EntitlementPickerWithErrorBoundary);
const $8d5ef4bc0473123a$var$ErrorMessageStyles = (0, $kig2V.xcss)({
    display: 'flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px',
    gap: 'space.050',
    marginTop: 'space.100'
});

});
parcelRegister("d1rFy", function(module, exports) {
$parcel$export(module.exports, "default", () => $444975b7d1e712d3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c6bb5fa6e478f4c6a8ce3a6d5efb67ff>>
 * @relayHash d648a72227e17e3ccc98e7fd2c57afbd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dda4ee455df530e7414799ed42e0fc926f0fd34bcd7f01eb987e038e2fe498f0
const $444975b7d1e712d3$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "entitlementPickerQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v2 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "individualByAccountId",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v5 /*: any*/ ,
                                                    "action": "THROW"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "CustomerServiceEntitlement",
                                                        "kind": "LinkedField",
                                                        "name": "entitlementList",
                                                        "plural": true,
                                                        "selections": [
                                                            v5 /*: any*/ ,
                                                            {
                                                                "concreteType": "CustomerServiceProduct",
                                                                "kind": "LinkedField",
                                                                "name": "product",
                                                                "plural": false,
                                                                "selections": [
                                                                    v6 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW"
                                                }
                                            ],
                                            "type": "CustomerServiceIndividual"
                                        },
                                        v7 /*: any*/ 
                                    ]
                                },
                                "action": "THROW"
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "entitlementPickerQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "individualByAccountId",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "concreteType": "CustomerServiceEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlementList",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "concreteType": "CustomerServiceProduct",
                                                    "kind": "LinkedField",
                                                    "name": "product",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CustomerServiceIndividual"
                                },
                                v7 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "dda4ee455df530e7414799ed42e0fc926f0fd34bcd7f01eb987e038e2fe498f0",
            "metadata": {},
            "name": "entitlementPickerQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$444975b7d1e712d3$var$node.hash = "baacf070b69f09d660710a825f4cc406";
var $444975b7d1e712d3$export$2e2bcd8739ae039 = $444975b7d1e712d3$var$node;

});

parcelRegister("4LXAs", function(module, exports) {
$parcel$export(module.exports, "getEntitlementIdFromAri", () => $a8e50134071ba52b$export$c84c5e2c8353ae63);
// eslint-disable-next-line no-restricted-imports

var $hW2RJ = parcelRequire("hW2RJ");
const $a8e50134071ba52b$export$c84c5e2c8353ae63 = (maybeAri)=>(0, $hW2RJ.JiraEntitlementAri).check(maybeAri) ? (0, $hW2RJ.JiraEntitlementAri).parse(maybeAri).entitlementId : maybeAri;

});
parcelRegister("hW2RJ", function(module, exports) {
$parcel$export(module.exports, "JiraEntitlementAri", () => $d0ea137f32bfdf76$export$2663fadb24b282b4);

var $ayW6a = parcelRequire("ayW6a");

var $bDhZ4 = parcelRequire("bDhZ4");

var $4UxLu = parcelRequire("4UxLu");
// src/jira/entitlement/manifest.ts
var $d0ea137f32bfdf76$var$jiraEntitlementAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $ayW6a.JiraEntitlementAriResourceOwner),
    resourceType: (0, $ayW6a.JiraEntitlementAriResourceType),
    resourceIdSlug: "activation/{activationId}/{entitlementId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        entitlementId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/jira/entitlement/index.ts
var $d0ea137f32bfdf76$export$2663fadb24b282b4 = class _JiraEntitlementAri extends (0, $bDhZ4.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._entitlementId = opts.resourceIdSegmentValues.entitlementId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get entitlementId() {
        return this._entitlementId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $d0ea137f32bfdf76$var$jiraEntitlementAriStaticOpts.qualifier,
            platformQualifier: $d0ea137f32bfdf76$var$jiraEntitlementAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $d0ea137f32bfdf76$var$jiraEntitlementAriStaticOpts.resourceOwner,
            resourceType: $d0ea137f32bfdf76$var$jiraEntitlementAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.entitlementId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                entitlementId: opts.entitlementId
            }
        }, ariOpts = (0, $4UxLu.AriParser).fromOpts(derivedOpts, $d0ea137f32bfdf76$var$jiraEntitlementAriStaticOpts);
        return new _JiraEntitlementAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $4UxLu.AriParser).fromString(maybeAri, $d0ea137f32bfdf76$var$jiraEntitlementAriStaticOpts);
        return new _JiraEntitlementAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            entitlementId: this.entitlementId
        };
    }
};

});
parcelRegister("ayW6a", function(module, exports) {
$parcel$export(module.exports, "JiraEntitlementAriResourceOwner", () => $7b0a2586bf4ade8d$export$b4b09eb5bbd0ddca);
$parcel$export(module.exports, "JiraEntitlementAriResourceType", () => $7b0a2586bf4ade8d$export$6126bfb6bbd3718);
// src/jira/entitlement/types.ts
var $7b0a2586bf4ade8d$export$b4b09eb5bbd0ddca = "jira", $7b0a2586bf4ade8d$export$6126bfb6bbd3718 = "entitlement";

});



parcelRegister("bns2e", function(module, exports) {
$parcel$export(module.exports, "EntitlementPickerDumb", () => (parcelRequire("beTNX")).EntitlementPickerDumb);

var $beTNX = parcelRequire("beTNX");

});
parcelRegister("beTNX", function(module, exports) {
$parcel$export(module.exports, "EntitlementPickerDumb", () => $d1a789cb3d3d76aa$export$2e3c94441e79ffd);

var $fc4bM = parcelRequire("fc4bM");

var $6v10u = parcelRequire("6v10u");

var $45AN4 = parcelRequire("45AN4");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $uYmrU = parcelRequire("uYmrU");

var $8trfq = parcelRequire("8trfq");
const $d1a789cb3d3d76aa$var$renderOption = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $d1a789cb3d3d76aa$var$optionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $d1a789cb3d3d76aa$var$iconContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($45AN4))), {
        label: ""
    })), option.label);
const $d1a789cb3d3d76aa$export$2e3c94441e79ffd = (props)=>{
    const { isLoading: isLoading, entitlements: entitlements, selectedEntitlement: selectedEntitlement, ...fieldProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $uYmrU.ExperienceSuccess), {
        experience: (0, $8trfq.entitlementPickerLoadExperience)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6v10u.FieldSingleSelect), {
        ...fieldProps,
        actionSubjectId: "entitlementPicker",
        value: selectedEntitlement,
        options: entitlements,
        formatOptionLabel: $d1a789cb3d3d76aa$var$renderOption,
        isDisabled: isLoading || props.disabled,
        isLoading: isLoading,
        isClearable: true
    }));
};
const $d1a789cb3d3d76aa$var$optionStyles = (0, $kig2V.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100'
});
const $d1a789cb3d3d76aa$var$iconContainerStyles = (0, $kig2V.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.xsmall',
    padding: 'space.025'
});

});
parcelRegister("8trfq", function(module, exports) {
$parcel$export(module.exports, "entitlementPickerLoadExperience", () => $e40cbf48e32a91a4$export$b2d10adb02fdf78b);

var $fCHdA = parcelRequire("fCHdA");

var $atXmE = parcelRequire("atXmE");
var $9LFKj = parcelRequire("9LFKj");
const $e40cbf48e32a91a4$export$b2d10adb02fdf78b = new (0, $9LFKj.UFOExperience)((0, $fCHdA.requestCreateEntitlementPickerExperienceId), {
    type: (0, $atXmE.ExperienceTypes).Experience,
    performanceType: (0, $atXmE.ExperiencePerformanceTypes).InlineResult
});

});



parcelRegister("hA8K4", function(module, exports) {
$parcel$export(module.exports, "default", () => $006571b07d41ecd5$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $006571b07d41ecd5$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    errorMessage: {
        defaultMessage: "We couldn't load this field. Refresh the page to try again.",
        description: 'Error message shown when entitlements fail to be fetched',
        id: 'cv.request.create.form.entitlement-picker.error-message'
    }
});

});



parcelRegister("l6jYy", function(module, exports) {
$parcel$export(module.exports, "ForgeField", () => (parcelRequire("7NGwE")).ForgeField);

var $7NGwE = parcelRequire("7NGwE");

});
parcelRegister("7NGwE", function(module, exports) {
$parcel$export(module.exports, "ForgeField", () => $b6d9cd0ce5113b9e$export$34a15d6027142c62);

var $fc4bM = parcelRequire("fc4bM");

var $9XZeF = parcelRequire("9XZeF");

var $l6v5q = parcelRequire("l6v5q");

var $iya1I = parcelRequire("iya1I");

var $hN5YJ = parcelRequire("hN5YJ");

var $5kfOu = parcelRequire("5kfOu");

var $2UXyw = parcelRequire("2UXyw");

var $1HEEa = parcelRequire("1HEEa");

var $6LH8a = parcelRequire("6LH8a");

var $gpjDl = parcelRequire("gpjDl");

var $hwMna = parcelRequire("hwMna");

var $1xUIS = parcelRequire("1xUIS");

var $iya1n = parcelRequire("iya1n");

var $ch1yB = parcelRequire("ch1yB");

var $dkKKz = parcelRequire("dkKKz");
parcelRequire("6rMSs");
var $7Iv02 = parcelRequire("7Iv02");
parcelRequire("cOmeO");
var $7OReX = parcelRequire("7OReX");

var $ckEaG = parcelRequire("ckEaG");

var $10X2G = parcelRequire("10X2G");

var $lGasn = parcelRequire("lGasn");

var $km7rM = parcelRequire("km7rM");

var $j4xhN = parcelRequire("j4xhN");
parcelRequire("eZy6P");
var $4Lbcj = parcelRequire("4Lbcj");
parcelRequire("kmLox");
var $165Jb = parcelRequire("165Jb");
parcelRequire("8vF5m");
var $jX0E7 = parcelRequire("jX0E7");

var $4V9fY = parcelRequire("4V9fY");

var $lyeIH = parcelRequire("lyeIH");

var $Inbg4 = parcelRequire("Inbg4");
const $b6d9cd0ce5113b9e$var$PORTAL_REQUEST_ANALYTICS_ATTRIBUTES = {
    source: (0, $lGasn.SOURCES).PORTAL_REQUEST,
    renderContext: (0, $lGasn.RENDER_CONTEXTS).PORTAL_REQUEST,
    experience: (0, $lGasn.EXPERIENCES).PORTAL_REQUEST
};
const $b6d9cd0ce5113b9e$var$ForgeFieldWithExtension = ({ id: id, value: value, extension: extension, requestTypeId: requestTypeId, portalId: portalId, projectId: projectId, issueType: issueType, issueTypeId: issueTypeId, disabled: disabled, loadingComponent: loadingComponent, isVisible: isVisible, onChange: onChange })=>{
    const extensionData = (0, $fc4bM.useMemo)(()=>({
            fieldType: extension.id,
            fieldId: id,
            type: extension.type,
            portal: {
                id: portalId
            },
            request: {
                typeId: requestTypeId
            },
            renderContext: (0, $lGasn.RENDER_CONTEXTS).PORTAL_REQUEST,
            experience: (0, $lGasn.EXPERIENCES).PORTAL_REQUEST,
            entryPoint: 'edit',
            project: {
                id: projectId,
                type: 'service_desk'
            },
            issue: {
                type: issueType,
                typeId: issueTypeId
            }
        }), [
        extension.id,
        extension.type,
        id,
        portalId,
        requestTypeId,
        projectId,
        issueType,
        issueTypeId
    ]);
    const extensionPayload = (0, $fc4bM.useMemo)(()=>({
            fieldValue: value
        }), [
        value
    ]);
    const onSubmit = (0, $fc4bM.useCallback)((fieldValue)=>onChange(extensionData.fieldId, (0, $Inbg4.transformValue)(fieldValue, extension), true), [
        extensionData.fieldId,
        extension,
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jX0E7.FieldState), {
        isDisabled: disabled,
        isVisible: isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7OReX.ForgeCustomFieldEdit), {
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        loadingComponent: loadingComponent,
        onSubmit: onSubmit,
        analyticsAttributes: $b6d9cd0ce5113b9e$var$PORTAL_REQUEST_ANALYTICS_ATTRIBUTES
    }));
};
const $b6d9cd0ce5113b9e$var$onInitializationFinished = (0, $km7rM.createInitializationFinished)((0, $lGasn.SOURCES).PORTAL_REQUEST, true);
const $b6d9cd0ce5113b9e$var$onInitializationFailed = (0, $km7rM.createInitializationFailed)((0, $lGasn.SOURCES).PORTAL_REQUEST, true);
const $b6d9cd0ce5113b9e$var$ForgeFieldImplOld = (props)=>{
    const { disableSubmitButton: disableSubmitButton, enableSubmitButton: enableSubmitButton, fallbackRender: fallbackRender, jiraFieldType: jiraFieldType, id: id, analyticsAttributes: analyticsAttributes } = props;
    const [isRendered, setIsRendered] = (0, $fc4bM.useState)(false);
    const accountType = (0, $6LH8a.getMetaFromHTML)('ajs-account-type') || (0, $2UXyw.AtlassianHelpConfigAccountType).ANONYMOUS;
    const hasAccess = accountType === (0, $2UXyw.AtlassianHelpConfigAccountType).ATLASSIAN;
    const [fieldState] = (0, $dkKKz.useInlineField)(id);
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const fireScreenEventOnce = (0, $fc4bM.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($l6v5q)))((0, $10X2G.fireScreenEvent)), []);
    const fireNotFoundOnce = (0, $fc4bM.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($l6v5q)))((0, $10X2G.fireOperationalEvent)), []);
    const showNotFoundFlagOnce = (0, $fc4bM.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($l6v5q)))(props.showErrorFlag), [
        props.showErrorFlag
    ]);
    const useExtensionsConfig = (0, $fc4bM.useMemo)(()=>({
            onInitializationFinished: $b6d9cd0ce5113b9e$var$onInitializationFinished,
            onInitializationFailed: $b6d9cd0ce5113b9e$var$onInitializationFailed,
            types: [
                (0, $1HEEa.CUSTOM_FIELD),
                (0, $1HEEa.CUSTOM_FIELD_TYPE)
            ],
            context: {
                portalId: String(props.portalId),
                requestTypeId: String(props.requestTypeId)
            },
            includeHidden: true,
            shouldFetch: hasAccess
        }), [
        hasAccess,
        props.portalId,
        props.requestTypeId
    ]);
    const { extensions: extensions, isLoading: isLoading, error: error } = (0, $4Lbcj.useExtensions)(useExtensionsConfig);
    const onRendered = (0, $fc4bM.useCallback)(()=>{
        setIsRendered(true);
        // oxlint-disable-next-line no-void
        fireScreenEventOnce({
            attributes: {
                ...analyticsAttributes,
                entryPoint: 'edit'
            },
            id: 'customFieldEditScreen',
            source: (0, $lGasn.SOURCES).PORTAL_REQUEST
        });
    }, [
        analyticsAttributes,
        fireScreenEventOnce
    ]);
    (0, $fc4bM.useEffect)(()=>{
        isLoading ? disableSubmitButton === null || disableSubmitButton === void 0 || disableSubmitButton() : enableSubmitButton === null || enableSubmitButton === void 0 || enableSubmitButton();
    }, [
        isLoading,
        disableSubmitButton,
        enableSubmitButton
    ]);
    const extension = (0, $fc4bM.useMemo)(()=>{
        const extensionId = (0, $ckEaG.isForgeLegacyFieldType)(jiraFieldType || '') ? (0, $ckEaG.getExtensionIdFromLegacyFieldType)(jiraFieldType || '') : jiraFieldType;
        return extensions.find((field)=>field.id === extensionId);
    }, [
        extensions,
        jiraFieldType
    ]);
    // We are going to pass to the list only the extension that is found.
    // This is to avoid showing the banner for the extensions that are not added to the experience but still installed on the tenant.
    const extensionsToCheck = (0, $fc4bM.useMemo)(()=>extension ? [
            extension
        ] : [], [
        extension
    ]);
    (0, $iya1n.default)(extensionsToCheck, (0, $1HEEa.FORGE_REQUEST_CREATE), hasAccess, props.showBanner, props.resetBannerState);
    const shouldFallBackToNativeRendering = (0, $fc4bM.useMemo)(()=>{
        var _extension$properties, _extension$properties2;
        // Too early to tell, just assume we have a custom renderer
        if (!extension) return false;
        // There is no resource, so it's not a custom renderer
        if (typeof ((_extension$properties = extension.properties.edit) === null || _extension$properties === void 0 ? void 0 : _extension$properties.resource) !== 'string') return true;
        // There must be a correct experience defined, otherwise we'd need to fallback to the native rendering
        const isValidExperience = (_extension$properties2 = extension.properties.edit) === null || _extension$properties2 === void 0 || (_extension$properties2 = _extension$properties2.experience) === null || _extension$properties2 === void 0 ? void 0 : _extension$properties2.includes((0, $lGasn.EXPERIENCES).PORTAL_REQUEST);
        return !isValidExperience;
    }, [
        extension
    ]);
    const preferredFieldNode = (0, $fc4bM.useMemo)(()=>{
        if (shouldFallBackToNativeRendering && extension) return fallbackRender((0, $Inbg4.getMappedFieldType)(extension));
        return null;
    }, [
        extension,
        fallbackRender,
        shouldFallBackToNativeRendering
    ]);
    const fieldBaseProps = (0, $fc4bM.useMemo)(()=>({
            label: extension ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7Iv02.ExtensionTitle), {
                extensionName: props.label,
                extensionEnvType: extension.environmentType,
                extensionEnvKey: extension.environmentKey
            }) : props.label,
            htmlFor: props.id,
            required: props.required,
            description: props.description,
            labelId: `${props.id}-label`
        }), [
        props.description,
        props.id,
        props.label,
        props.required,
        extension
    ]);
    const mergedErrorMessages = (0, $fc4bM.useMemo)(()=>[
            (fieldState === null || fieldState === void 0 ? void 0 : fieldState.status) === (0, $j4xhN.FIELD_STATE_FAILED) && formatMessage((0, $4V9fY.default).errorMessage),
            props.errorMessage
        ].filter(Boolean), [
        fieldState === null || fieldState === void 0 ? void 0 : fieldState.status,
        props.errorMessage,
        formatMessage
    ]);
    const isHidden = typeof (extension === null || extension === void 0 ? void 0 : extension.hiddenBy) === 'string';
    if (!hasAccess || isHidden || error) return null;
    if (!extension && !isLoading) {
        // oxlint-disable-next-line no-void
        fireNotFoundOnce((0, $lGasn.OPERATIONAL_ACTIONS).FAILED, {
            attributes: {
                ...analyticsAttributes,
                entryPoint: 'edit',
                reason: 'notFound',
                required: props.required
            },
            id: 'customFieldEdit',
            source: (0, $lGasn.SOURCES).PORTAL_REQUEST
        });
        if (props.required) showNotFoundFlagOnce((0, $4V9fY.default).notFoundRequiredFieldTitle, (0, $4V9fY.default).notFoundRequiredFieldDescription, [], undefined, {
            fieldName: props.label
        });
        return null;
    }
    if (preferredFieldNode) return preferredFieldNode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ch1yB.FieldBase), {
        ...fieldBaseProps,
        errorMessage: mergedErrorMessages.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $165Jb.ErrorMessage), {
            errorMessages: mergedErrorMessages
        }) : undefined
    }, isLoading || !isRendered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lyeIH.Skeleton), null) : null, extension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($b6d9cd0ce5113b9e$var$ForgeFieldWithExtension, {
        ...props,
        extension: extension,
        loadingComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lyeIH.Skeleton), {
            onUnmount: onRendered
        }),
        isVisible: isRendered
    }));
};
const $b6d9cd0ce5113b9e$var$ForgeFieldImplNew = (props)=>{
    const { extension: extension, fallbackRender: fallbackRender, id: id, analyticsAttributes: analyticsAttributes } = props;
    const [isRendered, setIsRendered] = (0, $fc4bM.useState)(false);
    const [fieldState] = (0, $dkKKz.useInlineField)(id);
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const fireScreenEventOnce = (0, $fc4bM.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($l6v5q)))((0, $10X2G.fireScreenEvent)), []);
    const fireNotFoundOnce = (0, $fc4bM.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($l6v5q)))((0, $10X2G.fireOperationalEvent)), []);
    const showNotFoundFlagOnce = (0, $fc4bM.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($l6v5q)))(props.showErrorFlag), [
        props.showErrorFlag
    ]);
    const onRendered = (0, $fc4bM.useCallback)(()=>{
        setIsRendered(true);
        // oxlint-disable-next-line no-void
        fireScreenEventOnce({
            attributes: {
                ...analyticsAttributes,
                entryPoint: 'edit'
            },
            id: 'customFieldEditScreen',
            source: (0, $lGasn.SOURCES).PORTAL_REQUEST
        });
    }, [
        analyticsAttributes,
        fireScreenEventOnce
    ]);
    // Transforming the extension to the old format which is used in the blocked apps banner
    const extensionsToCheck = (0, $fc4bM.useMemo)(()=>extension ? [
            {
                ...extension,
                dataClassificationPolicyDecision: {
                    status: extension.hiddenBy === 'AppAccessRules' ? 'BLOCKED' : 'ALLOWED'
                }
            }
        ] : [], [
        extension
    ]);
    (0, $iya1n.default)(extensionsToCheck, (0, $1HEEa.FORGE_REQUEST_CREATE), true, props.showBanner, props.resetBannerState);
    const shouldFallBackToNativeRendering = (0, $fc4bM.useMemo)(()=>{
        var _extension$properties3, _extension$properties4;
        // No way to determine, so falling back to native rendering
        if (!extension) return false;
        // There is no resource, so it's not a custom renderer
        if (typeof ((_extension$properties3 = extension.properties.edit) === null || _extension$properties3 === void 0 ? void 0 : _extension$properties3.resource) !== 'string') return true;
        // There must be a correct experience defined, otherwise we'd need to fallback to the native rendering
        const isValidExperience = (_extension$properties4 = extension.properties.edit) === null || _extension$properties4 === void 0 || (_extension$properties4 = _extension$properties4.experience) === null || _extension$properties4 === void 0 ? void 0 : _extension$properties4.includes((0, $lGasn.EXPERIENCES).PORTAL_REQUEST);
        return !isValidExperience;
    }, [
        extension
    ]);
    const preferredFieldNode = (0, $fc4bM.useMemo)(()=>{
        if (shouldFallBackToNativeRendering && extension) return fallbackRender((0, $Inbg4.getMappedFieldType)(extension));
        return null;
    }, [
        extension,
        fallbackRender,
        shouldFallBackToNativeRendering
    ]);
    const fieldBaseProps = (0, $fc4bM.useMemo)(()=>({
            label: extension ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7Iv02.ExtensionTitle), {
                extensionName: props.label,
                extensionEnvType: extension.environmentType,
                extensionEnvKey: extension.environmentKey
            }) : props.label,
            htmlFor: props.id,
            required: props.required,
            description: props.description,
            labelId: `${props.id}-label`
        }), [
        props.description,
        props.id,
        props.label,
        props.required,
        extension
    ]);
    const mergedErrorMessages = (0, $fc4bM.useMemo)(()=>[
            (fieldState === null || fieldState === void 0 ? void 0 : fieldState.status) === (0, $j4xhN.FIELD_STATE_FAILED) && formatMessage((0, $4V9fY.default).errorMessage),
            props.errorMessage
        ].filter(Boolean), [
        fieldState === null || fieldState === void 0 ? void 0 : fieldState.status,
        props.errorMessage,
        formatMessage
    ]);
    const errorMessageContent = (0, $fc4bM.useMemo)(()=>mergedErrorMessages && mergedErrorMessages.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $165Jb.ErrorMessage), {
            errorMessages: mergedErrorMessages
        }) : undefined, [
        mergedErrorMessages
    ]);
    if (!extension) {
        // oxlint-disable-next-line no-void
        fireNotFoundOnce((0, $lGasn.OPERATIONAL_ACTIONS).FAILED, {
            attributes: {
                ...analyticsAttributes,
                entryPoint: 'edit',
                reason: 'notFound',
                required: props.required
            },
            id: 'customFieldEdit',
            source: (0, $lGasn.SOURCES).PORTAL_REQUEST
        });
        if (props.required) showNotFoundFlagOnce((0, $4V9fY.default).notFoundRequiredFieldTitle, (0, $4V9fY.default).notFoundRequiredFieldDescription, [], undefined, {
            fieldName: props.label
        });
        return null;
    }
    const isHidden = typeof (extension === null || extension === void 0 ? void 0 : extension.hiddenBy) === 'string';
    if (isHidden) return null;
    if (preferredFieldNode) return preferredFieldNode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ch1yB.FieldBase), {
        ...fieldBaseProps,
        errorMessage: errorMessageContent
    }, !isRendered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lyeIH.Skeleton), null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($b6d9cd0ce5113b9e$var$ForgeFieldWithExtension, {
        ...props,
        extension: extension,
        loadingComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lyeIH.Skeleton), {
            onUnmount: onRendered
        }),
        isVisible: isRendered
    }));
};
const $b6d9cd0ce5113b9e$var$ForgeFieldImpl = (props)=>{
    if ((0, $hN5YJ.isForgeCustomFieldsOnPortalViewEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($b6d9cd0ce5113b9e$var$ForgeFieldImplNew, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($b6d9cd0ce5113b9e$var$ForgeFieldImplOld, props);
};
const $b6d9cd0ce5113b9e$export$ecd216b89a458857 = (props)=>{
    const id = 'customFieldEdit';
    const rawAttributes = (0, $fc4bM.useMemo)(()=>({
            source: (0, $lGasn.SOURCES).PORTAL_REQUEST,
            renderContext: (0, $lGasn.RENDER_CONTEXTS).PORTAL_REQUEST,
            experience: (0, $lGasn.EXPERIENCES).PORTAL_REQUEST
        }), []);
    const analyticsAttributes = (0, $fc4bM.useMemo)(()=>(0, $10X2G.createAttributes)(rawAttributes), [
        rawAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iya1I.default), {
        id: id,
        packageName: (0, $lGasn.PACKAGE_NAME_GASV3),
        analyticsAttributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($b6d9cd0ce5113b9e$var$ForgeFieldImpl, {
        ...props,
        analyticsAttributes: rawAttributes
    }));
};
const $b6d9cd0ce5113b9e$var$mapDispatchToProps = (dispatch)=>{
    return {
        ...(0, $hwMna.mapDispatchToPropsBanner)(dispatch),
        showErrorFlag: (...args)=>dispatch((0, $5kfOu.showErrorFlag)(...args))
    };
};
const $b6d9cd0ce5113b9e$export$34a15d6027142c62 = (0, $9XZeF.connect)((state, ownProps)=>{
    return {
        issueType: (0, $1xUIS.getIssueType)(state, ownProps.portalId, ownProps.requestTypeId),
        issueTypeId: (0, $1xUIS.getIssueTypeId)(state, ownProps.portalId, ownProps.requestTypeId)
    };
}, $b6d9cd0ce5113b9e$var$mapDispatchToProps)($b6d9cd0ce5113b9e$export$ecd216b89a458857);

});
parcelRegister("iya1n", function(module, exports) {
$parcel$export(module.exports, "default", () => $3785e417632fa222$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $2UXyw = parcelRequire("2UXyw");
const $3785e417632fa222$var$useShowBannerHook = (// TODO: Fix the issue with the extensions being undefined https://hello.jira.atlassian.cloud/browse/PORTAL-5931
extensions = [], page, shouldCallBanner, showBanner, resetBannerState)=>{
    const wasShowBannerCalled = (0, $fc4bM.useRef)(false);
    const allowedExtensions = (0, $fc4bM.useMemo)(()=>{
        if (!(extensions !== null && extensions !== void 0 && extensions.length)) return [];
        return extensions.filter((extension)=>{
            var _extension$dataClassi;
            return (extension === null || extension === void 0 || (_extension$dataClassi = extension.dataClassificationPolicyDecision) === null || _extension$dataClassi === void 0 ? void 0 : _extension$dataClassi.status) !== (0, $2UXyw.BLOCKED);
        });
    }, [
        extensions
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (shouldCallBanner && (allowedExtensions === null || allowedExtensions === void 0 ? void 0 : allowedExtensions.length) !== (extensions === null || extensions === void 0 ? void 0 : extensions.length) && showBanner) {
            showBanner(page);
            wasShowBannerCalled.current = true;
        }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        allowedExtensions
    ]);
    (0, $fc4bM.useEffect)(()=>{
        return ()=>{
            if (wasShowBannerCalled.current && resetBannerState) resetBannerState(page);
        };
    // Not adding all deps here since we only want to run this cleanup upon unmount and also when allowedExtensions change
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        allowedExtensions
    ]);
    return allowedExtensions;
};
var $3785e417632fa222$export$2e2bcd8739ae039 = $3785e417632fa222$var$useShowBannerHook;

});

parcelRegister("6rMSs", function(module, exports) {
$parcel$export(module.exports, "ExtensionTitle", () => (parcelRequire("7Iv02")).ExtensionTitle);

var $7Iv02 = parcelRequire("7Iv02");

});
parcelRegister("7Iv02", function(module, exports) {
$parcel$export(module.exports, "ExtensionTitle", () => $77eb58b57236c159$export$3aa4a75e461c581c);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $euRd1 = parcelRequire("euRd1");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $dRN1U = parcelRequire("dRN1U");
const $77eb58b57236c159$export$9af0088c49bdedb = 'PRODUCTION';
const $77eb58b57236c159$export$71acbd662c478c42 = 'STAGING';
const $77eb58b57236c159$export$978072fd3fd149 = 'DEVELOPMENT';
const $77eb58b57236c159$export$ebc15d9cebfd6063 = 'default';
const $77eb58b57236c159$export$3aa4a75e461c581c = ({ extensionEnvType: extensionEnvType, extensionEnvKey: extensionEnvKey, extensionName: extensionName })=>{
    if (!$77eb58b57236c159$var$shouldShowEnv(extensionEnvType)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, extensionName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $77eb58b57236c159$var$wrapperStyles,
        as: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, $77eb58b57236c159$var$nameWithCustomEnvironment(extensionName, extensionEnvType, extensionEnvKey), " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($77eb58b57236c159$export$278f8e01799d0418, {
        environmentType: extensionEnvType
    }));
};
const $77eb58b57236c159$export$278f8e01799d0418 = (props)=>{
    const { environmentType: environmentType } = props;
    const labelKey = $77eb58b57236c159$var$getEnvironmentTranslationKey(environmentType);
    return labelKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $euRd1.default), {
        appearance: environmentType === $77eb58b57236c159$export$978072fd3fd149 ? 'default' : 'moved'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), labelKey)) : null;
};
const $77eb58b57236c159$var$shouldShowEnv = (extensionEnvType)=>[
        $77eb58b57236c159$export$71acbd662c478c42,
        $77eb58b57236c159$export$978072fd3fd149
    ].includes(extensionEnvType);
const $77eb58b57236c159$var$getEnvironmentTranslationKey = (environmentType)=>{
    switch(environmentType){
        case $77eb58b57236c159$export$978072fd3fd149:
            return (0, $dRN1U.messages).developmentEnvironmentLozenge;
        case $77eb58b57236c159$export$71acbd662c478c42:
            return (0, $dRN1U.messages).stagingEnvironmentLozenge;
        default:
            return null;
    }
};
const $77eb58b57236c159$var$nameWithCustomEnvironment = (name, environmentType, environmentKey)=>{
    if (environmentType === $77eb58b57236c159$export$978072fd3fd149 && environmentKey && environmentKey !== $77eb58b57236c159$export$ebc15d9cebfd6063) return `${name} - ${environmentKey}`;
    return name;
};
const $77eb58b57236c159$var$wrapperStyles = (0, $kig2V.xcss)({
    alignItems: 'baseline'
});

});
parcelRegister("dRN1U", function(module, exports) {
$parcel$export(module.exports, "messages", () => $78bee81ad919eada$export$defe85febe8b728c);

var $8p5Cv = parcelRequire("8p5Cv");
const $78bee81ad919eada$export$defe85febe8b728c = (0, $8p5Cv.defineMessages)({
    developmentEnvironmentLozenge: {
        id: 'forge-ui-extension-title.environment-lozenge.development-environment-lozenge',
        defaultMessage: 'DEV',
        description: 'Navigation item lozenge label for forge apps on development environment'
    },
    stagingEnvironmentLozenge: {
        id: 'forge-ui-extension-title.environment-lozenge.staging-environment-lozenge',
        defaultMessage: 'STG',
        description: 'Navigation item lozenge label for forge apps on staging environment'
    }
});

});



parcelRegister("cOmeO", function(module, exports) {
$parcel$export(module.exports, "ForgeCustomFieldEdit", () => (parcelRequire("7OReX")).ForgeCustomFieldEdit);
$parcel$export(module.exports, "ForgeCustomFieldView", () => (parcelRequire("cKMWx")).ForgeCustomFieldView);

var $7OReX = parcelRequire("7OReX");
parcelRequire("bPOb0");
var $cKMWx = parcelRequire("cKMWx");

});
parcelRegister("bPOb0", function(module, exports) {
$parcel$export(module.exports, "ForgeCustomFieldView", () => (parcelRequire("cKMWx")).ForgeCustomFieldView);

var $cKMWx = parcelRequire("cKMWx");

});
parcelRegister("cKMWx", function(module, exports) {
$parcel$export(module.exports, "ForgeCustomFieldView", () => $a465974d990dd803$export$4edba301650506c5);

var $fc4bM = parcelRequire("fc4bM");

var $2UXyw = parcelRequire("2UXyw");

var $bTECU = parcelRequire("bTECU");

var $4Otn9 = parcelRequire("4Otn9");

var $493pH = parcelRequire("493pH");

var $gpjDl = parcelRequire("gpjDl");

var $dtvmL = parcelRequire("dtvmL");

var $1Lp7H = parcelRequire("1Lp7H");
const $a465974d990dd803$export$4edba301650506c5 = ({ extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, loadingComponent: loadingComponent, contextTokenType: contextTokenType = (0, $2UXyw.ContextTokenType).JIRA })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const getComponents = (0, $fc4bM.useCallback)((defaults)=>{
        return {
            ...defaults,
            Frame: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dtvmL.default), {
                    title: formatMessage((0, $1Lp7H.default).unsupportedFrameComponentTitle),
                    appearance: "error"
                }, formatMessage((0, $1Lp7H.default).unsupportedFrameComponentDescription))
        };
    }, [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bTECU.ExtensionPointProvider), {
        extensionType: extension.type
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4Otn9.ExtensionProvider), {
        extension: extension
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $493pH.Renderer), {
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        entryPoint: "view",
        loadingComponent: loadingComponent,
        contextTokenType: contextTokenType,
        getComponents: getComponents
    })));
};

});
parcelRegister("4Otn9", function(module, exports) {
$parcel$export(module.exports, "ExtensionProvider", () => $1137ebd513691d20$export$c6ef18cd2d1a61a0);

var $bQkfB = parcelRequire("bQkfB");

var $ieUrC = parcelRequire("ieUrC");

const $1137ebd513691d20$export$c6ef18cd2d1a61a0 = (0, $bQkfB.default)({
    loader: (0, $ieUrC.lazyForPaint)(()=>(parcelRequire("14xEY")), {
        moduleId: "./packages/common-utils/forge-ui-utils/src/extension-provider/extension-provider.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("14xEY", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("6OUGZ").then(()=>parcelRequire('70tmh'));

});


parcelRegister("1Lp7H", function(module, exports) {
$parcel$export(module.exports, "default", () => $935d365dfc92871d$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $935d365dfc92871d$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    unsupportedFrameComponentTitle: {
        id: 'forge-ui.common.extension.components.custom-field.view.unsupported-frame-component-title',
        defaultMessage: 'Frame not supported in view mode',
        description: 'Title of the error message shown to app developer when they try to use UI Kit Frame component for rendering custom field in the view mode'
    },
    unsupportedFrameComponentDescription: {
        id: 'forge-ui.common.extension.components.custom-field.view.unsupported-frame-component-description',
        defaultMessage: "Custom fields can\u2019t render the Frame component in view mode.",
        description: 'Description of the error message shown to app developer when they try to use UI Kit Frame component for rendering custom field in the view mode'
    }
});

});




parcelRegister("ckEaG", function(module, exports) {
$parcel$export(module.exports, "isForgeLegacyFieldType", () => $3ff29af01975ded4$export$3fb46a1fa454ffea);
$parcel$export(module.exports, "getExtensionIdFromLegacyFieldType", () => $3ff29af01975ded4$export$2b6a9cc67d548886);
const $3ff29af01975ded4$export$3193d714ab54ee26 = 'ari:cloud:ecosystem::extension/';
const $3ff29af01975ded4$export$df7774a415710cce = 'com.atlassian.forge:';
const $3ff29af01975ded4$export$51ab2784839ce348 = `${$3ff29af01975ded4$export$df7774a415710cce}${$3ff29af01975ded4$export$3193d714ab54ee26}`;
const $3ff29af01975ded4$export$3fb46a1fa454ffea = (fieldType)=>fieldType.startsWith($3ff29af01975ded4$export$51ab2784839ce348);
const $3ff29af01975ded4$export$2b6a9cc67d548886 = (fieldType)=>fieldType.split($3ff29af01975ded4$export$df7774a415710cce)[1] || null;

});

parcelRegister("km7rM", function(module, exports) {
$parcel$export(module.exports, "createInitializationFinished", () => $df62ee636440295d$export$b0c730765ca52cfc);
$parcel$export(module.exports, "createInitializationFailed", () => $df62ee636440295d$export$730b6703c16a1943);

var $53bjB = parcelRequire("53bjB");

var $10X2G = parcelRequire("10X2G");

var $lGasn = parcelRequire("lGasn");

var $3m6I3 = parcelRequire("3m6I3");
// Shared debounced functions per source and action type are used to ensure that multiple components
// with the same source and action type will share the same debounced function. This prevents duplicate
// analytics events when multiple components finish or fail initialization within the debounce interval.
const $df62ee636440295d$var$sharedDebouncedEvents = new Map();
const $df62ee636440295d$var$getCompositeKey = (source, action)=>`${source}-${action}`;
const $df62ee636440295d$var$getOrCreateDebouncedFn = (key, fn)=>{
    const existingFn = $df62ee636440295d$var$sharedDebouncedEvents.get(key);
    if (existingFn) return existingFn;
    const debouncedFn = (0, (/*@__PURE__*/$parcel$interopDefault($53bjB)))(fn, (0, $lGasn.DEBOUNCE_INTERVAL));
    $df62ee636440295d$var$sharedDebouncedEvents.set(key, debouncedFn);
    return debouncedFn;
};
const $df62ee636440295d$var$isInSample = (samplingRate)=>(0, $3m6I3.default).random() * 100 < samplingRate;
const $df62ee636440295d$export$b0c730765ca52cfc = (source, shouldDebounce = false)=>{
    const fireEvent = async (attributes)=>{
        if ($df62ee636440295d$var$isInSample((0, $lGasn.FORGE_SAMPLING_RATE))) await (0, $10X2G.fireInitializationEvent)((0, $lGasn.INITIALIZATION_ACTIONS).FINISHED, {
            source: source,
            attributes: attributes,
            id: 'fetchModulesInitialization'
        });
    };
    if (shouldDebounce) return $df62ee636440295d$var$getOrCreateDebouncedFn($df62ee636440295d$var$getCompositeKey(source, (0, $lGasn.INITIALIZATION_ACTIONS).FINISHED), fireEvent);
    return fireEvent;
};
const $df62ee636440295d$export$730b6703c16a1943 = (source, shouldDebounce = false)=>{
    const fireEvent = async (attributes)=>{
        await (0, $10X2G.fireInitializationEvent)((0, $lGasn.INITIALIZATION_ACTIONS).FAILED, {
            source: source,
            attributes: attributes,
            id: 'fetchModulesInitialization'
        });
    };
    if (shouldDebounce) return $df62ee636440295d$var$getOrCreateDebouncedFn($df62ee636440295d$var$getCompositeKey(source, (0, $lGasn.INITIALIZATION_ACTIONS).FAILED), fireEvent);
    return fireEvent;
};

});

parcelRegister("eZy6P", function(module, exports) {
$parcel$export(module.exports, "useExtensions", () => (parcelRequire("4Lbcj")).useExtensions);

var $4Lbcj = parcelRequire("4Lbcj");

});
parcelRegister("4Lbcj", function(module, exports) {
$parcel$export(module.exports, "useExtensions", () => $307732e1049d93bd$export$d3949313562c25d7);

var $1gAs7 = parcelRequire("1gAs7");

var $fc4bM = parcelRequire("fc4bM");

var $2UXyw = parcelRequire("2UXyw");

var $6LH8a = parcelRequire("6LH8a");

var $3BZyK = parcelRequire("3BZyK");

var $1xOZp = parcelRequire("1xOZp");
const $307732e1049d93bd$export$d8fab312eb2aaa85 = (0, $1gAs7.default);
const $307732e1049d93bd$export$d3949313562c25d7 = ({ types: types, context: context, includeHidden: includeHidden, shouldFetch: shouldFetch, onInitializationFinished: onInitializationFinished, onInitializationFailed: onInitializationFailed })=>{
    const cloudId = (0, $6LH8a.getCloudId)();
    const [isLoading, setIsLoading] = (0, $fc4bM.useState)(shouldFetch);
    const [extensions, setExtensions] = (0, $fc4bM.useState)([]);
    const [error, setError] = (0, $fc4bM.useState)(null);
    const fetchForgeModules = (0, $fc4bM.useCallback)(()=>{
        setIsLoading(true);
        (0, $3BZyK.fetchQuery)((0, $1xOZp.getRelayEnvironment)(), $307732e1049d93bd$export$d8fab312eb2aaa85, {
            cloudId: cloudId,
            context: context,
            types: types,
            includeHidden: includeHidden
        }).toPromise().then((data)=>{
            var _data$jira;
            const exts = ((data === null || data === void 0 || (_data$jira = data.jira) === null || _data$jira === void 0 || (_data$jira = _data$jira.forge) === null || _data$jira === void 0 ? void 0 : _data$jira.extensions) || []).filter((ext)=>types.includes(ext.type)).map($307732e1049d93bd$export$39ee489473821fbd);
            setExtensions(exts);
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            onInitializationFinished();
        }).catch((e)=>{
            setExtensions([]);
            setError(e);
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            onInitializationFailed({
                error: e
            });
        }).finally(()=>{
            setIsLoading(false);
        });
    }, [
        cloudId,
        context,
        includeHidden,
        types,
        onInitializationFinished,
        onInitializationFailed
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (shouldFetch) fetchForgeModules();
    }, [
        shouldFetch,
        fetchForgeModules
    ]);
    return (0, $fc4bM.useMemo)(()=>({
            extensions: extensions,
            isLoading: isLoading,
            error: error
        }), [
        error,
        extensions,
        isLoading
    ]);
};
const $307732e1049d93bd$export$39ee489473821fbd = (extension)=>{
    const license = extension.license;
    const transformedLicense = license ? {
        active: license.active,
        type: license.type ?? null,
        supportEntitlementNumber: license.supportEntitlementNumber ?? null,
        trialEndDate: license.trialEndDate ?? null,
        subscriptionEndDate: license.subscriptionEndDate ?? null,
        isEvaluation: license.isEvaluation ?? null,
        billingPeriod: license.billingPeriod ?? null,
        ccpEntitlementId: license.ccpEntitlementId ?? null,
        ccpEntitlementSlug: license.ccpEntitlementSlug ?? null,
        capabilitySet: license.capabilitySet ?? null,
        modes: null
    } : null;
    // Each Forge module has a unique id, however it may be used in different contexts.
    // In those contexts, some modules may be hidden depending on display conditions.
    // In order for Relay to not pick up hidden extensions from the cache, we need to use a unique id for each context.
    // This is done on the backend side by appending the hash to the module id.
    // This fixes the Relay cache issue but on the client side we still want to operate on the original extension id since Forge depends on it.
    // That's why we swap id with moduleId, which represents the original id; also as a fallback we strip the hash from the id just in case.
    const id = extension.moduleId ?? extension.id.replace(/-+\d+$/, '');
    return {
        ...extension,
        id: id,
        key: id,
        egress: extension.egress ?? [],
        consentUrl: extension.consentUrl ?? undefined,
        license: transformedLicense,
        dataClassificationPolicyDecision: {
            status: extension.hiddenBy === 'AppAccessRules' ? (0, $2UXyw.BLOCKED) : (0, $2UXyw.ALLOWED)
        }
    };
};

});
parcelRegister("1gAs7", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ed4b2b42efe608b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7529279f9f3ade19d56dc8361377f002>>
 * @relayHash a62833dfd2661ff1b5ca07e6a551b824
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8f0d4ed5503c6f67b5a7266ea07fcc9d673749ecd294218cabda51d8920bbb1e
const $0ed4b2b42efe608b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "context"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeHidden"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "types"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraForgeQuery",
                    "kind": "LinkedField",
                    "name": "forge",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "context",
                                    "variableName": "context"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "includeHidden",
                                    "variableName": "includeHidden"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "types",
                                    "variableName": "types"
                                }
                            ],
                            "concreteType": "JiraForgeExtension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hiddenBy"
                                },
                                v4 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "moduleId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "installationId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "appVersion"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "consentUrl"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "properties"
                                },
                                {
                                    "concreteType": "JiraUserAppAccess",
                                    "kind": "LinkedField",
                                    "name": "userAccess",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasAccess"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "enabled"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeAppEgressDeclaration",
                                    "kind": "LinkedField",
                                    "name": "egress",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "addresses"
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "category"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "inScopeEUD"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeInstallationConfigExtension",
                                    "kind": "LinkedField",
                                    "name": "installationConfig",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeExtensionLicense",
                                    "kind": "LinkedField",
                                    "name": "license",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "active"
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "supportEntitlementNumber"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "trialEndDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "subscriptionEndDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEvaluation"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "billingPeriod"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "ccpEntitlementId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "ccpEntitlementSlug"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "capabilitySet"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useExtensionsQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useExtensionsQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "id": "8f0d4ed5503c6f67b5a7266ea07fcc9d673749ecd294218cabda51d8920bbb1e",
            "metadata": {},
            "name": "useExtensionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0ed4b2b42efe608b$var$node.hash = "ca72edb566d5f0ae17dcb8d6cee09569";
var $0ed4b2b42efe608b$export$2e2bcd8739ae039 = $0ed4b2b42efe608b$var$node;

});



parcelRegister("kmLox", function(module, exports) {
$parcel$export(module.exports, "ErrorMessage", () => (parcelRequire("165Jb")).ErrorMessage);

var $165Jb = parcelRequire("165Jb");

});
parcelRegister("165Jb", function(module, exports) {
$parcel$export(module.exports, "ErrorMessage", () => $928c7bf3d368ad68$export$915e9e7bd4f0f96d);

var $fc4bM = parcelRequire("fc4bM");
const $928c7bf3d368ad68$export$915e9e7bd4f0f96d = ({ errorMessages: errorMessages })=>{
    if (!errorMessages.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, errorMessages.map((message, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Fragment), {
            key: index
        }, message, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("br", null))));
};

});


parcelRegister("8vF5m", function(module, exports) {
$parcel$export(module.exports, "FieldState", () => (parcelRequire("jX0E7")).FieldState);

var $jX0E7 = parcelRequire("jX0E7");

});
parcelRegister("jX0E7", function(module, exports) {
$parcel$export(module.exports, "FieldState", () => $c189411fcd79dd4d$export$f91d67ddd1e8123a);

var $fc4bM = parcelRequire("fc4bM");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");
const $c189411fcd79dd4d$export$f91d67ddd1e8123a = ({ isDisabled: isDisabled, isVisible: isVisible, children: children })=>{
    const styles = (0, $fc4bM.useMemo)(()=>[
            isVisible ? undefined : $c189411fcd79dd4d$var$hiddenStyles,
            isDisabled ? $c189411fcd79dd4d$var$disabledStyles : undefined
        ].filter(Boolean), [
        isVisible,
        isDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: styles
    }, children);
};
const $c189411fcd79dd4d$var$hiddenStyles = (0, $kig2V.xcss)({
    display: 'none'
});
const $c189411fcd79dd4d$var$disabledStyles = (0, $kig2V.xcss)({
    opacity: 0.4,
    // @ts-expect-error we want to disable pointer events for all the children coming from Forge apps
    '*': {
        pointerEvents: 'none !important'
    }
});

});


parcelRegister("4V9fY", function(module, exports) {
$parcel$export(module.exports, "default", () => $687b0dda1519513b$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $687b0dda1519513b$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    errorMessage: {
        defaultMessage: "We couldn't save the value of this custom field.",
        description: 'Error message when the value of a forge custom field cannot be saved',
        id: 'cv.request.create.form.forge-field.error-message'
    },
    notFoundRequiredFieldTitle: {
        defaultMessage: 'Custom field not found',
        description: 'Title of the error message shown in the flag when a custom field is required but is not found',
        id: 'cv.request.create.form.forge-field.not-found-required-title'
    },
    notFoundRequiredFieldDescription: {
        defaultMessage: "The {fieldName} custom field is required but couldn't be displayed. If this happens again, notify your admin.",
        description: 'Description of the error message shown in the flag when a custom field is required but is not found',
        id: 'cv.request.create.form.forge-field.not-found-required-description'
    }
});

});

parcelRegister("lyeIH", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $970b6c63829de2aa$export$8f31e4c4a37b8e9c);

var $fc4bM = parcelRequire("fc4bM");

var $8PITw = parcelRequire("8PITw");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");
const $970b6c63829de2aa$export$8f31e4c4a37b8e9c = ({ onUnmount: onUnmount })=>{
    (0, $fc4bM.useEffect)(()=>()=>onUnmount === null || onUnmount === void 0 ? void 0 : onUnmount(), [
        onUnmount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $970b6c63829de2aa$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8PITw.LoadingSkeleton), {
        height: 40,
        backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
    }));
};
const $970b6c63829de2aa$var$containerStyles = (0, $kig2V.xcss)({
    width: '100%'
});

});

parcelRegister("Inbg4", function(module, exports) {
$parcel$export(module.exports, "getMappedFieldType", () => $c2fbcf7988683bb2$export$c0b3058f961cfa89);
$parcel$export(module.exports, "transformValue", () => $c2fbcf7988683bb2$export$98c150630afe5417);
const $c2fbcf7988683bb2$var$fieldMap = {
    none: {
        string: 'text',
        number: 'text',
        object: 'textarea',
        user: 'userpicker',
        datetime: 'datetime',
        date: 'date'
    },
    list: {
        string: 'labelpicker',
        user: 'multiuserpicker'
    }
};
const $c2fbcf7988683bb2$export$c0b3058f961cfa89 = (extension)=>{
    const collection = extension.properties.collection === 'list' ? 'list' : 'none';
    return $c2fbcf7988683bb2$var$fieldMap[collection][extension.properties.type] || 'unknown';
};
const $c2fbcf7988683bb2$export$98c150630afe5417 = (value, extension)=>{
    switch(extension.properties.type){
        case 'object':
            return value != null ? JSON.stringify(value) : value;
        case 'user':
            return value != null ? $c2fbcf7988683bb2$var$transformUser(value) : value;
        default:
            return value;
    }
};
const $c2fbcf7988683bb2$var$transformUser = (value)=>Array.isArray(value) ? value.map((user)=>user.accountId).join(',') : value.accountId;

});



parcelRegister("k7LqY", function(module, exports) {
$parcel$export(module.exports, "LabelPicker", () => (parcelRequire("kW8X3")).default);

var $kW8X3 = parcelRequire("kW8X3");

});
parcelRegister("kW8X3", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e604b06127147b5$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $4Q7yw = parcelRequire("4Q7yw");

var $9mazR = parcelRequire("9mazR");

var $aYMdQ = parcelRequire("aYMdQ");

var $fcCIH = parcelRequire("fcCIH");

var $9Y7QD = parcelRequire("9Y7QD");
parcelRequire("2IdpX");
var $eecfC = parcelRequire("eecfC");

var $8n2Ui = parcelRequire("8n2Ui");
class $3e604b06127147b5$var$LabelPicker extends $fc4bM.PureComponent {
    render() {
        const { portalId: portalId, requestTypeId: requestTypeId, ...props } = this.props;
        return /*#__PURE__*/ $fc4bM.createElement((0, $eecfC.default), {
            ...props,
            loadOptions: this.loadOptions,
            validationErrorMessage: this.state.validationErrorMessage
        });
    }
    constructor(...args){
        super(...args), this.state = {
            validationErrorMessage: undefined
        }, this.isValidQuery = (inputValue)=>!/\s+/.test(inputValue), this.fetchLabels = (inputValue, callback)=>{
            const { intl: intl } = this.props;
            if (this.isValidQuery(inputValue)) {
                const { portalId: portalId, requestTypeId: requestTypeId, customFieldId: customFieldId } = this.props;
                return (0, $9Y7QD.searchLabel)({
                    portalId: portalId,
                    requestTypeId: requestTypeId,
                    customFieldId: customFieldId,
                    query: inputValue
                }).map((response)=>{
                    this.setState({
                        validationErrorMessage: undefined
                    });
                    return response.map((label)=>({
                            label: label,
                            value: label
                        }));
                }).catch((errors)=>{
                    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                    if (errors.status === 400) {
                        // Suppressing existing violation. Please fix this.
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                        this.setState({
                            validationErrorMessage: errors.response.errors[0].errorMessage
                        });
                        return (0, $4Q7yw.Observable).empty();
                    }
                    return (0, $4Q7yw.Observable).throw(errors);
                }).toPromise().then(callback);
            }
            this.setState({
                validationErrorMessage: intl.formatMessage((0, $8n2Ui.default).inputValidationErrorMessage, {
                    labelInput: inputValue
                })
            });
            return (0, $4Q7yw.Observable).empty();
        }, this.fetchLabelDebounced = (0, $aYMdQ.debounce)(this.fetchLabels, (0, $9mazR.USER_TYPING_DEBOUNCE_TIME)), this.loadOptions = (input, callback)=>{
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.fetchLabelDebounced(input, callback);
        };
    }
}
var $3e604b06127147b5$export$2e2bcd8739ae039 = (0, $fcCIH.default)($3e604b06127147b5$var$LabelPicker);

});
parcelRegister("9Y7QD", function(module, exports) {
$parcel$export(module.exports, "searchLabel", () => $8b7f34fd7f4f236a$export$f7d9887e8d9170ea);

var $bTjsX = parcelRequire("bTjsX");

var $jFk35 = parcelRequire("jFk35");

var $6dipk = parcelRequire("6dipk");

var $aIVqJ = parcelRequire("aIVqJ");

var $diqlM = parcelRequire("diqlM");
const $8b7f34fd7f4f236a$export$f7d9887e8d9170ea = (labelQuery)=>{
    let query = {
        query: labelQuery.query
    };
    if (labelQuery.customFieldId) query = {
        ...query,
        customFieldId: labelQuery.customFieldId
    };
    const queryString = $6dipk.stringify(query);
    const uri = `${(0, $diqlM.contextPath)}/rest/servicedesk/1/customer/portal/${labelQuery.portalId}/requestType/${labelQuery.requestTypeId}/labels/suggest?${queryString}`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.get)(uri).map((ajaxResponse)=>{
        const response = ajaxResponse.response;
        return response.suggestions.map((suggestion)=>suggestion.label);
    }).catch((e)=>{
        (0, $aIVqJ.trackError)('findlabel.fetch.failed', {}, e);
        return (0, $jFk35.Observable).throw(e);
    });
};

});

parcelRegister("2IdpX", function(module, exports) {
$parcel$export(module.exports, "LabelPickerDumb", () => (parcelRequire("eecfC")).default);

var $eecfC = parcelRequire("eecfC");

});
parcelRegister("eecfC", function(module, exports) {
$parcel$export(module.exports, "default", () => $8962943eb3733eba$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $cBmRF = parcelRequire("cBmRF");

var $6oof1 = parcelRequire("6oof1");
class $8962943eb3733eba$export$2e2bcd8739ae039 extends $fc4bM.PureComponent {
    componentDidMount() {
        // PORTAL-2032 - this is required to make url filling (e.g. ?customfield_10343=10657) work
        if (this.props.defaultLabels && this.props.defaultLabels.length > 0) this.onChange(this.props.defaultLabels);
    }
    render() {
        const { label: label, disabled: disabled, ...otherProps } = this.props;
        const errorMessage = this.props.validationErrorMessage ?? this.props.errorMessage;
        return /*#__PURE__*/ $fc4bM.createElement((0, $cBmRF.FormAsyncCreatableMultiSelect), {
            ...otherProps,
            actionSubjectId: "labelPickerField",
            label: label ?? '',
            isDisabled: disabled,
            onChange: this.onChange,
            loadOptions: this.props.loadOptions,
            defaultValue: this.state.selectedOption,
            isValidNewOption: this.isValidNewOption,
            errorMessage: errorMessage
        });
    }
    constructor(...args){
        super(...args), this.state = {
            selectedOption: this.props.defaultLabels
        }, this.isValidNewOption = (inputValue, _, existingLabels)=>{
            if (!!this.props.validationErrorMessage) return false;
            if (inputValue === '') return false;
            if (!Array.isArray(existingLabels)) return false;
            const isLabelAlreadyExisting = existingLabels.some((label)=>label.value === inputValue);
            return !isLabelAlreadyExisting;
        }, this.onChange = (value)=>{
            const { id: id, onChange: onChange } = this.props;
            const selectedValue = (0, $6oof1.toMultiSelectValue)(value);
            // The labels field requires that you pass the a value in the create request
            // lest Jira applies the default labels to it.
            const val = selectedValue.length !== 0 ? selectedValue.map((v)=>v.value) : '';
            onChange === null || onChange === void 0 || onChange(id, val, false, {
                rawObject: {},
                rawValue: selectedValue
            });
        };
    }
}

});


parcelRegister("8n2Ui", function(module, exports) {
$parcel$export(module.exports, "default", () => $16c464fc6f906cbc$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $16c464fc6f906cbc$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    inputValidationErrorMessage: {
        defaultMessage: `The label \u2019{labelInput}\u2019 can't contain spaces`,
        description: 'Request form labels input error validation messages',
        id: 'sd.customerview.field.labels.error.validation'
    }
});

});



parcelRegister("ck5CW", function(module, exports) {
$parcel$export(module.exports, "MultiSelectField", () => (parcelRequire("iQR8K")).default);
/** This is the single select form component type  */ 
var $iQR8K = parcelRequire("iQR8K");

});
parcelRegister("iQR8K", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2cc28f665b5ce5b$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $cBmRF = parcelRequire("cBmRF");

var $6oof1 = parcelRequire("6oof1");
class $b2cc28f665b5ce5b$var$MultiFieldSelect extends $fc4bM.PureComponent {
    componentDidMount() {
        // PORTAL-2032 - this is required to make url filling (e.g. ?customfield_10343=10657) work
        if (this.props.defaultValue && this.props.defaultValue.length > 0) this.onChange(this.props.defaultValue);
    }
    render() {
        const { disabled: disabled, ...otherProps } = this.props;
        return /*#__PURE__*/ $fc4bM.createElement((0, $cBmRF.FormMultiSelect), {
            ...otherProps,
            actionSubjectId: "multiSelectField",
            onChange: this.onChange,
            isDisabled: disabled
        });
    }
    constructor(...args){
        super(...args), this.onChange = (options, meta)=>{
            const selectedOptions = (0, $6oof1.toMultiSelectValue)(options);
            // The multiselect field requires that you pass a value in the create request
            // lest Jira applies the default options to it.
            const val = selectedOptions.length !== 0 ? selectedOptions.map((v)=>v.value) : '';
            this.props.onChange && this.props.onChange(this.props.id, val, false, {
                rawObject: meta ?? {},
                rawValue: options
            });
        };
    }
}
var $b2cc28f665b5ce5b$export$2e2bcd8739ae039 = $b2cc28f665b5ce5b$var$MultiFieldSelect;

});


parcelRegister("7nzE8", function(module, exports) {
$parcel$export(module.exports, "MultiServicePicker", () => (parcelRequire("ak5IU")).default);

var $ak5IU = parcelRequire("ak5IU");

});
parcelRegister("ak5IU", function(module, exports) {
$parcel$export(module.exports, "default", () => $2661a61b5ecaeb55$export$2e2bcd8739ae039);

var $9XZeF = parcelRequire("9XZeF");

var $5kfOu = parcelRequire("5kfOu");

var $liCNL = parcelRequire("liCNL");
var $2661a61b5ecaeb55$export$2e2bcd8739ae039 = (0, $9XZeF.connect)(null, {
    showErrorFlag: $5kfOu.showErrorFlag
})((0, $liCNL.default));

});
parcelRegister("liCNL", function(module, exports) {
$parcel$export(module.exports, "default", () => $59b9ce05150a9772$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $iya1I = parcelRequire("iya1I");

var $cBmRF = parcelRequire("cBmRF");

var $hN5YJ = parcelRequire("hN5YJ");

var $fcCIH = parcelRequire("fcCIH");

var $6oof1 = parcelRequire("6oof1");

var $ceVxk = parcelRequire("ceVxk");
parcelRequire("4M8UA");
var $807mG = parcelRequire("807mG");
const $59b9ce05150a9772$var$MultiServicePicker = (props)=>{
    const { disabled: disabled, onChange: onChange, intl: intl, defaultServices: defaultServices, value: value, ...otherProps } = props;
    const { useCallback: useCallback, useEffect: useEffect, useRef: useRef, useState: useState } = $fc4bM;
    const noOptionsMessage = useCallback(()=>{
        return intl.formatMessage((0, $ceVxk.default).noOptions);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { options: options, fetchMoreOptions: fetchMoreOptions, ...paginatedMultiSelectProps } = (0, $807mG.usePaginatedServiceOptions)(props.showErrorFlag);
    const [hasAppliedDefaults, setHasAppliedDefaults] = useState(false);
    const optionsCacheRef = useRef(new Map());
    // Keep the cache up-to-date whenever a new page of options arrives.
    useEffect(()=>{
        if ((0, $hN5YJ.isJsmPortalRovoIntegrationEnabled)()) options.forEach((option)=>{
            optionsCacheRef.current.set(option.value, option);
        });
    }, [
        options
    ]);
    const onChangeForMultiSelect = useCallback((opts)=>{
        const multiSelectValue = (0, $6oof1.toMultiSelectValue)(opts);
        onChange === null || onChange === void 0 || onChange(props.id, multiSelectValue.map((v)=>v.value));
        // search again if all the options have been selected
        if (multiSelectValue.length === options.length) fetchMoreOptions();
    }, // oxlint-disable-next-line react-hooks/exhaustive-deps
    [
        onChange,
        options.length
    ]);
    // When the Rovo integration flag is on, services are loaded, and defaultServices is provided,
    // select them as an initial pre-fill. This only runs once (guarded by hasAppliedDefaults).
    useEffect(()=>{
        if ((0, $hN5YJ.isJsmPortalRovoIntegrationEnabled)() && defaultServices && defaultServices.length > 0 && options.length > 0 && !hasAppliedDefaults) {
            const selectedOptions = options.filter((option)=>defaultServices.includes(option.value) || defaultServices.includes(option.label));
            if (selectedOptions.length > 0) {
                setHasAppliedDefaults(true);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                onChangeForMultiSelect(selectedOptions);
            }
        }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        defaultServices,
        options.length,
        onChangeForMultiSelect,
        hasAppliedDefaults
    ]);
    const displayValue = (0, $hN5YJ.isJsmPortalRovoIntegrationEnabled)() && value && Array.isArray(value) && value.length > 0 ? value.reduce((acc, id)=>{
        const cached = optionsCacheRef.current.get(id);
        if (cached) acc.push(cached);
        return acc;
    }, []) : undefined;
    return /*#__PURE__*/ $fc4bM.createElement((0, $cBmRF.FormMultiSelect), {
        ...otherProps,
        ...paginatedMultiSelectProps,
        actionSubjectId: "multiServicePickerField",
        placeholder: intl.formatMessage((0, $ceVxk.default).searchPlaceholder),
        noOptionsMessage: noOptionsMessage,
        isDisabled: disabled,
        onMenuScrollToBottom: fetchMoreOptions,
        options: options,
        onChange: onChangeForMultiSelect,
        value: displayValue
    });
};
const $59b9ce05150a9772$var$WithErrorBoundary = (props)=>/*#__PURE__*/ $fc4bM.createElement((0, $iya1I.default), {
        id: "multi-service-picker",
        packageName: "portal_fields"
    }, /*#__PURE__*/ $fc4bM.createElement($59b9ce05150a9772$var$MultiServicePicker, props));
var $59b9ce05150a9772$export$2e2bcd8739ae039 = (0, $fcCIH.default)($59b9ce05150a9772$var$WithErrorBoundary);

});
parcelRegister("ceVxk", function(module, exports) {
$parcel$export(module.exports, "default", () => $050397b22d20241e$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $050397b22d20241e$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    searchPlaceholder: {
        defaultMessage: 'Search for services',
        description: 'Placeholder for service picker field to advise the user to search for services',
        id: 'cv.request.create.form.multiservicepickerv2.search'
    },
    noOptions: {
        defaultMessage: 'No options',
        description: 'Text that appears in the dropdown for the service picker if there are no services to select',
        id: 'cv.request.create.form.multiservicepickerv2.no.options'
    }
});

});

parcelRegister("4M8UA", function(module, exports) {
$parcel$export(module.exports, "usePaginatedServiceOptions", () => (parcelRequire("807mG")).usePaginatedServiceOptions);

var $807mG = parcelRequire("807mG");

});
parcelRegister("807mG", function(module, exports) {
$parcel$export(module.exports, "usePaginatedServiceOptions", () => $4f68b9d656107817$export$48b464c13bc5007a);

var $fc4bM = parcelRequire("fc4bM");

var $53bjB = parcelRequire("53bjB");

var $9JVIU = parcelRequire("9JVIU");

var $4MjGQ = parcelRequire("4MjGQ");

var $7wx9B = parcelRequire("7wx9B");

var $eMH6M = parcelRequire("eMH6M");
// TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
var $4f68b9d656107817$var$Action = /*#__PURE__*/ function(Action) {
    Action[Action["Append"] = 0] = "Append";
    Action[Action["Replace"] = 1] = "Replace";
    return Action;
}($4f68b9d656107817$var$Action || {});
const $4f68b9d656107817$export$13990ad4625571ed = (action)=>{
    (0, $4MjGQ.operationalEvent)({
        action: action,
        actionSubject: 'portalFetchServices',
        source: 'multiServicePicker'
    });
};
const $4f68b9d656107817$export$48b464c13bc5007a = (showError)=>{
    const [options, setOptions] = (0, $fc4bM.useState)([]);
    const cursor = (0, $fc4bM.useRef)(null); // The end cursor/page number for the current search result
    const hasNextPage = (0, $fc4bM.useRef)(false); // Whether there are more options to load from fetchSearvices
    const prevSearchValue = (0, $fc4bM.useRef)(''); // The latest input value we entered in the search
    const [isLoading, setIsLoading] = (0, $fc4bM.useState)(false);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    const searchServices = async (inputValue, action)=>{
        // Don't search if doesn't have next page
        if (!hasNextPage.current && action === 0) return;
        setIsLoading(true);
        // Remove the cursor so that we could start search from first page. Set hasNextPage to true to ensure we are always searching
        if (action === 1) cursor.current = null;
        prevSearchValue.current = inputValue;
        try {
            const { services: services, endCursor: endCursor, hasNextPage: hasMorePage } = await (0, $9JVIU.fetchServices)(inputValue, cursor.current);
            cursor.current = endCursor;
            hasNextPage.current = hasMorePage;
            if (action === 1) setOptions(services);
            else if (action === 0) setOptions((prevOptions)=>[
                    ...prevOptions,
                    ...services
                ]);
            $4f68b9d656107817$export$13990ad4625571ed((0, $4MjGQ.AnalyticsTrackActions).FETCHED);
        } catch (err) {
            (0, $7wx9B.reportError)(err);
            $4f68b9d656107817$export$13990ad4625571ed((0, $4MjGQ.AnalyticsTrackActions).FETCHED_FAILURE);
            showError((0, $eMH6M.default).errorTitle, (0, $eMH6M.default).errorDescription);
            // We only remove all the available options if we need to replace. Otherwise, we still maintain previous options
            if (action === 1) setOptions([]);
            hasNextPage.current = false;
        } finally{
            setIsLoading(false);
        }
    };
    // Initial search
    (0, $fc4bM.useEffect)(()=>{
        // Disabling existing violations, should be fixed when revisited.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        searchServices(prevSearchValue.current, 1);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Search when user types input value in the search field
    const onInputChange = (0, $fc4bM.useCallback)((inputValue)=>{
        if (inputValue !== prevSearchValue.current) // Disabling existing violations, should be fixed when revisited.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        searchServices(inputValue, 1);
    }, [
        searchServices
    ]);
    const debouncedOnInputChange = (0, $fc4bM.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($53bjB)))(onInputChange, 100));
    // Search when user scrolls to bottom of the scroll menu or when all the available options have been selected
    const fetchMoreOptions = (0, $fc4bM.useCallback)(()=>{
        // Disabling existing violations, should be fixed when revisited.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        searchServices(prevSearchValue.current, 0);
    }, [
        searchServices
    ]);
    return {
        isLoading: isLoading,
        options: options,
        fetchMoreOptions: fetchMoreOptions,
        onInputChange: debouncedOnInputChange.current
    };
};

});
parcelRegister("eMH6M", function(module, exports) {
$parcel$export(module.exports, "default", () => $c325d4c030534296$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $c325d4c030534296$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    errorTitle: {
        defaultMessage: 'Error',
        description: 'Title of the error panel shown when a request types post has failed.',
        id: 'cv.request.create.form.multiservicepickerv2.usepaginatedservice.error.title'
    },
    errorDescription: {
        defaultMessage: "We couldn't load the affected services. Refresh the page and try again.",
        description: 'Description of the error panel shown when an affected services fetch has failed.',
        id: 'cv.request.create.form.multiservicepickerv2.usepaginatedservice.error.description'
    }
});

});






parcelRegister("42ctQ", function(module, exports) {
$parcel$export(module.exports, "MultiUserPicker", () => (parcelRequire("6fJnq")).default);

var $6fJnq = parcelRequire("6fJnq");

});
parcelRegister("6fJnq", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a3b6ccc9e83ca2f$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $aYMdQ = parcelRequire("aYMdQ");

var $keYO2 = parcelRequire("keYO2");
parcelRequire("10zyG");
var $1PKlH = parcelRequire("1PKlH");
class $5a3b6ccc9e83ca2f$export$2e2bcd8739ae039 extends $fc4bM.PureComponent {
    render() {
        const { portalId: portalId, canAddUserByEmailAddress: canAddUserByEmailAddress, ...props } = this.props;
        return /*#__PURE__*/ $fc4bM.createElement((0, $1PKlH.default), {
            ...props,
            loadOptions: this.loadOptions,
            doInitialSearch: true,
            canAddUserByEmailAddress: canAddUserByEmailAddress
        });
    }
    constructor(...args){
        super(...args), this.loadOptions = (inputValue, callback)=>{
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.fetchUserDebounced(inputValue, callback);
        }, this.fetchUsers = (inputValue, callback)=>{
            return (0, $keYO2.searchUser)({
                fieldName: this.props.id,
                query: inputValue,
                portalId: this.props.portalId,
                fieldConfigId: this.props.fieldConfigId
            }).map((response)=>response.map((user)=>({
                        value: user.id,
                        label: user.displayName,
                        iconUrl: user.avatar,
                        email: user.emailAddress
                    }))).toPromise().then(callback);
        }, this.fetchUserDebounced = (0, $aYMdQ.debounce)(this.fetchUsers, 400);
    }
}

});
parcelRegister("10zyG", function(module, exports) {
$parcel$export(module.exports, "MultiUserPickerDumb", () => (parcelRequire("1PKlH")).default);

var $1PKlH = parcelRequire("1PKlH");

});
parcelRegister("1PKlH", function(module, exports) {
$parcel$export(module.exports, "default", () => $809ded65e83616f1$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $2KIJl = parcelRequire("2KIJl");

var $cBmRF = parcelRequire("cBmRF");

var $fcCIH = parcelRequire("fcCIH");

var $cF33t = parcelRequire("cF33t");
parcelRequire("52Uk2");
var $iaVgA = parcelRequire("iaVgA");
parcelRequire("fAfqE");
var $ibiSw = parcelRequire("ibiSw");

var $6oof1 = parcelRequire("6oof1");

var $2WN7H = parcelRequire("2WN7H");
class $809ded65e83616f1$export$f9898dcf377cfa81 extends $fc4bM.Component {
    render() {
        const { disabled: disabled, canAddUserByEmailAddress: canAddUserByEmailAddress, defaultUsers: defaultUsers, doInitialSearch: doInitialSearch, intl: intl, onChange: onChange, ...otherProps } = this.props;
        if (canAddUserByEmailAddress) return /*#__PURE__*/ $fc4bM.createElement((0, $cBmRF.FormAsyncCreatableMultiSelect), {
            ...otherProps,
            actionSubjectId: "multiUserPickerField",
            formatOptionLabel: this.formatOptionLabel,
            formatCreateLabel: this.formatCreateLabel,
            isDisabled: disabled,
            isValidNewOption: this.isValidNewOption,
            onChange: this.onChangeForMultiSelect,
            defaultValue: defaultUsers,
            defaultOptions: doInitialSearch,
            noOptionsMessage: this.getNoOptionsCreatable,
            placeholder: intl.formatMessage((0, $cF33t.default).placeholder)
        });
        return /*#__PURE__*/ $fc4bM.createElement((0, $cBmRF.FormAsyncMultiSelect), {
            ...otherProps,
            actionSubjectId: "multiUserPickerField",
            formatOptionLabel: this.formatOptionLabel,
            isDisabled: disabled,
            onChange: this.onChangeForMultiSelect,
            defaultValue: defaultUsers,
            defaultOptions: doInitialSearch,
            placeholder: intl.formatMessage((0, $cF33t.default).placeholder),
            noOptionsMessage: this.getNoOptions
        });
    }
    constructor(...args){
        super(...args), this.onChangeForMultiSelect = (options)=>{
            var _this$props$onChange, _this$props;
            (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, this.props.id, (0, $6oof1.toMultiSelectValue)(options).map((v)=>v.value).join(','));
        }, this.formatOptionLabel = ({ iconUrl: iconUrl, label: label })=>{
            // Suppressing existing violation. Please fix this.
            return(// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            /*#__PURE__*/ $fc4bM.createElement((0, $ibiSw.default), {
                name: label,
                icon: iconUrl && /*#__PURE__*/ $fc4bM.createElement((0, $2KIJl.default), {
                    src: iconUrl
                })
            }));
        }, this.formatCreateLabel = (input)=>{
            const { intl: intl } = this.props;
            return intl.formatMessage((0, $2WN7H.default).addAction, {
                value: input
            });
        }, this.isValidNewOption = (inputValue, _, selectOptions)=>{
            // Check whether the input value already corresponds to one of the available option.
            // We check whether the email matches the input exactly otherwise we show the option to create
            const isInputValueAnOption = selectOptions && Array.isArray(selectOptions) && selectOptions.filter((option)=>option.email === inputValue).length > 0;
            return !isInputValueAnOption && (0, $iaVgA.isEmail)(inputValue);
        }, this.getNoOptionsCreatable = ()=>{
            const { intl: intl } = this.props;
            return intl.formatMessage((0, $cF33t.default).noOptionsCreatable);
        }, this.getNoOptions = ()=>{
            const { intl: intl } = this.props;
            return intl.formatMessage((0, $cF33t.default).noOptions);
        };
    }
}
var $809ded65e83616f1$export$2e2bcd8739ae039 = (0, $fcCIH.default)($809ded65e83616f1$export$f9898dcf377cfa81);

});
parcelRegister("cF33t", function(module, exports) {
$parcel$export(module.exports, "default", () => $99b93d33b1c923d5$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $99b93d33b1c923d5$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    createAction: {
        defaultMessage: 'Create "{value}"',
        description: 'Action shown to users when they have the option to create a new user',
        id: 'cv.user.picker.create.action'
    },
    addAction: {
        defaultMessage: 'Add "{value}"',
        description: 'Action shown to users when they have the option to add a existing user',
        id: 'cv.user.picker.add.action'
    },
    placeholder: {
        defaultMessage: 'Enter name or email...',
        description: 'Placeholder shown for a user to enter a name or email.',
        id: 'cv.user.picker.placeholder'
    },
    noOptionsCreatable: {
        defaultMessage: 'Enter an email to add a user',
        description: 'Message shown to the user when no options were available and they have the option to add a new user.',
        id: 'cv.user.picker.no-options-creatable'
    },
    noOptions: {
        defaultMessage: 'No users found',
        description: 'Message shown to the user when no options were available',
        id: 'cv.user.picker.no-options'
    }
});

});

parcelRegister("fAfqE", function(module, exports) {
$parcel$export(module.exports, "UserPickerItem", () => (parcelRequire("ibiSw")).default);

var $ibiSw = parcelRequire("ibiSw");

});
parcelRegister("ibiSw", function(module, exports) {
$parcel$export(module.exports, "default", () => $16d3046c65c786e1$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $2KIJl = parcelRequire("2KIJl");

var $fd880 = parcelRequire("fd880");

var $4VBqm = parcelRequire("4VBqm");

var $euRd1 = parcelRequire("euRd1");

var $dQ1SX = parcelRequire("dQ1SX");
const $16d3046c65c786e1$var$UserPickerItem = ({ icon: icon, name: name, email: email, isNew: isNew })=>{
    const content = email ? `${name} (${email})` : name;
    const iconComponent = typeof icon === 'string' ? /*#__PURE__*/ $fc4bM.createElement((0, $2KIJl.default), {
        src: icon,
        alt: ""
    }) : icon;
    return /*#__PURE__*/ $fc4bM.createElement($16d3046c65c786e1$var$UserPickerItemSectionFlex, null, /*#__PURE__*/ $fc4bM.createElement($16d3046c65c786e1$var$FlexIconCardLayout, {
        leftIcon: iconComponent,
        content: content,
        iconSize: 16,
        iconMargin: 8,
        padding: 0
    }), isNew && /*#__PURE__*/ $fc4bM.createElement((0, $euRd1.default), {
        appearance: "discovery"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $dQ1SX.default).newUserLozengeText)));
};
var $16d3046c65c786e1$export$2e2bcd8739ae039 = $16d3046c65c786e1$var$UserPickerItem;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $16d3046c65c786e1$var$UserPickerItemSectionFlex = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1ugscvf-0"
})`display:inline-flex;align-items:baseline;gap:${"var(--ds-space-100, 8px)"};grid-area:1 / 1 / 2 / 3;`;
// Constrains the name/email layout so it shrinks instead of pushing the lozenge off-line.
// Applied directly on IconCardLayout (via its forwarded className) rather than a parent-scoped
// nested selector, per go/ui-styling-standard.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $16d3046c65c786e1$var$FlexIconCardLayout = /*#__PURE__*/ (0, $luz1X.default)((0, $4VBqm.IconCardLayout)).withConfig({
    componentId: "sc-1ugscvf-1"
})`flex:0 1 auto;width:auto;`;

});
parcelRegister("dQ1SX", function(module, exports) {
$parcel$export(module.exports, "default", () => $945fc1c8903e462c$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $945fc1c8903e462c$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    newUserLozengeText: {
        defaultMessage: 'New',
        description: 'Text for a status lozenge that shows next to users that will be newly created',
        id: 'cv.request.create.form.user.picker.new.user'
    }
});

});



parcelRegister("2WN7H", function(module, exports) {
$parcel$export(module.exports, "default", () => $60733d047e01c24b$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $60733d047e01c24b$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    addAction: {
        defaultMessage: 'Add "{value}"',
        description: 'Action shown to users when they have the option to add a option',
        id: 'cv.multi.user.picker.add.action'
    }
});

});





parcelRegister("6lWzO", function(module, exports) {
$parcel$export(module.exports, "OrganisationPicker", () => (parcelRequire("eKHFe")).default);

var $eKHFe = parcelRequire("eKHFe");

});
parcelRegister("eKHFe", function(module, exports) {
$parcel$export(module.exports, "default", () => $62b08070b5a14fa3$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $9XZeF = parcelRequire("9XZeF");

var $4Q7yw = parcelRequire("4Q7yw");

var $2n2bS = parcelRequire("2n2bS");

var $gfySN = parcelRequire("gfySN");

var $aSveF = parcelRequire("aSveF");

var $1xUIS = parcelRequire("1xUIS");

var $6oof1 = parcelRequire("6oof1");
parcelRequire("7dbwd");
var $9fQm0 = parcelRequire("9fQm0");

var $42IAj = parcelRequire("42IAj");
class $62b08070b5a14fa3$export$ab2356e6e0b865c4 extends $fc4bM.PureComponent {
    static #_ = this.defaultProps = {
        organisations: []
    };
    componentDidMount() {
        const { organisations: organisations, enableSubmitButton: enableSubmitButton, defaultOrganisation: defaultOrganisation } = this.props;
        if (organisations) this.updateValue(organisations, true, defaultOrganisation);
        this.reporterChangesSub = this.reporterChanges.switchMap(({ projectId: projectId, organisationUserEmail: organisationUserEmail })=>{
            const { isNewReporter: isNewReporter } = this.props;
            if (isNewReporter) return (0, $4Q7yw.Observable).of([]);
            return (0, $gfySN.fetchOrganisations)(projectId, organisationUserEmail)// If can error happens we'll just return an empty array so the stream stays subscribed.
            .catch((_)=>(0, $4Q7yw.Observable).of([]));
        }).subscribe((updatedOrganisations)=>{
            enableSubmitButton();
            this.setState({
                organisations: updatedOrganisations,
                isLoading: false
            });
            this.updateValue(updatedOrganisations, true, defaultOrganisation);
        }, ()=>{
            enableSubmitButton();
            this.setState({
                organisations: undefined,
                isLoading: false
            });
        });
    }
    componentWillUnmount() {
        this.reporterChangesSub.unsubscribe();
    }
    componentDidUpdate(prevProps) {
        const { projectId: projectId, organisationUserEmail: organisationUserEmail, disableSubmitButton: disableSubmitButton } = this.props;
        const reporterUpdated = prevProps.organisationUserEmail !== organisationUserEmail;
        if (reporterUpdated && projectId) {
            disableSubmitButton();
            this.setState({
                isLoading: true
            });
            this.reporterChanges.next({
                projectId: projectId,
                organisationUserEmail: organisationUserEmail
            });
        }
    }
    // In the case where we have a single organisation, we want to select that as the default
    // otherwise it should be a Private request by default
    updateValue(organisations, notFromUserInteraction, defaultOrganisation) {
        // If a default organisation is provided via URL params, select it first
        if (defaultOrganisation) {
            const selected = {
                label: defaultOrganisation.name,
                value: String(defaultOrganisation.id)
            };
            this.setState({
                selectedOrganisation: selected
            });
            this.onChange(selected, notFromUserInteraction);
            return;
        }
        if (organisations.length === 1 && this.props.shareWithOrgByDefault) {
            const [defaultOrg] = organisations;
            const selected = {
                label: defaultOrg.name,
                value: String(defaultOrg.id)
            };
            this.setState({
                selectedOrganisation: selected
            });
            this.onChange(selected, notFromUserInteraction);
        } else {
            const privateRequest = {
                label: (0, $42IAj.default).privateRequest.defaultMessage,
                value: ''
            };
            // @ts-ignore TS(2322) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Type '{ label: string | undefined; value: string; ... Remove this comment to see the full error message
            this.setState({
                selectedOrganisation: privateRequest
            });
            // @ts-ignore TS(2345) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Argument of type '{ label: string | undefined; val... Remove this comment to see the full error message
            this.onChange(privateRequest, notFromUserInteraction);
        }
    }
    render() {
        const { organisations: organisations, isLoading: isLoading, selectedOrganisation: selectedOrganisation } = this.state;
        const { description: description, id: id, disabled: disabled } = this.props;
        if (!organisations || !organisations.length) return null;
        return /*#__PURE__*/ $fc4bM.createElement((0, $9fQm0.default), {
            id: id,
            organisations: organisations,
            description: description,
            selected: selectedOrganisation,
            onSelectOrg: this.onChange,
            isLoading: isLoading,
            isDisabled: isLoading || disabled
        });
    }
    constructor(...args){
        super(...args), this.state = {
            organisations: this.props.organisations,
            defaultUser: this.props.organisationUserEmail,
            selectedOrganisation: undefined,
            isLoading: false
        }, this.reporterChanges = new (0, $aSveF.Subject)(), // notFromUserInteraction here is to mark the change event as being not the result of
        // a user interaction but rather a side effect of something else. This is primarily used for
        // analytics at the moment
        this.onChange = (value, notFromUserInteraction)=>{
            var _this$props$onChange, _this$props;
            const organisation = (0, $6oof1.toSingleSelectValue)(value);
            if (organisation == null) return;
            this.setState({
                selectedOrganisation: organisation
            });
            (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, this.props.id, String(organisation.value), notFromUserInteraction);
        };
    }
}
const $62b08070b5a14fa3$var$selector = (0, $2n2bS.createSelector)((state, props)=>{
    const organisations = (0, $1xUIS.getOrganisationsForCurrentUser)(state, props.portalId, props.requestTypeId);
    return {
        organisations: organisations
    };
}, (organisationData)=>organisationData);
var $62b08070b5a14fa3$export$2e2bcd8739ae039 = (0, $9XZeF.connect)($62b08070b5a14fa3$var$selector)($62b08070b5a14fa3$export$ab2356e6e0b865c4);

});
parcelRegister("gfySN", function(module, exports) {
$parcel$export(module.exports, "fetchOrganisations", () => $beba5bd1108f8f90$export$7703463d715b54c6);

var $bTjsX = parcelRequire("bTjsX");

var $jFk35 = parcelRequire("jFk35");

var $aIVqJ = parcelRequire("aIVqJ");

var $diqlM = parcelRequire("diqlM");
const $beba5bd1108f8f90$export$7703463d715b54c6 = (projectId, reporter, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/organisations/project/${projectId}/member/account/${reporter}`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.get)(uri)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        (0, $aIVqJ.trackError)('organisation.fetch.failed', {}, e);
        // Rethrow error
        return (0, $jFk35.Observable).throw(e);
    });
};

});

parcelRegister("7dbwd", function(module, exports) {
$parcel$export(module.exports, "OrganisationPickerDumb", () => (parcelRequire("9fQm0")).default);

var $9fQm0 = parcelRequire("9fQm0");

});
parcelRegister("9fQm0", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ae2c5321b6b99d4$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $6v10u = parcelRequire("6v10u");

var $fOCtI = parcelRequire("fOCtI");

var $fd880 = parcelRequire("fd880");
var $fcCIH = parcelRequire("fcCIH");

var $jTWWA = parcelRequire("jTWWA");

var $dqriH = parcelRequire("dqriH");

var $42IAj = parcelRequire("42IAj");
const $2ae2c5321b6b99d4$var$privateOption = ()=>/*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement($2ae2c5321b6b99d4$var$IconWrap, null, /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jTWWA))), {
        label: "lock-icon"
    })), /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $42IAj.default).privateRequest));
const $2ae2c5321b6b99d4$var$organisationOption = (orgName)=>/*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement($2ae2c5321b6b99d4$var$IconWrap, null, /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dqriH))), {
        label: "unlocked-icon"
    })), /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), {
        ...(0, $42IAj.default).shareWith,
        values: {
            orgName: orgName
        }
    }));
const $2ae2c5321b6b99d4$var$renderOption = (option)=>{
    if (!option.value) return $2ae2c5321b6b99d4$var$privateOption();
    return $2ae2c5321b6b99d4$var$organisationOption(option.label);
};
const $2ae2c5321b6b99d4$var$createOption = (org)=>({
        label: org.name,
        value: String(org.id)
    });
const $2ae2c5321b6b99d4$export$5f131c02b6b3718d = (props)=>{
    const { organisations: organisations, description: description, selected: selected, isLoading: isLoading, isDisabled: isDisabled, onSelectOrg: onSelectOrg, id: id, intl: intl } = props;
    const label = intl.formatMessage((0, $42IAj.default).shareWithLabel);
    const options = [
        ...organisations.map($2ae2c5321b6b99d4$var$createOption),
        {
            label: intl.formatMessage((0, $42IAj.default).privateRequest),
            value: ''
        }
    ];
    return /*#__PURE__*/ $fc4bM.createElement($2ae2c5321b6b99d4$export$ab2356e6e0b865c4, {
        id: id,
        required: true,
        label: label,
        description: description,
        options: options,
        value: selected,
        formatOptionLabel: $2ae2c5321b6b99d4$var$renderOption,
        onChange: onSelectOrg,
        isLoading: isLoading,
        isDisabled: isLoading || isDisabled,
        backspaceRemovesValue: false
    });
};
var $2ae2c5321b6b99d4$export$2e2bcd8739ae039 = (0, $fcCIH.default)($2ae2c5321b6b99d4$export$5f131c02b6b3718d);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $2ae2c5321b6b99d4$var$IconWrap = /*#__PURE__*/ (0, $luz1X.default).span.withConfig({
    componentId: "sc-1wc1gcr-0"
})`margin-right:${"var(--ds-space-050, 4px)"};`;
const $2ae2c5321b6b99d4$export$ab2356e6e0b865c4 = /*#__PURE__*/ (0, $luz1X.default)((0, $6v10u.FieldSingleSelect)).withConfig({
    componentId: "sc-1wc1gcr-1"
})`display:inline-block;min-width:${$fOCtI.multiple(30).px};`;

});
parcelRegister("42IAj", function(module, exports) {
$parcel$export(module.exports, "default", () => $453e69ac681b6ed0$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $453e69ac681b6ed0$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    shareWith: {
        defaultMessage: 'Share with {orgName}',
        description: 'Label descibing the organisation the user is sharing their request with',
        id: 'cv.request.create.form.organisation.picker'
    },
    privateRequest: {
        defaultMessage: 'No one',
        description: 'Label indicating the user is making a private request',
        id: 'cv.request.create.form.organisation.picker.private'
    },
    shareWithLabel: {
        defaultMessage: 'Share with',
        description: 'Organisation picker field label',
        id: 'cv.request-create-form.organisation.picker.shareWithLabel'
    }
});

});





parcelRegister("fgllb", function(module, exports) {
$parcel$export(module.exports, "RadioGroup", () => (parcelRequire("d1cEw")).default);
$parcel$export(module.exports, "ControlledRadioGroup", () => (parcelRequire("d1cEw")).ControlledRadioGroup);

var $d1cEw = parcelRequire("d1cEw");

});
parcelRegister("d1cEw", function(module, exports) {
$parcel$export(module.exports, "ControlledRadioGroup", () => $0d5ff3009806482a$export$8053f6ba79274831);
$parcel$export(module.exports, "default", () => $0d5ff3009806482a$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $fcCIH = parcelRequire("fcCIH");

var $ch1yB = parcelRequire("ch1yB");

var $lAcXL = parcelRequire("lAcXL");

var $9Zxa0 = parcelRequire("9Zxa0");

var $16Uqd = parcelRequire("16Uqd");

var $ga1DS = parcelRequire("ga1DS");

var $6wHv6 = parcelRequire("6wHv6");

var $6XW18 = parcelRequire("6XW18");
const $0d5ff3009806482a$var$NONE_OPTION_VALUE = '-1';
class $0d5ff3009806482a$var$RadioGroup extends $fc4bM.PureComponent {
    render() {
        const { required: required, label: label, id: id, description: description, defaultValue: defaultValue, value: value, errorMessage: errorMessage, disabled: disabled, intl: intl, items: items = [] } = this.props;
        const radioItems = items.map((item)=>{
            return {
                label: item.label,
                name: item.name,
                value: item.value,
                isDisabled: disabled
            };
        });
        if (!required) radioItems.push({
            label: intl.formatMessage((0, $ga1DS.default).noneOptionLabel),
            name: id,
            value: $0d5ff3009806482a$var$NONE_OPTION_VALUE,
            isDisabled: disabled
        });
        return /*#__PURE__*/ $fc4bM.createElement((0, $ch1yB.FieldBase), {
            htmlFor: id,
            noLabel: true,
            required: required,
            description: description,
            label: label,
            labelId: `label-${id}`,
            errorMessage: errorMessage
        }, /*#__PURE__*/ $fc4bM.createElement((0, $lAcXL.Fieldset), {
            legend: /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, label, required && /*#__PURE__*/ $fc4bM.createElement((0, $9Zxa0.RequiredAsterisk), null))
        }, /*#__PURE__*/ $fc4bM.createElement($0d5ff3009806482a$var$RadioGroupWrapper, null, /*#__PURE__*/ $fc4bM.createElement((0, $16Uqd.default), {
            isRequired: required,
            options: radioItems,
            onChange: this.onChange,
            ...value === undefined ? {
                defaultValue: defaultValue
            } : {
                value: value
            },
            "aria-describedby": `${id}-field-description`
        }))));
    }
    constructor(...args){
        super(...args), this.onChange = (e)=>{
            if (!this.props.onChange) return;
            if (this.props.value !== undefined) {
                var _this$props$items;
                const selectedItem = (_this$props$items = this.props.items) === null || _this$props$items === void 0 ? void 0 : _this$props$items.find((item)=>item.value === e.target.value);
                this.props.onChange(this.props.id, e.target.value, false, {
                    rawObject: selectedItem ?? {},
                    rawValue: selectedItem ?? null
                });
                return;
            }
            this.props.onChange(this.props.id, e.target.value);
        };
    }
}
const $0d5ff3009806482a$var$IntlRadioGroup = (0, $fcCIH.default)($0d5ff3009806482a$var$RadioGroup);
const $0d5ff3009806482a$export$8053f6ba79274831 = (0, $6wHv6.withControlledFormComponentValue)((_field, value)=>value, (0, $6XW18.normalizeRadioButtonsValue))($0d5ff3009806482a$var$IntlRadioGroup);
var $0d5ff3009806482a$export$2e2bcd8739ae039 = $0d5ff3009806482a$var$IntlRadioGroup;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $0d5ff3009806482a$var$RadioGroupWrapper = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1smtcdf-0"
})`padding:${"var(--ds-space-075, 6px)"};`;

});
parcelRegister("lAcXL", function(module, exports) {
$parcel$export(module.exports, "Fieldset", () => $67c0d017d27f26d6$export$e154be390aa0e14);
/* fieldset.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $5zHWA = parcelRequire("5zHWA");
const $67c0d017d27f26d6$var$fieldSetStyles = null;
const $67c0d017d27f26d6$export$e154be390aa0e14 = ({ children: children, legend: legend })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsxs)("fieldset", {
        className: (0, $2R2iS.default)([
            "_1pfhu2gc"
        ]),
        children: [
            legend && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5zHWA.Legend), {
                children: legend
            }),
            children
        ]
    });
};

});
parcelRegister("5zHWA", function(module, exports) {
$parcel$export(module.exports, "Legend", () => $3091fa79044aadb6$export$ed247974535929c7);
/* legend.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $3091fa79044aadb6$var$fieldsetLabelStyles = null;
const $3091fa79044aadb6$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)("legend", {
        className: (0, $2R2iS.default)([
            "_11c8wadc _1e0c1o8l _syazazsu _k48pwu06 _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};

});


parcelRegister("16Uqd", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf1a7e87a5c699c3$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $9JZL9 = parcelRequire("9JZL9");

var $3zBNx = parcelRequire("3zBNx");

var $e8CgR = parcelRequire("e8CgR");
const $cf1a7e87a5c699c3$var$noOptions = [];
function $cf1a7e87a5c699c3$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, options: options = $cf1a7e87a5c699c3$var$noOptions, value: propValue, defaultValue: defaultValue, id: id, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, labelId: labelId, onInvalid: onInvalid = (0, $9JZL9.default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
    const uid = (0, $3zBNx.useId)();
    const [selectedValue, setSelectedValue] = (0, $fc4bM.useState)(propValue !== undefined ? propValue : defaultValue);
    const onRadioChange = (0, $fc4bM.useCallback)((e, analyticsEvent)=>{
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        role: "radiogroup",
        // TODO: Make `aria-labelledby` a `never` in TS. See https://product-fabric.atlassian.net/browse/DSP-23009
        "aria-labelledby": labelId || ariaLabelledBy,
        "data-testid": testId,
        "aria-describedby": isInvalid ? `${id || uid}-error` : undefined,
        id: id || uid,
        children: options.map(({ ...optionProps }, index)=>{
            if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
            const isChecked = value !== null && optionProps.value === value;
            return /*#__PURE__*/ (0, $fc4bM.createElement)((0, $e8CgR.default), {
                ...optionProps,
                name: name || optionProps.name,
                key: index,
                onChange: onRadioChange,
                onInvalid: onInvalid,
                isInvalid: isChecked && isInvalid,
                isChecked: isChecked,
                testId: optionProps.testId || testId,
                isRequired: isRequired,
                analyticsContext: analyticsContext
            });
        })
    });
}

});
parcelRegister("e8CgR", function(module, exports) {
$parcel$export(module.exports, "default", () => $23d09aa134463b9a$export$2e2bcd8739ae039);
/* radio.tsx generated by @compiled/babel-plugin v3.0.2 */ /// <reference types="node" />
// for typing `process`

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $7iKPB = parcelRequire("7iKPB");

var $9JZL9 = parcelRequire("9JZL9");

var $dRkX9 = parcelRequire("dRkX9");
const $23d09aa134463b9a$var$packageName = undefined;
const $23d09aa134463b9a$var$packageVersion = undefined;
const $23d09aa134463b9a$var$noop = (0, $9JZL9.default);
const $23d09aa134463b9a$var$labelPaddingStyles = null;
const $23d09aa134463b9a$var$labelStyles = null;
const $23d09aa134463b9a$var$labelDisabledStyles = null;
const $23d09aa134463b9a$var$radioBaseStyles = null;
const $23d09aa134463b9a$var$radioInteractiveStyles = null;
const $23d09aa134463b9a$var$radioDisabledStyles = null;
const $23d09aa134463b9a$var$radioDisabledCheckedStyles = null;
const $23d09aa134463b9a$var$radioInvalidStyles = null;
// Preserve the input's zoom correction and focus outline while cross-fading states.
// Preserve non-spatial transitions for reduced motion, per the LDR:
// https://hello.atlassian.net/wiki/spaces/DST/pages/7402790985
const $23d09aa134463b9a$var$crossFadeStyles = null;
const $23d09aa134463b9a$var$InnerRadio = /*#__PURE__*/ (0, $fc4bM.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, 'aria-labelledby': ariaLabelledBy, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, labelId: labelId, name: name, onChange: onChange = $23d09aa134463b9a$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $23d09aa134463b9a$var$packageName,
        packageVersion: $23d09aa134463b9a$var$packageVersion
    });
    return /*#__PURE__*/ (0, $3LM7S.jsxs)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $2R2iS.default)([
            "_11c8fhey _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazi7uo",
            isDisabled && "_syaz1gmx _80om13gf"
        ]),
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)("input", {
                ...rest,
                // It is necessary only for Safari. It allows to render focus styles.
                tabIndex: 0,
                "aria-label": ariaLabel,
                // TODO: Make `aria-labelledby` a `never` in TS. See https://product-fabric.atlassian.net/browse/DSP-23009
                "aria-labelledby": labelId || ariaLabelledBy,
                checked: isChecked,
                disabled: isDisabled,
                name: name,
                onChange: onChangeAnalytics,
                required: isRequired,
                type: "radio",
                value: value,
                "data-testid": testId && `${testId}--radio-input`,
                // isInvalid is used in a nonstandard way so cannot
                // use :invalid selector
                "data-invalid": isInvalid ? 'true' : undefined,
                ref: ref,
                className: (0, $2R2iS.default)([
                    "_18s8ze3t _19it3vzd _2rko1qll _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6q1j9a _1151rsbi _1s6w5w2r _tqbwidpf _t9ec1soj _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1qll _qc5orqeg _z0ai120g _1qdg120g _18postnw _aetrb3bt _1peq1xmd",
                    (0, $dRkX9.fg)('platform_design_system_selection_radial_fade') && "_v564109b _qc5o109b _s0npglyw _11fnglyw _1hdqglyw",
                    !isDisabled && "_iosijmqp _11jyjmqp _f3ett94y _y2mvdfik _1bg41l7b _6tjkdfik _awqn1l7b _1rvql4ek _1p9jrsbi _x2tz1q28 _1iwz1q28 _sj8yr01l _jcko12kk _1dvdrsbi _60ak5w2r",
                    isDisabled && "_80om13gf _1q6q187o _1151bk0g _1s6w2sac",
                    isDisabled && isChecked && "_tqbwt94y",
                    isInvalid && !isDisabled && "_1151s4qr _11jys4qr"
                ])
            }),
            label ? /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                className: (0, $2R2iS.default)([
                    "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
                ]),
                children: label
            }) : null
        ]
    });
});
/**
 * __Radio__
 *
 * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
 *
 * - [Examples](https://atlassian.design/components/radio/examples)
 * - [Code](https://atlassian.design/components/radio/code)
 * - [Usage](https://atlassian.design/components/radio/usage)
 */ const $23d09aa134463b9a$var$Radio = /*#__PURE__*/ (0, $fc4bM.memo)(/*#__PURE__*/ (0, $fc4bM.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)($23d09aa134463b9a$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $23d09aa134463b9a$export$2e2bcd8739ae039 = $23d09aa134463b9a$var$Radio;

});


parcelRegister("ga1DS", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9db29339886ff0f$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $e9db29339886ff0f$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    noneOptionLabel: {
        defaultMessage: 'None',
        description: 'Label for the radio group option to select no options.',
        id: 'sd.customerview.field.radio.group.none.option'
    }
});

});



parcelRegister("hr0iK", function(module, exports) {
$parcel$export(module.exports, "Reporter", () => (parcelRequire("1DirA")).default);

var $1DirA = parcelRequire("1DirA");

});
parcelRegister("1DirA", function(module, exports) {
$parcel$export(module.exports, "default", () => $8325ed087ce43805$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("gl25y");
var $bE4v0 = parcelRequire("bE4v0");
class $8325ed087ce43805$var$Reporter extends $fc4bM.PureComponent {
    render() {
        return /*#__PURE__*/ $fc4bM.createElement((0, $bE4v0.default), {
            ...this.props,
            defaultUser: this.props.defaultReporter,
            id: "reporter",
            required: true
        });
    }
}
var $8325ed087ce43805$export$2e2bcd8739ae039 = $8325ed087ce43805$var$Reporter;

});
parcelRegister("gl25y", function(module, exports) {
$parcel$export(module.exports, "UserPicker", () => (parcelRequire("bE4v0")).default);

var $bE4v0 = parcelRequire("bE4v0");

});
parcelRegister("bE4v0", function(module, exports) {
$parcel$export(module.exports, "default", () => $48ec495605d1c814$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $hN5YJ = parcelRequire("hN5YJ");

var $aYMdQ = parcelRequire("aYMdQ");

var $keYO2 = parcelRequire("keYO2");
parcelRequire("fT72v");
var $iFZxg = parcelRequire("iFZxg");
class $48ec495605d1c814$export$2e2bcd8739ae039 extends $fc4bM.PureComponent {
    render() {
        return /*#__PURE__*/ $fc4bM.createElement((0, $iFZxg.default), {
            ...this.props,
            loadOptions: this.loadOptions,
            ...this.isRequestCreateSkipDropdownInitialOptionsCallEnabled ? {
                onMenuOpen: this.handleMenuOpen,
                isLoading: this.state.isLoadingInitialOptions,
                defaultOptions: this.state.initialOptions
            } : {
                doInitialSearch: true
            }
        });
    }
    constructor(...args){
        super(...args), this.isRequestCreateSkipDropdownInitialOptionsCallEnabled = (0, $hN5YJ.isRequestCreateSkipDropdownInitialOptionsCallEnabled)(), this.state = {
            initialOptions: [],
            isLoadingInitialOptions: false,
            hasFetchedInitialOptions: false
        }, this.loadOptions = (inputValue, callback)=>{
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.fetchUserDebounced(inputValue, callback);
        }, this.fetchUsers = (inputValue, callback)=>{
            return (0, $keYO2.searchUser)({
                fieldName: this.props.id,
                query: inputValue,
                portalId: this.props.portalId,
                fieldConfigId: this.props.fieldConfigId
            }).map((response)=>response.map((user)=>({
                        value: user.id,
                        label: user.displayName,
                        iconUrl: user.avatar,
                        email: user.emailAddress,
                        accountId: user.accountId
                    }))).toPromise().then(callback);
        }, this.fetchUserDebounced = (0, $aYMdQ.debounce)(this.fetchUsers, 400), this.handleMenuOpen = ()=>{
            if (!this.state.hasFetchedInitialOptions) {
                this.setState({
                    hasFetchedInitialOptions: true,
                    isLoadingInitialOptions: true
                });
                // Disabling existing violations, should be fixed when revisited.
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.fetchUsers('', (options)=>this.setState({
                        isLoadingInitialOptions: false,
                        initialOptions: options
                    }));
            }
        };
    }
}

});
parcelRegister("fT72v", function(module, exports) {
$parcel$export(module.exports, "UserPickerDumb", () => (parcelRequire("iFZxg")).default);

var $iFZxg = parcelRequire("iFZxg");

});
parcelRegister("iFZxg", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a7f51c97ced27cc$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $hN5YJ = parcelRequire("hN5YJ");

var $6v10u = parcelRequire("6v10u");

var $fcCIH = parcelRequire("fcCIH");
parcelRequire("fAfqE");
var $ibiSw = parcelRequire("ibiSw");

var $9MLZi = parcelRequire("9MLZi");

var $6oof1 = parcelRequire("6oof1");

var $cF33t = parcelRequire("cF33t");
parcelRequire("52Uk2");
var $iaVgA = parcelRequire("iaVgA");
class $8a7f51c97ced27cc$export$72002aa2fe0510f1 extends $fc4bM.PureComponent {
    render() {
        const { disabled: disabled, defaultUser: defaultUser, doInitialSearch: doInitialSearch, canCreateUser: canCreateUser, defaultOptions: defaultOptions, createLabelType: createLabelType, onMenuOpen: onMenuOpen, isLoading: isLoading, intl: intl, onChange: onChange, ...otherProps } = this.props;
        const customComponents = {
            SingleValue: this.userPickerItem,
            Option: this.userPickerOption
        };
        if (this.shouldShowCreatabelSelect()) {
            const useShowNewLabelForCreatedValues = createLabelType === 'create';
            return /*#__PURE__*/ $fc4bM.createElement((0, $6v10u.FormAsyncCreatableSingleSelect), {
                ...otherProps,
                formatCreateLabel: this.formatCreateLabel,
                isDisabled: disabled,
                isValidNewOption: this.isValidNewOption,
                components: customComponents,
                onChange: this.onChangeForSelectField,
                onMenuOpen: onMenuOpen,
                isLoading: isLoading,
                defaultValue: defaultUser,
                defaultOptions: doInitialSearch || defaultOptions,
                placeholder: intl.formatMessage((0, $cF33t.default).placeholder),
                noOptionsMessage: this.getNoOptionsCreatable,
                showNewLabelForCreatedValues: useShowNewLabelForCreatedValues
            });
        }
        return /*#__PURE__*/ $fc4bM.createElement((0, $6v10u.FormAsyncSingleSelect), {
            ...otherProps,
            loadOptions: this.props.loadOptions,
            isDisabled: disabled,
            components: customComponents,
            onMenuOpen: onMenuOpen,
            isLoading: isLoading,
            onChange: this.onChangeForSelectField,
            defaultValue: defaultUser,
            placeholder: intl.formatMessage((0, $cF33t.default).placeholder),
            defaultOptions: doInitialSearch || defaultOptions,
            noOptionsMessage: this.getNoOptions
        });
    }
    constructor(...args){
        super(...args), this.onChangeForSelectField = (value)=>{
            var _this$props$onChange3, _this$props3, _this$props$onChange4, _this$props4;
            const selectedValue = (0, $6oof1.toSingleSelectValue)(value);
            if (selectedValue == null) {
                var _this$props$onChange, _this$props, _this$props$onChange2, _this$props2;
                (0, $hN5YJ.isUserPickerSupportEnabled)() ? (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, this.props.id, '', false, {
                    rawObject: value ?? {},
                    rawValue: {
                        accountId: ''
                    }
                }) : (_this$props$onChange2 = (_this$props2 = this.props).onChange) === null || _this$props$onChange2 === void 0 || _this$props$onChange2.call(_this$props2, this.props.id, '', false, {
                    rawObject: value ?? {}
                });
                return;
            }
            (0, $hN5YJ.isUserPickerSupportEnabled)() ? (_this$props$onChange3 = (_this$props3 = this.props).onChange) === null || _this$props$onChange3 === void 0 || _this$props$onChange3.call(_this$props3, this.props.id, selectedValue.value, false, {
                rawObject: value ?? {},
                rawValue: selectedValue ? {
                    accountId: selectedValue.value
                } : null
            }) : (_this$props$onChange4 = (_this$props4 = this.props).onChange) === null || _this$props$onChange4 === void 0 || _this$props$onChange4.call(_this$props4, this.props.id, selectedValue.value, false, {
                rawObject: value ?? {}
            });
        }, this.userPickerItem = ({ data: data })=>{
            const { iconUrl: iconUrl, label: label, email: email, isNew: isNew } = data;
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            return /*#__PURE__*/ $fc4bM.createElement((0, $ibiSw.default), {
                name: label,
                icon: iconUrl,
                email: email,
                isNew: isNew
            });
        }, this.userPickerOption = ({ data: data, ...props })=>{
            const { iconUrl: iconUrl, label: label, email: email, isNew: isNew } = data;
            return /*#__PURE__*/ $fc4bM.createElement((0, $9MLZi.components).Option, {
                ...props,
                data: data
            }, /*#__PURE__*/ $fc4bM.createElement((0, $ibiSw.default), {
                name: label,
                icon: iconUrl,
                email: email,
                isNew: isNew
            }));
        }, this.formatCreateLabel = (input)=>{
            const { intl: intl, createLabelType: createLabelType } = this.props;
            if (createLabelType === 'create') return intl.formatMessage((0, $cF33t.default).createAction, {
                value: input
            });
            if (createLabelType === 'add') return intl.formatMessage((0, $cF33t.default).addAction, {
                value: input
            });
            return input;
        }, this.isValidNewOption = (inputValue, _, selectOptions)=>{
            // Check whether the input value already corresponds to one of the available option.
            // We check whether the email matches the input exactly otherwise we show the option to create
            const isInputValueAnOption = selectOptions && Array.isArray(selectOptions) && selectOptions.filter((option)=>option.email === inputValue).length > 0;
            return !isInputValueAnOption && (0, $iaVgA.isEmail)(inputValue);
        }, this.shouldShowCreatabelSelect = ()=>{
            const { canCreateUser: canCreateUser } = this.props;
            if (canCreateUser) return true;
            return false;
        }, this.getNoOptionsCreatable = ()=>{
            const { intl: intl } = this.props;
            return intl.formatMessage((0, $cF33t.default).noOptionsCreatable);
        }, this.getNoOptions = ()=>{
            const { intl: intl } = this.props;
            return intl.formatMessage((0, $cF33t.default).noOptions);
        };
    }
}
var $8a7f51c97ced27cc$export$2e2bcd8739ae039 = (0, $fcCIH.default)($8a7f51c97ced27cc$export$72002aa2fe0510f1);

});






parcelRegister("lyyNE", function(module, exports) {
$parcel$export(module.exports, "RequestCreateAttachmentField", () => (parcelRequire("lgEHL")).default);

var $lgEHL = parcelRequire("lgEHL");

});
parcelRegister("lgEHL", function(module, exports) {
$parcel$export(module.exports, "default", () => $07f36e33e1f1836f$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $9XZeF = parcelRequire("9XZeF");

var $3ggHH = parcelRequire("3ggHH");

var $cD8ok = parcelRequire("cD8ok");

var $cizQ1 = parcelRequire("cizQ1");

var $57GTn = parcelRequire("57GTn");
parcelRequire("dSY8K");
var $3w36I = parcelRequire("3w36I");
parcelRequire("ax3IO");
var $a0Wt0 = parcelRequire("a0Wt0");
parcelRequire("fqXLb");
var $jv8Vi = parcelRequire("jv8Vi");
const $07f36e33e1f1836f$export$6df17d9d790736ce = 600000; // 10 minutes
class $07f36e33e1f1836f$var$RequestCreateAttachmentField extends $fc4bM.PureComponent {
    componentDidMount() {
        if (!this.props.mediaApiUploadToken) this.props.fetchPortalUploadMediaToken(this.props.portalId);
    }
    componentWillUnmount() {
        if (this.timeout) clearTimeout(this.timeout);
    }
    render() {
        const { id: id, label: label, description: description, errorMessage: errorMessage, mediaApiError: mediaApiError, required: required, mediaApiUploadToken: mediaApiUploadToken, blockFormSubmission: blockFormSubmission } = this.props;
        if (mediaApiUploadToken) return /*#__PURE__*/ $fc4bM.createElement((0, $3w36I.default), {
            renderError: this.renderError
        }, /*#__PURE__*/ $fc4bM.createElement((0, $a0Wt0.default), {
            ...this.props,
            mediaApiUploadToken: mediaApiUploadToken,
            saveAttachment: this.saveAttachment,
            authProvider: this.authProvider,
            blockFormSubmission: blockFormSubmission
        }));
        return /*#__PURE__*/ $fc4bM.createElement((0, $jv8Vi.default), {
            id: id,
            label: label,
            description: description,
            required: required,
            errorMessage: errorMessage,
            mediaApiError: mediaApiError
        });
    }
    constructor(...args){
        super(...args), this.timeout = undefined, this.mediaUploadAuth = undefined, this.authProvider = async ()=>{
            if (this.mediaUploadAuth) return this.mediaUploadAuth;
            const { portalId: portalId } = this.props;
            const { clientId: clientId, token: token, endpointUrl: baseUrl } = await (0, $cD8ok.getUploadCredentials)(portalId);
            this.mediaUploadAuth = {
                clientId: clientId,
                token: token,
                baseUrl: baseUrl
            };
            // Ideally token should be expired based on expiryEpoch on the response from getUploadCredentials
            // The token expires in 20 minutes
            this.timeout = setTimeout(()=>{
                this.mediaUploadAuth = undefined;
            }, $07f36e33e1f1836f$export$6df17d9d790736ce); // Cache token for 10 minutes
            return {
                clientId: clientId,
                token: token,
                baseUrl: baseUrl
            };
        }, this.saveAttachment = (fileId)=>{
            return (0, $3ggHH.default)(this.props.portalId, fileId);
        }, this.renderError = ()=>{
            const { id: id, label: label } = this.props;
            return /*#__PURE__*/ $fc4bM.createElement((0, $jv8Vi.default), {
                id: id,
                label: label
            });
        };
    }
}
const $07f36e33e1f1836f$var$selector = (state, props)=>{
    const { portalId: portalId } = props;
    const mediaApiUploadToken = (0, $57GTn.getMediaApiUploadToken)(state, portalId);
    const mediaApiError = (0, $57GTn.getMediaApiError)(state, portalId);
    return {
        ...props,
        mediaApiUploadToken: mediaApiUploadToken,
        mediaApiError: mediaApiError
    };
};
var $07f36e33e1f1836f$export$2e2bcd8739ae039 = (0, $9XZeF.connect)($07f36e33e1f1836f$var$selector, {
    fetchPortalUploadMediaToken: (0, $cizQ1.fetchPortalUploadMediaTokenAction)
})($07f36e33e1f1836f$var$RequestCreateAttachmentField);

});
parcelRegister("3ggHH", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c980ee995819e57$export$2e2bcd8739ae039);

var $bTjsX = parcelRequire("bTjsX");

var $jFk35 = parcelRequire("jFk35");

var $aIVqJ = parcelRequire("aIVqJ");

var $diqlM = parcelRequire("diqlM");
const $1c980ee995819e57$var$saveAttachment = (portalId, fileId)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.post)(`${(0, $diqlM.contextPath)}/rest/servicedesk/1/customer/portal/${portalId}/media/upload`, {
        fileId: fileId
    }, {
        'Content-Type': 'application/json'
    }).map((res)=>({
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            attachmentId: res.response.attachmentId
        })).catch((res)=>{
        (0, $aIVqJ.trackError)('attachment.save.failed', {}, res);
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        const errors = res.response.errors;
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        const error = errors && errors.length && errors[0].errorMessage;
        return (0, $jFk35.Observable).throw(error);
    });
};
var $1c980ee995819e57$export$2e2bcd8739ae039 = $1c980ee995819e57$var$saveAttachment;

});

parcelRegister("dSY8K", function(module, exports) {
$parcel$export(module.exports, "UnSupportedBrowserErrorBoundary", () => (parcelRequire("3w36I")).default);
parcelRequire("eA3aH");
var $3w36I = parcelRequire("3w36I");

});
parcelRegister("eA3aH", function(module, exports) {
$parcel$export(module.exports, "UnSupportedBrowserErrorBoundary", () => (parcelRequire("3w36I")).default);

var $3w36I = parcelRequire("3w36I");

});
parcelRegister("3w36I", function(module, exports) {
$parcel$export(module.exports, "default", () => $12a51ecc8624c3dd$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $7wx9B = parcelRequire("7wx9B");

var $2WmjE = parcelRequire("2WmjE");
const $12a51ecc8624c3dd$var$isUnSupportedBrowser = ()=>{
    return (0, $2WmjE.isOldSafari)();
};
class $12a51ecc8624c3dd$export$99acd2c5aad927c extends $fc4bM.Component {
    componentDidCatch(error) {
        const { onError: onError } = this.props;
        if ($12a51ecc8624c3dd$var$isUnSupportedBrowser()) {
            /**
       * Report error to sentry and don't re-throw the error
       */ (0, $7wx9B.reportError)(error);
            if (onError) onError(error);
        } else throw error;
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    render() {
        const { children: children, renderError: renderError } = this.props;
        const { error: error } = this.state;
        if (error) return renderError ? renderError() : null;
        return children;
    }
    constructor(...args){
        super(...args), this.state = {
            error: undefined
        };
    }
}
var $12a51ecc8624c3dd$export$2e2bcd8739ae039 = $12a51ecc8624c3dd$export$99acd2c5aad927c;

});



parcelRegister("ax3IO", function(module, exports) {
$parcel$export(module.exports, "RequestCreateAttachmentFieldDumb", () => (parcelRequire("a0Wt0")).default);

var $a0Wt0 = parcelRequire("a0Wt0");

});
parcelRegister("a0Wt0", function(module, exports) {
$parcel$export(module.exports, "default", () => $0783df107a21dbb9$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $aYMdQ = parcelRequire("aYMdQ");

var $Ny2r6 = parcelRequire("Ny2r6");

var $ch1yB = parcelRequire("ch1yB");
class $0783df107a21dbb9$var$RequestCreateAttachmentFieldDumb extends $fc4bM.PureComponent {
    render() {
        const { label: label, description: description, errorMessage: errorMessage, mediaApiUploadToken: mediaApiUploadToken, blockFormSubmission: blockFormSubmission, required: required, disabled: disabled, authProvider: authProvider, saveAttachment: saveAttachment, id: id } = this.props;
        return /*#__PURE__*/ $fc4bM.createElement((0, $ch1yB.FieldBase), {
            htmlFor: id,
            label: label,
            description: description,
            required: required,
            errorMessage: errorMessage
        }, /*#__PURE__*/ $fc4bM.createElement((0, $Ny2r6.Attachments), {
            onChange: this.onChange,
            authProvider: authProvider,
            collection: mediaApiUploadToken.targetCollection,
            saveAttachment: saveAttachment,
            blockFormSubmission: blockFormSubmission,
            onError: this.onError,
            disabled: disabled,
            hasError: !(0, $aYMdQ.isEmpty)(errorMessage),
            "aria-describedby": `${id}-field-description`
        }));
    }
    constructor(...args){
        super(...args), this.onChange = (value)=>{
            this.props.onChange && this.props.onChange(this.props.id, value);
        }, this.onError = (messages)=>{
            this.props.onError && this.props.onError({
                messages: messages,
                name: this.props.id
            });
        };
    }
}
var $0783df107a21dbb9$export$2e2bcd8739ae039 = $0783df107a21dbb9$var$RequestCreateAttachmentFieldDumb;

});
parcelRegister("Ny2r6", function(module, exports) {
$parcel$export(module.exports, "Attachments", () => $f945c3c8024f91ff$export$c129802f229d9594);

var $bQkfB = parcelRequire("bQkfB");

var $ieUrC = parcelRequire("ieUrC");

const $f945c3c8024f91ff$export$c129802f229d9594 = (0, $bQkfB.default)({
    loader: (0, $ieUrC.lazyForPaint)(()=>(parcelRequire("1wKsr")), {
        moduleId: "./src/view/common/attachments/attachments.tsx"
    })
});

});
parcelRegister("1wKsr", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("8QEJW"),
    $9dnsd("7K1bA")
]).then(()=>parcelRequire('7yDq0'));

});




parcelRegister("fqXLb", function(module, exports) {
$parcel$export(module.exports, "RequestCreateAttachmentFieldError", () => (parcelRequire("jv8Vi")).default);

var $jv8Vi = parcelRequire("jv8Vi");

});
parcelRegister("jv8Vi", function(module, exports) {
$parcel$export(module.exports, "default", () => $caf7d3afaef339f4$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $3DjOo = parcelRequire("3DjOo");

var $fd880 = parcelRequire("fd880");

var $ch1yB = parcelRequire("ch1yB");

var $kwfqB = parcelRequire("kwfqB");
const $caf7d3afaef339f4$var$RequestCreateAttachmentFieldError = ({ label: label, description: description, required: required, errorMessage: errorMessage, mediaApiError: mediaApiError, id: id })=>{
    return /*#__PURE__*/ $fc4bM.createElement((0, $ch1yB.FieldBase), {
        htmlFor: id,
        label: label,
        description: description,
        required: required,
        errorMessage: errorMessage
    }, /*#__PURE__*/ $fc4bM.createElement($caf7d3afaef339f4$var$Error, null, mediaApiError || /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $kwfqB.default).genericError)));
};
var $caf7d3afaef339f4$export$2e2bcd8739ae039 = $caf7d3afaef339f4$var$RequestCreateAttachmentFieldError;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $caf7d3afaef339f4$var$Error = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-jcr6mx-0"
})`${$3DjOo.borderRadius};border:${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-danger, #BF2600)"};width:100%;padding:${"var(--ds-space-100, 8px)"};text-align:center;`;

});
parcelRegister("kwfqB", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad9fdcad67718573$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $ad9fdcad67718573$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    genericError: {
        defaultMessage: 'An error occurred when loading the attachments field',
        description: 'Default message when an error occurs loading the media picker',
        id: 'sd.request.create.attachment.field.error'
    }
});

});





parcelRegister("f4Pmo", function(module, exports) {
$parcel$export(module.exports, "FormRichTextArea", () => (parcelRequire("ksO0j")).FormRichTextArea);

var $ksO0j = parcelRequire("ksO0j");

});
parcelRegister("ksO0j", function(module, exports) {
$parcel$export(module.exports, "FormRichTextArea", () => $ee3b2421be404019$export$5493e8865eb5ab09);
/* rich-text-area.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $53bjB = parcelRequire("53bjB");

var $9mazR = parcelRequire("9mazR");

var $8PITw = parcelRequire("8PITw");

var $dsycU = parcelRequire("dsycU");

var $ch1yB = parcelRequire("ch1yB");

var $6wHv6 = parcelRequire("6wHv6");

var $k2M4v = parcelRequire("k2M4v");

var $2eOU2 = parcelRequire("2eOU2");

var $aIVqJ = parcelRequire("aIVqJ");
class $ee3b2421be404019$var$RichTextArea extends $fc4bM.Component {
    componentDidUpdate(prevProps) {
        // Update editor content when value changes and UI modifications are enabled
        if (this.props.shouldReplaceValue && prevProps.value !== this.props.value && this.editorActions && this.props.value !== undefined) this.editorActions.replaceDocument(this.props.value);
    }
    render() {
        const { id: id, label: label, required: required, errorMessage: errorMessage, description: description, disabled: disabled, defaultValue: defaultValue, fieldConfigs: fieldConfigs, value: value } = this.props;
        const editorProps = (0, $k2M4v.default).checkGate('request_create_inline_attachment') ? {
            mediaContext: this.props.mediaContext
        } : {};
        const updatedDefaultValue = defaultValue ?? value;
        return /*#__PURE__*/ $fc4bM.createElement((0, $ch1yB.FieldBase), {
            label: label,
            description: description,
            htmlFor: id,
            required: required,
            errorMessage: errorMessage
        }, /*#__PURE__*/ $fc4bM.createElement("div", {
            id: id,
            "data-test-id": "rich-text-area-field",
            "aria-label": label,
            onBlur: this.onFieldBlur,
            className: (0, $2R2iS.default)([
                "_16jlkb7n _1o9zkb7n _i0dl1osq _1it91qi0 _165v1w7i _arztr5cv _1n18rsbi _wdezmag2 _h9ctidpf _168zidpf _1tnhidpf _1kalidpf _1rxnr5cv _1pom1qi0 _1m86mag2 _bbdp8bwy _11rh1l4g _1k1o1j9a _1skf8bwy _j1fv1l4g _1xz81j9a _1og910ko _5uu810ko _tvk11j9a _5chu1j9a",
                errorMessage ? "_1iun1jh0 _1n1816c1" : "_172m1r31 _1xdeglyw _1w6j1o36 _1n1817va"
            ])
        }, /*#__PURE__*/ $fc4bM.createElement((0, $dsycU.default), {
            isExpanded: true,
            editorType: "field",
            isEmojiEnabled: true,
            disabled: !!disabled,
            onChange: this.onFieldChangeDebounced,
            defaultValue: updatedDefaultValue,
            fieldConfigs: fieldConfigs,
            onInternalRender: this.handleInternalRender,
            // TODO: editor currently does not support aria-labelledby, so we are using ariaLabel for now
            ariaLabel: label,
            ariaDescribedby: `${id}-field-description`,
            LoadingComponent: (0, $8PITw.FieldLoadingSkeleton),
            ...editorProps
        })));
    }
    constructor(...args){
        super(...args), this.handleInternalRender = (editorActions)=>{
            this.editorActions = editorActions;
        }, this.onFieldChange = (transformedDoc)=>{
            const { id: id, onChange: onChange } = this.props;
            if (onChange) {
                // When the fields content is cleared we reset it's value to an empty string in order to correctly display the dirty form warning
                const correctValue = (0, $2eOU2.isOnlyWhitespaceAdf)(transformedDoc) ? '' : JSON.stringify(transformedDoc);
                onChange(id, correctValue, false, {
                    rawObject: {},
                    rawValue: correctValue
                });
            }
        }, this.onFieldBlur = (event)=>{
            // Check if the focus is moving to an element within this component
            const currentTarget = event.currentTarget;
            const relatedTarget = event.relatedTarget;
            // If relatedTarget is within the currentTarget, don't trigger blur
            if (relatedTarget && currentTarget.contains(relatedTarget)) return;
            if (this.props.onFieldBlurredByUser) {
                var _this$editorActions;
                const { onFieldBlurredByUser: onFieldBlurredByUser } = this.props;
                // Handle the promise properly to avoid floating promise error
                (_this$editorActions = this.editorActions) === null || _this$editorActions === void 0 || _this$editorActions.getValue().then((transformedDoc)=>{
                    const correctValue = (0, $2eOU2.isOnlyWhitespaceAdf)(transformedDoc) ? '' : JSON.stringify(transformedDoc);
                    onFieldBlurredByUser({
                        field: this.props.id,
                        value: correctValue,
                        additionalFieldData: {
                            rawObject: {},
                            rawValue: correctValue
                        }
                    });
                }).catch((error)=>{
                    (0, $aIVqJ.trackError)('rich.text.area.failed.to.get.value', {
                        message: JSON.stringify(error)
                    }, `Rich text area: Failed to get value from editor`);
                });
            }
        }, this.onFieldChangeDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($53bjB)))(this.onFieldChange, (0, $9mazR.USER_TYPING_DEBOUNCE_TIME));
    }
}
var $ee3b2421be404019$export$2e2bcd8739ae039 = $ee3b2421be404019$var$RichTextArea;
const $ee3b2421be404019$var$ControlledRichTextArea = (0, $6wHv6.withControlledFormComponentValue)((_field, value)=>value)($ee3b2421be404019$var$RichTextArea);
const $ee3b2421be404019$export$5493e8865eb5ab09 = $ee3b2421be404019$var$ControlledRichTextArea;
// Manual overrides required to theme the editor to look like a request create form field
const $ee3b2421be404019$var$wrapperStyles = null;
const $ee3b2421be404019$var$errorStyles = null;
const $ee3b2421be404019$var$noErrorStyles = null;

});
parcelRegister("dsycU", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a963c49e9288b0a$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $9XZeF = parcelRequire("9XZeF");

var $2n2bS = parcelRequire("2n2bS");

var $bQkfB = parcelRequire("bQkfB");

var $4OMBM = parcelRequire("4OMBM");

var $8MaoS = parcelRequire("8MaoS");

var $ieUrC = parcelRequire("ieUrC");

var $b46ZL = parcelRequire("b46ZL");

var $5D7rn = parcelRequire("5D7rn");

var $7ZNRj = parcelRequire("7ZNRj");

var $h6Bv6 = parcelRequire("h6Bv6");

var $58y5x = parcelRequire("58y5x");

/**
 *  (Currently) the editor supports 2 rendering modes in the Portal, it can render either as a comment box or as a field in the request create form.
 *  Both cases can be see as being "semi-uncontrolled" components.
 *
 *  In the case of the comment box, we copy the ADF document to redux UI state on submit
 *  so we can re-populate the editor if the request fails.
 *
 *  In the case of the field, we update Formik's internal state as the user types, and use that value when submitting the form.
 *
 */ const $5a963c49e9288b0a$var$AsyncRichTextEditor = (props)=>{
    const prevProps = $fc4bM.useRef(props);
    $fc4bM.useEffect(()=>{
        prevProps.current = props;
    });
    const AsyncEditor = $fc4bM.useMemo(()=>(0, $bQkfB.default)({
            loader: (0, $ieUrC.lazyForPaint)(()=>(parcelRequire("3yOoh")), {
                ssr: false,
                moduleId: "./packages/common-utils/rich-text-editor-v2/src/hocs.tsx"
            }),
            LoadingSkeleton: props.LoadingComponent
        }), // oxlint-disable-next-line react-hooks/exhaustive-deps
    [
        props.editorType
    ]);
    return /*#__PURE__*/ $fc4bM.createElement(AsyncEditor, props);
};
const $5a963c49e9288b0a$var$EditorWithTranslations = /*#__PURE__*/ $fc4bM.memo(function EditorWithTranslationsV2(ownProps) {
    const { locale: locale, LoadingComponent: LoadingComponent = ()=>null } = ownProps;
    const [intlMessages, setIntlMessages] = $fc4bM.useState();
    const [error, setError] = $fc4bM.useState();
    $fc4bM.useEffect(()=>{
        (0, $58y5x.promiseWithRetries)(()=>(0, $5D7rn.importLocaleMessages)(locale)).then((loaded)=>{
            setIntlMessages(loaded);
        }).catch((err)=>{
            setError(err);
        });
    }, [
        locale
    ]);
    if (!intlMessages) return /*#__PURE__*/ $fc4bM.createElement(LoadingComponent, {
        error: error,
        isLoading: !error
    });
    return /*#__PURE__*/ $fc4bM.createElement((0, $8MaoS.default), {
        messages: intlMessages,
        locale: (0, $7ZNRj.getLanguageFromLocale)(locale),
        onError: (0, $4OMBM.onIntlNextError)
    }, /*#__PURE__*/ $fc4bM.createElement($5a963c49e9288b0a$var$AsyncRichTextEditor, ownProps));
});
const $5a963c49e9288b0a$export$3301e0145bb4a9b5 = (props)=>{
    const { LoadingComponent: LoadingComponent = ()=>null } = props;
    const portalLocale = (0, $h6Bv6.usePortalLocale)();
    // Inside a portal page the editor follows the portal's locale; everywhere else
    // (CSM request details, embedded pages) it stays on the account locale the
    // Redux selector supplied.
    const locale = portalLocale ? (0, $5D7rn.getNormalizedLocale)(portalLocale) : props.locale;
    // If the users locale is english, which is the editors default locale, we can avoid requiring the locale unnecessarily
    if (locale === 'en') return /*#__PURE__*/ $fc4bM.createElement($5a963c49e9288b0a$var$AsyncRichTextEditor, {
        ...props,
        LoadingComponent: LoadingComponent
    });
    return /*#__PURE__*/ $fc4bM.createElement($5a963c49e9288b0a$var$EditorWithTranslations, {
        ...props,
        locale: locale,
        LoadingComponent: LoadingComponent
    });
};
const $5a963c49e9288b0a$var$selector = (0, $2n2bS.createSelector)((state)=>(0, $b46ZL.getLocale)(state), (locale)=>({
        locale: (0, $5D7rn.getNormalizedLocale)(locale)
    }));
var $5a963c49e9288b0a$export$2e2bcd8739ae039 = (0, $9XZeF.connect)($5a963c49e9288b0a$var$selector)($5a963c49e9288b0a$export$3301e0145bb4a9b5);

});
parcelRegister("3yOoh", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("4syaP"),
    $9dnsd("bmLFd"),
    $9dnsd("jsVEa"),
    $9dnsd("j81ar"),
    $9dnsd("fQ86q"),
    $9dnsd("8Qjad"),
    $9dnsd("jCVS7"),
    $9dnsd("hmbqh"),
    $9dnsd("hCVB4"),
    $9dnsd("jeCvC"),
    $9dnsd("4A2hN"),
    $9dnsd("hHYFE"),
    $9dnsd("b1NYz"),
    $9dnsd("6Df0C"),
    $9dnsd("fAWGE"),
    $9dnsd("ozcFp"),
    $9dnsd("2a74T"),
    $9dnsd("8QhuV"),
    $9dnsd("3EcVO"),
    $9dnsd("lsa7j"),
    $9dnsd("67Pud"),
    $9dnsd("9xUCJ"),
    $9dnsd("5nsCa"),
    $9dnsd("5TqqM"),
    $9dnsd("f9fS8")
]).then(()=>parcelRequire('9urSO'));

});




parcelRegister("fgxkG", function(module, exports) {
$parcel$export(module.exports, "PciSecureTextPicker", () => (parcelRequire("1TcxL")).PciSecureTextPicker);

var $1TcxL = parcelRequire("1TcxL");

});
parcelRegister("1TcxL", function(module, exports) {
$parcel$export(module.exports, "PciSecureTextPicker", () => $213c3ac6c0f57f2a$export$39a21ed08704fcf7);

var $fc4bM = parcelRequire("fc4bM");

var $2N4Ib = parcelRequire("2N4Ib");
const $213c3ac6c0f57f2a$export$39a21ed08704fcf7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2N4Ib.TextField), {
        ...props,
        shouldFitContainer: true
    });

});


parcelRegister("hgg7x", function(module, exports) {
$parcel$export(module.exports, "SummaryField", () => (parcelRequire("czFqK")).default);

var $czFqK = parcelRequire("czFqK");

});
parcelRegister("czFqK", function(module, exports) {
$parcel$export(module.exports, "default", () => $365ffa7d80e991a5$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $9XZeF = parcelRequire("9XZeF");

var $9mazR = parcelRequire("9mazR");

var $jFk35 = parcelRequire("jFk35");
var $8IeZR = parcelRequire("8IeZR");

var $9tWp4 = parcelRequire("9tWp4");

var $aYMdQ = parcelRequire("aYMdQ");

var $5w7ep = parcelRequire("5w7ep");

var $53Mcy = parcelRequire("53Mcy");

var $57GTn = parcelRequire("57GTn");

var $azARG = parcelRequire("azARG");

var $613oU = parcelRequire("613oU");

var $eENmG = parcelRequire("eENmG");

var $aIVqJ = parcelRequire("aIVqJ");

var $17nJI = parcelRequire("17nJI");
parcelRequire("bjb0w");
var $1rbVT = parcelRequire("1rbVT");
const $365ffa7d80e991a5$var$KB_SUGGESTIONS_MIN_QUERY_LENGTH = 3;
class $365ffa7d80e991a5$export$b75b6a6cc3a70ff8 extends $fc4bM.PureComponent {
    componentDidMount() {
        this.subscription = new (0, $8IeZR.Subscription)();
    }
    componentWillUnmount() {
        this.subscription.unsubscribe();
        const { fetchKBSuggestionsSuccess: fetchKBSuggestionsSuccess, portalId: portalId } = this.props;
        fetchKBSuggestionsSuccess({
            portalId: portalId,
            kbArticleSuggestions: []
        });
    }
    render() {
        const { knowledgeBase: knowledgeBase, onFieldBlurredByUser: onFieldBlurredByUser, kbSuggestions: kbSuggestions, ...props } = this.props;
        return /*#__PURE__*/ $fc4bM.createElement((0, $1rbVT.default), {
            ...props,
            onChange: this.onChange,
            onFieldBlurredByUser: onFieldBlurredByUser,
            kbArticles: kbSuggestions
        });
    }
    constructor(...args){
        super(...args), this.fetchKbSuggestions = (inputValue)=>{
            const { knowledgeBase: knowledgeBase, fetchKBSuggestionsSuccess: fetchKBSuggestionsSuccess, portalId: portalId, projectId: projectId, requestTypeId: requestTypeId } = this.props;
            const trimmedInputValue = inputValue.trim();
            if ((0, $aYMdQ.isEmpty)(trimmedInputValue)) return;
            if (trimmedInputValue.length < $365ffa7d80e991a5$var$KB_SUGGESTIONS_MIN_QUERY_LENGTH) {
                fetchKBSuggestionsSuccess({
                    portalId: portalId,
                    kbArticleSuggestions: []
                });
                return;
            }
            // projectId must be defined for the search endpoint to work
            if (projectId) {
                const subs = (0, $5w7ep.searchKbs)({
                    projectId: projectId,
                    requestTypeId: requestTypeId,
                    labels: knowledgeBase ? knowledgeBase.labels : [],
                    query: trimmedInputValue,
                    resultLimit: 3
                }).subscribe((kbSearchResponse)=>{
                    const meta = this.getAnalyticsEvent(kbSearchResponse.articles.length);
                    if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $aIVqJ.legacySendEvent)(meta.analyticsSuccessEvent);
                    fetchKBSuggestionsSuccess({
                        portalId: portalId,
                        kbArticleSuggestions: kbSearchResponse.articles
                    });
                }, (e)=>{
                    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
                    const meta = this.getAnalyticsEvent();
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                    if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $17nJI.isNetworkOrClientErrorCode)(e.status)) (0, $aIVqJ.legacySendEvent)(meta.analyticsFailureEvent);
                    (0, $aIVqJ.trackError)('kbsuggestions.fetch.failed', {}, e);
                    return (0, $jFk35.Observable).empty();
                });
                this.subscription.add(subs);
            }
        }, this.getAnalyticsEvent = (length)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            return {
                analyticsSuccessEvent: createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                    action: 'Fetch success',
                    analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
                    actionSubjectId: 'kbSuggestion',
                    actionSubject: 'kbSuggestionField',
                    totalArticles: length
                }),
                analyticsFailureEvent: createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                    action: 'Fetch failed',
                    analyticsType: (0, $eENmG.OPERATIONAL_EVENT_TYPE)
                })
            };
        }, this.loadKbSuggestions = (0, $aYMdQ.debounce)(this.fetchKbSuggestions, (0, $9mazR.USER_TYPING_DEBOUNCE_TIME)), this.onChange = (name, value, notFromUserInteraction, additionalFieldData)=>{
            const { onChange: onChange } = this.props;
            onChange && onChange(name, value, notFromUserInteraction, additionalFieldData);
            this.loadKbSuggestions(value);
        };
    }
}
const $365ffa7d80e991a5$export$9adbba5a02101fe3 = (0, $9XZeF.connect)((state)=>{
    const portalId = (0, $53Mcy.getPortalId)(state);
    const projectId = (0, $57GTn.getProjectId)(state, portalId);
    return {
        portalId: portalId,
        projectId: projectId,
        kbSuggestions: (0, $57GTn.getKbSuggestions)(state, portalId)
    };
}, {
    fetchKBSuggestionsSuccess: (0, $9tWp4.fetchKBSuggestionsSuccessAction)
})($365ffa7d80e991a5$export$b75b6a6cc3a70ff8);
var $365ffa7d80e991a5$export$2e2bcd8739ae039 = (0, $613oU.default)({
    componentName: 'KbSuggestions'
})((0, $azARG.default)()($365ffa7d80e991a5$export$9adbba5a02101fe3));

});
parcelRegister("bjb0w", function(module, exports) {
$parcel$export(module.exports, "SummaryDumbField", () => (parcelRequire("1rbVT")).default);

var $1rbVT = parcelRequire("1rbVT");

});
parcelRegister("1rbVT", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bad80112c809f16$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $9mazR = parcelRequire("9mazR");

var $aYMdQ = parcelRequire("aYMdQ");
parcelRequire("j2R8A");
var $8zlgB = parcelRequire("8zlgB");

var $2N4Ib = parcelRequire("2N4Ib");

var $6wHv6 = parcelRequire("6wHv6");
const $6bad80112c809f16$var$ControlledTextField = (0, $6wHv6.withControlledFormComponentValue)((_field, value)=>value)((0, $2N4Ib.TextField));
const $6bad80112c809f16$var$SummaryDumbField = ({ kbArticles: kbArticles, ...props })=>{
    const debouncedOnChange = $fc4bM.useMemo(()=>{
        if (props.onChange) return (0, $aYMdQ.debounce)(props.onChange, (0, $9mazR.USER_TYPING_DEBOUNCE_TIME));
        return props.onChange;
    }, [
        props.onChange
    ]);
    return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement($6bad80112c809f16$var$ControlledTextField, {
        id: props.id,
        label: props.label,
        required: props.required,
        defaultValue: props.defaultValue,
        valueOverride: props.valueOverride,
        description: props.description,
        onChange: debouncedOnChange,
        onFieldBlurredByUser: props.onFieldBlurredByUser,
        key: "summary-text-field",
        errorMessage: props.errorMessage,
        disabled: props.disabled,
        testId: "request-field-summary-input"
    }), !!kbArticles && !(0, $aYMdQ.isEmpty)(kbArticles) && /*#__PURE__*/ $fc4bM.createElement((0, $8zlgB.default), {
        articles: kbArticles,
        portalId: props.portalId
    }));
};
var $6bad80112c809f16$export$2e2bcd8739ae039 = $6bad80112c809f16$var$SummaryDumbField;

});
parcelRegister("j2R8A", function(module, exports) {
$parcel$export(module.exports, "KbSuggestedArticles", () => (parcelRequire("8zlgB")).default);

var $8zlgB = parcelRequire("8zlgB");

});
parcelRegister("8zlgB", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e0976a1f42d0297$export$2e2bcd8739ae039);
/* kb-suggestions.tsx generated by @compiled/babel-plugin v3.0.2 */ // eslint-disable-next-line @compiled/jsx-pragma

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $aYMdQ = parcelRequire("aYMdQ");

var $fcCIH = parcelRequire("fcCIH");
parcelRequire("flAUY");
var $xxBjZ = parcelRequire("xxBjZ");

var $azARG = parcelRequire("azARG");

var $1hJdJ = parcelRequire("1hJdJ");

var $eENmG = parcelRequire("eENmG");

var $g0AI0 = parcelRequire("g0AI0");
const $9e0976a1f42d0297$export$329234c6d2caa76b = ({ createAnalyticsEvent: createAnalyticsEvent, articles: articles, intl: intl, connectedToForm: connectedToForm, portalId: portalId })=>{
    $fc4bM.useEffect(()=>{
        createAnalyticsEvent && createAnalyticsEvent({
            action: 'viewed',
            analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
            actionSubjectId: `kbSuggestion${connectedToForm ? '-proforma' : ''}`,
            actionSubject: `kbSuggestionField${connectedToForm ? '-proforma' : ''}`,
            totalArticles: articles.length
        }).fire();
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        createAnalyticsEvent,
        articles.length
    ]);
    const articleList = !(0, $aYMdQ.isEmpty)(articles) && /*#__PURE__*/ $fc4bM.createElement($9e0976a1f42d0297$var$Container, null, articles.map((article)=>/*#__PURE__*/ $fc4bM.createElement($9e0976a1f42d0297$export$4c96a30fe18d5130, {
            articleUrl: article.articleUrl,
            sourceType: article.sourceType,
            key: article.id,
            elevated: false,
            title: article.name,
            openNewTab: true,
            focusable: true,
            isSuggestion: true,
            portalId: typeof portalId === 'number' ? portalId.toString() : portalId,
            ...article
        })));
    return /*#__PURE__*/ $fc4bM.createElement($9e0976a1f42d0297$var$Root, null, /*#__PURE__*/ $fc4bM.createElement("div", {
        "data-test-id": "request-field-kb-suggest-article"
    }, /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            "_1pfhpxbi _1q51v77o _85i51b66 _syazazsu _129u1kw7"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $1hJdJ.default), {
        size: "xxsmall",
        as: "h2"
    }, intl.formatMessage((0, $g0AI0.default).label))), articleList));
};
var $9e0976a1f42d0297$export$2e2bcd8739ae039 = (0, $azARG.default)()((0, $fcCIH.default)($9e0976a1f42d0297$export$329234c6d2caa76b));
const $9e0976a1f42d0297$var$sectionHeadingWrapperStyles = null;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $9e0976a1f42d0297$var$Root = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1m0nkh8-0"
})`width:100%;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $9e0976a1f42d0297$var$Container = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1m0nkh8-1"
})`padding:${"var(--ds-space-200, 16px)"};background-color:${"var(--ds-background-neutral, #FAFBFC)"};`;
const $9e0976a1f42d0297$export$4c96a30fe18d5130 = /*#__PURE__*/ (0, $luz1X.default)((0, $xxBjZ.default)).withConfig({
    componentId: "sc-1m0nkh8-2"
})`transition:box-shadow 0.2s ease-in-out;`;

});
parcelRegister("flAUY", function(module, exports) {
$parcel$export(module.exports, "SearchResultKb", () => (parcelRequire("xxBjZ")).default);

var $xxBjZ = parcelRequire("xxBjZ");

});
parcelRegister("xxBjZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1465671eadc511f3$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("6XAOI");
var $bWhp5 = parcelRequire("bWhp5");

var $3TJLC = parcelRequire("3TJLC");

var $3GHVc = parcelRequire("3GHVc");
const $1465671eadc511f3$export$a3d66732745adbf1 = (text)=>// eslint-disable-next-line no-useless-escape
    text.replace(/\@\@\@hl\@\@\@/g, '<strong>').replace(/\@\@\@endhl\@\@\@/g, '</strong>');
const $1465671eadc511f3$var$SearchResultKb = ({ title: title, portalName: portalName, portalId: portalId, id: id, articleUrl: articleUrl, articleSnippet: articleSnippet, isSmartSnippet: isSmartSnippet, pageVersion: pageVersion, score: score, linkedPortals: linkedPortals, openNewTab: openNewTab, sourceType: sourceType, ...props })=>{
    const articleId = id;
    const snippet = articleSnippet ? $1465671eadc511f3$export$a3d66732745adbf1(articleSnippet) : '';
    const getArticleUrl = ()=>{
        if ((0, $3GHVc.isThirdPartyArticle)(sourceType)) return articleUrl || '';
        if (portalId) return `/portal/${portalId}/article/${articleId}`;
        // If portalId doesnt exist in store, ie for global search, use the portalId for first linked portal
        if (Array.isArray(linkedPortals) && linkedPortals.length > 0) return `/portal/${linkedPortals[0].portalId}/article/${articleId}`;
        return `/article/${articleId}`;
    };
    return /*#__PURE__*/ $fc4bM.createElement((0, $3TJLC.default), {
        data: {
            attributes: {
                pageVersion: pageVersion,
                score: score,
                isSmartSnippet: isSmartSnippet,
                articleId: articleId,
                portalId: portalId,
                sourceType: sourceType,
                snippetsLength: snippet.length
            }
        }
    }, /*#__PURE__*/ $fc4bM.createElement((0, $bWhp5.default), {
        actionSubjectId: "smartSuggestion",
        titleHtml: $1465671eadc511f3$export$a3d66732745adbf1(title),
        to: getArticleUrl(),
        openNewTab: openNewTab,
        snippet: snippet,
        portalName: portalName,
        sourceType: sourceType,
        ...props
    }));
};
var $1465671eadc511f3$export$2e2bcd8739ae039 = $1465671eadc511f3$var$SearchResultKb;

});
parcelRegister("6XAOI", function(module, exports) {
$parcel$export(module.exports, "KbSnippet", () => (parcelRequire("bWhp5")).default);

var $bWhp5 = parcelRequire("bWhp5");

});
parcelRegister("bWhp5", function(module, exports) {
$parcel$export(module.exports, "default", () => $263266a12d38c425$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $io4o2 = parcelRequire("io4o2");

var $imLe4 = parcelRequire("imLe4");

var $fOCtI = parcelRequire("fOCtI");

var $3DjOo = parcelRequire("3DjOo");

var $6F3K7 = parcelRequire("6F3K7");

var $fJq3t = parcelRequire("fJq3t");

var $jEubQ = parcelRequire("jEubQ");

var $613oU = parcelRequire("613oU");

var $1AiIz = parcelRequire("1AiIz");

var $dS86g = parcelRequire("dS86g");

var $5a4EU = parcelRequire("5a4EU");

var $eENmG = parcelRequire("eENmG");

var $a1I28 = parcelRequire("a1I28");

var $3GHVc = parcelRequire("3GHVc");

var $kxTmS = parcelRequire("kxTmS");

var $672Ue = parcelRequire("672Ue");
const $263266a12d38c425$var$KbSnippet = ({ titleHtml: titleHtml, to: to, actionSubjectId: actionSubjectId, openNewTab: openNewTab, onClick: onClick, snippet: snippet, portalName: portalName, sourceType: sourceType, showPortalName: showPortalName = false, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const isAnExternalResource = (0, $3GHVc.isThirdPartyArticle)(sourceType);
    const highlightHtmlSanitizeConfig = {
        FORBID_TAGS: [
            'style'
        ],
        FORBID_ATTR: [
            'style'
        ]
    };
    const sanitizeHighlightHtml = (html)=>{
        return (0, $fJq3t.sanitize)(html, highlightHtmlSanitizeConfig);
    };
    const linkProps = (0, $3GHVc.urlRefsAndTarget)({
        isAnExternalResource: isAnExternalResource,
        displayLink: (0, $a1I28.addSourceToUrl)(to, 'request-form', isAnExternalResource)
    });
    const getIcon = ()=>{
        const IconInTile = ({ label: label })=>{
            if (sourceType === 'GOOGLE_DRIVE') return /*#__PURE__*/ $fc4bM.createElement((0, $kxTmS.default), {
                label: label,
                size: "medium"
            });
            if (sourceType === 'SHAREPOINT') return /*#__PURE__*/ $fc4bM.createElement((0, $672Ue.default), {
                label: label,
                size: "medium"
            });
            return /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dS86g))), {
                label: label
            });
        };
        return /*#__PURE__*/ $fc4bM.createElement((0, $1AiIz.default), {
            appearance: "blue",
            icon: IconInTile,
            label: "Article icon",
            size: "medium"
        });
    };
    $fc4bM.useEffect(()=>{
        createAnalyticsEvent({
            analyticsType: (0, $eENmG.UI_EVENT_TYPE),
            action: 'viewed'
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return(// eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/no-static-element-interactions, styled-components-a11y/click-events-have-key-events, styled-components-a11y/no-static-element-interactions -- Disabling existing violation, should be fixed when revisited.
    /*#__PURE__*/ $fc4bM.createElement($263266a12d38c425$var$LinkContainer, {
        key: to,
        onClick: onClick,
        actionSubjectId: actionSubjectId,
        "data-test-id": "article-link-container",
        ...props,
        ...linkProps
    }, /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), null, getIcon()), /*#__PURE__*/ $fc4bM.createElement($263266a12d38c425$var$ArticleContainer, {
        snippets: snippet
    }, /*#__PURE__*/ $fc4bM.createElement($263266a12d38c425$var$Title, {
        dangerouslySetInnerHTML: {
            __html: sanitizeHighlightHtml(titleHtml)
        }
    }), showPortalName && portalName && /*#__PURE__*/ $fc4bM.createElement($263266a12d38c425$var$ServiceDeskTitle, null, "from ", portalName), snippet && /*#__PURE__*/ $fc4bM.createElement($263266a12d38c425$var$Snippet, {
        dangerouslySetInnerHTML: {
            __html: sanitizeHighlightHtml(snippet)
        }
    }))));
};
var $263266a12d38c425$export$2e2bcd8739ae039 = (0, $613oU.default)({
    componentName: 'KbSnippet'
})($263266a12d38c425$var$KbSnippet);
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $263266a12d38c425$var$TitleH3Css = /*#__PURE__*/ (0, $luz1X.css)`${$imLe4.regular};overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;word-break:break-word;-webkit-box-orient:vertical;text-transform:uppercase;margin:${"var(--ds-space-0, 0px)"};font-weight:normal;transition:color ${$6F3K7.speedMs.medium}ms ${$6F3K7.timingFunctions.easeInOut};color:${"var(--ds-text, #172B4D)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $263266a12d38c425$var$Title = /*#__PURE__*/ (0, $luz1X.default).h3.withConfig({
    componentId: "sc-ioq6m2-0"
})`${$263266a12d38c425$var$TitleH3Css}`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $263266a12d38c425$var$SnippetParagraphCss = /*#__PURE__*/ (0, $luz1X.css)`${$imLe4.small};color:${"var(--ds-text, #172B4D)"};margin-top:${"var(--ds-space-100, 8px)"};padding-right:${"var(--ds-space-200, 16px)"};overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;line-height:${"var(--ds-space-250, 20px)"};word-break:break-word;white-space:normal;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $263266a12d38c425$var$Snippet = /*#__PURE__*/ (0, $luz1X.default).p.withConfig({
    componentId: "sc-ioq6m2-1"
})`${$263266a12d38c425$var$SnippetParagraphCss}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $263266a12d38c425$var$LinkContainer = /*#__PURE__*/ (0, $luz1X.default)((0, $io4o2.Link)).withConfig({
    componentId: "sc-ioq6m2-2"
})`${$3DjOo.borderRadius};${(props)=>$3DjOo.applyIf(!props.isSuggestion, $3DjOo.raiseUpOnHoverOrFocus())};display:flex;background-color:${(props)=>props.isSuggestion ? 'none' : "var(--ds-surface-raised, #FFFFFF)"};padding:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-150, 12px)"};margin:${(props)=>props.isSuggestion ? '0' : `${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-200, 16px)"}`};&:hover,&:focus{background:${(props)=>props.isSuggestion ? "var(--ds-background-neutral-subtle-hovered, #EBECF0)" : "var(--ds-surface-raised, #FFFFFF)"};text-decoration:none;}&:hover h3,&:focus h3{color:${(props)=>`var(--ds-link, ${props.theme.color})`};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $263266a12d38c425$var$ArticleContainer = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-ioq6m2-3"
})`margin-left:${"var(--ds-space-250, 20px)"};${(props)=>!props.snippets ? `
            display: flex;
            align-items: center
            ` : ''}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $263266a12d38c425$var$ServiceDeskTitle = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-ioq6m2-4"
})`color:${"var(--ds-text-subtlest, #7A869A)"};font-size:${$fOCtI.multiple(1.375).px};`;

});




parcelRegister("g0AI0", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1c442be120a2ae4$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $e1c442be120a2ae4$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    label: {
        defaultMessage: 'Suggested articles',
        description: 'label for related articles in request create form based on text in summary field',
        id: 'cv.request.create.form.kb.suggestions.label'
    }
});

});







parcelRegister("kGj1m", function(module, exports) {
$parcel$export(module.exports, "TextArea", () => (parcelRequire("h3NhD")).default);
$parcel$export(module.exports, "FormTextArea", () => (parcelRequire("h3NhD")).FormTextArea);

var $h3NhD = parcelRequire("h3NhD");

});
parcelRegister("h3NhD", function(module, exports) {
$parcel$export(module.exports, "default", () => $4652ab94e04f789c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FormTextArea", () => $4652ab94e04f789c$export$a83de22056f04f06);

var $fc4bM = parcelRequire("fc4bM");

var $aYMdQ = parcelRequire("aYMdQ");

var $ch1yB = parcelRequire("ch1yB");

var $6wHv6 = parcelRequire("6wHv6");

var $96kXu = parcelRequire("96kXu");
class $4652ab94e04f789c$export$2e2bcd8739ae039 extends $fc4bM.PureComponent {
    render() {
        const { id: id, required: required, label: label, defaultValue: defaultValue, description: description, maxLength: maxLength, minimumRows: minimumRows, errorMessage: errorMessage, disabled: disabled, placeholder: placeholder, isLabelHidden: isLabelHidden, enableResize: enableResize, value: value } = this.props;
        const isInvalid = !(0, $aYMdQ.isEmpty)(errorMessage);
        return /*#__PURE__*/ $fc4bM.createElement((0, $ch1yB.FieldBase), {
            htmlFor: id,
            required: required,
            description: description,
            label: label,
            errorMessage: errorMessage,
            noLabel: isLabelHidden
        }, /*#__PURE__*/ $fc4bM.createElement((0, $96kXu.default), {
            id: id,
            name: id,
            defaultValue: defaultValue,
            maxLength: maxLength,
            minimumRows: minimumRows,
            resize: enableResize === undefined || enableResize ? 'vertical' : 'none',
            isInvalid: isInvalid,
            onChange: this.onChange,
            isDisabled: disabled,
            placeholder: placeholder,
            value: value,
            "aria-describedby": `${id}-field-description`,
            onBlur: this.onBlur
        }));
    }
    constructor(...args){
        super(...args), this.onChange = (e)=>{
            if (this.props.onChange) this.props.onChange(this.props.id, e.target.value, false, {
                rawObject: e,
                rawValue: e.target.value
            });
        }, this.onBlur = (e)=>{
            if (this.props.onFieldBlurredByUser) this.props.onFieldBlurredByUser({
                field: this.props.id,
                value: e.target.value,
                additionalFieldData: {
                    rawObject: e,
                    rawValue: e.target.value
                }
            });
        };
    }
}
const $4652ab94e04f789c$var$ControlledTextArea = (0, $6wHv6.withControlledFormComponentValue)((_field, value)=>value)($4652ab94e04f789c$export$2e2bcd8739ae039);
const $4652ab94e04f789c$export$a83de22056f04f06 = $4652ab94e04f789c$var$ControlledTextArea;

});


parcelRegister("9AOAz", function(module, exports) {
$parcel$export(module.exports, "UnknownField", () => (parcelRequire("fxF7L")).default);

var $fxF7L = parcelRequire("fxF7L");

});
parcelRegister("fxF7L", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1789089b6d4b8f8$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $9XZeF = parcelRequire("9XZeF");

var $2n2bS = parcelRequire("2n2bS");

var $fcCIH = parcelRequire("fcCIH");

var $b46ZL = parcelRequire("b46ZL");

var $ch1yB = parcelRequire("ch1yB");

var $aC1um = parcelRequire("aC1um");
class $c1789089b6d4b8f8$export$64cd47482e3a83fe extends $fc4bM.Component {
    render() {
        const { id: id, intl: intl, canAdministerJIRA: canAdministerJIRA, agentForPortal: agentForPortal } = this.props;
        if (canAdministerJIRA || agentForPortal) return /*#__PURE__*/ $fc4bM.createElement((0, $ch1yB.FieldBase), {
            htmlFor: id,
            label: intl.formatMessage((0, $aC1um.default).unknownField, {
                id: id
            })
        });
        return null;
    }
}
const $c1789089b6d4b8f8$var$selector = (0, $2n2bS.createSelector)((0, $b46ZL.getCanAdministerJIRA), (0, $b46ZL.getAgentForPortal), (canAdministerJIRA, agentForPortal)=>({
        canAdministerJIRA: canAdministerJIRA,
        agentForPortal: agentForPortal
    }));
var $c1789089b6d4b8f8$export$2e2bcd8739ae039 = (0, $9XZeF.connect)($c1789089b6d4b8f8$var$selector, {})((0, $fcCIH.default)($c1789089b6d4b8f8$export$64cd47482e3a83fe));

});
parcelRegister("aC1um", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9b0fbd997881b63$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $f9b0fbd997881b63$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    unknownField: {
        defaultMessage: 'Unknown field: {id}',
        description: 'Fallback message to display field when its type is unknown',
        id: 'cv.request.create.form.field.unknown'
    }
});

});



parcelRegister("eGyNW", function(module, exports) {
$parcel$export(module.exports, "RecaptchaForm", () => (parcelRequire("2c0lV")).default);

var $2c0lV = parcelRequire("2c0lV");

});
parcelRegister("2c0lV", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e4216d27922f5a2$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $eENmG = parcelRequire("eENmG");

var $8SVUy = parcelRequire("8SVUy");

var $6ZuDy = parcelRequire("6ZuDy");
class $5e4216d27922f5a2$export$2e2bcd8739ae039 extends $fc4bM.PureComponent {
    constructor(props){
        super(props), this.state = {
            isExecuting: false,
            isError: false
        }, this.lastFormSubmissionEvent = undefined, this.recaptchaInstance = undefined, this.onSubmit = (e)=>{
            if (this.props.recaptchaEnabled) this.handleRecaptchaOnSubmit(e);
            else this.props.onSubmit && this.props.onSubmit(e);
        }, this.handleRecaptchaOnSubmit = (e)=>{
            e.persist();
            e.preventDefault();
            this.lastFormSubmissionEvent = e;
            // If the recaptcha instance has not loaded properly then show an error
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
            if (this.recaptchaInstance == null || this.recaptchaInstance.getWidgetId() == null) this.setState({
                isError: true
            });
            else {
                this.setState({
                    isExecuting: true
                });
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
                this.recaptchaInstance && this.recaptchaInstance.reset();
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
                this.recaptchaInstance && this.recaptchaInstance.execute();
            }
        }, this.handeRecaptchaOnChange = (token)=>{
            if (this.props.onSubmit && this.lastFormSubmissionEvent) {
                this.props.onTokenChange(token);
                this.props.onSubmit(this.lastFormSubmissionEvent);
            }
            this.setState({
                isExecuting: false
            });
        }, this.onError = ()=>{
            // This is to ensure the user can retry after an recaptcha error.
            this.setState({
                isExecuting: false
            });
        }, this.onDismissError = ()=>{
            this.setState({
                isError: false
            });
        };
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any, @atlassian/ssr-linting/no-dom-globals-in-constructor
        window.recaptchaOptions = {
            useRecaptchaNet: true
        };
    }
    render() {
        const { children: children, sitekey: sitekey, recaptchaEnabled: recaptchaEnabled, formRef: formRef, onSubmit: onSubmit, onTokenChange: _, ...formProps } = this.props;
        return /*#__PURE__*/ $fc4bM.createElement((0, $eENmG.AnalyticsContext), {
            attributes: {
                sitekey: sitekey,
                recaptchaEnabled: recaptchaEnabled
            }
        }, /*#__PURE__*/ $fc4bM.createElement("form", {
            ...formProps,
            ref: formRef,
            onSubmit: this.onSubmit
        }, children({
            isExecuting: this.state.isExecuting
        }), recaptchaEnabled && sitekey && /*#__PURE__*/ $fc4bM.createElement((0, $8SVUy.default), {
            ref: (e)=>{
                /* eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment */ /* oxlint-disable-next-line no-return-assign */ return this.recaptchaInstance = e;
            },
            sitekey: sitekey,
            onChange: this.handeRecaptchaOnChange,
            size: "invisible",
            onErrored: this.onError
        }), recaptchaEnabled && sitekey && this.state.isError && /*#__PURE__*/ $fc4bM.createElement((0, $6ZuDy.RecaptchaFormError), {
            onDismiss: this.onDismissError
        })));
    }
}

});
parcelRegister("8SVUy", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2c8c3a910a36d18$export$2e2bcd8739ae039);

var $f025p = parcelRequire("f025p");
var $b2c8c3a910a36d18$export$2e2bcd8739ae039 = (0, $f025p.default);

});
parcelRegister("f025p", function(module, exports) {
$parcel$export(module.exports, "default", () => $d046b297224571d3$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $lTM5g = parcelRequire("lTM5g");
class $d046b297224571d3$export$d720047286fe21e9 extends $fc4bM.Component {
    static #_ = this.defaultProps = {
        onChange: ()=>0,
        theme: 'light',
        type: 'image',
        tabindex: 0,
        size: 'normal',
        badge: 'bottomright'
    };
    constructor(props){
        super(props), this._executeRequested = false;
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this.handleExpired = this.handleExpired.bind(this);
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this.handleErrored = this.handleErrored.bind(this);
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this.handleRecaptchaRef = this.handleRecaptchaRef.bind(this);
    }
    getValue() {
        if (this.props.grecaptcha && this.props.grecaptcha.enterprise && this._widgetId !== undefined) return this.props.grecaptcha.enterprise.getResponse(this._widgetId);
        return null;
    }
    getWidgetId() {
        if (this.props.grecaptcha && this._widgetId !== undefined) return this._widgetId;
        return null;
    }
    execute() {
        const { grecaptcha: grecaptcha } = this.props;
        if (grecaptcha && grecaptcha.enterprise && this._widgetId !== undefined) return grecaptcha.enterprise.execute(this._widgetId);
        this._executeRequested = true;
        return null;
    }
    reset() {
        if (this.props.grecaptcha && this.props.grecaptcha.enterprise && this._widgetId !== undefined) this.props.grecaptcha.enterprise.reset(this._widgetId);
    }
    handleExpired() {
        if (this.props.onExpired) this.props.onExpired();
        else if (this.props.onChange) /*
                   we will be resetting the recaptcha after the faulty token expires.
                   The expiry will happen once the current token has returned a 400 from the JIRA backend,
                   which will keep the page on the same route and not navigate further and thus lead to token
                   expiry from google which is around 2mins.
                   In case of a success, the route changes so this condition is out of question.
               */ this.reset();
    }
    handleErrored() {
        if (this.props.onErrored) this.props.onErrored();
    }
    explicitRender() {
        if (this.props.grecaptcha && this.props.grecaptcha.enterprise && this.props.grecaptcha.enterprise.render && this._widgetId === undefined) {
            // Upgrading @atlaskit/platform; fix these violations.
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            const wrapper = document.createElement('div');
            this._widgetId = this.props.grecaptcha.enterprise.render(wrapper, {
                sitekey: this.props.sitekey,
                callback: this.props.onChange,
                theme: this.props.theme,
                type: this.props.type,
                tabindex: this.props.tabindex,
                'expired-callback': this.handleExpired,
                'error-callback': this.handleErrored,
                size: this.props.size,
                stoken: this.props.stoken,
                hl: this.props.hl,
                badge: this.props.badge
            });
            this.captcha.appendChild(wrapper);
        }
        if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
            this._executeRequested = false;
            this.execute();
        }
    }
    componentDidMount() {
        this.explicitRender();
    }
    componentDidUpdate() {
        this.explicitRender();
    }
    componentWillUnmount() {
        if (this._widgetId !== undefined) {
            this.delayOfCaptchaIframeRemoving();
            this.reset();
        }
    }
    delayOfCaptchaIframeRemoving() {
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        const temporaryNode = document.createElement('div');
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        document.body.appendChild(temporaryNode);
        temporaryNode.style.display = 'none';
        // move of the recaptcha to a temporary node
        while(this.captcha.firstChild)temporaryNode.appendChild(this.captcha.firstChild);
        // delete the temporary node after reset will be done
        setTimeout(()=>{
            // Upgrading @atlaskit/platform; fix these violations.
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            document.body.removeChild(temporaryNode);
        }, 5000);
    }
    handleRecaptchaRef(elem) {
        this.captcha = elem;
    }
    render() {
        // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.
        const { sitekey: sitekey, onChange: onChange, theme: theme, type: type, tabindex: tabindex, onExpired: onExpired, onErrored: onErrored, size: size, stoken: stoken, grecaptcha: grecaptcha, badge: badge, hl: hl, ...childProps } = this.props;
        return /*#__PURE__*/ $fc4bM.createElement("div", {
            ...childProps,
            ref: this.handleRecaptchaRef
        });
    }
}
const $d046b297224571d3$var$callbackName = 'onloadcallback';
const $d046b297224571d3$var$globalName = 'grecaptcha';
const $d046b297224571d3$var$recaptchaOptions = 'recaptchaOptions';
// @ts-ignore TS(7015) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because index... Remove this comment to see the full error message
// Suppressing existing violation. Please fix this.
// eslint-disable-next-line @typescript-eslint/no-unsafe-return
const $d046b297224571d3$var$getOptions = ()=>typeof window !== 'undefined' && window[$d046b297224571d3$var$recaptchaOptions] || {};
function $d046b297224571d3$export$152462a4e1ffe278() {
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const dynamicOptions = $d046b297224571d3$var$getOptions();
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-unsafe-member-access
    const lang = dynamicOptions.lang ? `&hl=${dynamicOptions.lang}` : '';
    const hostname = 'www.google.com';
    return `https://${hostname}/recaptcha/enterprise.js?onload=${$d046b297224571d3$var$callbackName}&render=explicit${lang}`;
}
var // Suppressing existing violation. Please fix this.
// eslint-disable-next-line @typescript-eslint/no-unsafe-call
$d046b297224571d3$export$2e2bcd8739ae039 = (0, $lTM5g.default)($d046b297224571d3$export$152462a4e1ffe278, {
    callbackName: $d046b297224571d3$var$callbackName,
    globalName: $d046b297224571d3$var$globalName,
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    removeOnUnmount: $d046b297224571d3$var$getOptions().removeOnUnmount || false
})($d046b297224571d3$export$d720047286fe21e9);

});


parcelRegister("6ZuDy", function(module, exports) {
$parcel$export(module.exports, "RecaptchaFormError", () => $07f368054d0a14b5$export$c70e25c9a04c26c4);

var $aWDCT = parcelRequire("aWDCT");

var $bntPj = parcelRequire("bntPj");
const $07f368054d0a14b5$export$c70e25c9a04c26c4 = (0, $aWDCT.PortalAnalyticsInlineDialog)('RecaptchaError')((0, $bntPj.default));

});
parcelRegister("bntPj", function(module, exports) {
$parcel$export(module.exports, "default", () => $d56eef803e25395a$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fcCIH = parcelRequire("fcCIH");

var $bAQQ9 = parcelRequire("bAQQ9");

var $jS4uw = parcelRequire("jS4uw");

var $48hlF = parcelRequire("48hlF");

var $eENmG = parcelRequire("eENmG");

var $lvRbB = parcelRequire("lvRbB");

var $kiRdG = parcelRequire("kiRdG");
class $d56eef803e25395a$export$c70e25c9a04c26c4 extends $fc4bM.PureComponent {
    render() {
        const { intl: intl, onDismiss: onDismiss } = this.props;
        const errorMessageTitle = intl.formatMessage((0, $kiRdG.default).loadErrorTitle);
        const errorMessageDescription = intl.formatMessage((0, $kiRdG.default).loadErrorDesc);
        return /*#__PURE__*/ $fc4bM.createElement((0, $eENmG.AnalyticsContext), {
            attributes: {
                recaptchaError: 'load'
            }
        }, /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement((0, $bAQQ9.default), {
            onDismissed: onDismiss
        }, /*#__PURE__*/ $fc4bM.createElement((0, $jS4uw.default), {
            id: "recaptcha-fail-flag",
            icon: /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($48hlF))), {
                spacing: "spacious",
                color: "var(--ds-icon-danger, #BF2600)",
                label: "error-with-recaptcha"
            }),
            title: errorMessageTitle,
            description: errorMessageDescription
        })), /*#__PURE__*/ $fc4bM.createElement((0, $lvRbB.FireScreenEventOnMount), null)));
    }
}
var $d56eef803e25395a$export$2e2bcd8739ae039 = (0, $fcCIH.default)($d56eef803e25395a$export$c70e25c9a04c26c4);

});
parcelRegister("kiRdG", function(module, exports) {
$parcel$export(module.exports, "default", () => $35083ff7a4121713$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $35083ff7a4121713$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    loadErrorTitle: {
        defaultMessage: 'Error submitting form',
        description: 'Error title shown when the recaptcha is blocked or fails to load on the page',
        id: 'sd.recaptcha.load.error.title'
    },
    loadErrorDesc: {
        defaultMessage: 'We were unable verify that you are not a bot. Reload your form and give it another try. If the problem persists please contact your Administrator.',
        description: 'Error description shown when the recaptcha is blocked or fails to load on the page',
        id: 'sd.recaptcha.load.error.desc'
    }
});

});





parcelRegister("axCcv", function(module, exports) {
$parcel$export(module.exports, "RequestCreatePropertyPanelModule", () => $727a7a9c25c9da36$export$39102d36f906b040);

var $bQkfB = parcelRequire("bQkfB");

var $ieUrC = parcelRequire("ieUrC");

const $727a7a9c25c9da36$export$39102d36f906b040 = (0, $bQkfB.default)({
    loader: (0, $ieUrC.lazyForPaint)(()=>(parcelRequire("dOwSa")), {
        moduleId: "./src/view/forge-ui/request-create-property-panel/request-create-property-panel.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("dOwSa", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("79KZp").then(()=>parcelRequire('a2jmC'));

});


parcelRegister("fLu4j", function(module, exports) {
$parcel$export(module.exports, "ButtonGroup", () => $0e96be8621dc8389$export$69b1032f2ecdf404);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $luz1X = parcelRequire("luz1X");

var $3DjOo = parcelRequire("3DjOo");
const $0e96be8621dc8389$export$69b1032f2ecdf404 = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-17h17d1-0"
})`${$3DjOo.flexCenter};margin-top:${"var(--ds-space-200, 16px)"};justify-content:flex-start;> *{margin-right:${"var(--ds-space-100, 8px)"};}`;

});

parcelRegister("6Cpd6", function(module, exports) {
$parcel$export(module.exports, "CmdbObjectPicker", () => (parcelRequire("36Ozg")).default);

var $36Ozg = parcelRequire("36Ozg");

});
parcelRegister("36Ozg", function(module, exports) {
$parcel$export(module.exports, "default", () => $c99ae855429ba09b$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $53bjB = parcelRequire("53bjB");

var $3ZJj6 = parcelRequire("3ZJj6");

var $iya1I = parcelRequire("iya1I");

var $hN5YJ = parcelRequire("hN5YJ");

var $fcCIH = parcelRequire("fcCIH");

var $4h23n = parcelRequire("4h23n");

var $k2M4v = parcelRequire("k2M4v");

var $jS4uw = parcelRequire("jS4uw");

var $bAQQ9 = parcelRequire("bAQQ9");

var $gDsF8 = parcelRequire("gDsF8");

var $aIVqJ = parcelRequire("aIVqJ");

var $ehZx5 = parcelRequire("ehZx5");
parcelRequire("1XkRq");
var $iAoWi = parcelRequire("iAoWi");
parcelRequire("liiP6");
var $78E3R = parcelRequire("78E3R");

var $3mq0K = parcelRequire("3mq0K");

var $5auA6 = parcelRequire("5auA6");
const $c99ae855429ba09b$var$NEW_EXPERIENCE_GATE = 'assets_custom_fields_limit_increase_ga';
const $c99ae855429ba09b$var$isNewExperienceEnabled = ()=>(0, $k2M4v.default).checkGate($c99ae855429ba09b$var$NEW_EXPERIENCE_GATE);
const $c99ae855429ba09b$var$MAX_OBJECT_COUNT_CUTOFF = 1000;
class $c99ae855429ba09b$export$1c8a8ad79184b709 extends $fc4bM.Component {
    componentDidMount() {
        if ((0, $k2M4v.default).checkGate('assets_custom_field_ui_assign_strict_scope') && this.props.assignStrict === true) return;
        if (this.props.populateDefaultValue) // Disabling existing violations, should be fixed when revisited.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.getObjectOptions(()=>this.fetchFunction('', false, true), true);
        if ((0, $hN5YJ.isJsmPortalRovoIntegrationEnabled)()) {
            if (this.props.initialValues) this.setState({
                values: this.props.initialValues
            });
        }
    }
    componentDidUpdate(prevProps) {
        if ((0, $k2M4v.default).checkGate('assets_custom_field_ui_assign_strict_scope') && (prevProps.id !== this.props.id || prevProps.portalId !== this.props.portalId || prevProps.requestTypeId !== this.props.requestTypeId)) this.hasManualChanges = false;
        if ((0, $k2M4v.default).checkGate('assets_custom_field_ui_assign_strict_scope') && this.props.assignStrict === true) {
            if (prevProps.assignStrict !== true || prevProps.id !== this.props.id) {
                var _this$abortController;
                (_this$abortController = this.abortController) === null || _this$abortController === void 0 || _this$abortController.abort();
            }
            return;
        }
        if (this.props.populateDefaultValue && !(0, (/*@__PURE__*/$parcel$interopDefault($3ZJj6)))(prevProps.placeholderValues, this.props.placeholderValues)) // Disabling existing violations, should be fixed when revisited.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.getObjectOptions(()=>this.fetchFunction('', false, true), true);
    }
    renderNewExperience() {
        const { options: options, loading: loading, values: values, hasNextPage: hasNextPage } = this.state;
        const { isMulti: isMulti, limit: limit, label: label, required: required, errorMessage: errorMessage, filterAttributes: filterAttributes } = this.props;
        const selectedObjects = values.map((v)=>v.cmdbObject).filter((o)=>Boolean(o));
        const searchResults = options.map((o)=>o.cmdbObject).filter((o)=>Boolean(o));
        return /*#__PURE__*/ $fc4bM.createElement((0, $iya1I.default), {
            id: 'cmdb-object-picker',
            packageName: 'portal_fields'
        }, /*#__PURE__*/ $fc4bM.createElement((0, $iAoWi.PaginatedObjectsView), {
            selectedObjects: selectedObjects,
            searchResults: searchResults,
            isMulti: isMulti,
            limit: limit,
            attributesToDisplayInSearch: filterAttributes,
            fieldLabel: label,
            searchQuery: this.state.lastSearchedInputValue,
            onSearchChange: this.handleNewSearch,
            isLoading: loading,
            hasMore: hasNextPage,
            onLoadMore: this.handleNewLoadMore,
            onSelectionCommit: this.handleSelectionCommit,
            required: required,
            errorMessage: errorMessage
        }));
    }
    render() {
        if ((0, $k2M4v.default).checkGate('assets_custom_field_ui_assign_strict_scope') && this.props.assignStrict === true) return /*#__PURE__*/ $fc4bM.createElement((0, $5auA6.AssignScopePreview), {
            portalId: this.props.portalId,
            requestTypeId: this.props.requestTypeId,
            fieldId: this.props.id,
            fieldValueMap: this.props.fieldValueMap,
            fieldLabel: this.props.label,
            isMulti: this.props.isMulti,
            limit: this.props.limit,
            errorMessage: this.props.errorMessage
        });
        // The new create-issue-style experience only applies to multi-select fields.
        // Single-select CMDB fields always use the original picker.
        if (this.props.isMulti && $c99ae855429ba09b$var$isNewExperienceEnabled()) return this.renderNewExperience();
        const { options: options, loading: loading, responseTotal: responseTotal, selectedOptions: selectedOptions, values: values, flags: flags } = this.state;
        const { onChange: onChange, populateDefaultValue: populateDefaultValue, intl: intl, ...otherProps } = this.props;
        // This feature gate turns the component into a completely controlled component.
        // Previously it was uncontrolled except for when `populateDefaultValue` was true, making the logic
        // difficult to follow.
        const controlledComponentState = (0, $k2M4v.default).checkGate('jsm_assets_field_only_display_label_in_portal');
        let numberOfAlreadySelectedSearchResults;
        if (controlledComponentState) // If always a controlled component, then we can just rely on `values` and don't need `selectedOptions`.
        // Please clean up `selectedOptions` when removing jsm_assets_field_only_display_label_in_portal feature gate.
        numberOfAlreadySelectedSearchResults = options.filter((object)=>values.some((value)=>value.value === object.value)).length;
        else numberOfAlreadySelectedSearchResults = options.filter((object)=>selectedOptions.some((option)=>option === object.value)).length;
        return /*#__PURE__*/ $fc4bM.createElement((0, $iya1I.default), {
            id: 'cmdb-object-picker',
            packageName: 'portal_fields'
        }, /*#__PURE__*/ $fc4bM.createElement((0, $78E3R.default), {
            ...otherProps,
            doInitialSearch: true,
            onInputChange: this.onInputChangeDebounced,
            options: this.getOptionsWithLabel(options, responseTotal, numberOfAlreadySelectedSearchResults),
            onFocus: this.onFocus,
            isLoading: loading,
            defaultValue: values,
            onChange: populateDefaultValue || controlledComponentState ? this.onChange : onChange,
            populateDefaultValue: populateDefaultValue,
            classNamePrefix: "cmdbObjectPickerField",
            onMenuScrollToBottom: this.onMenuScrollToBottom
        }), /*#__PURE__*/ $fc4bM.createElement((0, $bAQQ9.default), {
            onDismissed: this.dismissErrorFlag
        }, flags.map((flagId)=>{
            return /*#__PURE__*/ $fc4bM.createElement((0, $jS4uw.default), {
                id: flagId,
                icon: /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDsF8))), {
                    color: "var(--ds-icon-danger, #BF2600)",
                    label: "Error",
                    spacing: "spacious"
                }),
                key: flagId,
                title: intl.formatMessage((0, $3mq0K.default).errorFlagTitle),
                description: intl.formatMessage((0, $3mq0K.default).errorFlagDescription)
            });
        })));
    }
    constructor(...args){
        super(...args), this.state = {
            options: [],
            values: [],
            loading: false,
            responseTotal: 0,
            selectedOptions: [],
            flags: [],
            hasNextPage: false,
            lastSearchedInputValue: ''
        }, this.abortController = null, this.hasManualChanges = false, this.getLabel = (total)=>{
            const { intl: intl } = this.props;
            return (total ?? 0) >= $c99ae855429ba09b$var$MAX_OBJECT_COUNT_CUTOFF ? intl.formatMessage((0, $3mq0K.default).dropdownMaxNumberOfSearchResultsLabel, {
                maxObjectCountCutoff: $c99ae855429ba09b$var$MAX_OBJECT_COUNT_CUTOFF
            }) : intl.formatMessage((0, $3mq0K.default).dropdownNumberOfSearchResultsLabel, {
                numberOfSearchResults: total
            });
        }, this.getOptionsWithLabel = (options, numberOfResults, numberOfAlreadySelectedResults)=>{
            if ((0, $k2M4v.default).checkGate('jsm_assets_field_only_display_label_in_portal')) {
                // When isMulti is true, selected values are stripped out from the results dropdown.
                if (this.props.isMulti) return [
                    {
                        options: options,
                        label: this.getLabel(numberOfResults - numberOfAlreadySelectedResults)
                    }
                ];
                return [
                    {
                        options: options,
                        label: this.getLabel(numberOfResults)
                    }
                ];
            }
            return [
                {
                    options: options,
                    label: this.getLabel(numberOfResults - numberOfAlreadySelectedResults)
                }
            ];
        }, // getObjectOptions, fetchFunction retrieveObjects used by FIS FF
        this.getSearchableObject = (cmdbObject, attributesToDisplayInSearch)=>{
            const getDisplayValuesFromAttribute = (attribute)=>attribute.objectAttributeValues.map((val)=>val.displayValue).join(' ');
            // This label is the string value that @atlaskit/select uses under the hood
            // to determine a 'match' when typing in the select field. Therefore, we need to
            // build a string that includes values for all the attributes marked as
            // 'searchable' within the Insight field configuration.
            const searchableLabel = cmdbObject.attributes.map((attribute)=>{
                if (attributesToDisplayInSearch.includes(attribute.objectTypeAttribute.name) || attributesToDisplayInSearch.includes('Label') && attribute.objectTypeAttribute.label) return getDisplayValuesFromAttribute(attribute);
                return undefined;
            }).filter(Boolean).join(' ');
            // Label should fall back to the label attribute of the object if it doesn't contain any of the search attributes
            return {
                cmdbObject: cmdbObject,
                value: cmdbObject.id,
                label: searchableLabel || cmdbObject.label
            };
        }, this.getObjectOptions = async (fetchFunction, setValues = false)=>{
            const { populateDefaultValue: populateDefaultValue, isMulti: isMulti, limit: limit, id: id } = this.props;
            try {
                const response = await fetchFunction();
                // A manual/default request may finish after the field switches to strict mode.
                if ((0, $k2M4v.default).checkGate('assets_custom_field_ui_assign_strict_scope') && this.props.assignStrict === true) return;
                const options = response.cmdbObjects.map((object)=>this.getSearchableObject(object, this.props.filterAttributes));
                this.setState({
                    responseTotal: response.total
                });
                if (populateDefaultValue && setValues && !((0, $k2M4v.default).checkGate('assets_custom_field_ui_assign_strict_scope') && this.hasManualChanges)) {
                    var _this$props$onChange, _this$props;
                    const newValues = this.getDefaultInitialValues(options, isMulti, limit);
                    this.setState({
                        values: newValues
                    });
                    (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, id, newValues.map((val)=>val ? val.value : ''));
                }
                this.setState((prevState)=>({
                        options: [
                            ...prevState.options,
                            ...options
                        ]
                    }));
            } catch (error) {
                // Ensure the dropdown never gets stuck on the loading spinner if the fetch (or
                // subsequent processing) throws. fetchFunction already handles its own errors, but
                // this guards against any other failure in this method.
                this.setState({
                    loading: false
                });
                (0, $aIVqJ.trackError)('cmdb-fetch-error', {}, error);
            }
        }, this.addErrorFlag = ()=>{
            const { flags: flags } = this.state;
            const newFlags = [
                ...flags
            ];
            newFlags.splice(0, 0, (0, $4h23n.v4)());
            this.setState({
                flags: newFlags
            });
        }, this.dismissErrorFlag = ()=>{
            const flags = this.state.flags;
            this.setState({
                flags: flags.splice(1)
            });
        }, this.handleError = (error)=>{
            if (error.status === 400) this.addErrorFlag();
        }, this.fetchFunction = (inputValue, isNextPageQuery = false, includeAssignScope = false)=>{
            // Abort any in-flight requests, and create a new AbortController for the new request.
            if (this.abortController) this.abortController.abort('Cancelling in-flight request');
            const abortController = new AbortController();
            this.abortController = abortController;
            const { signal: signal } = abortController;
            // If fetching a fresh set of values rather than a subsequent page, clear out the options shown in the dropdown.
            if (!isNextPageQuery) this.setState({
                options: []
            });
            this.setState({
                loading: true
            });
            return (0, $ehZx5.fetchCmdbObjectsWithSignal)(this.props.portalId, this.props.requestTypeId, this.props.id, inputValue, this.props.fieldValueMap, signal, isNextPageQuery ? this.state.options.length : 0, includeAssignScope).then((response)=>{
                this.setState({
                    hasNextPage: response.hasNextPage,
                    lastSearchedInputValue: inputValue,
                    loading: false
                });
                return response;
            }).catch((err)=>{
                if (!abortController.signal.aborted) {
                    (0, $aIVqJ.trackError)('cmdb-fetch-error', {}, err);
                    this.handleError(err);
                    this.setState({
                        loading: false
                    });
                }
                return {
                    cmdbObjects: [],
                    total: 0,
                    hasNextPage: false
                };
            });
        }, this.retrieveObjects = (inputValue, type)=>{
            if (type.action === 'input-change') // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.getObjectOptions(()=>this.fetchFunction(inputValue));
        }, this.onInputChangeDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($53bjB)))(this.retrieveObjects, 400), this.onMenuScrollToBottom = async ()=>{
            if (this.state.hasNextPage) await this.getObjectOptions(()=>this.fetchFunction(this.state.lastSearchedInputValue, true));
        }, this.onFocus = ()=>{
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.getObjectOptions(()=>this.fetchFunction(''));
        }, this.onChange = (name, value)=>{
            var _this$props$onChange2, _this$props2;
            if ((0, $k2M4v.default).checkGate('assets_custom_field_ui_assign_strict_scope')) this.hasManualChanges = true;
            this.setState({
                selectedOptions: value
            });
            // The existing code breaks if a search is currently in progress because prevState.options is empty.
            if ((0, $k2M4v.default).checkGate('jsm_assets_field_only_display_label_in_portal')) this.setState((prevState)=>{
                // prevState.values will have existing values, and `prevState.options` will have potential new values.
                // We cannot only rely on prevState.options because they will be empty if search is occurring right now.
                // Get all existing values from prevValues
                const valuesFromExisting = prevState.values.filter((val)=>value === null || value === void 0 ? void 0 : value.includes(val === null || val === void 0 ? void 0 : val.value));
                // Get any new values from options
                const valuesFromSearch = prevState.options.filter((opt)=>value === null || value === void 0 ? void 0 : value.includes(opt === null || opt === void 0 ? void 0 : opt.value));
                // Combine and dedupe
                const newValues = [
                    ...valuesFromExisting,
                    ...valuesFromSearch
                ].filter((obj1, i, arr)=>arr.findIndex((obj2)=>obj2.value === obj1.value) === i);
                return {
                    values: newValues
                };
            });
            else this.setState((prevState)=>({
                    values: prevState.options.filter((opt)=>value === null || value === void 0 ? void 0 : value.includes(opt === null || opt === void 0 ? void 0 : opt.value))
                }));
            (_this$props$onChange2 = (_this$props2 = this.props).onChange) === null || _this$props$onChange2 === void 0 || _this$props$onChange2.call(_this$props2, name, value);
        }, this.getDefaultInitialValues = (options, isMulti, limit)=>{
            if (options.length === 0 && (0, $k2M4v.default).checkGate('jsm_assets_field_only_display_label_in_portal')) return options;
            if (isMulti) return options.length > limit ? options.slice(0, limit - 1) : options;
            return [
                options[0]
            ];
        }, // --- New (create-issue style) experience handlers, gated behind NEW_EXPERIENCE_GATE ---
        this.handleNewSearch = (query)=>{
            this.setState({
                lastSearchedInputValue: query
            });
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.getObjectOptions(()=>this.fetchFunction(query));
        }, this.handleNewLoadMore = ()=>{
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.onMenuScrollToBottom();
        }, this.handleSelectionCommit = (objects)=>{
            var _this$props$onChange3, _this$props3;
            if ((0, $k2M4v.default).checkGate('assets_custom_field_ui_assign_strict_scope')) this.hasManualChanges = true;
            const newValues = objects.map((object)=>this.getSearchableObject(object, this.props.filterAttributes));
            this.setState({
                values: newValues
            });
            (_this$props$onChange3 = (_this$props3 = this.props).onChange) === null || _this$props$onChange3 === void 0 || _this$props$onChange3.call(_this$props3, this.props.id, newValues.map((val)=>val.value));
        };
    }
}
var $c99ae855429ba09b$export$2e2bcd8739ae039 = (0, $fcCIH.default)($c99ae855429ba09b$export$1c8a8ad79184b709);

});
parcelRegister("1XkRq", function(module, exports) {
$parcel$export(module.exports, "PaginatedObjectsView", () => (parcelRequire("iAoWi")).PaginatedObjectsView);

var $iAoWi = parcelRequire("iAoWi");

var $eUTjw = parcelRequire("eUTjw");

});
parcelRegister("iAoWi", function(module, exports) {
$parcel$export(module.exports, "PaginatedObjectsView", () => $14cbacd356ee390c$export$6c89780265eb1a35);

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $jEubQ = parcelRequire("jEubQ");

var $eENmG = parcelRequire("eENmG");

var $5a4EU = parcelRequire("5a4EU");

var $lgMZ2 = parcelRequire("lgMZ2");

var $7yidP = parcelRequire("7yidP");

var $4T8rw = parcelRequire("4T8rw");

var $kig2V = parcelRequire("kig2V");

var $k2M4v = parcelRequire("k2M4v");

var $kTVlm = parcelRequire("kTVlm");

var $fRCnG = parcelRequire("fRCnG");

var $jGvkt = parcelRequire("jGvkt");

var $48hlF = parcelRequire("48hlF");

var $gV8E5 = parcelRequire("gV8E5");

var $13zmE = parcelRequire("13zmE");

var $8K7DG = parcelRequire("8K7DG");

var $2feYn = parcelRequire("2feYn");

var $bcTS3 = parcelRequire("bcTS3");

var $aEtFp = parcelRequire("aEtFp");

var $4EPUx = parcelRequire("4EPUx");

var $kAjco = parcelRequire("kAjco");

var $gSOfb = parcelRequire("gSOfb");

var $3rlj9 = parcelRequire("3rlj9");

var $eaozo = parcelRequire("eaozo");

var $jfcYL = parcelRequire("jfcYL");

var $eUTjw = parcelRequire("eUTjw");

var $hrDvi = parcelRequire("hrDvi");

var $2xHR5 = parcelRequire("2xHR5");

var $9Zxa0 = parcelRequire("9Zxa0");
/** Number of selected-object cards shown per page in the field. */ const $14cbacd356ee390c$var$CARDS_PER_PAGE = 10;
const $14cbacd356ee390c$var$EMPTY_ATTRIBUTE_NAMES = [];
const $14cbacd356ee390c$export$6c89780265eb1a35 = ({ selectedObjects: selectedObjects, searchResults: searchResults, isMulti: isMulti, limit: limit, fieldLabel: fieldLabel, searchQuery: searchQuery, onSearchChange: onSearchChange, isLoading: isLoading, hasMore: hasMore, onLoadMore: onLoadMore, onSelectionCommit: onSelectionCommit, errorMessage: errorMessage, attributesToDisplayInSearch: attributesToDisplayInSearch = $14cbacd356ee390c$var$EMPTY_ATTRIBUTE_NAMES, required: required = false, isReadOnly: isReadOnly = false })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const addTriggerLabel = (0, $hrDvi.default).addObjectsLabel;
    const hasError = errorMessage != null && errorMessage !== '';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $fc4bM.useState)(false);
    // Mirror of `isOpen` so event handlers can read the latest value without putting
    // side effects inside a setState updater (which React 18 may invoke more than once).
    const isOpenRef = (0, $fc4bM.useRef)(isOpen);
    (0, $fc4bM.useEffect)(()=>{
        isOpenRef.current = isOpen;
    }, [
        isOpen
    ]);
    // In-dropdown checkbox selections (object ids) staged before the user confirms with "Add".
    const [pendingIds, setPendingIds] = (0, $fc4bM.useState)([]);
    // Which page of selected-object cards is shown in the field.
    const [cardsPage, setCardsPage] = (0, $fc4bM.useState)(0);
    // Search query over the already-added objects (filters the cards list).
    const [listSearchQuery, setListSearchQuery] = (0, $fc4bM.useState)('');
    // Caches the full CmdbObject for every id that gets checked, so a confirm can still resolve
    // objects that were evicted from the current search results by a later query change.
    const pendingObjectsRef = (0, $fc4bM.useRef)(new Map());
    // The dropdown shows all search results; already-added objects appear pre-checked
    // (their id is seeded into pendingIds on open).
    // Set for O(1) membership checks instead of O(n) Array.includes.
    const pendingIdSet = (0, $fc4bM.useMemo)(()=>new Set(pendingIds), [
        pendingIds
    ]);
    const attributesToDisplaySet = (0, $fc4bM.useMemo)(()=>new Set(attributesToDisplayInSearch), [
        attributesToDisplayInSearch
    ]);
    const dropdownItems = (0, $fc4bM.useMemo)(()=>searchResults.map((object)=>{
            const metadata = object.attributes.filter((attribute)=>attributesToDisplaySet.has(attribute.objectTypeAttribute.name) || attributesToDisplaySet.has('Label') && attribute.objectTypeAttribute.label).flatMap((attribute)=>attribute.objectAttributeValues.map((value)=>value.displayValue).filter((value)=>Boolean(value)));
            return {
                object: object,
                isSelected: pendingIdSet.has(object.id),
                metadata: metadata.length > 0 ? metadata : undefined
            };
        }), [
        searchResults,
        pendingIdSet,
        attributesToDisplaySet
    ]);
    // Resolve an id to its object from search results or the already-committed set
    // (a pre-checked object may not be on the current search page).
    const objectById = (0, $fc4bM.useMemo)(()=>{
        const map = new Map();
        selectedObjects.forEach((o)=>map.set(o.id, o));
        searchResults.forEach((o)=>map.set(o.id, o));
        return map;
    }, [
        selectedObjects,
        searchResults
    ]);
    // Ids already committed to the field (the main list).
    const committedIds = (0, $fc4bM.useMemo)(()=>new Set(selectedObjects.map((o)=>o.id)), [
        selectedObjects
    ]);
    // "N selected" = the number of currently-checked rows in the dropdown. On open this is seeded
    // with the main-list objects (so reopen shows them checked), and it drops by one when a row is
    // unchecked.
    const selectedCount = pendingIds.length;
    // The whole field must not exceed the limit. The checked set (pendingIds) already includes the
    // pre-checked committed objects, so the checked count is the eventual field size.
    const isLimitReached = selectedCount >= limit;
    // "Select first N results" / "Showing N" reflect what can still be selected, capped at the limit.
    const allowedLimit = limit;
    // Confirm is enabled when the checked set differs from the current main list (additions/removals).
    const hasChanges = (0, $fc4bM.useMemo)(()=>{
        const pendingSet = new Set(pendingIds);
        const hasAdditions = pendingIds.some((id)=>!committedIds.has(id));
        const hasRemovals = selectedObjects.some((o)=>!pendingSet.has(o.id));
        return hasAdditions || hasRemovals;
    }, [
        pendingIds,
        committedIds,
        selectedObjects
    ]);
    const closeAndReset = (0, $fc4bM.useCallback)(()=>{
        setIsOpen(false);
        setPendingIds([]);
        pendingObjectsRef.current.clear();
        onSearchChange('');
    }, [
        onSearchChange
    ]);
    // Fired when the dropdown is dismissed via Cancel (or clicking away).
    const handleCancel = (0, $fc4bM.useCallback)(()=>{
        createAnalyticsEvent({
            analyticsType: (0, $eENmG.UI_EVENT_TYPE),
            action: 'cancelled',
            actionSubject: 'cmdbObjectPicker',
            source: 'cmdbObjectPicker',
            selectedCount: pendingIds.length
        }).fire();
        closeAndReset();
    }, [
        createAnalyticsEvent,
        closeAndReset,
        pendingIds.length
    ]);
    // Wrap the dropdown search so each query change is tracked (search over the searchable results).
    const handleDropdownSearchChange = (0, $fc4bM.useCallback)((query)=>{
        createAnalyticsEvent({
            analyticsType: (0, $eENmG.UI_EVENT_TYPE),
            action: 'searched',
            actionSubject: 'cmdbObjectPicker',
            source: 'cmdbObjectPicker',
            resultCount: searchResults.length
        }).fire();
        onSearchChange(query);
    }, [
        createAnalyticsEvent,
        onSearchChange,
        searchResults.length
    ]);
    // Wrap load-more (infinite scroll / "Load more") so paginated fetches are tracked.
    const handleLoadMore = (0, $fc4bM.useCallback)(()=>{
        createAnalyticsEvent({
            analyticsType: (0, $eENmG.UI_EVENT_TYPE),
            action: 'loadedMore',
            actionSubject: 'cmdbObjectPicker',
            source: 'cmdbObjectPicker',
            resultCount: searchResults.length
        }).fire();
        onLoadMore();
    }, [
        createAnalyticsEvent,
        onLoadMore,
        searchResults.length
    ]);
    const handleObjectSelectionChange = (0, $fc4bM.useCallback)((objectId, isSelected)=>{
        if (isSelected) {
            // Cache the full object so confirm can resolve it even if a later search evicts it.
            const object = objectById.get(objectId);
            if (object) pendingObjectsRef.current.set(objectId, object);
        }
        setPendingIds((prev)=>{
            if (isSelected) return prev.includes(objectId) ? prev : [
                ...prev,
                objectId
            ];
            return prev.filter((id)=>id !== objectId);
        });
    }, [
        objectById
    ]);
    const handleSelectAllChange = (0, $fc4bM.useCallback)((isChecked)=>{
        createAnalyticsEvent({
            limit: limit,
            analyticsType: (0, $eENmG.UI_EVENT_TYPE),
            action: isChecked ? 'selectedAll' : 'deselectedAll',
            actionSubject: 'cmdbObjectSelection',
            source: 'cmdbObjectPicker',
            resultCount: searchResults.length
        }).fire();
        if (!isChecked) {
            // Only deselect the currently-visible results; preserve pre-checked committed
            // objects that aren't on this search page.
            const visibleIds = new Set(searchResults.map((o)=>o.id));
            setPendingIds((prev)=>prev.filter((id)=>!visibleIds.has(id)));
            return;
        }
        // Fill up to the field limit with the visible results (preserving any already-checked).
        setPendingIds((prev)=>{
            const next = [
                ...prev
            ];
            for (const o of searchResults){
                if (next.length >= limit) break;
                if (!next.includes(o.id)) {
                    next.push(o.id);
                    pendingObjectsRef.current.set(o.id, o);
                }
            }
            return next.slice(0, limit);
        });
    }, [
        searchResults,
        limit,
        createAnalyticsEvent
    ]);
    const handleConfirm = (0, $fc4bM.useCallback)(()=>{
        // The field becomes exactly the checked set. Unchecked items are dropped. Resolve each id
        // from the current results/committed map, falling back to the pending cache so a checked
        // object isn't lost if a later search evicted it from the results.
        const committed = pendingIds.map((id)=>objectById.get(id) ?? pendingObjectsRef.current.get(id)).filter((o)=>Boolean(o));
        onSelectionCommit(committed);
        createAnalyticsEvent({
            analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
            action: 'confirmed',
            actionSubject: 'cmdbObjectSelection',
            selectedCount: committed.length
        }).fire();
        closeAndReset();
    }, [
        pendingIds,
        objectById,
        onSelectionCommit,
        closeAndReset,
        createAnalyticsEvent
    ]);
    const handleRemove = (0, $fc4bM.useCallback)((objectId)=>{
        onSelectionCommit(selectedObjects.filter((o)=>o.id !== objectId));
        createAnalyticsEvent({
            analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
            action: 'removed',
            actionSubject: 'cmdbObject'
        }).fire();
    }, [
        selectedObjects,
        onSelectionCommit,
        createAnalyticsEvent
    ]);
    // All visible results are checked (capped by the field limit).
    const isAllSelected = searchResults.length > 0 && searchResults.slice(0, allowedLimit).every((o)=>pendingIdSet.has(o.id));
    const isIndeterminate = selectedCount > 0 && !isAllSelected;
    // Search over the already-added objects (the cards list), mirroring Create Issue.
    const listFilteredObjects = (0, $fc4bM.useMemo)(()=>{
        const query = listSearchQuery.trim().toLowerCase();
        if (!query) return selectedObjects;
        return selectedObjects.filter((object)=>{
            const label = String(object.label ?? '').toLowerCase();
            return label.includes(query);
        });
    }, [
        selectedObjects,
        listSearchQuery
    ]);
    // Paginate the filtered selected-object cards shown in the field.
    const totalCardPages = Math.max(Math.ceil(listFilteredObjects.length / $14cbacd356ee390c$var$CARDS_PER_PAGE), 1);
    // Keep the current page in range when objects are removed/filtered.
    (0, $fc4bM.useEffect)(()=>{
        if (cardsPage > totalCardPages - 1) setCardsPage(totalCardPages - 1);
    }, [
        cardsPage,
        totalCardPages
    ]);
    const pagedObjects = (0, $fc4bM.useMemo)(()=>listFilteredObjects.slice(cardsPage * $14cbacd356ee390c$var$CARDS_PER_PAGE, cardsPage * $14cbacd356ee390c$var$CARDS_PER_PAGE + $14cbacd356ee390c$var$CARDS_PER_PAGE), [
        listFilteredObjects,
        cardsPage
    ]);
    const isListSearching = listSearchQuery.trim().length > 0;
    const showListSearch = selectedObjects.length > 1;
    const handleListSearchChange = (0, $fc4bM.useCallback)((event)=>{
        createAnalyticsEvent({
            analyticsType: (0, $eENmG.UI_EVENT_TYPE),
            action: 'searched',
            actionSubject: 'cmdbObjectField',
            source: 'cmdbObjectPicker'
        }).fire();
        setListSearchQuery(event.target.value);
        setCardsPage(0);
    }, [
        createAnalyticsEvent
    ]);
    const handleClearListSearch = (0, $fc4bM.useCallback)(()=>{
        createAnalyticsEvent({
            analyticsType: (0, $eENmG.UI_EVENT_TYPE),
            action: 'searchCleared',
            actionSubject: 'cmdbObjectField',
            source: 'cmdbObjectPicker'
        }).fire();
        setListSearchQuery('');
        setCardsPage(0);
    }, [
        createAnalyticsEvent
    ]);
    const fireRemoveEvent = (0, $fc4bM.useCallback)((mode, removedCount)=>{
        createAnalyticsEvent({
            mode: mode,
            removedCount: removedCount,
            analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
            action: 'removed',
            actionSubject: 'cmdbObjectSelection'
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handleRemoveAll = (0, $fc4bM.useCallback)(()=>{
        fireRemoveEvent('all', selectedObjects.length);
        onSelectionCommit([]);
    }, [
        onSelectionCommit,
        selectedObjects.length,
        fireRemoveEvent
    ]);
    // Remove only the objects shown on the current cards page.
    const handleRemoveThisPage = (0, $fc4bM.useCallback)(()=>{
        const pageIds = new Set(pagedObjects.map((o)=>o.id));
        fireRemoveEvent('page', pageIds.size);
        onSelectionCommit(selectedObjects.filter((o)=>!pageIds.has(o.id)));
    }, [
        pagedObjects,
        selectedObjects,
        onSelectionCommit,
        fireRemoveEvent
    ]);
    // Remove all objects matching the current list-search query.
    const handleRemoveSearchResults = (0, $fc4bM.useCallback)(()=>{
        const matchedIds = new Set(listFilteredObjects.map((o)=>o.id));
        fireRemoveEvent('searchResults', matchedIds.size);
        onSelectionCommit(selectedObjects.filter((o)=>!matchedIds.has(o.id)));
    }, [
        listFilteredObjects,
        selectedObjects,
        onSelectionCommit,
        fireRemoveEvent
    ]);
    // Open/close state for the create-issue-style "Remove all" options menu.
    const [isRemoveAllOpen, setIsRemoveAllOpen] = (0, $fc4bM.useState)(false);
    const toggleRemoveAll = (0, $fc4bM.useCallback)(()=>{
        // Compute the next value and fire analytics outside the setState updater
        // (React 18 may invoke updaters more than once, causing duplicate events).
        const willOpen = !isRemoveAllOpen;
        // Only track the open action, not the close.
        if (willOpen) createAnalyticsEvent({
            analyticsType: (0, $eENmG.UI_EVENT_TYPE),
            action: 'opened',
            actionSubject: 'cmdbObjectRemoveAllMenu',
            source: 'cmdbObjectPicker',
            selectedCount: selectedObjects.length
        }).fire();
        setIsRemoveAllOpen(willOpen);
    }, [
        createAnalyticsEvent,
        isRemoveAllOpen,
        selectedObjects.length
    ]);
    const closeRemoveAll = (0, $fc4bM.useCallback)(()=>setIsRemoveAllOpen(false), []);
    // Track pagination through the selected-object cards, then move to the requested page.
    const handleCardsPageChange = (0, $fc4bM.useCallback)((_event, page)=>{
        createAnalyticsEvent({
            analyticsType: (0, $eENmG.UI_EVENT_TYPE),
            action: 'paginated',
            actionSubject: 'cmdbObjectField',
            source: 'cmdbObjectPicker',
            pageCount: totalCardPages
        }).fire();
        setCardsPage(page - 1);
    }, [
        createAnalyticsEvent,
        totalCardPages
    ]);
    const handleOpen = (0, $fc4bM.useCallback)(()=>{
        // Keep side effects out of the setState updater (React 18 may invoke updaters
        // more than once). Read the latest open state via the functional ref pattern
        // by toggling based on the current value captured in a ref.
        const willOpen = !isOpenRef.current;
        setIsOpen(willOpen);
        if (willOpen) {
            // Pre-check the already-added objects so the dropdown reflects the current field.
            setPendingIds(selectedObjects.map((o)=>o.id));
            // Seed the cache with committed objects so they survive a confirm after searching.
            pendingObjectsRef.current = new Map(selectedObjects.map((o)=>[
                    o.id,
                    o
                ]));
            // Fetch the initial (unfiltered) page when the dropdown opens.
            onSearchChange('');
            createAnalyticsEvent({
                analyticsType: (0, $eENmG.UI_EVENT_TYPE),
                action: 'opened',
                actionSubject: 'cmdbObjectPicker',
                selectedCount: selectedObjects.length
            }).fire();
        }
    }, [
        onSearchChange,
        selectedObjects,
        createAnalyticsEvent
    ]);
    const hasObjects = selectedObjects.length > 0;
    // Show the field trigger when multi-select, or single-select with nothing chosen yet.
    const isStrictReadOnly = (0, $k2M4v.default).checkGate('assets_custom_field_ui_assign_strict_scope') && isReadOnly;
    const showTrigger = isMulti || !hasObjects;
    // When objects already exist, the trigger is a compact "+" icon; otherwise the full button.
    const renderAddTrigger = (triggerProps)=>hasObjects ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            xcss: $14cbacd356ee390c$var$addTriggerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fRCnG.default), {
            ...triggerProps,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jGvkt))),
            appearance: "subtle",
            spacing: "compact",
            isDisabled: isStrictReadOnly || isLimitReached,
            label: formatMessage(addTriggerLabel),
            onClick: handleOpen
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kTVlm.default), {
            ...triggerProps,
            appearance: "link",
            isDisabled: isStrictReadOnly,
            spacing: "none",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jGvkt))), {
                label: "",
                color: "var(--ds-link, #0C66E4)"
            }),
            onClick: handleOpen
        }, formatMessage(addTriggerLabel));
    const dropdownContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eUTjw.ObjectsDropdown), {
            items: dropdownItems,
            displayedCount: searchResults.length,
            searchQuery: searchQuery,
            onSearchChange: handleDropdownSearchChange,
            isLoading: isLoading,
            hasMore: hasMore,
            onLoadMore: handleLoadMore,
            selectedCount: selectedCount,
            allowedLimit: allowedLimit,
            isAllSelected: isAllSelected,
            isIndeterminate: isIndeterminate,
            onSelectAllChange: handleSelectAllChange,
            onObjectSelectionChange: handleObjectSelectionChange,
            isConfirmDisabled: !hasChanges,
            onCancel: handleCancel,
            onConfirm: handleConfirm
        });
    const popupTrigger = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4EPUx.Popup), {
        isOpen: !isStrictReadOnly && isOpen,
        onClose: closeAndReset,
        placement: "top-start",
        content: dropdownContent,
        trigger: renderAddTrigger
    });
    // Empty state: title (with required asterisk) on its own line, the
    // "Add objects" trigger on the line below, and an optional error message.
    if (!hasObjects) {
        const fieldTitle = fieldLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), {
            size: "small",
            weight: "semibold",
            color: "color.text.subtle"
        }, fieldLabel, required && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9Zxa0.RequiredAsterisk), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            xcss: $14cbacd356ee390c$var$rootStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7yidP.Stack), {
            space: "space.100",
            alignInline: "start"
        }, fieldTitle, showTrigger && popupTrigger), hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2xHR5.ErrorMessage), null, errorMessage));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7yidP.Stack), {
        space: "space.100",
        xcss: $14cbacd356ee390c$var$rootStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), {
        alignBlock: "center",
        spread: "space-between",
        space: "space.100"
    }, fieldLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), {
        size: "small",
        weight: "semibold",
        color: "color.text.subtle"
    }, fieldLabel, required && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9Zxa0.RequiredAsterisk), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, isStrictReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bcTS3.default), {
        content: formatMessage((0, $hrDvi.default).editingDisabled)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fRCnG.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2feYn))),
        appearance: "subtle",
        spacing: "compact",
        label: formatMessage((0, $hrDvi.default).editingDisabled)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4EPUx.Popup), {
        isOpen: !isStrictReadOnly && isRemoveAllOpen,
        onClose: closeRemoveAll,
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gSOfb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3rlj9.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eaozo.default), {
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
                    xcss: $14cbacd356ee390c$var$menuItemIconStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gV8E5))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                })),
                isDisabled: pagedObjects.length === 0,
                onClick: ()=>{
                    handleRemoveThisPage();
                    closeRemoveAll();
                }
            }, formatMessage((0, $hrDvi.default).removeOnThisPage, {
                count: pagedObjects.length
            })), isListSearching && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eaozo.default), {
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
                    xcss: $14cbacd356ee390c$var$menuItemIconStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gV8E5))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                })),
                isDisabled: listFilteredObjects.length === 0,
                onClick: ()=>{
                    handleRemoveSearchResults();
                    closeRemoveAll();
                }
            }, formatMessage((0, $hrDvi.default).removeSearchResults, {
                count: listFilteredObjects.length
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eaozo.default), {
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
                    xcss: $14cbacd356ee390c$var$menuItemIconStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gV8E5))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                })),
                isDisabled: isStrictReadOnly || selectedObjects.length === 0,
                onClick: ()=>{
                    handleRemoveAll();
                    closeRemoveAll();
                }
            }, formatMessage((0, $hrDvi.default).removeAddedObjects, {
                count: selectedObjects.length
            })))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kTVlm.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($13zmE))), {
                    label: ""
                }),
                isDisabled: isStrictReadOnly || selectedObjects.length === 0,
                onClick: toggleRemoveAll
            }, formatMessage((0, $hrDvi.default).removeAll))
    }), showTrigger && popupTrigger)), showListSearch && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $14cbacd356ee390c$var$listSearchStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $aEtFp.default), {
        value: listSearchQuery,
        onChange: handleListSearchChange,
        placeholder: formatMessage((0, $hrDvi.default).searchPlaceholder),
        "aria-label": formatMessage((0, $hrDvi.default).search),
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            xcss: $14cbacd356ee390c$var$listSearchIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8K7DG))), {
            label: "",
            size: "small"
        }))
    })), isListSearching && listFilteredObjects.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $14cbacd356ee390c$var$listSearchEmptyStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), {
        color: "color.text.subtle"
    }, formatMessage((0, $hrDvi.default).noResults)), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kTVlm.default), {
        appearance: "link",
        spacing: "none",
        onClick: handleClearListSearch
    }, formatMessage((0, $hrDvi.default).clearSearch))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7yidP.Stack), {
        space: "space.050"
    }, pagedObjects.map((object)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            key: object.id,
            xcss: $14cbacd356ee390c$var$cardRowStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jfcYL.CmdbObjectCard), {
            cmdbObject: object,
            hideExpand: true
        }), !((0, $k2M4v.default).checkGate('assets_custom_field_ui_assign_strict_scope') && isReadOnly) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            xcss: $14cbacd356ee390c$var$removeButtonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fRCnG.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($48hlF))),
            appearance: "subtle",
            spacing: "compact",
            shape: "circle",
            label: formatMessage((0, $hrDvi.default).removeObject, {
                objectLabel: object.label
            }),
            onClick: ()=>handleRemove(object.id)
        })))), listFilteredObjects.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $14cbacd356ee390c$var$paginationStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $14cbacd356ee390c$var$paginationRangeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), {
        size: "medium",
        color: "color.text.subtlest"
    }, formatMessage((0, $hrDvi.default).paginationRangeInline, {
        start: cardsPage * $14cbacd356ee390c$var$CARDS_PER_PAGE + 1,
        end: Math.min((cardsPage + 1) * $14cbacd356ee390c$var$CARDS_PER_PAGE, listFilteredObjects.length),
        total: listFilteredObjects.length
    }))), totalCardPages > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $14cbacd356ee390c$var$paginationControlsStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kAjco.default), {
        label: formatMessage((0, $hrDvi.default).pageLabel),
        pageLabel: formatMessage((0, $hrDvi.default).pageLabel),
        nextLabel: formatMessage((0, $hrDvi.default).nextPage),
        previousLabel: formatMessage((0, $hrDvi.default).previousPage),
        pages: Array.from({
            length: totalCardPages
        }, (_, index)=>index + 1),
        selectedIndex: cardsPage,
        onChange: handleCardsPageChange,
        max: 7
    })))), hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2xHR5.ErrorMessage), null, errorMessage));
};
const $14cbacd356ee390c$var$rootStyles = (0, $kig2V.xcss)({
    paddingBlockStart: 'space.200'
});
const $14cbacd356ee390c$var$paginationStyles = (0, $kig2V.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: 'space.150',
    flexWrap: 'wrap',
    paddingBlockStart: 'space.050'
});
const $14cbacd356ee390c$var$paginationRangeStyles = (0, $kig2V.xcss)({
    flexShrink: 0
});
const $14cbacd356ee390c$var$paginationControlsStyles = (0, $kig2V.xcss)({
    display: 'flex',
    alignItems: 'center'
});
const $14cbacd356ee390c$var$cardRowStyles = (0, $kig2V.xcss)({
    position: 'relative',
    width: '100%'
});
// Search bar above the added-objects cards list.
const $14cbacd356ee390c$var$listSearchStyles = (0, $kig2V.xcss)({
    paddingBlockEnd: 'space.050'
});
const $14cbacd356ee390c$var$listSearchIconStyles = (0, $kig2V.xcss)({
    display: 'flex',
    alignItems: 'center',
    paddingInlineStart: 'space.075',
    color: 'color.text.subtle'
});
// "No results matching your search." + Clear search empty state (centered).
const $14cbacd356ee390c$var$listSearchEmptyStyles = (0, $kig2V.xcss)({
    paddingBlock: 'space.100',
    textAlign: 'center'
});
// Trailing cross icon inside each Remove-all menu option (matches Create Issue).
const $14cbacd356ee390c$var$menuItemIconStyles = (0, $kig2V.xcss)({
    display: 'flex',
    alignItems: 'center'
});
// Overlay the remove control in the card's top-right corner without extra wrapper chrome.
const $14cbacd356ee390c$var$removeButtonStyles = (0, $kig2V.xcss)({
    position: 'absolute',
    top: 'space.100',
    right: 'space.100',
    zIndex: 'card'
});
// "+" add trigger: bordered at rest, background change on hover (matches Create Issue).
const $14cbacd356ee390c$var$addTriggerStyles = (0, $kig2V.xcss)({
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});

});
parcelRegister("eUTjw", function(module, exports) {
$parcel$export(module.exports, "ObjectsDropdown", () => $6e610a52264f807f$export$af6ac03c30eda9b9);

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $5a4EU = parcelRequire("5a4EU");

var $lgMZ2 = parcelRequire("lgMZ2");

var $l3fZT = parcelRequire("l3fZT");

var $7yidP = parcelRequire("7yidP");

var $4T8rw = parcelRequire("4T8rw");

var $kig2V = parcelRequire("kig2V");

var $aEtFp = parcelRequire("aEtFp");

var $8K7DG = parcelRequire("8K7DG");

var $7ZdBj = parcelRequire("7ZdBj");

var $kDn5h = parcelRequire("kDn5h");

var $5dzEI = parcelRequire("5dzEI");

var $hculA = parcelRequire("hculA");

var $eJ8cW = parcelRequire("eJ8cW");

var $hrDvi = parcelRequire("hrDvi");
const $6e610a52264f807f$var$DropdownListItem = ({ item: item, onSelectionChange: onSelectionChange, isDisabled: isDisabled })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const handleCheckboxChange = (0, $fc4bM.useCallback)((event)=>{
        onSelectionChange(item.object.id, event.target.checked);
    }, [
        item.object.id,
        onSelectionChange
    ]);
    const label = item.object.label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $6e610a52264f807f$var$listItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kDn5h.Checkbox), {
        isChecked: item.isSelected,
        onChange: handleCheckboxChange,
        "aria-label": formatMessage((0, $hrDvi.default).selectObject, {
            objectLabel: label
        }),
        isDisabled: item.isSelected ? false : isDisabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $6e610a52264f807f$var$iconContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eJ8cW.MemoizedInsightIcon), {
        ...item.object.avatar.mediaClientConfig,
        iconUrl: item.object.avatar.url48
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7yidP.Stack), {
        space: "space.0",
        grow: "fill",
        xcss: $6e610a52264f807f$var$textColumnStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $6e610a52264f807f$var$objectLabelStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), null, label)), item.metadata && item.metadata.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $6e610a52264f807f$var$metadataStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, item.metadata.join(' | '))))));
};
const $6e610a52264f807f$export$af6ac03c30eda9b9 = ({ items: items, displayedCount: displayedCount, searchQuery: searchQuery, onSearchChange: onSearchChange, isLoading: isLoading, hasMore: hasMore, onLoadMore: onLoadMore, selectedCount: selectedCount, allowedLimit: allowedLimit, isAllSelected: isAllSelected, isIndeterminate: isIndeterminate, onSelectAllChange: onSelectAllChange, onObjectSelectionChange: onObjectSelectionChange, isConfirmDisabled: isConfirmDisabled, onCancel: onCancel, onConfirm: onConfirm })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const listContainerRef = (0, $fc4bM.useRef)(null);
    const handleSearchChange = (0, $fc4bM.useCallback)((event)=>{
        onSearchChange(event.target.value);
    }, [
        onSearchChange
    ]);
    const handleScroll = (0, $fc4bM.useCallback)(()=>{
        const el = listContainerRef.current;
        if (!el || isLoading || !hasMore) return;
        if (el.scrollTop + el.clientHeight >= el.scrollHeight - 24) onLoadMore();
    }, [
        isLoading,
        hasMore,
        onLoadMore
    ]);
    (0, $fc4bM.useEffect)(()=>{
        const el = listContainerRef.current;
        if (!el) return undefined;
        el.addEventListener('scroll', handleScroll);
        return ()=>el.removeEventListener('scroll', handleScroll);
    }, [
        handleScroll
    ]);
    const selectAllCount = displayedCount > allowedLimit ? allowedLimit : displayedCount;
    const isLimitReached = selectedCount >= allowedLimit;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $6e610a52264f807f$var$containerStyles,
        testId: "cmdb-object-picker-new.objects-dropdown"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $6e610a52264f807f$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $aEtFp.default), {
        appearance: "standard",
        value: searchQuery,
        onChange: handleSearchChange,
        placeholder: formatMessage((0, $hrDvi.default).searchPlaceholder),
        "aria-label": formatMessage((0, $hrDvi.default).search),
        autoFocus: true,
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            xcss: $6e610a52264f807f$var$searchIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8K7DG))), {
            label: "",
            size: "small"
        }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $6e610a52264f807f$var$resultsInfoStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), {
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        as: "span",
        role: "status",
        "aria-atomic": "true"
    }, formatMessage((0, $hrDvi.default).showingResults, {
        displayed: displayedCount
    }))), hasMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $l3fZT.Pressable), {
        xcss: $6e610a52264f807f$var$loadMoreButtonStyles,
        onClick: onLoadMore
    }, formatMessage((0, $hrDvi.default).loadMore))))), displayedCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $6e610a52264f807f$var$selectAllContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kDn5h.Checkbox), {
        isChecked: isAllSelected,
        isIndeterminate: isIndeterminate,
        onChange: (e)=>onSelectAllChange(e.target.checked),
        label: formatMessage((0, $hrDvi.default).selectFirstResults, {
            count: selectAllCount
        }),
        isDisabled: allowedLimit === 0 || isLimitReached && !isIndeterminate && !isAllSelected
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $6e610a52264f807f$var$dividerStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $6e610a52264f807f$var$listContainerStyles,
        ref: listContainerRef
    }, items.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($6e610a52264f807f$var$DropdownListItem, {
            key: item.object.id,
            item: item,
            onSelectionChange: onObjectSelectionChange,
            isDisabled: isLimitReached
        })), !isLoading && items.length === 0 && searchQuery && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $6e610a52264f807f$var$emptyStateStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), {
        size: "small"
    }, formatMessage((0, $hrDvi.default).noResults))), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $6e610a52264f807f$var$loadingContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hculA.default), {
        size: "small",
        label: formatMessage((0, $hrDvi.default).loading)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $6e610a52264f807f$var$dividerStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $6e610a52264f807f$var$footerStyles
    }, isLimitReached ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $6e610a52264f807f$var$warningIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ZdBj))), {
        label: "",
        color: "var(--ds-icon-warning, #E06C00)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), {
        size: "small"
    }, formatMessage((0, $hrDvi.default).fieldLimitReached))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), {
        size: "small"
    }, formatMessage((0, $hrDvi.default).selectedCount, {
        count: selectedCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5dzEI.default), {
        appearance: "subtle",
        onClick: onCancel
    }, formatMessage((0, $hrDvi.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5dzEI.default), {
        appearance: "primary",
        onClick: onConfirm,
        isDisabled: isConfirmDisabled
    }, formatMessage((0, $hrDvi.default).addObjects, {
        count: selectedCount
    })))));
};
const $6e610a52264f807f$var$containerStyles = (0, $kig2V.xcss)({
    width: '400px',
    minWidth: '400px',
    maxWidth: '600px',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderRadius: 'radius.small',
    backgroundColor: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.overlay'
});
const $6e610a52264f807f$var$headerStyles = (0, $kig2V.xcss)({
    padding: 'space.150'
});
const $6e610a52264f807f$var$searchIconStyles = (0, $kig2V.xcss)({
    display: 'flex',
    alignItems: 'center',
    paddingInlineStart: 'space.050',
    color: 'color.text.subtle'
});
const $6e610a52264f807f$var$resultsInfoStyles = (0, $kig2V.xcss)({
    marginTop: 'space.100',
    color: 'color.text.subtlest'
});
const $6e610a52264f807f$var$selectAllContainerStyles = (0, $kig2V.xcss)({
    paddingInline: 'space.150',
    paddingBlock: 'space.050'
});
const $6e610a52264f807f$var$dividerStyles = (0, $kig2V.xcss)({
    height: '1px',
    backgroundColor: 'color.background.neutral',
    flexShrink: 0
});
const $6e610a52264f807f$var$listContainerStyles = (0, $kig2V.xcss)({
    maxHeight: '240px',
    overflowY: 'auto',
    paddingBlock: 'space.050'
});
const $6e610a52264f807f$var$listItemStyles = (0, $kig2V.xcss)({
    paddingInline: 'space.150',
    paddingBlock: 'space.075',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});
const $6e610a52264f807f$var$iconContainerStyles = (0, $kig2V.xcss)({
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0
});
const $6e610a52264f807f$var$textColumnStyles = (0, $kig2V.xcss)({
    minWidth: 'space.0'
});
const $6e610a52264f807f$var$objectLabelStyles = (0, $kig2V.xcss)({
    overflowWrap: 'anywhere',
    wordBreak: 'break-word'
});
const $6e610a52264f807f$var$metadataStyles = (0, $kig2V.xcss)({
    overflowWrap: 'anywhere',
    wordBreak: 'break-word'
});
const $6e610a52264f807f$var$emptyStateStyles = (0, $kig2V.xcss)({
    padding: 'space.150',
    color: 'color.text.subtlest',
    textAlign: 'center'
});
const $6e610a52264f807f$var$loadingContainerStyles = (0, $kig2V.xcss)({
    display: 'flex',
    justifyContent: 'center',
    padding: 'space.150'
});
const $6e610a52264f807f$var$footerStyles = (0, $kig2V.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 'space.150'
});
const $6e610a52264f807f$var$warningIconStyles = (0, $kig2V.xcss)({
    display: 'flex',
    alignItems: 'center'
});
// "Load more" rendered as an inline text link (mirrors Jira's ObjectsDropdown Pressable), avoiding button chrome.
const $6e610a52264f807f$var$loadMoreButtonStyles = (0, $kig2V.xcss)({
    display: 'inline-flex',
    color: 'color.link',
    cursor: 'pointer',
    textDecoration: 'none',
    backgroundColor: 'color.background.neutral.subtle',
    padding: 'space.0',
    ':hover': {
        textDecoration: 'underline'
    }
});

});
parcelRegister("hrDvi", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf87c1c2e9eb044f$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $bf87c1c2e9eb044f$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    editingDisabled: {
        id: 'cmdb-components.cmdb-object-picker-new.editing-disabled',
        defaultMessage: 'Editing has been disabled for this field',
        description: 'Tooltip explaining why the Assets field editing controls are disabled'
    },
    searchPlaceholder: {
        id: 'cmdb-components.cmdb-object-picker-new.search-placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder text for the search input in the object dropdown'
    },
    showingResults: {
        id: 'cmdb-components.cmdb-object-picker-new.showing-results',
        defaultMessage: 'Showing {displayed} results.',
        description: 'Text showing the number of results currently displayed in the dropdown'
    },
    loadMore: {
        id: 'cmdb-components.cmdb-object-picker-new.load-more',
        defaultMessage: 'Load more',
        description: 'Link text to load more search results in the dropdown list'
    },
    selectFirstResults: {
        id: 'cmdb-components.cmdb-object-picker-new.select-first-results',
        defaultMessage: 'Select first {count} results',
        description: 'Label for the select-all checkbox that selects the first N results'
    },
    selectedCount: {
        id: 'cmdb-components.cmdb-object-picker-new.selected-count',
        defaultMessage: '{count} selected',
        description: 'Text showing the number of currently selected items'
    },
    fieldLimitReached: {
        id: 'cmdb-components.cmdb-object-picker-new.field-limit-reached',
        defaultMessage: 'Field limit reached',
        description: 'Message shown when the maximum number of objects for the field has been reached'
    },
    cancel: {
        id: 'cmdb-components.cmdb-object-picker-new.cancel',
        defaultMessage: 'Cancel',
        description: 'Text for the cancel button to dismiss the dropdown'
    },
    addObjects: {
        id: 'cmdb-components.cmdb-object-picker-new.add-objects',
        defaultMessage: '{count, plural, one {Add # object} other {Add # objects}}',
        description: 'Text for the button that confirms adding the selected objects'
    },
    addObject: {
        id: 'cmdb-components.cmdb-object-picker-new.add-object',
        defaultMessage: 'Add object',
        description: 'Label for the button that opens the object search dropdown'
    },
    addObjectsLabel: {
        id: 'cmdb-components.cmdb-object-picker-new.add-objects-label',
        defaultMessage: 'Add objects',
        description: 'Label for the button that opens the object search dropdown (portal enhancements)'
    },
    removeObject: {
        id: 'cmdb-components.cmdb-object-picker-new.remove-object',
        defaultMessage: 'Remove {objectLabel}',
        description: 'Accessible label for the button that removes a selected object from the field'
    },
    selectObject: {
        id: 'cmdb-components.cmdb-object-picker-new.select-object',
        defaultMessage: 'Select {objectLabel}',
        description: 'Accessible label for the checkbox that selects an object in the dropdown'
    },
    noObjectsAdded: {
        id: 'cmdb-components.cmdb-object-picker-new.no-objects-added',
        defaultMessage: 'No objects added',
        description: 'Empty-state message shown when no objects are selected for the field'
    },
    noResults: {
        id: 'cmdb-components.cmdb-object-picker-new.no-results',
        defaultMessage: 'No results matching your search.',
        description: 'Message shown when the search returns no matching objects'
    },
    loading: {
        id: 'cmdb-components.cmdb-object-picker-new.loading',
        defaultMessage: 'Loading',
        description: 'Accessible label for the loading spinner'
    },
    search: {
        id: 'cmdb-components.cmdb-object-picker-new.search-label',
        defaultMessage: 'Search assets',
        description: 'Accessible label for the search input'
    },
    removeAll: {
        id: 'cmdb-components.cmdb-object-picker-new.remove-all',
        defaultMessage: 'Remove all',
        description: 'Label for the button that removes all selected objects from the field'
    },
    removeOnThisPage: {
        id: 'cmdb-components.cmdb-object-picker-new.remove-on-this-page',
        defaultMessage: 'On this page ({count})',
        description: 'Remove-all menu option that removes the objects shown on the current page'
    },
    removeSearchResults: {
        id: 'cmdb-components.cmdb-object-picker-new.remove-search-results',
        defaultMessage: 'Search results ({count})',
        description: 'Remove-all menu option that removes all objects matching the current search'
    },
    removeAddedObjects: {
        id: 'cmdb-components.cmdb-object-picker-new.remove-added-objects',
        defaultMessage: 'Added objects ({count})',
        description: 'Remove-all menu option that removes all added objects from the field'
    },
    previousPage: {
        id: 'cmdb-components.cmdb-object-picker-new.previous-page',
        defaultMessage: 'Previous',
        description: 'Label for the button that shows the previous page of selected object cards'
    },
    nextPage: {
        id: 'cmdb-components.cmdb-object-picker-new.next-page',
        defaultMessage: 'Next',
        description: 'Label for the button that shows the next page of selected object cards'
    },
    pageIndicator: {
        id: 'cmdb-components.cmdb-object-picker-new.page-indicator',
        defaultMessage: 'Page {current} of {total}',
        description: 'Indicates the current page and total pages of selected object cards'
    },
    pageLabel: {
        id: 'cmdb-components.cmdb-object-picker-new.page-label',
        defaultMessage: 'Page',
        description: 'Accessible label for a page number in the selected objects pagination'
    },
    paginationRangeInline: {
        id: 'cmdb-components.cmdb-object-picker-new.pagination-range-inline',
        defaultMessage: 'Viewing {start}-{end} of {total}',
        description: 'Shows the range of selected object cards currently visible out of the total count'
    },
    clearSearch: {
        id: 'cmdb-components.cmdb-object-picker-new.clear-search',
        defaultMessage: 'Clear search',
        description: 'Link to clear the added-objects list search and show all objects again'
    }
});

});




parcelRegister("liiP6", function(module, exports) {
$parcel$export(module.exports, "CmdbObjectPickerDumb", () => (parcelRequire("78E3R")).default);

var $78E3R = parcelRequire("78E3R");

});
parcelRegister("78E3R", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c5dec8a8acd94d7$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $6v10u = parcelRequire("6v10u");
var $cBmRF = parcelRequire("cBmRF");

var $fcCIH = parcelRequire("fcCIH");

var $k2M4v = parcelRequire("k2M4v");

var $6oof1 = parcelRequire("6oof1");
parcelRequire("hpYiC");
var $3X32l = parcelRequire("3X32l");

var $ipNyj = parcelRequire("ipNyj");
class $6c5dec8a8acd94d7$export$d12f6928a020725f extends $fc4bM.Component {
    render() {
        const { isMulti: isMulti, disabled: disabled, doInitialSearch: doInitialSearch, intl: intl, defaultValue: defaultValue, populateDefaultValue: populateDefaultValue, ...otherProps } = this.props;
        const placeholder = intl.formatMessage((0, $ipNyj.default).searchPlaceholder);
        const makeControlledAndOnlyDisplayLabel = (0, $k2M4v.default).checkGate('jsm_assets_field_only_display_label_in_portal');
        let selectedValues = defaultValue;
        if (makeControlledAndOnlyDisplayLabel && Array.isArray(defaultValue)) // We change the shape of the selected values to display just the object label rather than the full searchable label
        selectedValues = defaultValue.filter((value)=>value !== undefined).map((value)=>({
                ...value,
                label: value.cmdbObject.label
            }));
        if (isMulti) return /*#__PURE__*/ $fc4bM.createElement((0, $cBmRF.FormMultiSelect), {
            ...otherProps,
            actionSubjectId: "cmdbObjectPickerField",
            placeholder: placeholder,
            noOptionsMessage: this.noOptionsMessage,
            onChange: this.onChangeForSelect,
            components: this.customComponents,
            value: populateDefaultValue || makeControlledAndOnlyDisplayLabel ? selectedValues : undefined
        });
        let singleSelectValue = selectedValues && selectedValues[0];
        if (makeControlledAndOnlyDisplayLabel) // Need to explicitly set to `null` rather than `undefined` to clear the value.
        singleSelectValue = selectedValues && selectedValues.length > 0 ? selectedValues[0] : null;
        return /*#__PURE__*/ $fc4bM.createElement((0, $6v10u.FieldSingleSelect), {
            ...otherProps,
            actionSubjectId: "cmdbObjectPickerField",
            placeholder: placeholder,
            noOptionsMessage: this.noOptionsMessage,
            onChange: this.onChangeForSelect,
            components: this.customComponents,
            value: (populateDefaultValue || makeControlledAndOnlyDisplayLabel) && selectedValues ? singleSelectValue : undefined,
            isClearable: true
        });
    }
    constructor(...args){
        super(...args), this.onChangeForSelect = (selectedOption)=>{
            var _this$props$onChange, _this$props;
            (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, this.props.id, (0, $6oof1.toMultiSelectValue)(selectedOption).map((v)=>v.value));
        }, this.customComponents = {
            Option: (0, $3X32l.CmdbSelectOption)
        }, this.noOptionsMessage = ()=>{
            const { intl: intl } = this.props;
            return intl.formatMessage((0, $ipNyj.default).noOptions);
        };
    }
}
var $6c5dec8a8acd94d7$export$2e2bcd8739ae039 = (0, $fcCIH.default)($6c5dec8a8acd94d7$export$d12f6928a020725f);

});
parcelRegister("hpYiC", function(module, exports) {
$parcel$export(module.exports, "CmdbSelectOption", () => (parcelRequire("3X32l")).CmdbSelectOption);

var $3X32l = parcelRequire("3X32l");

});
parcelRegister("3X32l", function(module, exports) {
$parcel$export(module.exports, "CmdbSelectOption", () => $26a92ad6a5b93244$export$a7be07965a3ed09b);
/* cmdb-object-picker-option.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $9XZeF = parcelRequire("9XZeF");

var $2n2bS = parcelRequire("2n2bS");

var $aYMdQ = parcelRequire("aYMdQ");

var $4T8rw = parcelRequire("4T8rw");

var $9MLZi = parcelRequire("9MLZi");

var $73xOu = parcelRequire("73xOu");

var $eJ8cW = parcelRequire("eJ8cW");
const $26a92ad6a5b93244$export$5a780c1be95ea1c8 = (attributes, attributesToDisplay, timezone)=>{
    const notUndefined = (attr)=>{
        return Boolean(attr);
    };
    const deepClonedAttributes = (0, $aYMdQ.cloneDeep)(attributes);
    return attributesToDisplay.map((attrName)=>attrName === 'Label' ? deepClonedAttributes.find((attr)=>attr.objectTypeAttribute.label) : deepClonedAttributes.find((attr)=>attr.objectTypeAttribute.name === attrName))// get only attributes that have valid displayValue
    .filter(notUndefined).filter((attribute)=>attribute.objectAttributeValues.length > 0 && attribute.objectAttributeValues.every((value)=>value && value.displayValue)).map((attribute)=>{
        var _attribute$objectType;
        if (((_attribute$objectType = attribute.objectTypeAttribute.defaultType) === null || _attribute$objectType === void 0 ? void 0 : _attribute$objectType.name) === 'DateTime') attribute.objectAttributeValues.forEach((value)=>{
            value.displayValue = value.value ? (0, $73xOu.convertToTimezone)(value.value, timezone.id) : value.displayValue;
        });
        return attribute;
    });
};
const $26a92ad6a5b93244$export$fee117cd50d6234b = ({ match: match, children: children })=>{
    if (match === '') return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, children);
    // we need to escape special characters to avoid getting them interpreted in the RegExp group
    const escapedSpecialCharsInMatchQuery = match.replace(/[\\.,*+?^${}()|[\]]/g, '\\$&');
    const parts = children.split(new RegExp(`(${escapedSpecialCharsInMatchQuery})`, 'gi'));
    return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, parts.map((part, i)=>{
        if (part.toLowerCase() === match.toLowerCase()) // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        return /*#__PURE__*/ $fc4bM.createElement("strong", {
            key: i
        }, part);
        return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, {
            key: i
        }, part);
    }));
};
const $26a92ad6a5b93244$export$3c4337b649d4ffca = (attributes, attributesToDisplay)=>{
    const notUndefined = (attr)=>{
        return Boolean(attr);
    };
    return attributesToDisplay.map((attrName)=>attrName === 'Label' ? attributes.find((attr)=>attr.objectTypeAttribute.label) : attributes.find((attr)=>attr.objectTypeAttribute.name === attrName))// get only attributes that have valid displayValue
    .filter(notUndefined).filter((attribute)=>attribute.objectAttributeValues.length > 0 && attribute.objectAttributeValues.every((value)=>value && value.displayValue));
};
const $26a92ad6a5b93244$export$cd0f2f750043f4bc = (attributes)=>{
    return attributes.map((attribute)=>attribute.objectAttributeValues.map((value)=>value.displayValue).join(', ')).join(' | ');
};
const $26a92ad6a5b93244$export$9ce1cf00f76f3d0b = (attributes, defaultLabel)=>{
    var _attributes$;
    return ((_attributes$ = attributes[0]) === null || _attributes$ === void 0 ? void 0 : _attributes$.objectAttributeValues.map((v)=>v.displayValue).join(', ')) || defaultLabel;
};
const $26a92ad6a5b93244$export$e4de0626a00cf8b4 = (optionProps)=>{
    const { data: data, innerProps: innerProps, selectProps: selectProps, timezone: timezone } = optionProps;
    const { inputValue: inputValue, filterAttributes: filterAttributes } = selectProps;
    const object = data.cmdbObject;
    const visibleAttributes = $26a92ad6a5b93244$export$5a780c1be95ea1c8(object.attributes, filterAttributes ?? [], timezone);
    const [, ...secondaryAttributes] = visibleAttributes;
    const labelAttribute = $26a92ad6a5b93244$export$9ce1cf00f76f3d0b(visibleAttributes, object.label);
    const secondaryAttributesDescription = $26a92ad6a5b93244$export$cd0f2f750043f4bc(secondaryAttributes);
    const { Option: Option } = (0, $9MLZi.components);
    const { ref: ref, ...otherDivProps } = innerProps;
    return /*#__PURE__*/ $fc4bM.createElement(Option, optionProps, /*#__PURE__*/ $fc4bM.createElement("div", {
        ...otherDivProps,
        className: (0, $2R2iS.default)([
            "_1e0c1txw _ca0qcxkx _n3tdcxkx _19bv1e9d _u5f31e9d _irr3dvhl"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            "_2hwx1no3 _1o9zidpf"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $eJ8cW.MemoizedInsightIcon), {
        ...object.avatar.mediaClientConfig,
        iconUrl: object.avatar.url48
    })), /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            "_1e0c1txw _2lx21bp4 _ca0q1xvx"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $4T8rw.Text), {
        size: "medium",
        weight: "medium"
    }, /*#__PURE__*/ $fc4bM.createElement($26a92ad6a5b93244$export$fee117cd50d6234b, {
        match: inputValue ?? ''
    }, labelAttribute)), /*#__PURE__*/ $fc4bM.createElement((0, $4T8rw.Text), {
        size: "small"
    }, /*#__PURE__*/ $fc4bM.createElement($26a92ad6a5b93244$export$fee117cd50d6234b, {
        match: inputValue ?? ''
    }, secondaryAttributesDescription)))));
};
const $26a92ad6a5b93244$var$selector = (0, $2n2bS.createSelector)((state)=>{
    return state.persisted.user.timezone;
}, (timezone)=>({
        timezone: timezone
    }));
const $26a92ad6a5b93244$export$a7be07965a3ed09b = (0, $9XZeF.connect)($26a92ad6a5b93244$var$selector)($26a92ad6a5b93244$export$e4de0626a00cf8b4);
const $26a92ad6a5b93244$var$outerStyles = null;
const $26a92ad6a5b93244$var$iconStyles = null;
const $26a92ad6a5b93244$var$contentStyles = null;

});


parcelRegister("ipNyj", function(module, exports) {
$parcel$export(module.exports, "default", () => $d33f767071aec7e3$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $d33f767071aec7e3$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    searchPlaceholder: {
        defaultMessage: 'Search...',
        description: 'Placeholder for CMDB object picker field to advise the user to search for objects',
        id: 'cv.request.create.form.cmdbobjectpicker.search.new'
    },
    noOptions: {
        defaultMessage: 'No options',
        description: 'Text that appears in the dropdown for the CMDB object picker if there are no objects to select',
        id: 'cv.request.create.form.cmdbobjectpicker.no.options'
    }
});

});



parcelRegister("3mq0K", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c1763811130f453$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $4c1763811130f453$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    dropdownNumberOfSearchResultsLabel: {
        id: 'cv.request.create.form.cmdbobjectpicker.numberofsearchresultslabel',
        defaultMessage: `{numberOfSearchResults, plural, one {# search result} other {# search results}}`,
        description: 'Description above cmdb objects options describing how many objects were found'
    },
    dropdownMaxNumberOfSearchResultsLabel: {
        id: 'cv.request.create.form.cmdbobjectpicker.maxnumberofsearchresultslabel',
        defaultMessage: '{maxObjectCountCutoff}+ search results',
        description: 'Description above cmdb objects options describing how many objects were found'
    },
    errorFlagTitle: {
        id: 'cv.request.create.form.cmdbobjectpicker.errorFlagTitle',
        defaultMessage: `We couldn't fetch any results for this search`,
        description: 'Title for error flag that is triggered when searching for CMDB objects fails'
    },
    errorFlagDescription: {
        id: 'cv.request.create.form.cmdbobjectpicker.errorFlagDescription',
        defaultMessage: `Ask your team or admin for support.`,
        description: 'Description for error flag that is triggered when searching for CMDB objects fails'
    }
});

});

parcelRegister("5auA6", function(module, exports) {
$parcel$export(module.exports, "AssignScopePreview", () => $02022c8d91ae1d08$export$6cd03e1ba49f977c);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");
var $gpjDl = parcelRequire("gpjDl");

var $5dzEI = parcelRequire("5dzEI");

var $cJzRi = parcelRequire("cJzRi");

var $hculA = parcelRequire("hculA");

var $ehZx5 = parcelRequire("ehZx5");
parcelRequire("1XkRq");
var $iAoWi = parcelRequire("iAoWi");
const $02022c8d91ae1d08$export$6cd03e1ba49f977c = ({ portalId: portalId, requestTypeId: requestTypeId, fieldId: fieldId, fieldValueMap: fieldValueMap, fieldLabel: fieldLabel, isMulti: isMulti, limit: limit, errorMessage: errorMessage })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const [state, setState] = (0, $fc4bM.useState)(null);
    const [retry, setRetry] = (0, $fc4bM.useState)(0);
    const contextKey = JSON.stringify(fieldValueMap.filter(([id])=>id !== fieldId));
    const maximum = isMulti ? Math.min(limit, 1000) : 1;
    const requestKey = JSON.stringify([
        portalId,
        requestTypeId,
        fieldId,
        contextKey,
        maximum,
        retry
    ]);
    const visibleState = (state === null || state === void 0 ? void 0 : state.requestKey) === requestKey ? state : null;
    (0, $fc4bM.useEffect)(()=>{
        const controller = new AbortController();
        const loadPage = async (objects)=>{
            if (objects.length >= maximum || controller.signal.aborted) return objects;
            const response = await (0, $ehZx5.fetchCmdbObjectsWithSignal)(portalId, requestTypeId, fieldId, '', JSON.parse(contextKey), controller.signal, objects.length);
            const next = [
                ...objects,
                ...response.cmdbObjects.slice(0, maximum - objects.length)
            ];
            return response.hasNextPage && response.cmdbObjects.length > 0 ? loadPage(next) : next;
        };
        const load = ()=>{
            loadPage([]).then((objects)=>{
                if (!controller.signal.aborted) setState({
                    objects: objects,
                    requestKey: requestKey,
                    status: 'ready'
                });
            }, ()=>{
                if (!controller.signal.aborted) setState({
                    requestKey: requestKey,
                    status: 'error',
                    objects: []
                });
            });
        };
        const timer = setTimeout(load, 300);
        return ()=>{
            clearTimeout(timer);
            controller.abort();
        };
    }, [
        portalId,
        requestTypeId,
        fieldId,
        contextKey,
        maximum,
        requestKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cJzRi.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
        id: "cmdb-components.assign-scope-readonly",
        defaultMessage: "Objects are assigned automatically. You can\u2019t edit this field.",
        description: "Explains why an Assets portal field is read only"
    }), !visibleState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hculA.default), {
        label: formatMessage({
            id: 'cmdb-components.assign-scope-loading',
            defaultMessage: 'Loading assigned objects',
            description: 'Accessible label while loading automatically assigned objects'
        })
    }), (visibleState === null || visibleState === void 0 ? void 0 : visibleState.status) === 'error' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
        id: "cmdb-components.assign-scope-error",
        defaultMessage: "We couldn\u2019t load the assigned objects.",
        description: "Error loading the automatic Assets object preview"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5dzEI.default), {
        onClick: ()=>setRetry((value)=>value + 1)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
        id: "cmdb-components.assign-scope-retry",
        defaultMessage: "Try again",
        description: "Retry the automatic object preview"
    }))), (visibleState === null || visibleState === void 0 ? void 0 : visibleState.status) === 'ready' && visibleState.objects.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        role: "status"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
        id: "cmdb-components.assign-scope-empty",
        defaultMessage: "No objects found",
        description: "Empty assign-scope preview"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iAoWi.PaginatedObjectsView), {
        key: contextKey,
        isReadOnly: true,
        selectedObjects: (visibleState === null || visibleState === void 0 ? void 0 : visibleState.objects) ?? [],
        searchResults: [],
        isMulti: isMulti,
        limit: maximum,
        fieldLabel: fieldLabel,
        searchQuery: "",
        onSearchChange: ()=>undefined,
        isLoading: !visibleState,
        hasMore: false,
        onLoadMore: ()=>undefined,
        onSelectionCommit: ()=>undefined,
        errorMessage: errorMessage
    }));
};

});



parcelRegister("apqs2", function(module, exports) {
$parcel$export(module.exports, "createPlaceholderValueMap", () => $9c28e685e5175b55$export$e48ef9588813000d);
const $9c28e685e5175b55$export$e48ef9588813000d = (fieldValues, placeholderKeys)=>{
    // This reducer takes the field keys specified by the BE and grabs the relevant values from the form
    // to construct a map of values for the specified fields
    // This map is used by the CmdbObectPicker to determine when to display a default value based on an IQL query
    const placeholderValuesReducer = (accumulator, currentPlaceholder)=>{
        if (fieldValues[currentPlaceholder]) {
            var _fieldValues$currentP;
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call,  @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            accumulator[currentPlaceholder] = ((_fieldValues$currentP = fieldValues[currentPlaceholder]) === null || _fieldValues$currentP === void 0 ? void 0 : _fieldValues$currentP.toString()) || '';
        }
        return accumulator;
    };
    return placeholderKeys === null || placeholderKeys === void 0 ? void 0 : placeholderKeys.reduce(placeholderValuesReducer, {});
};

});

parcelRegister("ik8St", function(module, exports) {
$parcel$export(module.exports, "createAsyncProformaRequestCreate", () => $0a95d2287da83738$export$e401e2e1cb149a1b);


var $bQkfB = parcelRequire("bQkfB");

var $ieUrC = parcelRequire("ieUrC");

var $5Kuf4 = parcelRequire("5Kuf4");

const $0a95d2287da83738$export$e401e2e1cb149a1b = (options)=>(0, $bQkfB.default)({
        LoadingSkeleton: options === null || options === void 0 ? void 0 : options.LoadingSkeleton,
        loader: (0, $ieUrC.lazyForPaint)(()=>(parcelRequire("lt554")).then((module)=>{
                var _options$onLoaded;
                options === null || options === void 0 || (_options$onLoaded = options.onLoaded) === null || _options$onLoaded === void 0 || _options$onLoaded.call(options);
                return (0, $5Kuf4.withFadeIn)()(module.ConnectedProformaRequestCreate);
            }), {
            ssr: false,
            moduleId: "./packages/proforma/request-create/src/ui/index.tsx"
        })
    });
const $0a95d2287da83738$export$2e65e0be2de61019 = $0a95d2287da83738$export$e401e2e1cb149a1b();

});
parcelRegister("lt554", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("e2nF0"),
    $9dnsd("khy6p"),
    $9dnsd("jsVEa"),
    $9dnsd("hHYFE"),
    $9dnsd("6VzBn"),
    $9dnsd("8QEJW"),
    $9dnsd("3vLNJ")
]).then(()=>parcelRequire('i0zgy'));

});


parcelRegister("v2bn4", function(module, exports) {
$parcel$export(module.exports, "FormErrorMessage", () => (parcelRequire("b64HO")).default);

var $b64HO = parcelRequire("b64HO");

});
parcelRegister("b64HO", function(module, exports) {
$parcel$export(module.exports, "default", () => $5beb66f26c202944$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fZAYv = parcelRequire("fZAYv");
var $5QDex = parcelRequire("5QDex");

var $fd880 = parcelRequire("fd880");
var $fcCIH = parcelRequire("fcCIH");

var $8Mq6O = parcelRequire("8Mq6O");

var $gwdtf = parcelRequire("gwdtf");
class $5beb66f26c202944$export$185a8afe504e8fca extends $fc4bM.Component {
    render() {
        const { errors: errors, intl: intl } = this.props;
        const { errorReasonKey: errorReasonKey } = errors;
        const { errorMessageTitle: errorMessageTitle, errorMessageTitleForBot: errorMessageTitleForBot, errorMessageOfflineText: errorMessageOfflineText, errorMessageText: errorMessageText, errorMessageContactLink: errorMessageContactLink, errorMessageForInternalError: errorMessageForInternalError } = (0, $8Mq6O.default);
        const submissionError = errors.submissionError;
        const errorTitleDescriptor = errorReasonKey === (0, $gwdtf.ERROR_REASON_KEYS).RECAPTCHA_ERROR ? errorMessageTitleForBot : errorMessageTitle;
        const errorTitle = intl.formatMessage(errorTitleDescriptor);
        let errorMessage;
        const hasTraceId = !!errors.traceId;
        if (submissionError && 'isOfflineError' in submissionError && submissionError.isOfflineError) errorMessage = intl.formatMessage(errorMessageOfflineText);
        else if (hasTraceId && submissionError && 'isGeneric' in submissionError && submissionError.isGeneric) errorMessage = /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), {
            ...errorMessageText,
            values: {
                contactLink: // eslint-disable-next-line @atlassian/i18n/no-unsafe-message-composition -- Pre-existing; to be migrated
                /*#__PURE__*/ $fc4bM.createElement((0, $5QDex.Link), {
                    href: errors.contactLink,
                    target: "_blank",
                    actionSubjectId: "errorMessageContactLink"
                }, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), errorMessageContactLink))
            }
        });
        else // pre-translated error message from the backend
        errorMessage = submissionError && 'errorMessage' in submissionError && submissionError.errorMessage;
        if (!errorMessage && !hasTraceId) errorMessage = intl.formatMessage(errorMessageForInternalError);
        return /*#__PURE__*/ $fc4bM.createElement((0, $fZAYv.default), {
            title: errorTitle,
            message: errorMessage
        });
    }
}
var $5beb66f26c202944$export$2e2bcd8739ae039 = (0, $fcCIH.default)($5beb66f26c202944$export$185a8afe504e8fca);

});
parcelRegister("fZAYv", function(module, exports) {
$parcel$export(module.exports, "default", () => $8fabb2733e2d3b85$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $fOCtI = parcelRequire("fOCtI");

var $3DjOo = parcelRequire("3DjOo");

var $gDsF8 = parcelRequire("gDsF8");
const $8fabb2733e2d3b85$var$ErrorMessage = ({ title: title, message: message })=>{
    return(// Ensures users can always tab from the error message
    // eslint-disable-next-line @atlassian/a11y/no-noninteractive-tabindex, styled-components-a11y/no-noninteractive-tabindex
    /*#__PURE__*/ $fc4bM.createElement($8fabb2733e2d3b85$var$Container, {
        tabIndex: 0,
        "data-test-id": "error-message"
    }, /*#__PURE__*/ $fc4bM.createElement($8fabb2733e2d3b85$var$Header, null, /*#__PURE__*/ $fc4bM.createElement($8fabb2733e2d3b85$var$Title, null, /*#__PURE__*/ $fc4bM.createElement($8fabb2733e2d3b85$var$Icon, null, /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDsF8))), {
        spacing: "spacious",
        label: "error"
    })), title)), /*#__PURE__*/ $fc4bM.createElement($8fabb2733e2d3b85$var$Content, null, message)));
};
var $8fabb2733e2d3b85$export$2e2bcd8739ae039 = $8fabb2733e2d3b85$var$ErrorMessage;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8fabb2733e2d3b85$var$Container = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-l2wj5c-0"
})`${$3DjOo.borderBox};${$3DjOo.borderRadius};padding:${"var(--ds-space-200, 16px)"} 0;color:${"var(--ds-text-danger, #BF2600)"};margin-top:${"var(--ds-space-100, 8px)"};&:focus{outline:none;}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8fabb2733e2d3b85$var$Header = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-l2wj5c-1"
})`display:flex;align-items:center;height:${$fOCtI.multiple(4).px};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8fabb2733e2d3b85$var$Content = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-l2wj5c-2"
})`display:flex;flex:1 1 100%;flex-direction:column;justify-content:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8fabb2733e2d3b85$var$Icon = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-l2wj5c-3"
})`margin-right:${"var(--ds-space-050, 4px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8fabb2733e2d3b85$var$Title = /*#__PURE__*/ (0, $luz1X.default).span.withConfig({
    componentId: "sc-l2wj5c-4"
})`${$3DjOo.clamp};color:${"var(--ds-text-danger, #BF2600)"};display:flex;align-items:center;flex:1;font-weight:600;`;

});

parcelRegister("5QDex", function(module, exports) {
$parcel$export(module.exports, "Link", () => $40bc819d7316c6e0$export$a6c7ac8248d6e38a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $luz1X = parcelRequire("luz1X");

var $g9mbo = parcelRequire("g9mbo");
const $40bc819d7316c6e0$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $luz1X.default)((0, $g9mbo.HtmlAnchor)).withConfig({
    componentId: "sc-c173o3-0"
})`color:${"var(--ds-text-danger, #BF2600)"} !important;font-weight:600;text-decoration:underline;`;

});

parcelRegister("8Mq6O", function(module, exports) {
$parcel$export(module.exports, "default", () => $7eb568a7c6691f94$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $7eb568a7c6691f94$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    errorMessageTitle: {
        defaultMessage: "Couldn't send request",
        description: 'Error message title when form submission fails',
        id: 'cv.request.create.form.error.banner.title'
    },
    errorMessageTitleForBot: {
        defaultMessage: "We couldn\u2019t verify that you are not a bot",
        description: 'Error message title when form submission fails due to bot validation failure',
        id: 'cv.request.create.form.error.banner.title.bot'
    },
    errorMessageText: {
        defaultMessage: "Please copy your text, then refresh the page and try again. If you've already tried again, {contactLink}.",
        description: 'Error message title when form submission fails',
        id: 'cv.request.create.form.error.banner.message'
    },
    errorMessageContactLink: {
        defaultMessage: 'tell us about this issue',
        description: 'Text inside the refresh link inside the error banner.',
        id: 'cv.request.create.form.error.banner.contact.link'
    },
    errorMessageOfflineText: {
        defaultMessage: "You've been disconnected from the internet, wait until you have connectivity and then try again.",
        description: 'Error message title when form submission fails',
        id: 'cv.request.create.form.error.banner.message.offline'
    },
    errorMessageForInternalError: {
        defaultMessage: 'Contact your administrator to verify your internal network settings or disable any VPNs, and try again.',
        description: 'Error message description when form submission fails due to internal tenant proxy settings',
        id: 'cv.request.create.form.error.banner.message.internal'
    }
});

});




parcelRegister("drnAg", function(module, exports) {
$parcel$export(module.exports, "RequestTypeProformaError", () => (parcelRequire("92RVp")).default);

var $92RVp = parcelRequire("92RVp");

});
parcelRegister("92RVp", function(module, exports) {
$parcel$export(module.exports, "default", () => $e225b19de71efc54$export$2e2bcd8739ae039);
/* request-type-proforma-error.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $fcCIH = parcelRequire("fcCIH");

var $azARG = parcelRequire("azARG");

var $dtvmL = parcelRequire("dtvmL");

var $eENmG = parcelRequire("eENmG");

var $5iOO8 = parcelRequire("5iOO8");

var $gKh9Y = parcelRequire("gKh9Y");

var $bx3Kj = parcelRequire("bx3Kj");
const $e225b19de71efc54$var$styles = null;
class $e225b19de71efc54$export$67634daa559dd1dc extends $fc4bM.Component {
    componentDidMount() {
        this.fireRequestTypeViewedTrackEvent();
    }
    render() {
        const { admin: admin, intl: intl, formValidationResult: formValidationResult } = this.props;
        let errorMessage;
        if (formValidationResult !== null && formValidationResult !== void 0 && formValidationResult.readOnlyMandatory.some(({ readOnlyReason: readOnlyReason })=>readOnlyReason === (0, $5iOO8.ReadOnlyReason).Anonymous)) errorMessage = intl.formatMessage((0, $bx3Kj.default).couldntLoadRequestAnonymousDescription);
        else if (formValidationResult !== null && formValidationResult !== void 0 && formValidationResult.readOnlyMandatory.some(({ readOnlyReason: readOnlyReason })=>readOnlyReason === (0, $5iOO8.ReadOnlyReason).Unlicensed)) errorMessage = intl.formatMessage((0, $bx3Kj.default).couldntLoadRequestUnlicensedDescription);
        else if (admin && formValidationResult !== null && formValidationResult !== void 0 && formValidationResult.isConditionallyShown.length) errorMessage = intl.formatMessage((0, $bx3Kj.default).couldntLoadRequestConditionalSectionDescription);
        else errorMessage = intl.formatMessage((0, $bx3Kj.default).couldntLoadRequestGenericDescription);
        return /*#__PURE__*/ $fc4bM.createElement("div", {
            className: (0, $2R2iS.default)([
                "_19pkpxbi"
            ])
        }, /*#__PURE__*/ $fc4bM.createElement((0, $dtvmL.default), {
            appearance: "error",
            title: intl.formatMessage((0, $bx3Kj.default).couldntLoadRequestTitle)
        }, errorMessage));
    }
    constructor(...args){
        super(...args), this.fireRequestTypeViewedTrackEvent = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent, requestTypeId: requestTypeId, portalId: portalId, formValidationResult: formValidationResult } = this.props;
            if (!createAnalyticsEvent) return;
            let analyticsReason;
            if (formValidationResult !== null && formValidationResult !== void 0 && formValidationResult.readOnlyMandatory.length) analyticsReason = 'readOnlyMandatory';
            else if (formValidationResult !== null && formValidationResult !== void 0 && formValidationResult.isConditionallyShown.length) analyticsReason = 'isConditionallyShown';
            const analyticsEvent = createAnalyticsEvent({
                portalId: portalId,
                requestTypeId: requestTypeId,
                analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
                action: (0, $gKh9Y.Action).STOPPED,
                actionSubject: (0, $gKh9Y.ActionSubject).FORM_VALIDATION,
                stopReason: analyticsReason
            });
            analyticsEvent.fire();
        };
    }
}
var $e225b19de71efc54$export$2e2bcd8739ae039 = (0, $fcCIH.default)((0, $azARG.default)()($e225b19de71efc54$export$67634daa559dd1dc));

});
parcelRegister("5iOO8", function(module, exports) {
$parcel$export(module.exports, "ReadOnlyReason", () => $1b6710046f08352e$export$3981c7d6e6518dac);
var $1b6710046f08352e$export$3981c7d6e6518dac = /*#__PURE__*/ function(ReadOnlyReason) {
    ReadOnlyReason["Anonymous"] = "anonymous";
    ReadOnlyReason["Unlicensed"] = "unlicensed";
    return ReadOnlyReason;
}({});

});

parcelRegister("gKh9Y", function(module, exports) {
$parcel$export(module.exports, "ActionSubject", () => $ae9f7bdc9c29eff0$export$7f97440769de1377);
$parcel$export(module.exports, "Action", () => $ae9f7bdc9c29eff0$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "FormUpdateType", () => $ae9f7bdc9c29eff0$export$d7867a52899740a0);
/* Read https://hello.atlassian.net/wiki/spaces/DQ/pages/786078865 on how to instrument well. */ // These are entities in ProForma. Reuse as much as possible.
// Think carefully when making a new ActionSubject about whether you can reuse an existing one.
var $ae9f7bdc9c29eff0$export$7f97440769de1377 = /*#__PURE__*/ function(ActionSubject) {
    // Objects
    ActionSubject["FORM"] = "form";
    // An actual form on an issue.
    ActionSubject["FORM_FIELD"] = "formField";
    // A field in a form.
    ActionSubject["FORM_FIELD_CHOICES_DATA_CONNECTION"] = "formFieldChoicesDataConnection";
    // A data connection's choices in a form.
    ActionSubject["FORM_FIELD_CHOICES_JIRA_FIELD"] = "formFieldChoicesJiraField";
    // A Jira field's choices in a form.
    ActionSubject["FORM_SETTINGS_LANGUAGE"] = "formSettingsLanguage";
    // Language dropdown of a form in form settings.
    ActionSubject["FORM_SETTINGS_SUBMIT"] = "formSettingsSubmit";
    // Lock and PDF of a form on submit toggle in form settings.
    ActionSubject["FORM_SETTINGS_ISSUE_CREATE"] = "formSettingsIssueCreate";
    // Submit and validate on create toggle in form settings.
    ActionSubject["FORM_SETTINGS_ISSUE_FORMS_TYPES"] = "formSettingsIssueFormsTypes";
    // Issue forms types dropdown in form settings, enabled through issue forms toggle.
    ActionSubject["FORM_SETTINGS_RECOMMENDED_FORMS_TYPES"] = "formSettingsRecommendedFormsTypes";
    // Recommended forms types dropdown in form settings, enabled through recommended forms toggle.
    ActionSubject["FORM_SETTINGS_REQUEST_CREATE_TYPES"] = "formSettingsRequestCreateTypes";
    // Request create types dropdown in form settings, enabled through request create toggle ("Attach to request types").
    ActionSubject["QUESTION_ANSWER"] = "questionAnswer";
    // Answer of a Question in a form.
    ActionSubject["TEMPLATE_FORM"] = "templateForm";
    // A form in a project created by form builder than can be then instantiated on an issue.
    ActionSubject["EXAMPLE_TEMPLATE"] = "exampleTemplate";
    // Predefined templates available in the form builder that can be inserted into a template form.
    ActionSubject["BUTTON"] = "button";
    ActionSubject["DROPDOWN_ITEM"] = "dropdownItem";
    ActionSubject["SELECT_ITEM"] = "selectItem";
    ActionSubject["FILTER"] = "filter";
    ActionSubject["LIST"] = "list";
    ActionSubject["PANEL"] = "panel";
    ActionSubject["SECTION"] = "section";
    ActionSubject["TABLE"] = "table";
    ActionSubject["MODAL"] = "modal";
    ActionSubject["PROFORMA_API"] = "proformaAPI";
    ActionSubject["PROFORMA_UI"] = "proformaUI";
    ActionSubject["SECTION_MESSAGE"] = "sectionMessage";
    ActionSubject["ATTACHMENT"] = "proformaAttachment";
    ActionSubject["ATTACHMENT_UPLOAD"] = "proformaAttachmentUpload";
    ActionSubject["ATTACHMENT_VIEWER"] = "proformaAttachmentViewer";
    ActionSubject["ATTACHMENT_VIEWER_CARD"] = "proformaAttachmentViewerCard";
    ActionSubject["REQUEST_TYPE"] = "requestType";
    ActionSubject["DUPLICATE_REQUEST_TYPE_LINKED_FIELDS_WARNING_MODAL"] = "duplicateRequestTypeLinkedFieldsWarningModal";
    ActionSubject["TRANSLATIONS_EDITOR"] = "translationsEditor";
    ActionSubject["FORM_PERMISSIONS"] = "proformaFormPermissions";
    // Processes
    ActionSubject["ADF_NODE_INSERT"] = "adfNodeInsert";
    ActionSubject["FORM_VALIDATION"] = "formValidation";
    ActionSubject["FORM_EDIT"] = "formEdit";
    ActionSubject["FORM_SAVE"] = "formSave";
    ActionSubject["SEARCH_ASYNC_CHOICES"] = "searchAsyncChoices";
    ActionSubject["FETCH_FORM_ATTACHMENTS"] = "fetchFormAttachments";
    ActionSubject["UPLOAD_ISSUE_FORM_ATTACHMENTS"] = "uploadFormAttachments";
    ActionSubject["TRANSLATIONS_LANGUAGES_LOAD"] = "translationsLoad";
    ActionSubject["TRANSLATIONS_LOAD"] = "translationsLoad";
    ActionSubject["TRANSLATIONS_SAVE"] = "translationsSave";
    ActionSubject["TRANSLATIONS_DELETE"] = "translationsDelete";
    return ActionSubject;
}({});
var $ae9f7bdc9c29eff0$export$e19cd5f9376f8cee = /*#__PURE__*/ function(Action) {
    // Objects
    Action["ADDED"] = "added";
    // When an entity is added/inserted into another.
    Action["CLICKED"] = "clicked";
    Action["CREATED"] = "created";
    Action["DELETED"] = "deleted";
    Action["DOWNLOADED"] = "downloaded";
    Action["EXPORTED"] = "exported";
    Action["UPDATED"] = "updated";
    Action["VIEWED"] = "viewed";
    Action["SELECTED"] = "selected";
    Action["COPIED"] = "copied";
    // Processes
    Action["FAILED"] = "failed";
    Action["FINISHED"] = "finished";
    Action["STARTED"] = "started";
    Action["STOPPED"] = "stopped";
    return Action;
}({});
var $ae9f7bdc9c29eff0$export$d7867a52899740a0 = /*#__PURE__*/ function(FormUpdateType) {
    FormUpdateType["REOPEN"] = "REOPEN";
    FormUpdateType["SAVE"] = "SAVE";
    FormUpdateType["SET_EXTERNAL"] = "SET_EXTERNAL";
    FormUpdateType["SET_INTERNAL"] = "SET_INTERNAL";
    FormUpdateType["SUBMIT"] = "SUBMIT";
    FormUpdateType["CLOSE"] = "CLOSE";
    return FormUpdateType;
}({});

});

parcelRegister("bx3Kj", function(module, exports) {
$parcel$export(module.exports, "default", () => $eae1cb6a2553e476$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $eae1cb6a2553e476$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    couldntLoadRequestTitle: {
        defaultMessage: "We couldn\u2019t load this request",
        description: 'Title shown in section message when form could not be loaded',
        id: 'sd.jsm.customerview.portalrequesttype.couldnt.load.request.title'
    },
    couldntLoadRequestGenericDescription: {
        defaultMessage: 'Select a different request, or contact your admin.',
        description: 'Description shown in section message when form could not be loaded due to an unknown reason.',
        id: 'sd.jsm.customerview.portalrequesttype.couldnt.load.request.generic.description'
    },
    couldntLoadRequestAnonymousDescription: {
        defaultMessage: 'Log in with a valid account to access, or select a different request.',
        description: 'Description shown in section message when form could not be loaded due to user not being logged in.',
        id: 'sd.jsm.customerview.portalrequesttype.couldnt.load.request.anonymous.description'
    },
    couldntLoadRequestUnlicensedDescription: {
        defaultMessage: 'This request is only available to users with Jira access. Select a different request, or contact your admin.',
        description: 'Description shown in section message when form could not be loaded due to not having Jira access.',
        id: 'sd.jsm.customerview.portalrequesttype.couldnt.load.request.unlicensed.description'
    },
    couldntLoadRequestConditionalSectionDescription: {
        defaultMessage: 'Remove required fields from conditional sections, or change their linked Jira fields to optional.',
        description: 'Description shown in section message when form could not be loaded due to required Jira fields being inside conditional section.',
        id: 'sd.jsm.customerview.portalrequesttype.couldnt.load.request.conditional.section.description'
    }
});

});





parcelRegister("bcRo2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f9c38bfa054ce139eb4eb1d828621cdf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $828a3a29660c4c44$var$_react = $828a3a29660c4c44$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $828a3a29660c4c44$var$_iconNew = $828a3a29660c4c44$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $828a3a29660c4c44$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Clock".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/clock
 * Usage guidance:
 * Known uses: recent, time input, sprint time remaining, overdue task work type status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $828a3a29660c4c44$var$ClockIcon = (props)=>/*#__PURE__*/ $828a3a29660c4c44$var$_react.default.createElement($828a3a29660c4c44$var$_iconNew.default, Object.assign({
        name: "ClockIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0M8.75 3.25v4.389l2.219 1.775-.938 1.172-2.5-2-.281-.226V3.25zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$828a3a29660c4c44$var$ClockIcon.displayName = 'ClockIcon';
var $828a3a29660c4c44$var$_default = module.exports.default = $828a3a29660c4c44$var$ClockIcon;

});

parcelRegister("3r3PH", function(module, exports) {
$parcel$export(module.exports, "Grid", () => $588dfabc01e1351b$export$ef2184bd89960b14);
/* grid.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $588dfabc01e1351b$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz",
    'space.gap.xxsmall': "_1p571j29",
    'space.gap.xsmall': "_1p57t24t",
    'space.gap.small': "_1p57e2kt",
    'space.gap.medium': "_1p57slki",
    'space.gap.large': "_1p571l0c",
    'space.gap.xlarge': "_1p571a4g",
    'space.gap.xxlarge': "_1p57rdp2"
};
const $588dfabc01e1351b$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz",
    'space.gap.xxsmall': "_gy1p1j29",
    'space.gap.xsmall': "_gy1pt24t",
    'space.gap.small': "_gy1pe2kt",
    'space.gap.medium': "_gy1pslki",
    'space.gap.large': "_gy1p1l0c",
    'space.gap.xlarge': "_gy1p1a4g",
    'space.gap.xxlarge': "_gy1prdp2"
};
const $588dfabc01e1351b$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $588dfabc01e1351b$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $588dfabc01e1351b$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $588dfabc01e1351b$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $588dfabc01e1351b$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
const $588dfabc01e1351b$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $fc4bM.memo)(/*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $3LM7S.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $2R2iS.default)([
            $588dfabc01e1351b$var$baseStyles.root,
            gap && $588dfabc01e1351b$var$columnGapMap[gap],
            columnGap && $588dfabc01e1351b$var$columnGapMap[columnGap],
            gap && $588dfabc01e1351b$var$rowGapMap[gap],
            rowGap && $588dfabc01e1351b$var$rowGapMap[rowGap],
            alignItems && $588dfabc01e1351b$var$alignItemsMap[alignItems],
            alignContent && $588dfabc01e1351b$var$alignContentMap[alignContent],
            justifyContent && $588dfabc01e1351b$var$justifyContentMap[justifyContent],
            autoFlow && $588dfabc01e1351b$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$588dfabc01e1351b$export$ef2184bd89960b14.displayName = 'Grid';

});

parcelRegister("7MNh1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bdcfaadd200b1558cd21a6be22e04743>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ab33cce72de74fe$var$_react = $5ab33cce72de74fe$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $5ab33cce72de74fe$var$_iconNew = $5ab33cce72de74fe$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $5ab33cce72de74fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/calendar
 * Usage guidance:
 * Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ab33cce72de74fe$var$CalendarIcon = (props)=>/*#__PURE__*/ $5ab33cce72de74fe$var$_react.default.createElement($5ab33cce72de74fe$var$_iconNew.default, Object.assign({
        name: "CalendarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$5ab33cce72de74fe$var$CalendarIcon.displayName = 'CalendarIcon';
var $5ab33cce72de74fe$var$_default = module.exports.default = $5ab33cce72de74fe$var$CalendarIcon;

});

parcelRegister("gn6xt", function(module, exports) {
$parcel$export(module.exports, "createLocalizationProvider", () => $2e2a2824ec184343$export$ea56ca58f08ffa52);

var $giS2p = parcelRequire("giS2p");

var $2Ptbb = parcelRequire("2Ptbb");

var $9InEt = parcelRequire("9InEt");

var $4aOGO = parcelRequire("4aOGO");
const $2e2a2824ec184343$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $giS2p.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>getDays(weekStartDay, 'short');
    const getDaysLong = (weekStartDay = 0)=>getDays(weekStartDay, 'long');
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $2Ptbb.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
     * Safari has a bug that returns the wrong month for years 2005 and before.
     * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
     * Not all the months fail in each year. To ensure the correct output,
     * we select 2020 as the base year for the whole date,
     * then we replace in the result the original input year
     */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $4aOGO.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $4aOGO.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
     * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
     * We fix it by detecting the real time with getHours method
     */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    let intlLocale;
    const getFirstDayOfWeek = ()=>{
        if (!intlLocale) intlLocale = new Intl.Locale(normalizedLocale);
        const weekInfo = (0, $9InEt.getWeekInfo)(intlLocale);
        // Intl uses ISO weekdays (1 = Monday … 7 = Sunday).
        // Calendar / getDays* use JS weekdays (0 = Sunday … 6 = Saturday).
        return weekInfo.firstDay % 7;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts,
        getFirstDayOfWeek: getFirstDayOfWeek
    };
};

});
parcelRegister("giS2p", function(module, exports) {
$parcel$export(module.exports, "normalizeLocale", () => $8eb7b2bbcf5cf884$export$dca0327c9b9c6498);
const $8eb7b2bbcf5cf884$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("2Ptbb", function(module, exports) {
$parcel$export(module.exports, "createDateParser", () => $0cdb83868f288f2e$export$cfa2ef2687faeda2);

var $giS2p = parcelRequire("giS2p");

var $6fF4j = parcelRequire("6fF4j");

var $jKEYW = parcelRequire("jKEYW");

var $iUEzZ = parcelRequire("iUEzZ");
const $0cdb83868f288f2e$var$INVALID_DATE = new Date(NaN);
const $0cdb83868f288f2e$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $0cdb83868f288f2e$var$INVARIANT_DATE = (0, $iUEzZ.toDate)($0cdb83868f288f2e$var$INVARIANT);
const $0cdb83868f288f2e$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $0cdb83868f288f2e$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $0cdb83868f288f2e$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $0cdb83868f288f2e$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $0cdb83868f288f2e$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $giS2p.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($0cdb83868f288f2e$var$INVARIANT_DATE);
    const shortDate = $0cdb83868f288f2e$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($0cdb83868f288f2e$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $0cdb83868f288f2e$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($0cdb83868f288f2e$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($0cdb83868f288f2e$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($0cdb83868f288f2e$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $0cdb83868f288f2e$var$stripExtras(date).match($0cdb83868f288f2e$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $0cdb83868f288f2e$var$INVALID_DATE;
        const dateParts = $0cdb83868f288f2e$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $jKEYW.normalizeDate)(extractedDate, options === null || options === void 0 ? void 0 : options.defaultFirstDay);
        if (!(0, $6fF4j.isValid)(normalizedDate)) return $0cdb83868f288f2e$var$INVALID_DATE;
        return (0, $iUEzZ.toDate)(normalizedDate);
    };
};

});
parcelRegister("6fF4j", function(module, exports) {
$parcel$export(module.exports, "isValid", () => $82f301c46db7f11b$export$1ea939691cdc45b8);

var $8sMJq = parcelRequire("8sMJq");
const $82f301c46db7f11b$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = (0, $8sMJq.getDaysInMonth)(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};

});
parcelRegister("8sMJq", function(module, exports) {
$parcel$export(module.exports, "getDaysInMonth", () => $b3994bc6db0451e5$export$f645ddd439eb259d);

var $4YZt3 = parcelRequire("4YZt3");
const $b3994bc6db0451e5$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && (0, $4YZt3.isLeapYear)(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};

});
parcelRegister("4YZt3", function(module, exports) {
$parcel$export(module.exports, "isLeapYear", () => $14555d0110362eff$export$553d7fa8e3805fc0);
const $14555d0110362eff$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};

});



parcelRegister("jKEYW", function(module, exports) {
$parcel$export(module.exports, "normalizeDate", () => $b9bb7983fe86168c$export$fcc71269590ba0a8);

var $908Ua = parcelRequire("908Ua");
const $b9bb7983fe86168c$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = (0, $908Ua.toDateObj)(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});
parcelRegister("908Ua", function(module, exports) {
$parcel$export(module.exports, "toDateObj", () => $2d135357ba282a2b$export$abe96da78d4f59dd);
const $2d135357ba282a2b$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });

});


parcelRegister("iUEzZ", function(module, exports) {
$parcel$export(module.exports, "toDate", () => $3fc8eca55b25ea72$export$e67a095c620b86fe);
const $3fc8eca55b25ea72$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);

});


parcelRegister("9InEt", function(module, exports) {
$parcel$export(module.exports, "getWeekInfo", () => $d0a68b319572b3d5$export$837830ce0c77272);
// Regional exceptions from Unicode CLDR 48; all other regions use Monday.
// https://github.com/unicode-org/cldr-json/blob/48.0.0/cldr-json/cldr-core/supplemental/weekData.json
const $d0a68b319572b3d5$var$firstDays = {
    AF: 6,
    AG: 7,
    AS: 7,
    BD: 7,
    BH: 6,
    BR: 7,
    BS: 7,
    BT: 7,
    BW: 7,
    BZ: 7,
    CA: 7,
    CO: 7,
    DJ: 6,
    DM: 7,
    DO: 7,
    DZ: 6,
    EG: 6,
    ET: 7,
    GT: 7,
    GU: 7,
    HK: 7,
    HN: 7,
    ID: 7,
    IL: 7,
    IN: 7,
    IQ: 6,
    IR: 6,
    IS: 7,
    JM: 7,
    JO: 6,
    JP: 7,
    KE: 7,
    KH: 7,
    KR: 7,
    KW: 6,
    LA: 7,
    LY: 6,
    MH: 7,
    MM: 7,
    MO: 7,
    MT: 7,
    MV: 5,
    MX: 7,
    MZ: 7,
    NI: 7,
    NP: 7,
    OM: 6,
    PA: 7,
    PE: 7,
    PH: 7,
    PK: 7,
    PR: 7,
    PT: 7,
    PY: 7,
    QA: 6,
    SA: 7,
    SD: 6,
    SG: 7,
    SV: 7,
    SY: 6,
    TH: 7,
    TT: 7,
    TW: 7,
    UM: 7,
    US: 7,
    VE: 7,
    VI: 7,
    WS: 7,
    YE: 7,
    ZA: 7,
    ZW: 7
};
// Only regular territories may override a locale's region (CLDR 48 region validity data).
// https://github.com/unicode-org/cldr/blob/release-48/common/validity/region.xml
const $d0a68b319572b3d5$var$regularRegions = new Set([
    'AC AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF',
    'BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH',
    'CI CK CL CM CN CO CP CQ CR CU CV CW CX CY CZ DE DG DJ DK DM DO DZ',
    'EA EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI',
    'GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU IC ID IE IL IM',
    'IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA',
    'LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO',
    'MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU',
    'NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW',
    'SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TA',
    'TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ',
    'VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW'
].join(' ').split(' '));
// Read only Unicode keywords, excluding other extensions and private-use subtags.
const $d0a68b319572b3d5$var$getUnicodeKeyword = (locale, key)=>{
    const extensions = locale.toString().split('-');
    const start = extensions.indexOf('u');
    const privateUse = extensions.indexOf('x');
    if (start === -1 || privateUse !== -1 && privateUse < start) return undefined;
    for(let index = start + 1; index < extensions.length; index++){
        if (extensions[index].length === 1) break;
        if (extensions[index] === key) {
            const value = [];
            while(((_extensions = extensions[index + 1]) === null || _extensions === void 0 ? void 0 : _extensions.length) > 2){
                var _extensions;
                value.push(extensions[++index]);
            }
            return value.join('-');
        }
    }
    return undefined;
};
// Canonicalize aliases before rejecting unknown, private-use, and macroregion overrides.
const $d0a68b319572b3d5$var$getOverrideRegion = (value)=>{
    if (!value) return undefined;
    const region = new Intl.Locale(`und-${value}`).region;
    return region && $d0a68b319572b3d5$var$regularRegions.has(region) ? region : undefined;
};
const $d0a68b319572b3d5$export$837830ce0c77272 = (locale)=>{
    var _getUnicodeKeyword, _getUnicodeKeyword2;
    if (typeof locale.getWeekInfo === 'function') return locale.getWeekInfo();
    const legacyWeekInfo = locale.weekInfo;
    if (legacyWeekInfo) return legacyWeekInfo;
    const regionOverride = $d0a68b319572b3d5$var$getOverrideRegion((_getUnicodeKeyword = $d0a68b319572b3d5$var$getUnicodeKeyword(locale, 'rg')) === null || _getUnicodeKeyword === void 0 || (_getUnicodeKeyword = _getUnicodeKeyword.match(/^([a-z]{2}|[0-9]{3})zzzz$/)) === null || _getUnicodeKeyword === void 0 ? void 0 : _getUnicodeKeyword[1]);
    const subdivision = $d0a68b319572b3d5$var$getOverrideRegion((_getUnicodeKeyword2 = $d0a68b319572b3d5$var$getUnicodeKeyword(locale, 'sd')) === null || _getUnicodeKeyword2 === void 0 || (_getUnicodeKeyword2 = _getUnicodeKeyword2.match(/^([a-z]{2}|[0-9]{3})[a-z0-9]+$/)) === null || _getUnicodeKeyword2 === void 0 ? void 0 : _getUnicodeKeyword2[1]);
    const region = regionOverride || locale.region || subdivision || locale.maximize().region || '001';
    const preferredDay = [
        'mon',
        'tue',
        'wed',
        'thu',
        'fri',
        'sat',
        'sun'
    ].indexOf($d0a68b319572b3d5$var$getUnicodeKeyword(locale, 'fw') || '');
    const firstDay = preferredDay !== -1 ? preferredDay + 1 : !regionOverride && locale.calendar === 'iso8601' ? 1 : $d0a68b319572b3d5$var$firstDays[region] || 1;
    return {
        firstDay: firstDay
    };
};

});

parcelRegister("4aOGO", function(module, exports) {
$parcel$export(module.exports, "toFormattedParts", () => $7376652f26b3db2c$export$9b7ca29af37c192);
const $7376652f26b3db2c$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("4LHy0", function(module, exports) {

var $daBML = parcelRequire("daBML");

var $8GSh0 = parcelRequire("8GSh0");
/** `Object#toString` result references. */ var $378d54d7f229c8a8$var$boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $378d54d7f229c8a8$var$isBoolean(value) {
    return value === true || value === false || $8GSh0(value) && $daBML(value) == $378d54d7f229c8a8$var$boolTag;
}
module.exports = $378d54d7f229c8a8$var$isBoolean;

});


//# sourceMappingURL=request-create-form.fa7da8cc.js.map
